/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Lusca Search
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActiveProjectValidation
 */
export interface ActiveProjectValidation {
    /**
     * 
     * @type {string}
     * @memberof ActiveProjectValidation
     */
    'jobId': string;
    /**
     * 
     * @type {ProjectValidationStage}
     * @memberof ActiveProjectValidation
     */
    'stage': ProjectValidationStage;
    /**
     * 
     * @type {string}
     * @memberof ActiveProjectValidation
     */
    'startedAt': string;
}
/**
 * 
 * @export
 * @interface AmountDto
 */
export interface AmountDto {
    /**
     * The numeric amount value as a string
     * @type {string}
     * @memberof AmountDto
     */
    'value'?: string;
    /**
     * The ISO currency code
     * @type {string}
     * @memberof AmountDto
     */
    'currencyCode'?: string;
}
/**
 * 
 * @export
 * @interface AsanaAuthorizationCompleteRequest
 */
export interface AsanaAuthorizationCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationCompleteRequest
     */
    'sessionId': string;
}
/**
 * 
 * @export
 * @interface AsanaAuthorizationCompleteResponse
 */
export interface AsanaAuthorizationCompleteResponse {
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationCompleteResponse
     */
    'status': AsanaAuthorizationCompleteResponseStatusEnum;
}

export const AsanaAuthorizationCompleteResponseStatusEnum = {
    Connected: 'connected'
} as const;

export type AsanaAuthorizationCompleteResponseStatusEnum = typeof AsanaAuthorizationCompleteResponseStatusEnum[keyof typeof AsanaAuthorizationCompleteResponseStatusEnum];

/**
 * 
 * @export
 * @interface AsanaAuthorizationRequest
 */
export interface AsanaAuthorizationRequest {
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationRequest
     */
    'state': string;
    /**
     * 
     * @type {boolean}
     * @memberof AsanaAuthorizationRequest
     */
    'forceAuthentication'?: boolean;
}
/**
 * 
 * @export
 * @interface AsanaAuthorizationResponse
 */
export interface AsanaAuthorizationResponse {
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationResponse
     */
    'status': AsanaAuthorizationResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationResponse
     */
    'authorizationUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationResponse
     */
    'sessionId'?: string;
}

export const AsanaAuthorizationResponseStatusEnum = {
    Connected: 'connected',
    AuthorizationRequired: 'authorization_required'
} as const;

export type AsanaAuthorizationResponseStatusEnum = typeof AsanaAuthorizationResponseStatusEnum[keyof typeof AsanaAuthorizationResponseStatusEnum];

/**
 * 
 * @export
 * @interface AsanaLink
 */
export interface AsanaLink {
    /**
     * 
     * @type {string}
     * @memberof AsanaLink
     */
    'projectGid': string;
    /**
     * 
     * @type {string}
     * @memberof AsanaLink
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof AsanaLink
     */
    'projectUrl': string;
}
/**
 * 
 * @export
 * @interface AsanaLinkPreviewRequest
 */
export interface AsanaLinkPreviewRequest {
    /**
     * Asana project URL or numeric project GID
     * @type {string}
     * @memberof AsanaLinkPreviewRequest
     */
    'projectReference': string;
}
/**
 * 
 * @export
 * @interface AsanaLinkUpdate
 */
export interface AsanaLinkUpdate {
    /**
     * 
     * @type {string}
     * @memberof AsanaLinkUpdate
     */
    'projectGid': string;
    /**
     * 
     * @type {number}
     * @memberof AsanaLinkUpdate
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface AsanaProjectList
 */
export interface AsanaProjectList {
    /**
     * Whether more matching projects exist beyond this response
     * @type {boolean}
     * @memberof AsanaProjectList
     */
    'hasMore': boolean;
    /**
     * 
     * @type {Array<AsanaProjectReference>}
     * @memberof AsanaProjectList
     */
    'projects': Array<AsanaProjectReference>;
}
/**
 * 
 * @export
 * @interface AsanaProjectPreview
 */
export interface AsanaProjectPreview {
    /**
     * 
     * @type {AsanaProjectReference}
     * @memberof AsanaProjectPreview
     */
    'project': AsanaProjectReference;
}
/**
 * 
 * @export
 * @interface AsanaProjectReference
 */
export interface AsanaProjectReference {
    /**
     * 
     * @type {string}
     * @memberof AsanaProjectReference
     */
    'gid': string;
    /**
     * 
     * @type {string}
     * @memberof AsanaProjectReference
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AsanaProjectReference
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface Cbe
 */
export interface Cbe {
    /**
     * 
     * @type {string}
     * @memberof Cbe
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface CbeSummaryResponse
 */
export interface CbeSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponse
     */
    'totalCbes'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CbeSummaryResponse
     */
    'byUsecase'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CbeSummaryResponse
     */
    'byAccountingOperation'?: { [key: string]: number; };
    /**
     * 
     * @type {CbeSummaryResponsePublishStatus}
     * @memberof CbeSummaryResponse
     */
    'publishStatus'?: CbeSummaryResponsePublishStatus;
}
/**
 * 
 * @export
 * @interface CbeSummaryResponsePublishStatus
 */
export interface CbeSummaryResponsePublishStatus {
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponsePublishStatus
     */
    'published'?: number;
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponsePublishStatus
     */
    'failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponsePublishStatus
     */
    'skipped'?: number;
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponsePublishStatus
     */
    'unknown'?: number;
}
/**
 * 
 * @export
 * @interface ChatAsyncResponse
 */
export interface ChatAsyncResponse {
    /**
     * Id to poll on chat-status
     * @type {string}
     * @memberof ChatAsyncResponse
     */
    'jobId'?: string;
    /**
     * 
     * @type {ChatJobStatus}
     * @memberof ChatAsyncResponse
     */
    'status'?: ChatJobStatus;
}
/**
 * 
 * @export
 * @interface ChatFollowupsResponse
 */
export interface ChatFollowupsResponse {
    /**
     * Suggested follow-up questions
     * @type {Array<string>}
     * @memberof ChatFollowupsResponse
     */
    'followups'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatJobStatus = {
    Pending: 'PENDING',
    Done: 'DONE',
    Failed: 'FAILED'
} as const;

export type ChatJobStatus = typeof ChatJobStatus[keyof typeof ChatJobStatus];

/**
 * 
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'role': ChatMessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'content': string;
}

export const ChatMessageRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;

export type ChatMessageRoleEnum = typeof ChatMessageRoleEnum[keyof typeof ChatMessageRoleEnum];

/**
 * 
 * @export
 * @interface ChatRequest
 */
export interface ChatRequest {
    /**
     * The transaction/order the conversation is scoped to
     * @type {string}
     * @memberof ChatRequest
     */
    'transactionId': string;
    /**
     * Full conversation history, oldest first
     * @type {Array<ChatMessage>}
     * @memberof ChatRequest
     */
    'messages': Array<ChatMessage>;
}
/**
 * 
 * @export
 * @interface ChatResponse
 */
export interface ChatResponse {
    /**
     * Assistant reply text
     * @type {string}
     * @memberof ChatResponse
     */
    'content'?: string;
    /**
     * Names of the data sources and actions used to produce the answer
     * @type {Array<string>}
     * @memberof ChatResponse
     */
    'toolsUsed'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ChatStatusResponse
 */
export interface ChatStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatStatusResponse
     */
    'jobId'?: string;
    /**
     * 
     * @type {ChatJobStatus}
     * @memberof ChatStatusResponse
     */
    'status'?: ChatJobStatus;
    /**
     * Steps completed so far, oldest first
     * @type {Array<string>}
     * @memberof ChatStatusResponse
     */
    'progress'?: Array<string>;
    /**
     * Assistant reply text, present once status is DONE
     * @type {string}
     * @memberof ChatStatusResponse
     */
    'content'?: string;
    /**
     * Names of the data sources and actions used to produce the answer
     * @type {Array<string>}
     * @memberof ChatStatusResponse
     */
    'toolsUsed'?: Array<string>;
    /**
     * Failure reason, present once status is FAILED
     * @type {string}
     * @memberof ChatStatusResponse
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ChatUatAction
 */
export interface ChatUatAction {
    /**
     * Canonical tool name used as an opaque action identifier
     * @type {string}
     * @memberof ChatUatAction
     */
    'type': string;
    /**
     * Tool-specific status retained for diagnostics and specialized clients
     * @type {string}
     * @memberof ChatUatAction
     */
    'status': string;
    /**
     * Tool-independent presentation category. confirmed means only that the action-specific acknowledgement was verified.
     * @type {string}
     * @memberof ChatUatAction
     */
    'outcome': ChatUatActionOutcomeEnum;
    /**
     * Short deterministic heading for the action outcome
     * @type {string}
     * @memberof ChatUatAction
     */
    'summary': string;
    /**
     * 
     * @type {ChatUatActionReference}
     * @memberof ChatUatAction
     */
    'reference'?: ChatUatActionReference;
}

export const ChatUatActionOutcomeEnum = {
    Confirmed: 'confirmed',
    Uncertain: 'uncertain',
    Failed: 'failed'
} as const;

export type ChatUatActionOutcomeEnum = typeof ChatUatActionOutcomeEnum[keyof typeof ChatUatActionOutcomeEnum];

/**
 * 
 * @export
 * @interface ChatUatActionReference
 */
export interface ChatUatActionReference {
    /**
     * Human-readable label for the copyable reference
     * @type {string}
     * @memberof ChatUatActionReference
     */
    'label': string;
    /**
     * Exact, case-sensitive reference value. Clients must not trim or otherwise normalize it.
     * @type {string}
     * @memberof ChatUatActionReference
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ChatUatActionResponse
 */
export interface ChatUatActionResponse {
    /**
     * Echo of the conversation id to send on the next turn
     * @type {string}
     * @memberof ChatUatActionResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatActionResponse
     */
    'responseType': ChatUatActionResponseResponseTypeEnum;
    /**
     * Safe explanatory text for the action outcome
     * @type {string}
     * @memberof ChatUatActionResponse
     */
    'conversational': string;
    /**
     * 
     * @type {ChatUatAction}
     * @memberof ChatUatActionResponse
     */
    'action': ChatUatAction;
}

export const ChatUatActionResponseResponseTypeEnum = {
    Action: 'action'
} as const;

export type ChatUatActionResponseResponseTypeEnum = typeof ChatUatActionResponseResponseTypeEnum[keyof typeof ChatUatActionResponseResponseTypeEnum];

/**
 * Optional presentation preference. It changes explanation emphasis and suggested next steps but never evidence, authorization, or verdicts.
 * @export
 * @enum {string}
 */

export const ChatUatAudience = {
    Customer: 'customer',
    Engineer: 'engineer'
} as const;

export type ChatUatAudience = typeof ChatUatAudience[keyof typeof ChatUatAudience];

/**
 * 
 * @export
 * @interface ChatUatContentFacts
 */
export interface ChatUatContentFacts {
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'schemaVersion': ChatUatContentFactsSchemaVersionEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'status': ChatUatContentFactsStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'orderId': string;
    /**
     * 
     * @type {Stage}
     * @memberof ChatUatContentFacts
     */
    'stage': Stage;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'contentType': ChatUatContentFactsContentTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatUatContentFacts
     */
    'sourceRefs': Array<string>;
}

export const ChatUatContentFactsSchemaVersionEnum = {
    _1: '1'
} as const;

export type ChatUatContentFactsSchemaVersionEnum = typeof ChatUatContentFactsSchemaVersionEnum[keyof typeof ChatUatContentFactsSchemaVersionEnum];
export const ChatUatContentFactsStatusEnum = {
    Ok: 'ok'
} as const;

export type ChatUatContentFactsStatusEnum = typeof ChatUatContentFactsStatusEnum[keyof typeof ChatUatContentFactsStatusEnum];
export const ChatUatContentFactsContentTypeEnum = {
    Episode: 'episode',
    Movie: 'movie'
} as const;

export type ChatUatContentFactsContentTypeEnum = typeof ChatUatContentFactsContentTypeEnum[keyof typeof ChatUatContentFactsContentTypeEnum];

/**
 * 
 * @export
 * @interface ChatUatContextReference
 */
export interface ChatUatContextReference {
    /**
     * 
     * @type {string}
     * @memberof ChatUatContextReference
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContextReference
     */
    'taskGid': string;
    /**
     * Optional browser display value. The backend verifies it against the persisted validation case and supplies the authoritative value to AgentCore.
     * @type {string}
     * @memberof ChatUatContextReference
     */
    'orderId'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatUatError
 */
export interface ChatUatError {
    /**
     * Safe request or service error
     * @type {string}
     * @memberof ChatUatError
     */
    'error': string;
}
/**
 * Optional bounded failure category supplied by newer Agent runtimes. Clients must use the safe error string for backward compatibility and must not display this internal code as prose.
 * @export
 * @enum {string}
 */

export const ChatUatFailureCode = {
    ReviewTooLarge: 'review_too_large',
    Timeout: 'timeout',
    ExecutionLimit: 'execution_limit',
    Cancelled: 'cancelled',
    Lost: 'lost',
    InternalError: 'internal_error'
} as const;

export type ChatUatFailureCode = typeof ChatUatFailureCode[keyof typeof ChatUatFailureCode];

/**
 * 
 * @export
 * @interface ChatUatFeedbackContext
 */
export interface ChatUatFeedbackContext {
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackContext
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackContext
     */
    'taskGid': string;
}
/**
 * 
 * @export
 * @interface ChatUatFeedbackRequest
 */
export interface ChatUatFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'feedbackId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'responseFingerprint': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'rating': ChatUatFeedbackRequestRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'reason'?: ChatUatFeedbackRequestReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {ChatUatFeedbackContext}
     * @memberof ChatUatFeedbackRequest
     */
    'context'?: ChatUatFeedbackContext;
}

export const ChatUatFeedbackRequestRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;

export type ChatUatFeedbackRequestRatingEnum = typeof ChatUatFeedbackRequestRatingEnum[keyof typeof ChatUatFeedbackRequestRatingEnum];
export const ChatUatFeedbackRequestReasonEnum = {
    Incorrect: 'incorrect',
    MissingEvidence: 'missing_evidence',
    Unclear: 'unclear',
    TooSlow: 'too_slow',
    Other: 'other'
} as const;

export type ChatUatFeedbackRequestReasonEnum = typeof ChatUatFeedbackRequestReasonEnum[keyof typeof ChatUatFeedbackRequestReasonEnum];

/**
 * 
 * @export
 * @interface ChatUatFeedbackResponse
 */
export interface ChatUatFeedbackResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackResponse
     */
    'feedbackId': string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUatFeedbackResponse
     */
    'accepted': ChatUatFeedbackResponseAcceptedEnum;
}

export const ChatUatFeedbackResponseAcceptedEnum = {
    True: true
} as const;

export type ChatUatFeedbackResponseAcceptedEnum = typeof ChatUatFeedbackResponseAcceptedEnum[keyof typeof ChatUatFeedbackResponseAcceptedEnum];

/**
 * 
 * @export
 * @interface ChatUatJobCompletedResponse
 */
export interface ChatUatJobCompletedResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobCompletedResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobCompletedResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobCompletedResponse
     */
    'status': ChatUatJobCompletedResponseStatusEnum;
    /**
     * 
     * @type {ChatUatResponse}
     * @memberof ChatUatJobCompletedResponse
     */
    'response': ChatUatResponse;
}

export const ChatUatJobCompletedResponseStatusEnum = {
    Completed: 'completed'
} as const;

export type ChatUatJobCompletedResponseStatusEnum = typeof ChatUatJobCompletedResponseStatusEnum[keyof typeof ChatUatJobCompletedResponseStatusEnum];

/**
 * 
 * @export
 * @interface ChatUatJobFailedResponse
 */
export interface ChatUatJobFailedResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobFailedResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobFailedResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobFailedResponse
     */
    'status': ChatUatJobFailedResponseStatusEnum;
    /**
     * Safe terminal error suitable for display
     * @type {string}
     * @memberof ChatUatJobFailedResponse
     */
    'error': string;
    /**
     * 
     * @type {ChatUatFailureCode}
     * @memberof ChatUatJobFailedResponse
     */
    'failureCode'?: ChatUatFailureCode;
}

export const ChatUatJobFailedResponseStatusEnum = {
    Failed: 'failed'
} as const;

export type ChatUatJobFailedResponseStatusEnum = typeof ChatUatJobFailedResponseStatusEnum[keyof typeof ChatUatJobFailedResponseStatusEnum];

/**
 * 
 * @export
 * @interface ChatUatJobPendingResponse
 */
export interface ChatUatJobPendingResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobPendingResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobPendingResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobPendingResponse
     */
    'status': ChatUatJobPendingResponseStatusEnum;
    /**
     * Minimum delay before the next status request
     * @type {number}
     * @memberof ChatUatJobPendingResponse
     */
    'retryAfterMs': number;
}

export const ChatUatJobPendingResponseStatusEnum = {
    Pending: 'pending',
    Running: 'running'
} as const;

export type ChatUatJobPendingResponseStatusEnum = typeof ChatUatJobPendingResponseStatusEnum[keyof typeof ChatUatJobPendingResponseStatusEnum];

/**
 * 
 * @export
 * @interface ChatUatJobRequest
 */
export interface ChatUatJobRequest {
    /**
     * Client-generated job key used for best-effort deduplication within the current AgentCore runtime process. A runtime replacement or restart can lose that state. After an ambiguous submission or a state_lost response, the original outcome may be unknown and the client must not automatically submit the POST again.
     * @type {string}
     * @memberof ChatUatJobRequest
     */
    'jobId': string;
    /**
     * The user\'s non-whitespace question
     * @type {string}
     * @memberof ChatUatJobRequest
     */
    'prompt': string;
    /**
     * Client-generated conversation id reused for status requests and subsequent turns. The backend binds it to the authenticated actor, and the agent rehydrates history from Memory. Do not automatically resubmit an ambiguously acknowledged or state-lost job.
     * @type {string}
     * @memberof ChatUatJobRequest
     */
    'conversationId': string;
    /**
     * 
     * @type {ChatUatAudience}
     * @memberof ChatUatJobRequest
     */
    'audience'?: ChatUatAudience;
    /**
     * 
     * @type {ChatUatContextReference}
     * @memberof ChatUatJobRequest
     */
    'context'?: ChatUatContextReference;
}
/**
 * @type ChatUatJobStartResponse
 * A pending, running, completed, or failed runtime-local job returned during submission.
 * @export
 */
export type ChatUatJobStartResponse = ChatUatJobCompletedResponse | ChatUatJobFailedResponse | ChatUatJobPendingResponse;

/**
 * 
 * @export
 * @interface ChatUatJobStateLostResponse
 */
export interface ChatUatJobStateLostResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobStateLostResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobStateLostResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobStateLostResponse
     */
    'status': ChatUatJobStateLostResponseStatusEnum;
    /**
     * Safe terminal uncertainty message. The original action outcome may be unknown, so clients must not automatically resubmit the job. Clients may continue the existing conversation.
     * @type {string}
     * @memberof ChatUatJobStateLostResponse
     */
    'error': string;
}

export const ChatUatJobStateLostResponseStatusEnum = {
    StateLost: 'state_lost'
} as const;

export type ChatUatJobStateLostResponseStatusEnum = typeof ChatUatJobStateLostResponseStatusEnum[keyof typeof ChatUatJobStateLostResponseStatusEnum];

/**
 * @type ChatUatJobStatusResponse
 * A pending, running, completed, failed, or state-lost background turn. Job state and deduplication are local to the AgentCore runtime process. If AgentCore replaces that runtime, state_lost is terminal uncertainty: the original outcome may be unknown, so clients must not automatically submit that job again. The conversation itself remains usable.
 * @export
 */
export type ChatUatJobStatusResponse = ChatUatJobCompletedResponse | ChatUatJobFailedResponse | ChatUatJobPendingResponse | ChatUatJobStateLostResponse;

/**
 * A non-review conversational turn, such as a request for a missing action input. It is not evidence of an action outcome.
 * @export
 * @interface ChatUatMessageResponse
 */
export interface ChatUatMessageResponse {
    /**
     * Echo of the conversation id to send on the next turn
     * @type {string}
     * @memberof ChatUatMessageResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatMessageResponse
     */
    'responseType': ChatUatMessageResponseResponseTypeEnum;
    /**
     * The text-only chat answer
     * @type {string}
     * @memberof ChatUatMessageResponse
     */
    'conversational': string;
}

export const ChatUatMessageResponseResponseTypeEnum = {
    Message: 'message'
} as const;

export type ChatUatMessageResponseResponseTypeEnum = typeof ChatUatMessageResponseResponseTypeEnum[keyof typeof ChatUatMessageResponseResponseTypeEnum];

/**
 * @type ChatUatResponse
 * A discriminated ChatUAT review, text-only message, or structured action outcome. The backend also enforces each variant at runtime.
 * @export
 */
export type ChatUatResponse = ChatUatActionResponse | ChatUatMessageResponse | ChatUatReviewResponse;

/**
 * 
 * @export
 * @interface ChatUatReviewResponse
 */
export interface ChatUatReviewResponse {
    /**
     * Echo of the conversation id to send on the next turn
     * @type {string}
     * @memberof ChatUatReviewResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatReviewResponse
     */
    'responseType': ChatUatReviewResponseResponseTypeEnum;
    /**
     * The chat answer text
     * @type {string}
     * @memberof ChatUatReviewResponse
     */
    'conversational': string;
    /**
     * The self-contained review block, present only for a review response
     * @type {string}
     * @memberof ChatUatReviewResponse
     */
    'artefact': string;
    /**
     * The evidence sources cited by a review response; present only for a review
     * @type {Set<string>}
     * @memberof ChatUatReviewResponse
     */
    'groundedIn': Set<ChatUatReviewResponseGroundedInEnum>;
}

export const ChatUatReviewResponseResponseTypeEnum = {
    Review: 'review'
} as const;

export type ChatUatReviewResponseResponseTypeEnum = typeof ChatUatReviewResponseResponseTypeEnum[keyof typeof ChatUatReviewResponseResponseTypeEnum];
export const ChatUatReviewResponseGroundedInEnum = {
    OrderData: 'order data',
    ClassificationDescription: 'classification description',
    CuratedKnowledge: 'curated knowledge'
} as const;

export type ChatUatReviewResponseGroundedInEnum = typeof ChatUatReviewResponseGroundedInEnum[keyof typeof ChatUatReviewResponseGroundedInEnum];

/**
 * 
 * @export
 * @interface ChatUatValidationJobResponse
 */
export interface ChatUatValidationJobResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationJobResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationJobResponse
     */
    'status': ChatUatValidationJobResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ChatUatValidationJobResponse
     */
    'retryAfterMs'?: number;
    /**
     * 
     * @type {ProjectValidationProgress}
     * @memberof ChatUatValidationJobResponse
     */
    'progress'?: ProjectValidationProgress;
    /**
     * 
     * @type {ProjectValidationResult}
     * @memberof ChatUatValidationJobResponse
     */
    'result'?: ProjectValidationResult;
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationJobResponse
     */
    'error'?: string;
}

export const ChatUatValidationJobResponseStatusEnum = {
    Pending: 'pending',
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed',
    StateLost: 'state_lost'
} as const;

export type ChatUatValidationJobResponseStatusEnum = typeof ChatUatValidationJobResponseStatusEnum[keyof typeof ChatUatValidationJobResponseStatusEnum];

/**
 * 
 * @export
 * @interface ChatUatValidationRun
 */
export interface ChatUatValidationRun {
    /**
     * 
     * @type {ProjectValidationRunSummary}
     * @memberof ChatUatValidationRun
     */
    'run': ProjectValidationRunSummary;
    /**
     * 
     * @type {Array<ProjectValidationCase>}
     * @memberof ChatUatValidationRun
     */
    'cases': Array<ProjectValidationCase>;
}
/**
 * 
 * @export
 * @interface ChatUatValidationStartRequest
 */
export interface ChatUatValidationStartRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationStartRequest
     */
    'jobId': string;
    /**
     * 
     * @type {ProjectValidationStage}
     * @memberof ChatUatValidationStartRequest
     */
    'stage': ProjectValidationStage;
    /**
     * 
     * @type {number}
     * @memberof ChatUatValidationStartRequest
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface ChatUatValidationState
 */
export interface ChatUatValidationState {
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationState
     */
    'schemaVersion': ChatUatValidationStateSchemaVersionEnum;
    /**
     * 
     * @type {number}
     * @memberof ChatUatValidationState
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationState
     */
    'updatedAt': string;
    /**
     * 
     * @type {AsanaLink}
     * @memberof ChatUatValidationState
     */
    'asanaLink'?: AsanaLink;
    /**
     * 
     * @type {ActiveProjectValidation}
     * @memberof ChatUatValidationState
     */
    'activeValidation'?: ActiveProjectValidation;
    /**
     * 
     * @type {ProjectValidationRunSummary}
     * @memberof ChatUatValidationState
     */
    'latestValidationRun'?: ProjectValidationRunSummary;
    /**
     * 
     * @type {Array<ProjectValidationRunSummary>}
     * @memberof ChatUatValidationState
     */
    'runs': Array<ProjectValidationRunSummary>;
}

export const ChatUatValidationStateSchemaVersionEnum = {
    _1: '1'
} as const;

export type ChatUatValidationStateSchemaVersionEnum = typeof ChatUatValidationStateSchemaVersionEnum[keyof typeof ChatUatValidationStateSchemaVersionEnum];

/**
 * 
 * @export
 * @interface ClassificationEntry
 */
export interface ClassificationEntry {
    /**
     * 
     * @type {string}
     * @memberof ClassificationEntry
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ClassificationEntry
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassificationEntry
     */
    'isFailure': boolean;
}
/**
 * 
 * @export
 * @interface CreateShadowTestRequest
 */
export interface CreateShadowTestRequest {
    /**
     * Marketplace code (e.g., US, ROW_NA)
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'marketplace': string;
    /**
     * GL Product Group ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'glProductGroupId': string;
    /**
     * List of transaction IDs to test
     * @type {Array<string>}
     * @memberof CreateShadowTestRequest
     */
    'transactionIds': Array<string>;
    /**
     * Country code (e.g., AR, US, PE)
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'countryCode': string;
    /**
     * Order date (ISO format)
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'orderDate'?: string;
    /**
     * Accounting Unique ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'auid'?: string;
    /**
     * Subscription ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'subscriptionId'?: string;
    /**
     * Subscription period number
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'periodNumber'?: string;
    /**
     * Delivery Packet Item ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'deliveryPacketItemId'?: string;
    /**
     * Digital Order ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'digitalOrderID'?: string;
    /**
     * Finance Tag Auth Reference ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'financeTagAuthReferenceId'?: string;
    /**
     * Return ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'returnID'?: string;
}
/**
 * 
 * @export
 * @interface DLQInfoResult
 */
export interface DLQInfoResult {
    /**
     * The status of the DLQ query (e.g., \"pending\", \"completed\", \"failed\")
     * @type {string}
     * @memberof DLQInfoResult
     */
    'status': string;
    /**
     * The ID of the query execution (present when status is \"pending\")
     * @type {string}
     * @memberof DLQInfoResult
     */
    'queryExecutionId'?: string;
    /**
     * Whether the order is in DLQ (present when status is \"completed\")
     * @type {boolean}
     * @memberof DLQInfoResult
     */
    'inDLQ'?: boolean;
    /**
     * The DLQ items (present when status is \"completed\" and inDLQ is true)
     * @type {Array<DLQItem>}
     * @memberof DLQInfoResult
     */
    'dlqItems'?: Array<DLQItem>;
    /**
     * 
     * @type {string}
     * @memberof DLQInfoResult
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface DLQItem
 */
export interface DLQItem {
    /**
     * The primary key of the DLQ item (use this for redrive operations)
     * @type {string}
     * @memberof DLQItem
     */
    'pk': string;
    /**
     * The name of the queue where the message failed
     * @type {string}
     * @memberof DLQItem
     */
    'eventsourcekey': string;
    /**
     * The timestamp when the message failed processing
     * @type {string}
     * @memberof DLQItem
     */
    'timestamp': string;
    /**
     * 
     * @type {DLQItemProcessedBody}
     * @memberof DLQItem
     */
    'processed_body': DLQItemProcessedBody;
    /**
     * Indicates whether the message is a raw string (true) or valid JSON object (false)
     * @type {boolean}
     * @memberof DLQItem
     */
    'is_malformed_json': boolean;
    /**
     * The type of the error that occurred during processing
     * @type {string}
     * @memberof DLQItem
     */
    'error_type': string;
    /**
     * The message of the error that occurred during processing
     * @type {string}
     * @memberof DLQItem
     */
    'error_message': string;
    /**
     * The stack trace of the error that occurred during processing
     * @type {string}
     * @memberof DLQItem
     */
    'error_stack_trace'?: string;
    /**
     * The SQS message ID (for reference only, not used for redrive)
     * @type {string}
     * @memberof DLQItem
     */
    'message_id'?: string;
    /**
     * True when this DLQ item is a message that the Lusca DLQ redriver previously requeued and that then failed again and returned to the DLQ (\"Returned after redrive\"). It is identified by the DLQ_REDRIVE_ jobId marker the redriver stamps on requeued messages. It is NOT set merely because a message appeared in a redrive manifest, and a message being absent from the DLQ is not proof that downstream processing succeeded.
     * @type {boolean}
     * @memberof DLQItem
     */
    'redrive_attempted'?: boolean;
    /**
     * Server-generated id of the latest redrive attempt that requeued this message (the redriveAttemptId of that execution, infrastructure prefix stripped). Null unless redrive_attempted is true.
     * @type {string}
     * @memberof DLQItem
     */
    'redrive_attempt_id'?: string | null;
}
/**
 * @type DLQItemProcessedBody
 * The message body, either as a raw string (if malformed) or parsed JSON object
 * @export
 */
export type DLQItemProcessedBody = string | { [key: string]: any; };

/**
 * 
 * @export
 * @interface DLQRedriveInfoResult
 */
export interface DLQRedriveInfoResult {
    /**
     * The status of the DLQ query (e.g., \"PENDING\", \"COMPLETED\", \"ERROR\")
     * @type {string}
     * @memberof DLQRedriveInfoResult
     */
    'status': string;
    /**
     * The ID of the redrive execution (present when status is \"PENDING\")
     * @type {string}
     * @memberof DLQRedriveInfoResult
     */
    'executionArn'?: string;
    /**
     * Server-generated id of this redrive attempt, returned when a real (non-dry-run) redrive or retry is started. Requeued messages carry it as their jobId marker, so a DLQ item whose redrive_attempt_id equals this value returned from this execution.
     * @type {string}
     * @memberof DLQRedriveInfoResult
     */
    'redriveAttemptId'?: string;
    /**
     * 
     * @type {DLQRedriveInfoResultResult}
     * @memberof DLQRedriveInfoResult
     */
    'result'?: DLQRedriveInfoResultResult;
    /**
     * 
     * @type {DLQRedriveInfoResultMetadata}
     * @memberof DLQRedriveInfoResult
     */
    'metadata'?: DLQRedriveInfoResultMetadata;
    /**
     * 
     * @type {string}
     * @memberof DLQRedriveInfoResult
     */
    'error'?: string;
}
/**
 * Execution metadata for the detail view (who/when/what was redriven)
 * @export
 * @interface DLQRedriveInfoResultMetadata
 */
export interface DLQRedriveInfoResultMetadata {
    /**
     * Alias of the user who started the redrive
     * @type {string}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'executor'?: string;
    /**
     * Epoch seconds when the redrive was started
     * @type {number}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'timestamp'?: number;
    /**
     * Whether the redrive was a dry run
     * @type {boolean}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'dryRun'?: boolean;
    /**
     * Whether the redrive was a delete-without-redrive deletion
     * @type {boolean}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'deleteWithoutRedriving'?: boolean;
    /**
     * MCM id supplied for a delete-without-redrive deletion
     * @type {string}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'mcmId'?: string;
    /**
     * Human-readable request type (\"Redrive\", \"Dry run\", \"Delete without redrive\")
     * @type {string}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'requestType'?: string;
    /**
     * Number of inline message ids, when provided inline
     * @type {number}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'messageCount'?: number;
    /**
     * S3 URI of the uploaded message-id file, when provided as a file
     * @type {string}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'messageIdsS3Uri'?: string;
    /**
     * Server-generated redrive attempt id of this execution; null for dry runs, which requeue nothing and are therefore not represented as attempts
     * @type {string}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'redriveAttemptId'?: string | null;
}
/**
 * 
 * @export
 * @interface DLQRedriveInfoResultResult
 */
export interface DLQRedriveInfoResultResult {
    /**
     * Mapping of messageId to status (SUCCESS, DRY_RUN, ERROR, NOT_FOUND)
     * @type {{ [key: string]: any; }}
     * @memberof DLQRedriveInfoResultResult
     */
    'redrivenMessages'?: { [key: string]: any; };
    /**
     * True when a large file redrive\'s per-row results were capped
     * @type {boolean}
     * @memberof DLQRedriveInfoResultResult
     */
    'truncated'?: boolean;
    /**
     * S3 prefix holding the full per-row results (present when truncated)
     * @type {string}
     * @memberof DLQRedriveInfoResultResult
     */
    'resultsS3Uri'?: string;
    /**
     * 
     * @type {DLQRedriveInfoResultResultCounts}
     * @memberof DLQRedriveInfoResultResult
     */
    'counts'?: DLQRedriveInfoResultResultCounts;
    /**
     * Error code from failed execution
     * @type {string}
     * @memberof DLQRedriveInfoResultResult
     */
    'error'?: string;
    /**
     * Detailed error message from failed execution
     * @type {string}
     * @memberof DLQRedriveInfoResultResult
     */
    'cause'?: string;
}
/**
 * Message-level totals (from the DistributedMap item counts) for a file redrive, present when resolvable
 * @export
 * @interface DLQRedriveInfoResultResultCounts
 */
export interface DLQRedriveInfoResultResultCounts {
    /**
     * Total messages the redrive attempted
     * @type {number}
     * @memberof DLQRedriveInfoResultResultCounts
     */
    'total'?: number;
    /**
     * Messages whose batch completed
     * @type {number}
     * @memberof DLQRedriveInfoResultResultCounts
     */
    'succeeded'?: number;
    /**
     * Messages in batches that failed, aborted or timed out
     * @type {number}
     * @memberof DLQRedriveInfoResultResultCounts
     */
    'failed'?: number;
    /**
     * Messages that never ran (skipped after the redrive failed)
     * @type {number}
     * @memberof DLQRedriveInfoResultResultCounts
     */
    'pending'?: number;
}
/**
 * 
 * @export
 * @interface DLQRedriveMcmError
 */
export interface DLQRedriveMcmError {
    /**
     * 
     * @type {string}
     * @memberof DLQRedriveMcmError
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof DLQRedriveMcmError
     */
    'details'?: string;
    /**
     * 
     * @type {string}
     * @memberof DLQRedriveMcmError
     */
    'requestId'?: string;
}
/**
 * 
 * @export
 * @interface DashboardEmbedResponse
 */
export interface DashboardEmbedResponse {
    /**
     * The URL for embedding the dashboard
     * @type {string}
     * @memberof DashboardEmbedResponse
     */
    'embedUrl': string;
    /**
     * The request ID for this embed URL generation
     * @type {string}
     * @memberof DashboardEmbedResponse
     */
    'requestId': string;
}
/**
 * 
 * @export
 * @interface DayCount
 */
export interface DayCount {
    /**
     * UTC calendar day, YYYY-MM-DD
     * @type {string}
     * @memberof DayCount
     */
    'day'?: string;
    /**
     * 
     * @type {number}
     * @memberof DayCount
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface DetailsResponse
 */
export interface DetailsResponse {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof DetailsResponse
     */
    'events'?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof DetailsResponse
     */
    'cbes'?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {DetailsResponseFallback}
     * @memberof DetailsResponse
     */
    'fallback'?: DetailsResponseFallback;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailsResponse
     */
    'auids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DetailsResponseFallback
 */
export interface DetailsResponseFallback {
    /**
     * 
     * @type {string}
     * @memberof DetailsResponseFallback
     */
    'originalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailsResponseFallback
     */
    'resolvedId'?: string;
}
/**
 * 
 * @export
 * @interface DigitalPaymentDocument
 */
export interface DigitalPaymentDocument {
    /**
     * The top-level document ID
     * @type {string}
     * @memberof DigitalPaymentDocument
     */
    'id': string;
    /**
     * The top-level document version
     * @type {number}
     * @memberof DigitalPaymentDocument
     */
    'version': number;
    /**
     * Discriminator identifying this as a DigitalPaymentDocument
     * @type {string}
     * @memberof DigitalPaymentDocument
     */
    'documentType': DigitalPaymentDocumentDocumentTypeEnum;
    /**
     * 
     * @type {DigitalPaymentDocumentBody}
     * @memberof DigitalPaymentDocument
     */
    'body': DigitalPaymentDocumentBody;
}

export const DigitalPaymentDocumentDocumentTypeEnum = {
    DigitalPaymentDocument: 'DigitalPaymentDocument'
} as const;

export type DigitalPaymentDocumentDocumentTypeEnum = typeof DigitalPaymentDocumentDocumentTypeEnum[keyof typeof DigitalPaymentDocumentDocumentTypeEnum];

/**
 * 
 * @export
 * @interface DigitalPaymentDocumentBody
 */
export interface DigitalPaymentDocumentBody {
    /**
     * 
     * @type {DigitalPaymentDocumentHeader}
     * @memberof DigitalPaymentDocumentBody
     */
    'header': DigitalPaymentDocumentHeader;
    /**
     * 
     * @type {DigitalPaymentDocumentBody}
     * @memberof DigitalPaymentDocumentBody
     */
    'body': DigitalPaymentDocumentBody;
    /**
     * 
     * @type {DigitalPaymentDocumentMetadata}
     * @memberof DigitalPaymentDocumentBody
     */
    'metadata': DigitalPaymentDocumentMetadata;
}
/**
 * 
 * @export
 * @interface DigitalPaymentDocumentHeader
 */
export interface DigitalPaymentDocumentHeader {
    /**
     * The document ID
     * @type {string}
     * @memberof DigitalPaymentDocumentHeader
     */
    'id'?: string;
    /**
     * The document version
     * @type {number}
     * @memberof DigitalPaymentDocumentHeader
     */
    'version'?: number;
    /**
     * The marketplace ID
     * @type {string}
     * @memberof DigitalPaymentDocumentHeader
     */
    'marketplaceId'?: string;
    /**
     * The transaction date
     * @type {string}
     * @memberof DigitalPaymentDocumentHeader
     */
    'transactionDate'?: string;
}
/**
 * 
 * @export
 * @interface DigitalPaymentDocumentMetadata
 */
export interface DigitalPaymentDocumentMetadata {
    /**
     * Additional attributes map
     * @type {{ [key: string]: string; }}
     * @memberof DigitalPaymentDocumentMetadata
     */
    'attributes'?: { [key: string]: string; };
    /**
     * Events map
     * @type {{ [key: string]: any; }}
     * @memberof DigitalPaymentDocumentMetadata
     */
    'events'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface DlqSizeHistory
 */
export interface DlqSizeHistory {
    /**
     * 
     * @type {Stage}
     * @memberof DlqSizeHistory
     */
    'stage': Stage;
    /**
     * The DLQ DynamoDB table the metric describes
     * @type {string}
     * @memberof DlqSizeHistory
     */
    'tableName': string;
    /**
     * Width of one point (3600 or 86400)
     * @type {number}
     * @memberof DlqSizeHistory
     */
    'periodSeconds': number;
    /**
     * 
     * @type {Array<DlqSizePoint>}
     * @memberof DlqSizeHistory
     */
    'points': Array<DlqSizePoint>;
    /**
     * Per-snapshot totals within the window, oldest first (empty until recorded)
     * @type {Array<DlqSnapshotPoint>}
     * @memberof DlqSizeHistory
     */
    'snapshots'?: Array<DlqSnapshotPoint>;
}
/**
 * 
 * @export
 * @interface DlqSizePoint
 */
export interface DlqSizePoint {
    /**
     * Start of the period (ISO 8601 UTC)
     * @type {string}
     * @memberof DlqSizePoint
     */
    't': string;
    /**
     * Items in the DLQ table (the period\'s maximum ItemCount)
     * @type {number}
     * @memberof DlqSizePoint
     */
    'n': number;
}
/**
 * 
 * @export
 * @interface DlqSnapshotPoint
 */
export interface DlqSnapshotPoint {
    /**
     * Snapshot time (ISO 8601 UTC), when the Glue job captured the DLQ
     * @type {string}
     * @memberof DlqSnapshotPoint
     */
    't': string;
    /**
     * Items in the snapshot
     * @type {number}
     * @memberof DlqSnapshotPoint
     */
    'items': number;
    /**
     * Summed financial impact (USD) of every item in the snapshot
     * @type {number}
     * @memberof DlqSnapshotPoint
     */
    'impactUsd'?: number;
    /**
     * Items no active investigation owned at that reconcile
     * @type {number}
     * @memberof DlqSnapshotPoint
     */
    'unassignedItems'?: number;
    /**
     * Summed financial impact (USD) of the unassigned items
     * @type {number}
     * @memberof DlqSnapshotPoint
     */
    'unassignedImpactUsd'?: number;
}
/**
 * 
 * @export
 * @interface DownloadS3FileResponse
 */
export interface DownloadS3FileResponse {
    /**
     * Pre-Signed url for S3 file
     * @type {string}
     * @memberof DownloadS3FileResponse
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ErrorCategorySource
 */
export interface ErrorCategorySource {
    /**
     * 
     * @type {string}
     * @memberof ErrorCategorySource
     */
    'category': string;
    /**
     * CR id from the commit\'s `cr:` trailer (CR-123), absent if the commit has none
     * @type {string}
     * @memberof ErrorCategorySource
     */
    'cr'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCategorySource
     */
    'crUrl'?: string;
    /**
     * SHA1 of the first commit that added the category\'s rule
     * @type {string}
     * @memberof ErrorCategorySource
     */
    'commit': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCategorySource
     */
    'commitUrl': string;
    /**
     * Commit subject
     * @type {string}
     * @memberof ErrorCategorySource
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCategorySource
     */
    'author'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorCategorySource
     */
    'date'?: string;
    /**
     * The commit moved existing rules into code, so it is not where the category was first created
     * @type {boolean}
     * @memberof ErrorCategorySource
     */
    'migrated': boolean;
    /**
     * False when the rule has since been removed from the Glue job
     * @type {boolean}
     * @memberof ErrorCategorySource
     */
    'inCode': boolean;
}
/**
 * 
 * @export
 * @interface ErrorCategorySourcesResult
 */
export interface ErrorCategorySourcesResult {
    /**
     * False until the category-source task has written its first result
     * @type {boolean}
     * @memberof ErrorCategorySourcesResult
     */
    'available': boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorCategorySourcesResult
     */
    'generatedAt'?: string;
    /**
     * Package whose history was read (PVAccountingCDK)
     * @type {string}
     * @memberof ErrorCategorySourcesResult
     */
    'package'?: string;
    /**
     * File whose history was read
     * @type {string}
     * @memberof ErrorCategorySourcesResult
     */
    'path'?: string;
    /**
     * 
     * @type {Array<ErrorCategorySource>}
     * @memberof ErrorCategorySourcesResult
     */
    'categories': Array<ErrorCategorySource>;
}
/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface FinancialAmountRow
 */
export interface FinancialAmountRow {
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'sourceAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'sourceCurr'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'gammaUslAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'gammaUslCurr'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'prodUslAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'prodUslCurr'?: string;
}
/**
 * 
 * @export
 * @interface GetDLQRedriveUploadUrl200Response
 */
export interface GetDLQRedriveUploadUrl200Response {
    /**
     * Presigned URL for file upload
     * @type {string}
     * @memberof GetDLQRedriveUploadUrl200Response
     */
    'uploadUrl'?: string;
    /**
     * S3 URI of the file after upload
     * @type {string}
     * @memberof GetDLQRedriveUploadUrl200Response
     */
    's3Uri'?: string;
}
/**
 * 
 * @export
 * @interface GetDLQRedrivesInfo200ResponseInner
 */
export interface GetDLQRedrivesInfo200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetDLQRedrivesInfo200ResponseInner
     */
    'executionArn': string;
    /**
     * 
     * @type {string}
     * @memberof GetDLQRedrivesInfo200ResponseInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetDLQRedrivesInfo200ResponseInner
     */
    'startDate': string;
}
/**
 * 
 * @export
 * @interface GetPsnsRedriveUploadUrl200Response
 */
export interface GetPsnsRedriveUploadUrl200Response {
    /**
     * Presigned URL for NDJSON file upload
     * @type {string}
     * @memberof GetPsnsRedriveUploadUrl200Response
     */
    'uploadUrl'?: string;
    /**
     * S3 URI of the file after upload
     * @type {string}
     * @memberof GetPsnsRedriveUploadUrl200Response
     */
    's3Uri'?: string;
}
/**
 * 
 * @export
 * @interface GetRedriveInfo200Response
 */
export interface GetRedriveInfo200Response {
    /**
     * 
     * @type {Array<GetRedriveInfo200ResponseExecutionsInner>}
     * @memberof GetRedriveInfo200Response
     */
    'executions'?: Array<GetRedriveInfo200ResponseExecutionsInner>;
}
/**
 * 
 * @export
 * @interface GetRedriveInfo200ResponseExecutionsInner
 */
export interface GetRedriveInfo200ResponseExecutionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'executionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'stage'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'orders'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'executor'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'timestamp'?: number;
}
/**
 * 
 * @export
 * @interface GetRedriveOrders200Response
 */
export interface GetRedriveOrders200Response {
    /**
     * Presigned URL to download the orders CSV file
     * @type {string}
     * @memberof GetRedriveOrders200Response
     */
    'downloadUrl'?: string;
    /**
     * User who executed the redrive
     * @type {string}
     * @memberof GetRedriveOrders200Response
     */
    'executor'?: string;
    /**
     * Execution status of the redrive
     * @type {string}
     * @memberof GetRedriveOrders200Response
     */
    'status'?: string;
    /**
     * Epoch seconds when the redrive was requested
     * @type {number}
     * @memberof GetRedriveOrders200Response
     */
    'timestamp'?: number;
    /**
     * Number of orders in the redrive
     * @type {number}
     * @memberof GetRedriveOrders200Response
     */
    'orders'?: number;
}
/**
 * 
 * @export
 * @interface HerdErrorDetail
 */
export interface HerdErrorDetail {
    /**
     * 
     * @type {string}
     * @memberof HerdErrorDetail
     */
    'stackTrace'?: string;
}
/**
 * 
 * @export
 * @interface ImportTrackStarsReportRequest
 */
export interface ImportTrackStarsReportRequest {
    /**
     * TrackStars report (metadata.report_id, executive_summary, pattern_analysis[], recommendations[]).
     * @type {{ [key: string]: any; }}
     * @memberof ImportTrackStarsReportRequest
     */
    'report': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface Investigation
 */
export interface Investigation {
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'id': string;
    /**
     * 
     * @type {Stage}
     * @memberof Investigation
     */
    'stage': Stage;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'title': string;
    /**
     * Who chose the title — the builder\'s suggestion, a person, or a TrackStars run.
     * @type {string}
     * @memberof Investigation
     */
    'titleSource'?: InvestigationTitleSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'description'?: string;
    /**
     * 
     * @type {InvestigationStatus}
     * @memberof Investigation
     */
    'status': InvestigationStatus;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'owner'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Investigation
     */
    'contributors'?: Array<string>;
    /**
     * Aliases following the investigation (see followInvestigation); visible to everyone
     * @type {Array<string>}
     * @memberof Investigation
     */
    'followers'?: Array<string>;
    /**
     * 
     * @type {InvestigationMyReminder}
     * @memberof Investigation
     */
    'myReminder'?: InvestigationMyReminder;
    /**
     * Conjunction of predicates describing the live population (one rule branch): every field pinned must match (an `in` field matches any of its values).
     * @type {Array<InvestigationPredicate>}
     * @memberof Investigation
     */
    'rule'?: Array<InvestigationPredicate>;
    /**
     * Disjunction of rule branches: an item belongs to the population when ANY branch matches. Unmerged investigations have exactly one branch (identical to `rule`); merging appends the source rules as further branches.
     * @type {Array<Array<InvestigationPredicate>>}
     * @memberof Investigation
     */
    'rules'?: Array<Array<InvestigationPredicate>>;
    /**
     * 
     * @type {InvestigationPopulation}
     * @memberof Investigation
     */
    'population'?: InvestigationPopulation;
    /**
     * 
     * @type {number}
     * @memberof Investigation
     */
    'assignedCount'?: number;
    /**
     * Deprecated — always 0 since overlap ownership became narrowest-rule-then-oldest-case (no AMBIGUOUS items); kept for compatibility, will be removed.
     * @type {number}
     * @memberof Investigation
     * @deprecated
     */
    'ambiguousCount'?: number;
    /**
     * 
     * @type {InvestigationAssignment}
     * @memberof Investigation
     */
    'assignment'?: InvestigationAssignment;
    /**
     * 
     * @type {InvestigationConclusion}
     * @memberof Investigation
     */
    'conclusion'?: InvestigationConclusion;
    /**
     * Evidence links backing the conclusion
     * @type {Array<InvestigationLink>}
     * @memberof Investigation
     */
    'links'?: Array<InvestigationLink>;
    /**
     * 
     * @type {InvestigationTask}
     * @memberof Investigation
     */
    'task'?: InvestigationTask;
    /**
     * Taskei room the \"Create task\" deep link targets (server configuration). Absent when the deployment has no room configured; the UI then hides the create action.
     * @type {string}
     * @memberof Investigation
     */
    'taskeiRoomId'?: string;
    /**
     * Taskei epic new tasks are parented under (server configuration, e.g. TRACK-11243 \"[Lusca] DLQ Investigations\"). Absent when not configured.
     * @type {string}
     * @memberof Investigation
     */
    'taskeiParentTaskId'?: string;
    /**
     * True when the backend creates and updates the Taskei task itself (worker sync). The UI then waits for `task` to appear instead of offering the manual \"Create task\" deep link.
     * @type {boolean}
     * @memberof Investigation
     */
    'taskeiSyncEnabled'?: boolean;
    /**
     * 
     * @type {InvestigationTaskSync}
     * @memberof Investigation
     */
    'taskSync'?: InvestigationTaskSync;
    /**
     * 
     * @type {InvestigationTaskDrift}
     * @memberof Investigation
     */
    'taskDrift'?: InvestigationTaskDrift;
    /**
     * 
     * @type {InvestigationBlocker}
     * @memberof Investigation
     */
    'blocker'?: InvestigationBlocker;
    /**
     * 
     * @type {InvestigationResolution}
     * @memberof Investigation
     */
    'resolution'?: InvestigationResolution;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'parentInvestigationId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Investigation
     */
    'childInvestigationIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Investigation
     */
    'linkedInvestigationIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'recurrenceOfInvestigationId'?: string;
    /**
     * Investigations absorbed into this one (survivor side)
     * @type {Array<string>}
     * @memberof Investigation
     */
    'mergedFromInvestigationIds'?: Array<string>;
    /**
     * Set on a source closed by a merge; the case is read-only and cannot be reopened
     * @type {string}
     * @memberof Investigation
     */
    'mergedIntoInvestigationId'?: string;
    /**
     * Set by Lusca when the population claim won no items because this active investigation already owned all of them. The case is closed (RESOLVED, reason DUPLICATE) and cannot be reopened; work on the referenced investigation instead.
     * @type {string}
     * @memberof Investigation
     */
    'duplicateOfInvestigationId'?: string;
    /**
     * 
     * @type {InvestigationMergePending}
     * @memberof Investigation
     */
    'mergePending'?: InvestigationMergePending;
    /**
     * 
     * @type {InvestigationCategoryScope}
     * @memberof Investigation
     */
    'categoryScope'?: InvestigationCategoryScope;
    /**
     * 
     * @type {InvestigationOrigin}
     * @memberof Investigation
     */
    'origin'?: InvestigationOrigin;
    /**
     * 
     * @type {InvestigationTrackStarsRun}
     * @memberof Investigation
     */
    'trackstarsRun'?: InvestigationTrackStarsRun;
    /**
     * 
     * @type {number}
     * @memberof Investigation
     */
    'redriveAttemptCount'?: number;
    /**
     * Document redrives launched from this investigation
     * @type {number}
     * @memberof Investigation
     */
    'documentRedriveCount'?: number;
    /**
     * 
     * @type {InvestigationDocumentRedriveState}
     * @memberof Investigation
     */
    'documentRedrive'?: InvestigationDocumentRedriveState;
    /**
     * external — this deployment cannot redrive the stage (Prod from a non-prod Lusca Search); redrives are run in Lusca Search Prod (externalRedriveUrl) and linked back.
     * @type {string}
     * @memberof Investigation
     */
    'redriveMode'?: InvestigationRedriveModeEnum;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'externalRedriveUrl'?: string;
    /**
     * True when this deployment can block a case on a CR (blocker.codeReview). The UI hides the CR field otherwise.
     * @type {boolean}
     * @memberof Investigation
     */
    'codeReviewTracking'?: boolean;
    /**
     * 
     * @type {InvestigationRedriveSummary}
     * @memberof Investigation
     */
    'latestRedrive'?: InvestigationRedriveSummary;
    /**
     * 
     * @type {InvestigationPendingDeletion}
     * @memberof Investigation
     */
    'pendingDeletion'?: InvestigationPendingDeletion;
    /**
     * 
     * @type {number}
     * @memberof Investigation
     */
    'returnedCount'?: number;
    /**
     * New-error returns released by the owner (or found no longer held here).
     * @type {number}
     * @memberof Investigation
     */
    'returnedReleasedCount'?: number;
    /**
     * 
     * @type {Array<InvestigationNotification>}
     * @memberof Investigation
     */
    'notifications'?: Array<InvestigationNotification>;
    /**
     * 
     * @type {number}
     * @memberof Investigation
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'updatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'lastHumanActivityAt'?: string;
    /**
     * Rows matched by the live rule in the latest reconciled snapshot
     * @type {number}
     * @memberof Investigation
     */
    'liveMatchCount'?: number;
    /**
     * Summed estimated financial impact (USD) of the items this investigation owns in the latest reconciled snapshot. Exact for cases reconciled item-by-item; for oversized cases it is the group-level total of every group the rule matches. Absent until the first reconciliation after the case is created.
     * @type {number}
     * @memberof Investigation
     */
    'impactUsd'?: number | null;
    /**
     * True when the live rule matches more rows than the reconciliation can assign exactly; narrow the rule
     * @type {boolean}
     * @memberof Investigation
     */
    'populationOversized'?: boolean;
    /**
     * Population size per reconciled DLQ snapshot, oldest first: every snapshot of the last 48 hours, then the last one of each day for 90 days. Absent until the first reconciliation after the case is created; frozen once the case is closed.
     * @type {Array<InvestigationTrendPoint>}
     * @memberof Investigation
     */
    'trend'?: Array<InvestigationTrendPoint>;
    /**
     * Events that explain bends in the trend (split, merge, redrive, fix in progress, resolved), oldest first, at most 50. Recorded when the event is committed.
     * @type {Array<InvestigationTrendMarker>}
     * @memberof Investigation
     */
    'trendMarkers'?: Array<InvestigationTrendMarker>;
    /**
     * 
     * @type {InvestigationPendingRefresh}
     * @memberof Investigation
     */
    'pendingRefresh'?: InvestigationPendingRefresh;
    /**
     * 
     * @type {boolean}
     * @memberof Investigation
     */
    'isStale'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Investigation
     */
    'staleAfterHours'?: number;
}

export const InvestigationTitleSourceEnum = {
    System: 'system',
    User: 'user',
    Trackstars: 'trackstars'
} as const;

export type InvestigationTitleSourceEnum = typeof InvestigationTitleSourceEnum[keyof typeof InvestigationTitleSourceEnum];
export const InvestigationRedriveModeEnum = {
    Direct: 'direct',
    External: 'external'
} as const;

export type InvestigationRedriveModeEnum = typeof InvestigationRedriveModeEnum[keyof typeof InvestigationRedriveModeEnum];

/**
 * The case an activity event belongs to, as it is now.
 * @export
 * @interface InvestigationActivityCase
 */
export interface InvestigationActivityCase {
    /**
     * 
     * @type {string}
     * @memberof InvestigationActivityCase
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationActivityCase
     */
    'title'?: string;
    /**
     * 
     * @type {InvestigationStatus}
     * @memberof InvestigationActivityCase
     */
    'status'?: InvestigationStatus;
    /**
     * 
     * @type {string}
     * @memberof InvestigationActivityCase
     */
    'owner'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationActivityPage
 */
export interface InvestigationActivityPage {
    /**
     * 
     * @type {Array<InvestigationEvent>}
     * @memberof InvestigationActivityPage
     */
    'events': Array<InvestigationEvent>;
    /**
     * Summary of every case referenced by `events`, keyed by investigation id.
     * @type {{ [key: string]: InvestigationActivityCase; }}
     * @memberof InvestigationActivityPage
     */
    'investigations': { [key: string]: InvestigationActivityCase; };
    /**
     * 
     * @type {string}
     * @memberof InvestigationActivityPage
     */
    'nextToken'?: string;
}
/**
 * What Lusca does once the blocking CR is deployed to the case\'s stage. NONE moves the case back to blocker.blockedFrom. DOCUMENT_REDRIVE and DLQ_REDRIVE move it to READY_TO_REDRIVE and launch that redrive as the owner who queued it.
 * @export
 * @enum {string}
 */

export const InvestigationAfterDeploy = {
    None: 'NONE',
    DocumentRedrive: 'DOCUMENT_REDRIVE',
    DlqRedrive: 'DLQ_REDRIVE'
} as const;

export type InvestigationAfterDeploy = typeof InvestigationAfterDeploy[keyof typeof InvestigationAfterDeploy];

/**
 * 
 * @export
 * @interface InvestigationAgentPrompt
 */
export interface InvestigationAgentPrompt {
    /**
     * 
     * @type {string}
     * @memberof InvestigationAgentPrompt
     */
    'investigationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAgentPrompt
     */
    'prompt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAgentPrompt
     */
    'generatedAt'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationAssigneesResult
 */
export interface InvestigationAssigneesResult {
    /**
     * Sorted, lower-case aliases permitted to use Lusca Search
     * @type {Array<string>}
     * @memberof InvestigationAssigneesResult
     */
    'aliases': Array<string>;
    /**
     * Where the list came from (bindle-lock)
     * @type {string}
     * @memberof InvestigationAssigneesResult
     */
    'source'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationAssignment
 */
export interface InvestigationAssignment {
    /**
     * RELEASE_AFTER_SNAPSHOT: resolved by a delete-without-redrive the run confirmed; its items stay owned until a DLQ snapshot taken after the delete (releaseAfter), then RELEASED.
     * @type {string}
     * @memberof InvestigationAssignment
     */
    'status'?: InvestigationAssignmentStatusEnum;
    /**
     * When the delete finished (RELEASE_AFTER_SNAPSHOT only).
     * @type {string}
     * @memberof InvestigationAssignment
     */
    'releaseAfter'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationAssignment
     */
    'requestedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationAssignment
     */
    'assignedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationAssignment
     */
    'overlappingCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationAssignment
     */
    'conflictedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationAssignment
     */
    'releasedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAssignment
     */
    'completedAt'?: string;
}

export const InvestigationAssignmentStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Releasing: 'RELEASING',
    Released: 'RELEASED',
    ReleaseAfterSnapshot: 'RELEASE_AFTER_SNAPSHOT'
} as const;

export type InvestigationAssignmentStatusEnum = typeof InvestigationAssignmentStatusEnum[keyof typeof InvestigationAssignmentStatusEnum];

/**
 * 
 * @export
 * @interface InvestigationAttachment
 */
export interface InvestigationAttachment {
    /**
     * S3 key under investigations/<id>/artifacts/ (the only field needed on input)
     * @type {string}
     * @memberof InvestigationAttachment
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachment
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachment
     */
    'contentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationAttachment
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachment
     */
    'uploadedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachment
     */
    'uploadedAt'?: string;
    /**
     * Presigned download URL (responses only; valid for an hour)
     * @type {string}
     * @memberof InvestigationAttachment
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachment
     */
    'urlExpiresAt'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationAttachmentUpload
 */
export interface InvestigationAttachmentUpload {
    /**
     * Send this in `attachments` of a comment or conclusion once uploaded
     * @type {string}
     * @memberof InvestigationAttachmentUpload
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachmentUpload
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachmentUpload
     */
    'contentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationAttachmentUpload
     */
    'maxBytes'?: number;
    /**
     * 
     * @type {InvestigationAttachmentUploadPost}
     * @memberof InvestigationAttachmentUpload
     */
    'post'?: InvestigationAttachmentUploadPost;
    /**
     * Presigned PUT (send Content-Type matching contentType)
     * @type {string}
     * @memberof InvestigationAttachmentUpload
     */
    'uploadUrl': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachmentUpload
     */
    's3Uri'?: string;
}
/**
 * Presigned POST (size-limited by S3); preferred for browsers
 * @export
 * @interface InvestigationAttachmentUploadPost
 */
export interface InvestigationAttachmentUploadPost {
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachmentUploadPost
     */
    'url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof InvestigationAttachmentUploadPost
     */
    'fields': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface InvestigationAttachmentUploadRequest
 */
export interface InvestigationAttachmentUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachmentUploadRequest
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationAttachmentUploadRequest
     */
    'contentType'?: string;
    /**
     * File size in bytes; checked against the limit before a URL is issued
     * @type {number}
     * @memberof InvestigationAttachmentUploadRequest
     */
    'size'?: number;
}
/**
 * REDRIVE requeues the manifest; DELETE removes it without redriving under an approved MCM; DOCUMENT_REDRIVE re-processes the manifest\'s transactions through the order redrive (the DLQ is untouched).
 * @export
 * @enum {string}
 */

export const InvestigationAttemptKind = {
    Redrive: 'REDRIVE',
    Delete: 'DELETE',
    DocumentRedrive: 'DOCUMENT_REDRIVE'
} as const;

export type InvestigationAttemptKind = typeof InvestigationAttemptKind[keyof typeof InvestigationAttemptKind];

/**
 * 
 * @export
 * @interface InvestigationBlocker
 */
export interface InvestigationBlocker {
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlocker
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlocker
     */
    'link'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlocker
     */
    'nextReviewDate'?: string;
    /**
     * Status the investigation was in when it was blocked; set by Lusca, ignored on input.
     * @type {string}
     * @memberof InvestigationBlocker
     */
    'blockedFrom'?: string;
    /**
     * Set by Lusca when the investigation leaves BLOCKED without replacing the blocker.
     * @type {string}
     * @memberof InvestigationBlocker
     */
    'clearedAt'?: string;
    /**
     * 
     * @type {InvestigationBlockerCodeReview}
     * @memberof InvestigationBlocker
     */
    'codeReview'?: InvestigationBlockerCodeReview;
}
/**
 * The CR the case waits on. Only id and afterDeploy are read from requests; every other field is set by Lusca and ignored on input. Changing the id resets the tracking.
 * @export
 * @interface InvestigationBlockerCodeReview
 */
export interface InvestigationBlockerCodeReview {
    /**
     * CR-<n>. A https://code.amazon.com/reviews/CR-<n> URL is accepted and normalised.
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'id': string;
    /**
     * 
     * @type {InvestigationAfterDeploy}
     * @memberof InvestigationBlockerCodeReview
     */
    'afterDeploy'?: InvestigationAfterDeploy;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'addedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'addedAt'?: string;
    /**
     * The PVAccounting deployment group Lusca watches, e.g. us-west-2:4046629:prod.
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'target'?: string;
    /**
     * 
     * @type {InvestigationCodeReviewState}
     * @memberof InvestigationBlockerCodeReview
     */
    'state'?: InvestigationCodeReviewState;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'stateReason'?: string;
    /**
     * The CR revision that shipped.
     * @type {number}
     * @memberof InvestigationBlockerCodeReview
     */
    'revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'revisionCreatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'mergedAt'?: string;
    /**
     * Merged commit SHAs from CriticService, rebased and squashed ones included.
     * @type {Array<string>}
     * @memberof InvestigationBlockerCodeReview
     */
    'commits'?: Array<string>;
    /**
     * The CR\'s packages that the PVAccounting pipeline builds.
     * @type {Array<InvestigationCodeReviewPackage>}
     * @memberof InvestigationBlockerCodeReview
     */
    'packages'?: Array<InvestigationCodeReviewPackage>;
    /**
     * The CR\'s packages that the PVAccounting pipeline does not build.
     * @type {Array<string>}
     * @memberof InvestigationBlockerCodeReview
     */
    'ignoredPackages'?: Array<string>;
    /**
     * 
     * @type {InvestigationBlockerCodeReviewBaselineRevision}
     * @memberof InvestigationBlockerCodeReview
     */
    'baselineRevision'?: InvestigationBlockerCodeReviewBaselineRevision;
    /**
     * 
     * @type {InvestigationBlockerCodeReviewBaselineRevision}
     * @memberof InvestigationBlockerCodeReview
     */
    'checkedRevision'?: InvestigationBlockerCodeReviewBaselineRevision;
    /**
     * 
     * @type {InvestigationBlockerCodeReviewBaselineRevision}
     * @memberof InvestigationBlockerCodeReview
     */
    'versionSetRevision'?: InvestigationBlockerCodeReviewBaselineRevision;
    /**
     * How Lusca found the CR\'s commits: from CriticService, or (until CriticService onboarding) from the `cr:` line CRUX writes into every commit it merges, searched in the PVAccounting version set\'s history (versionSetRevision is the newest revision searched).
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'source'?: InvestigationBlockerCodeReviewSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'deployedAt'?: string;
    /**
     * The version set revision deployed to the stage when the CR was found there.
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'deployedRevision'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'lastCheckedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'queuedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'queuedAt'?: string;
    /**
     * assignedCount when the redrive was queued; a move of more than 20% skips it.
     * @type {number}
     * @memberof InvestigationBlockerCodeReview
     */
    'queuedItemCount'?: number;
    /**
     * 
     * @type {InvestigationCodeReviewOutcome}
     * @memberof InvestigationBlockerCodeReview
     */
    'outcome'?: InvestigationCodeReviewOutcome;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'outcomeReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReview
     */
    'redriveAttemptId'?: string;
}

export const InvestigationBlockerCodeReviewSourceEnum = {
    CriticService: 'CRITIC_SERVICE',
    CommitMessages: 'COMMIT_MESSAGES'
} as const;

export type InvestigationBlockerCodeReviewSourceEnum = typeof InvestigationBlockerCodeReviewSourceEnum[keyof typeof InvestigationBlockerCodeReviewSourceEnum];

/**
 * 
 * @export
 * @interface InvestigationBlockerCodeReviewBaselineRevision
 */
export interface InvestigationBlockerCodeReviewBaselineRevision {
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReviewBaselineRevision
     */
    'revision'?: string;
    /**
     * The version set revision, e.g. PVAccounting/development@B6524559840.
     * @type {string}
     * @memberof InvestigationBlockerCodeReviewBaselineRevision
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationBlockerCodeReviewBaselineRevision
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationCaseReminderRequest
 */
export interface InvestigationCaseReminderRequest {
    /**
     * When to remind, ISO 8601 with a zone, 5 minutes to 7 days from now
     * @type {string}
     * @memberof InvestigationCaseReminderRequest
     */
    'remindAt': string;
}
/**
 * Present when the case was created from an `error_category = uncategorized` rule. The stored `rule` drops that pin (it would stop matching once the categoriser names the pattern) and excludes `excludedCategories` — categories the pattern already carried at creation — instead. UIs show the rule as the creator picked it.
 * @export
 * @interface InvestigationCategoryScope
 */
export interface InvestigationCategoryScope {
    /**
     * The category value the creator picked (always \"uncategorized\")
     * @type {string}
     * @memberof InvestigationCategoryScope
     */
    'selected': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationCategoryScope
     */
    'excludedCategories': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InvestigationCodeReviewOutcome = {
    Unblocked: 'UNBLOCKED',
    RedriveLaunched: 'REDRIVE_LAUNCHED',
    RedriveNotRun: 'REDRIVE_NOT_RUN'
} as const;

export type InvestigationCodeReviewOutcome = typeof InvestigationCodeReviewOutcome[keyof typeof InvestigationCodeReviewOutcome];

/**
 * 
 * @export
 * @interface InvestigationCodeReviewPackage
 */
export interface InvestigationCodeReviewPackage {
    /**
     * 
     * @type {string}
     * @memberof InvestigationCodeReviewPackage
     */
    'name': string;
    /**
     * The CR\'s merged commit found in the revision deployed to the stage.
     * @type {string}
     * @memberof InvestigationCodeReviewPackage
     */
    'commit'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationCodeReviewPackage
     */
    'deployedAt'?: string;
}
/**
 * CHECKING until Lusca has read the CR. WAITING_FOR_MERGE while it is open. MERGED once it shipped and Lusca is waiting for the deployment. DEPLOYED when it reached the stage and Lusca acted. DISCARDED and INVALID carry a stateReason; the case stays BLOCKED. A CR that is already deployed to the stage is refused when it is attached (409 CODE_REVIEW_ALREADY_DEPLOYED).
 * @export
 * @enum {string}
 */

export const InvestigationCodeReviewState = {
    Checking: 'CHECKING',
    WaitingForMerge: 'WAITING_FOR_MERGE',
    Merged: 'MERGED',
    Deployed: 'DEPLOYED',
    Discarded: 'DISCARDED',
    Invalid: 'INVALID'
} as const;

export type InvestigationCodeReviewState = typeof InvestigationCodeReviewState[keyof typeof InvestigationCodeReviewState];

/**
 * 
 * @export
 * @interface InvestigationCommentRequest
 */
export interface InvestigationCommentRequest {
    /**
     * Required unless attachments are given
     * @type {string}
     * @memberof InvestigationCommentRequest
     */
    'text'?: string;
    /**
     * `[{key}]` of files uploaded via artifacts/upload-url. On edit, the full new list (omit to keep the current attachments).
     * @type {Array<InvestigationAttachment>}
     * @memberof InvestigationCommentRequest
     */
    'attachments'?: Array<InvestigationAttachment>;
    /**
     * 
     * @type {number}
     * @memberof InvestigationCommentRequest
     */
    'expectedVersion'?: number;
}
/**
 * 
 * @export
 * @interface InvestigationConclusion
 */
export interface InvestigationConclusion {
    /**
     * 
     * @type {string}
     * @memberof InvestigationConclusion
     */
    'summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationConclusion
     */
    'rootCause'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationConclusion
     */
    'fix'?: string;
    /**
     * Screenshots and files backing the conclusion. On update send `[{key}]` for each file to keep or add (upload first via artifacts/upload-url); omit to keep the current ones, send [] to remove all (files are kept in S3).
     * @type {Array<InvestigationAttachment>}
     * @memberof InvestigationConclusion
     */
    'attachments'?: Array<InvestigationAttachment>;
}
/**
 * 
 * @export
 * @interface InvestigationConflict
 */
export interface InvestigationConflict {
    /**
     * 
     * @type {string}
     * @memberof InvestigationConflict
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationConflict
     */
    'code'?: InvestigationConflictCodeEnum;
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationConflict
     */
    'current'?: Investigation;
    /**
     * 
     * @type {InvestigationPreview}
     * @memberof InvestigationConflict
     */
    'preview'?: InvestigationPreview;
    /**
     * 
     * @type {Array<InvestigationConflictItem>}
     * @memberof InvestigationConflict
     */
    'conflicts'?: Array<InvestigationConflictItem>;
    /**
     * 
     * @type {InvestigationPendingDeletion}
     * @memberof InvestigationConflict
     */
    'pendingDeletion'?: InvestigationPendingDeletion;
    /**
     * MANIFEST_DRIFTED — manifest PKs no longer owned by the investigation
     * @type {number}
     * @memberof InvestigationConflict
     */
    'driftedCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationConflict
     */
    'driftedDlqPks'?: Array<string>;
}

export const InvestigationConflictCodeEnum = {
    VersionConflict: 'VERSION_CONFLICT',
    PreviewStale: 'PREVIEW_STALE',
    NotOwner: 'NOT_OWNER',
    InvalidTransition: 'INVALID_TRANSITION',
    RefreshInProgress: 'REFRESH_IN_PROGRESS',
    DeletionPending: 'DELETION_PENDING',
    DocumentRedriveUnconfirmed: 'DOCUMENT_REDRIVE_UNCONFIRMED',
    ExternalRedrive: 'EXTERNAL_REDRIVE',
    ManifestDrifted: 'MANIFEST_DRIFTED',
    DuplicateRule: 'DUPLICATE_RULE',
    Merged: 'MERGED',
    Duplicate: 'DUPLICATE',
    StaleRun: 'STALE_RUN',
    InvestigationClosed: 'INVESTIGATION_CLOSED',
    NotAuthor: 'NOT_AUTHOR',
    CommentDeleted: 'COMMENT_DELETED',
    MergePending: 'MERGE_PENDING',
    ListPopulation: 'LIST_POPULATION',
    CodeReviewAlreadyDeployed: 'CODE_REVIEW_ALREADY_DEPLOYED'
} as const;

export type InvestigationConflictCodeEnum = typeof InvestigationConflictCodeEnum[keyof typeof InvestigationConflictCodeEnum];

/**
 * 
 * @export
 * @interface InvestigationConflictItem
 */
export interface InvestigationConflictItem {
    /**
     * 
     * @type {string}
     * @memberof InvestigationConflictItem
     */
    'dlqPk'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationConflictItem
     */
    'ownerInvestigationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationConflictItem
     */
    'ownerInvestigationTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationConflictItem
     */
    'owner'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationCreateRequest
 */
export interface InvestigationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof InvestigationCreateRequest
     */
    'previewId': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationCreateRequest
     */
    'title': string;
    /**
     * user when the creator typed the title; otherwise the builder\'s suggestion (default). A TrackStars run only renames titles no person chose.
     * @type {string}
     * @memberof InvestigationCreateRequest
     */
    'titleSource'?: InvestigationCreateRequestTitleSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationCreateRequest
     */
    'description'?: string;
    /**
     * Claim ownership on creation; false creates an unclaimed investigation. Ignored when owner is set.
     * @type {boolean}
     * @memberof InvestigationCreateRequest
     */
    'claim'?: boolean;
    /**
     * Assign ownership to this alias on creation instead of the caller. Must be a Lusca Search user (GET investigations/assignees); otherwise 400 UNKNOWN_ASSIGNEE. The assignee is notified and the audit trail records who assigned them.
     * @type {string}
     * @memberof InvestigationCreateRequest
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationCreateRequest
     */
    'mode'?: InvestigationCreateRequestModeEnum;
    /**
     * Required for mode=child
     * @type {string}
     * @memberof InvestigationCreateRequest
     */
    'parentInvestigationId'?: string;
    /**
     * Link this investigation as a recurrence of a resolved one
     * @type {string}
     * @memberof InvestigationCreateRequest
     */
    'recurrenceOfInvestigationId'?: string;
    /**
     * 
     * @type {InvestigationOrigin}
     * @memberof InvestigationCreateRequest
     */
    'origin'?: InvestigationOrigin;
    /**
     * A first comment recorded at creation in the creator\'s name (e.g. the TrackStars root cause and evidence the population was suggested from).
     * @type {string}
     * @memberof InvestigationCreateRequest
     */
    'initialComment'?: string;
    /**
     * Evidence links added at creation in the creator\'s name (http(s) URLs; duplicates dropped).
     * @type {Array<InvestigationLinkInput>}
     * @memberof InvestigationCreateRequest
     */
    'links'?: Array<InvestigationLinkInput>;
}

export const InvestigationCreateRequestTitleSourceEnum = {
    System: 'system',
    User: 'user'
} as const;

export type InvestigationCreateRequestTitleSourceEnum = typeof InvestigationCreateRequestTitleSourceEnum[keyof typeof InvestigationCreateRequestTitleSourceEnum];
export const InvestigationCreateRequestModeEnum = {
    Full: 'full',
    Remainder: 'remainder',
    Child: 'child'
} as const;

export type InvestigationCreateRequestModeEnum = typeof InvestigationCreateRequestModeEnum[keyof typeof InvestigationCreateRequestModeEnum];

/**
 * 
 * @export
 * @interface InvestigationCreateResult
 */
export interface InvestigationCreateResult {
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationCreateResult
     */
    'investigation'?: Investigation;
    /**
     * 
     * @type {number}
     * @memberof InvestigationCreateResult
     */
    'assignedCount'?: number;
    /**
     * Items skipped because another active investigation owns them (mode=remainder)
     * @type {number}
     * @memberof InvestigationCreateResult
     */
    'overlappingCount'?: number;
    /**
     * Items lost to a concurrent claim during creation
     * @type {number}
     * @memberof InvestigationCreateResult
     */
    'conflictedCount'?: number;
    /**
     * 
     * @type {Array<InvestigationConflictItem>}
     * @memberof InvestigationCreateResult
     */
    'conflicts'?: Array<InvestigationConflictItem>;
    /**
     * True when the population is large and ownership is being claimed asynchronously by the worker; poll the investigation until assignment.status is COMPLETED
     * @type {boolean}
     * @memberof InvestigationCreateResult
     */
    'assignmentPending'?: boolean;
    /**
     * Set when the claim won nothing because another active investigation already owned every item. The new case was closed immediately (RESOLVED, reason DUPLICATE) and points at the owner; nothing is left for the creator to do on it. Only reported on the synchronous path; a deferred claim records the same outcome on the investigation itself.
     * @type {string}
     * @memberof InvestigationCreateResult
     */
    'duplicateOfInvestigationId'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationDeletionRequest
 */
export interface InvestigationDeletionRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationDeletionRequest
     */
    'expectedVersion': number;
    /**
     * Why these items are deleted instead of fixed and redriven; included in the MCM description
     * @type {string}
     * @memberof InvestigationDeletionRequest
     */
    'justification': string;
    /**
     * Optional SIM issue URL included in the MCM description
     * @type {string}
     * @memberof InvestigationDeletionRequest
     */
    'simLink'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationDeletionResponse
 */
export interface InvestigationDeletionResponse {
    /**
     * 
     * @type {InvestigationRedriveAttempt}
     * @memberof InvestigationDeletionResponse
     */
    'attempt': InvestigationRedriveAttempt;
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationDeletionResponse
     */
    'investigation': Investigation;
}
/**
 * Outcome of checking a completed DELETE attempt against the first DLQ snapshot taken after it finished. VERIFIED: every manifest PK is absent. INCOMPLETE: some remain (the case reopens).
 * @export
 * @enum {string}
 */

export const InvestigationDeletionVerification = {
    Verified: 'VERIFIED',
    Incomplete: 'INCOMPLETE'
} as const;

export type InvestigationDeletionVerification = typeof InvestigationDeletionVerification[keyof typeof InvestigationDeletionVerification];

/**
 * 
 * @export
 * @interface InvestigationDetail
 */
export interface InvestigationDetail {
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationDetail
     */
    'investigation'?: Investigation;
    /**
     * 
     * @type {Array<InvestigationRedriveAttempt>}
     * @memberof InvestigationDetail
     */
    'attempts'?: Array<InvestigationRedriveAttempt>;
    /**
     * 
     * @type {InvestigationTimelinePage}
     * @memberof InvestigationDetail
     */
    'timeline'?: InvestigationTimelinePage;
    /**
     * Summaries of the investigations this one is related to (parent, children, the case it recurs, linked cases, merged sources or the survivor it was merged into), so the UI can show titles and how a split narrowed the rule instead of bare IDs. Order: parent, children, recurrence, merged, linked.
     * @type {Array<RelatedInvestigation>}
     * @memberof InvestigationDetail
     */
    'related'?: Array<RelatedInvestigation>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationDetail
     */
    'registryTimestamp'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationDocumentRedriveRequest
 */
export interface InvestigationDocumentRedriveRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationDocumentRedriveRequest
     */
    'expectedVersion': number;
}
/**
 * The document-redrive path the case is on (absent otherwise). RUNNING while the order redrive runs (case EXECUTING_REDRIVE); AWAITING_CONFIRMATION once it finished (case READY_TO_REDRIVE, shown as \"Ready to redrive (DLQ)\") until the owner confirms the CBEs; CONFIRMED afterwards; FAILED when the run failed. Cleared when the case moves back to INVESTIGATING or FIX_IN_PROGRESS.
 * @export
 * @interface InvestigationDocumentRedriveState
 */
export interface InvestigationDocumentRedriveState {
    /**
     * 
     * @type {string}
     * @memberof InvestigationDocumentRedriveState
     */
    'attemptId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationDocumentRedriveState
     */
    'stage'?: InvestigationDocumentRedriveStateStageEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationDocumentRedriveState
     */
    'startedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationDocumentRedriveState
     */
    'startedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationDocumentRedriveState
     */
    'completedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationDocumentRedriveState
     */
    'requestedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationDocumentRedriveState
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationDocumentRedriveState
     */
    'processedCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InvestigationDocumentRedriveState
     */
    'failedCount'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof InvestigationDocumentRedriveState
     */
    'outcomes'?: { [key: string]: number; };
    /**
     * Up to 5 redriven transaction IDs for the owner to spot-check
     * @type {Array<string>}
     * @memberof InvestigationDocumentRedriveState
     */
    'sampleIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationDocumentRedriveState
     */
    'confirmedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationDocumentRedriveState
     */
    'confirmedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationDocumentRedriveState
     */
    'error'?: string;
    /**
     * 
     * @type {InvestigationReminder}
     * @memberof InvestigationDocumentRedriveState
     */
    'reminder'?: InvestigationReminder;
}

export const InvestigationDocumentRedriveStateStageEnum = {
    Running: 'RUNNING',
    AwaitingConfirmation: 'AWAITING_CONFIRMATION',
    Confirmed: 'CONFIRMED',
    Failed: 'FAILED'
} as const;

export type InvestigationDocumentRedriveStateStageEnum = typeof InvestigationDocumentRedriveStateStageEnum[keyof typeof InvestigationDocumentRedriveStateStageEnum];

/**
 * 
 * @export
 * @interface InvestigationEvent
 */
export interface InvestigationEvent {
    /**
     * 
     * @type {string}
     * @memberof InvestigationEvent
     */
    'eventId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationEvent
     */
    'investigationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationEvent
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationEvent
     */
    'actor'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationEvent
     */
    'source'?: InvestigationEventSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationEvent
     */
    'timestamp'?: string;
    /**
     * The event\'s text. For a COMMENT this is what was posted and is never rewritten (the audit log is append-only); see currentText for what the comment says now.
     * @type {string}
     * @memberof InvestigationEvent
     */
    'text'?: string;
    /**
     * The value(s) before the change, for events that change something. COMMENT_EDITED and COMMENT_DELETED carry {text, attachments?} of the comment as it read before.
     * @type {{ [key: string]: any; }}
     * @memberof InvestigationEvent
     */
    'previous'?: { [key: string]: any; };
    /**
     * The value(s) after the change; COMMENT_EDITED carries {text, attachments?}.
     * @type {{ [key: string]: any; }}
     * @memberof InvestigationEvent
     */
    'new'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InvestigationEvent
     */
    'data'?: { [key: string]: any; };
    /**
     * Set on a COMMENT once it has been edited (the latest edit). The original text stays in `text`; the edit itself is a COMMENT_EDITED event with previous/new.
     * @type {string}
     * @memberof InvestigationEvent
     */
    'editedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationEvent
     */
    'editedBy'?: string;
    /**
     * What an edited COMMENT says now (absent when never edited). Views that show comments display this over `text`; the audit log shows both.
     * @type {string}
     * @memberof InvestigationEvent
     */
    'currentText'?: string;
    /**
     * The files an edited COMMENT shows now (absent when its attachments were never changed).
     * @type {Array<InvestigationAttachment>}
     * @memberof InvestigationEvent
     */
    'currentAttachments'?: Array<InvestigationAttachment>;
    /**
     * Set when a comment was deleted. The event keeps its text and attachments for audit; views that show comments hide it. The deletion is its own COMMENT_DELETED event.
     * @type {string}
     * @memberof InvestigationEvent
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationEvent
     */
    'deletedBy'?: string;
    /**
     * Files attached to a comment as posted (with presigned download URLs)
     * @type {Array<InvestigationAttachment>}
     * @memberof InvestigationEvent
     */
    'attachments'?: Array<InvestigationAttachment>;
    /**
     * Lusca Search users a COMMENT @-mentions (author excluded). Each was notified (type MENTION) and became a contributor unless they owned or already contributed to the case (recorded as a CONTRIBUTOR_ADDED event). Unknown @aliases are plain text and absent here.
     * @type {Array<string>}
     * @memberof InvestigationEvent
     */
    'mentions'?: Array<string>;
}

export const InvestigationEventSourceEnum = {
    Ui: 'ui',
    Mcp: 'mcp',
    System: 'system'
} as const;

export type InvestigationEventSourceEnum = typeof InvestigationEventSourceEnum[keyof typeof InvestigationEventSourceEnum];

/**
 * 
 * @export
 * @interface InvestigationExtendRequest
 */
export interface InvestigationExtendRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationExtendRequest
     */
    'expectedVersion': number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationExtendRequest
     */
    'previewId': string;
    /**
     * Also add the preview\'s rule to the case as an extra OR branch, so reconciliation keeps adding future matching items (not only the ones previewed now). Ignored when the case\'s rule already covers the preview\'s.
     * @type {boolean}
     * @memberof InvestigationExtendRequest
     */
    'widenRule'?: boolean;
}
/**
 * 
 * @export
 * @interface InvestigationExtendResponse
 */
export interface InvestigationExtendResponse {
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationExtendResponse
     */
    'investigation': Investigation;
    /**
     * 
     * @type {number}
     * @memberof InvestigationExtendResponse
     */
    'addedCount': number;
    /**
     * True when the preview\'s rule was added to the case\'s rules
     * @type {boolean}
     * @memberof InvestigationExtendResponse
     */
    'ruleWidened'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvestigationExtendResponse
     */
    'ownedElsewhereCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationExtendResponse
     */
    'alreadyIncludedCount'?: number;
}
/**
 * 
 * @export
 * @interface InvestigationExternalRedriveExport
 */
export interface InvestigationExternalRedriveExport {
    /**
     * 
     * @type {InvestigationAttemptKind}
     * @memberof InvestigationExternalRedriveExport
     */
    'kind': InvestigationAttemptKind;
    /**
     * 
     * @type {string}
     * @memberof InvestigationExternalRedriveExport
     */
    'downloadUrl': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationExternalRedriveExport
     */
    'fileName': string;
    /**
     * DLQ items (REDRIVE / DELETE) or transactions (DOCUMENT_REDRIVE) in the file
     * @type {number}
     * @memberof InvestigationExternalRedriveExport
     */
    'count': number;
    /**
     * Lusca Search Prod page to run the redrive on
     * @type {string}
     * @memberof InvestigationExternalRedriveExport
     */
    'targetUrl': string;
}
/**
 * 
 * @export
 * @interface InvestigationExternalRedriveExportRequest
 */
export interface InvestigationExternalRedriveExportRequest {
    /**
     * 
     * @type {InvestigationAttemptKind}
     * @memberof InvestigationExternalRedriveExportRequest
     */
    'kind': InvestigationAttemptKind;
}
/**
 * 
 * @export
 * @interface InvestigationExternalRedriveLinkRequest
 */
export interface InvestigationExternalRedriveLinkRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationExternalRedriveLinkRequest
     */
    'expectedVersion': number;
    /**
     * 
     * @type {InvestigationAttemptKind}
     * @memberof InvestigationExternalRedriveLinkRequest
     */
    'kind': InvestigationAttemptKind;
    /**
     * Execution ARN, or just the execution ID shown by the Prod tool
     * @type {string}
     * @memberof InvestigationExternalRedriveLinkRequest
     */
    'executionArn': string;
}
/**
 * 
 * @export
 * @interface InvestigationFieldBreakdown
 */
export interface InvestigationFieldBreakdown {
    /**
     * Rule field (see InvestigationPredicate.field)
     * @type {string}
     * @memberof InvestigationFieldBreakdown
     */
    'field': string;
    /**
     * Population size the distribution was computed over
     * @type {number}
     * @memberof InvestigationFieldBreakdown
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationFieldBreakdown
     */
    'distinctValues': number;
    /**
     * Most frequent values, descending by count (bounded)
     * @type {Array<InvestigationFieldBreakdownValue>}
     * @memberof InvestigationFieldBreakdown
     */
    'values': Array<InvestigationFieldBreakdownValue>;
    /**
     * Items whose value is not in values
     * @type {number}
     * @memberof InvestigationFieldBreakdown
     */
    'otherCount': number;
}
/**
 * 
 * @export
 * @interface InvestigationFieldBreakdownValue
 */
export interface InvestigationFieldBreakdownValue {
    /**
     * Field value as it appears in the snapshot; \"\" for NULL/empty
     * @type {string}
     * @memberof InvestigationFieldBreakdownValue
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationFieldBreakdownValue
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface InvestigationFollowRequest
 */
export interface InvestigationFollowRequest {
    /**
     * true to follow, false to stop following
     * @type {boolean}
     * @memberof InvestigationFollowRequest
     */
    'follow': boolean;
}
/**
 * 
 * @export
 * @interface InvestigationInbox
 */
export interface InvestigationInbox {
    /**
     * 
     * @type {Array<InvestigationInboxItem>}
     * @memberof InvestigationInbox
     */
    'items': Array<InvestigationInboxItem>;
    /**
     * 
     * @type {number}
     * @memberof InvestigationInbox
     */
    'unreadCount': number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInbox
     */
    'nextToken'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationInboxItem
 */
export interface InvestigationInboxItem {
    /**
     * Notification id (also the audit id used as the email/Slack idempotency key)
     * @type {string}
     * @memberof InvestigationInboxItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInboxItem
     */
    'investigationId': string;
    /**
     * 
     * @type {Stage}
     * @memberof InvestigationInboxItem
     */
    'stage'?: Stage;
    /**
     * Investigation title at the time of the notification
     * @type {string}
     * @memberof InvestigationInboxItem
     */
    'title'?: string;
    /**
     * TRANSFER, TAKEOVER, COMMENT, MENTION, CONTRIBUTION, MERGED, REDRIVE_SUCCEEDED, REDRIVE_FAILED, DELETION_VERIFIED, DELETION_INCOMPLETE
     * @type {string}
     * @memberof InvestigationInboxItem
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInboxItem
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInboxItem
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInboxItem
     */
    'createdAt': string;
    /**
     * Absent while unread
     * @type {string}
     * @memberof InvestigationInboxItem
     */
    'readAt'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationInboxReadRequest
 */
export interface InvestigationInboxReadRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationInboxReadRequest
     */
    'notificationIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInboxReadRequest
     */
    'investigationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationInboxReadRequest
     */
    'all'?: boolean;
}
/**
 * 
 * @export
 * @interface InvestigationInboxReadResult
 */
export interface InvestigationInboxReadResult {
    /**
     * 
     * @type {number}
     * @memberof InvestigationInboxReadResult
     */
    'updatedCount': number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationInboxReadResult
     */
    'unreadCount': number;
}
/**
 * 
 * @export
 * @interface InvestigationItem
 */
export interface InvestigationItem {
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'dlqPk'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'dlqTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'eventsourcekey'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'errorType'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'errorCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'glProductGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'marketplaceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'transactionId'?: string;
    /**
     * Transaction date from the DLQ snapshot; absent for manifests frozen before it was captured
     * @type {string}
     * @memberof InvestigationItem
     */
    'transactionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'usecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItem
     */
    'orderId'?: string;
    /**
     * True when this investigation still holds primary ownership of the item
     * @type {boolean}
     * @memberof InvestigationItem
     */
    'currentlyOwned'?: boolean;
    /**
     * Whether the item was in the DLQ at the last reconcile (false once redriven or deleted). Absent when the case has no live list yet.
     * @type {boolean}
     * @memberof InvestigationItem
     */
    'inDlq'?: boolean;
    /**
     * 
     * @type {InvestigationItemHolder}
     * @memberof InvestigationItem
     */
    'heldBy'?: InvestigationItemHolder;
}
/**
 * The other active investigation that now holds this item (a narrower child, a merge survivor, or a case that won the claim). Absent when this investigation holds it or when nobody does — after this case was resolved or cancelled its items were released, so an unheld item there is the normal state, not a problem.
 * @export
 * @interface InvestigationItemHolder
 */
export interface InvestigationItemHolder {
    /**
     * 
     * @type {string}
     * @memberof InvestigationItemHolder
     */
    'investigationId': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItemHolder
     */
    'title'?: string;
}
/**
 * Per-day counts over all manifest rows matching the current filter (not just the page)
 * @export
 * @interface InvestigationItemsHistogram
 */
export interface InvestigationItemsHistogram {
    /**
     * 
     * @type {string}
     * @memberof InvestigationItemsHistogram
     */
    'bucket'?: InvestigationItemsHistogramBucketEnum;
    /**
     * 
     * @type {Array<DayCount>}
     * @memberof InvestigationItemsHistogram
     */
    'dlqByDay'?: Array<DayCount>;
    /**
     * 
     * @type {Array<DayCount>}
     * @memberof InvestigationItemsHistogram
     */
    'transactionByDay'?: Array<DayCount>;
    /**
     * Rows without a transaction date (older manifests or rows lacking the field)
     * @type {number}
     * @memberof InvestigationItemsHistogram
     */
    'missingTransactionDate'?: number;
}

export const InvestigationItemsHistogramBucketEnum = {
    Day: 'day'
} as const;

export type InvestigationItemsHistogramBucketEnum = typeof InvestigationItemsHistogramBucketEnum[keyof typeof InvestigationItemsHistogramBucketEnum];

/**
 * 
 * @export
 * @interface InvestigationItemsResult
 */
export interface InvestigationItemsResult {
    /**
     * 
     * @type {Array<InvestigationItem>}
     * @memberof InvestigationItemsResult
     */
    'items'?: Array<InvestigationItem>;
    /**
     * Rows matching the filter in the listed scope
     * @type {number}
     * @memberof InvestigationItemsResult
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationItemsResult
     */
    'offset'?: number;
    /**
     * The scope actually listed (all when the case has no live list yet)
     * @type {string}
     * @memberof InvestigationItemsResult
     */
    'scope'?: InvestigationItemsResultScopeEnum;
    /**
     * Owned items still in the DLQ at the last reconcile; null before the first one
     * @type {number}
     * @memberof InvestigationItemsResult
     */
    'liveCount'?: number | null;
    /**
     * DLQ snapshot the live list was taken from
     * @type {string}
     * @memberof InvestigationItemsResult
     */
    'liveSnapshotTimestamp'?: string | null;
    /**
     * Rows in the frozen manifest
     * @type {number}
     * @memberof InvestigationItemsResult
     */
    'frozenCount'?: number;
    /**
     * 
     * @type {InvestigationItemsHistogram}
     * @memberof InvestigationItemsResult
     */
    'histogram'?: InvestigationItemsHistogram;
    /**
     * Value distribution of every rule field the population rule does not pin, over all manifest rows matching the current filter (not just the page). Same shape as the preview\'s suggested splits.
     * @type {Array<InvestigationFieldBreakdown>}
     * @memberof InvestigationItemsResult
     */
    'fieldBreakdown'?: Array<InvestigationFieldBreakdown>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItemsResult
     */
    'manifestUri'?: string;
    /**
     * Whether the page was produced by Athena over the frozen manifest or by the Lambda reading the CSV (legacy layout / fallback)
     * @type {string}
     * @memberof InvestigationItemsResult
     */
    'servedBy'?: InvestigationItemsResultServedByEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItemsResult
     */
    'snapshotTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationItemsResult
     */
    'frozenAt'?: string;
}

export const InvestigationItemsResultScopeEnum = {
    Live: 'live',
    All: 'all'
} as const;

export type InvestigationItemsResultScopeEnum = typeof InvestigationItemsResultScopeEnum[keyof typeof InvestigationItemsResultScopeEnum];
export const InvestigationItemsResultServedByEnum = {
    Athena: 'athena',
    Lambda: 'lambda'
} as const;

export type InvestigationItemsResultServedByEnum = typeof InvestigationItemsResultServedByEnum[keyof typeof InvestigationItemsResultServedByEnum];

/**
 * Evidence link (CR, ticket, log query, dashboard) that backs the conclusion.
 * @export
 * @interface InvestigationLink
 */
export interface InvestigationLink {
    /**
     * 
     * @type {string}
     * @memberof InvestigationLink
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLink
     */
    'url': string;
    /**
     * Set when the link is TrackStars\' evidence rather than something a person found.
     * @type {string}
     * @memberof InvestigationLink
     */
    'source'?: InvestigationLinkSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLink
     */
    'addedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLink
     */
    'addedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLink
     */
    'editedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLink
     */
    'editedBy'?: string;
}

export const InvestigationLinkSourceEnum = {
    Trackstars: 'trackstars'
} as const;

export type InvestigationLinkSourceEnum = typeof InvestigationLinkSourceEnum[keyof typeof InvestigationLinkSourceEnum];

/**
 * Edit an evidence link identified by its current URL (adder or owner only)
 * @export
 * @interface InvestigationLinkEdit
 */
export interface InvestigationLinkEdit {
    /**
     * Current URL of the link to edit
     * @type {string}
     * @memberof InvestigationLinkEdit
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLinkEdit
     */
    'newUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLinkEdit
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationLinkInput
 */
export interface InvestigationLinkInput {
    /**
     * 
     * @type {string}
     * @memberof InvestigationLinkInput
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLinkInput
     */
    'url': string;
    /**
     * Where the link came from when a person did not type it. Shown as the adder in place of the caller; the caller is still recorded in addedBy for permissions and audit.
     * @type {string}
     * @memberof InvestigationLinkInput
     */
    'source'?: InvestigationLinkInputSourceEnum;
}

export const InvestigationLinkInputSourceEnum = {
    Trackstars: 'trackstars'
} as const;

export type InvestigationLinkInputSourceEnum = typeof InvestigationLinkInputSourceEnum[keyof typeof InvestigationLinkInputSourceEnum];

/**
 * 
 * @export
 * @interface InvestigationListResult
 */
export interface InvestigationListResult {
    /**
     * 
     * @type {Array<Investigation>}
     * @memberof InvestigationListResult
     */
    'items'?: Array<Investigation>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationListResult
     */
    'nextToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationListResult
     */
    'registryTimestamp'?: string;
    /**
     * job_run of the DLQ snapshot used by the latest reconciliation
     * @type {string}
     * @memberof InvestigationListResult
     */
    'snapshotTimestamp'?: string;
}
/**
 * Set while the worker re-points the merged sources\' item ownership to the survivor
 * @export
 * @interface InvestigationMergePending
 */
export interface InvestigationMergePending {
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationMergePending
     */
    'sourceInvestigationIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationMergePending
     */
    'requestedAt'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationMergeRequest
 */
export interface InvestigationMergeRequest {
    /**
     * Version of the survivor
     * @type {number}
     * @memberof InvestigationMergeRequest
     */
    'expectedVersion': number;
    /**
     * Active investigations to absorb (same stage, not the survivor)
     * @type {Array<string>}
     * @memberof InvestigationMergeRequest
     */
    'sourceInvestigationIds': Array<string>;
    /**
     * Optional new title for the survivor (the root cause is usually understood by now)
     * @type {string}
     * @memberof InvestigationMergeRequest
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationMergeResult
 */
export interface InvestigationMergeResult {
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationMergeResult
     */
    'investigation': Investigation;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationMergeResult
     */
    'mergedInvestigationIds': Array<string>;
    /**
     * Items re-pointed to the survivor inline (0 when deferred to the worker)
     * @type {number}
     * @memberof InvestigationMergeResult
     */
    'movedCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationMergeResult
     */
    'mergePending': boolean;
}
/**
 * The caller\'s own pending \"remind me\" on this case (see setInvestigationReminder)
 * @export
 * @interface InvestigationMyReminder
 */
export interface InvestigationMyReminder {
    /**
     * 
     * @type {string}
     * @memberof InvestigationMyReminder
     */
    'remindAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationMyReminder
     */
    'setBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationMyReminder
     */
    'setAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationMyReminder
     */
    'status'?: InvestigationMyReminderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationMyReminder
     */
    'notificationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationMyReminder
     */
    'error'?: string;
}

export const InvestigationMyReminderStatusEnum = {
    Scheduling: 'SCHEDULING',
    Scheduled: 'SCHEDULED',
    Failed: 'FAILED'
} as const;

export type InvestigationMyReminderStatusEnum = typeof InvestigationMyReminderStatusEnum[keyof typeof InvestigationMyReminderStatusEnum];

/**
 * Private in-app notice. The API only returns the entries addressed to the caller.
 * @export
 * @interface InvestigationNotification
 */
export interface InvestigationNotification {
    /**
     * 
     * @type {string}
     * @memberof InvestigationNotification
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationNotification
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationNotification
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationNotification
     */
    'type'?: string;
    /**
     * Alias the notice is addressed to (usually the owner; a previous owner for a takeover). Never the person who caused it.
     * @type {string}
     * @memberof InvestigationNotification
     */
    'recipient'?: string;
}
/**
 * Where the population came from when it was not built by hand. Today only TrackStars patterns: suggestions from that pattern then show this case as its owner, and the case page can show the source analysis.
 * @export
 * @interface InvestigationOrigin
 */
export interface InvestigationOrigin {
    /**
     * 
     * @type {string}
     * @memberof InvestigationOrigin
     */
    'source': InvestigationOriginSourceEnum;
    /**
     * TrackStars pattern id (PAT-001 …)
     * @type {string}
     * @memberof InvestigationOrigin
     */
    'patternId': string;
    /**
     * TrackStars report id the pattern came from
     * @type {string}
     * @memberof InvestigationOrigin
     */
    'reportId'?: string;
}

export const InvestigationOriginSourceEnum = {
    Trackstars: 'trackstars'
} as const;

export type InvestigationOriginSourceEnum = typeof InvestigationOriginSourceEnum[keyof typeof InvestigationOriginSourceEnum];

/**
 * 
 * @export
 * @interface InvestigationOtherOwner
 */
export interface InvestigationOtherOwner {
    /**
     * 
     * @type {string}
     * @memberof InvestigationOtherOwner
     */
    'investigationId': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationOtherOwner
     */
    'title'?: string;
    /**
     * 
     * @type {InvestigationStatus}
     * @memberof InvestigationOtherOwner
     */
    'status'?: InvestigationStatus;
    /**
     * 
     * @type {string}
     * @memberof InvestigationOtherOwner
     */
    'owner'?: string;
    /**
     * Items of this population the investigation owns (scaled when sampled)
     * @type {number}
     * @memberof InvestigationOtherOwner
     */
    'count': number;
    /**
     * How the owner relates to this investigation, when it does
     * @type {string}
     * @memberof InvestigationOtherOwner
     */
    'relation'?: InvestigationOtherOwnerRelationEnum;
}

export const InvestigationOtherOwnerRelationEnum = {
    Parent: 'parent',
    Child: 'child'
} as const;

export type InvestigationOtherOwnerRelationEnum = typeof InvestigationOtherOwnerRelationEnum[keyof typeof InvestigationOtherOwnerRelationEnum];

/**
 * 
 * @export
 * @interface InvestigationOtherOwnersResult
 */
export interface InvestigationOtherOwnersResult {
    /**
     * 
     * @type {Array<InvestigationOtherOwner>}
     * @memberof InvestigationOtherOwnersResult
     */
    'owners': Array<InvestigationOtherOwner>;
    /**
     * Items no active investigation owns (released since the snapshot)
     * @type {number}
     * @memberof InvestigationOtherOwnersResult
     */
    'unownedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationOtherOwnersResult
     */
    'checkedCount': number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationOtherOwnersResult
     */
    'totalCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationOtherOwnersResult
     */
    'sampled': boolean;
}
/**
 * 
 * @export
 * @interface InvestigationOverlap
 */
export interface InvestigationOverlap {
    /**
     * 
     * @type {string}
     * @memberof InvestigationOverlap
     */
    'investigationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationOverlap
     */
    'title'?: string;
    /**
     * 
     * @type {InvestigationStatus}
     * @memberof InvestigationOverlap
     */
    'status'?: InvestigationStatus;
    /**
     * 
     * @type {string}
     * @memberof InvestigationOverlap
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationOverlap
     */
    'relation'?: InvestigationOverlapRelationEnum;
    /**
     * Number of preview items owned by this investigation (item-level)
     * @type {number}
     * @memberof InvestigationOverlap
     */
    'overlappingCount'?: number;
    /**
     * Active overlaps only: predicates that, added to the previewed rule (replacing the rule\'s predicate on the same field), leave out every item this investigation\'s rule selects — e.g. `error_message not_in [its message]` when its rule is the preview\'s plus that one message. Absent when no single-field carve-out exists (it is as wide as the preview\'s rule, narrows it on several fields at once, or narrows a field the preview already pins).
     * @type {Array<InvestigationPredicate>}
     * @memberof InvestigationOverlap
     */
    'exclusion'?: Array<InvestigationPredicate>;
    /**
     * Present when no exact carve-out exists (the investigation narrows the preview\'s rule on several fields): `exclusion` is then the single-field `not_in` that removes the fewest other items, and this is how many previewed items it removes that this investigation\'s rule does not select (0 = it removes exactly its items).
     * @type {number}
     * @memberof InvestigationOverlap
     */
    'exclusionExtraCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationOverlap
     */
    'conclusion'?: string;
    /**
     * 
     * @type {InvestigationResolutionReason}
     * @memberof InvestigationOverlap
     */
    'resolutionReason'?: InvestigationResolutionReason;
    /**
     * 
     * @type {string}
     * @memberof InvestigationOverlap
     */
    'resolvedAt'?: string;
}

export const InvestigationOverlapRelationEnum = {
    RuleOverlap: 'rule_overlap',
    RuleSubset: 'rule_subset',
    RuleSuperset: 'rule_superset',
    ItemOverlap: 'item_overlap'
} as const;

export type InvestigationOverlapRelationEnum = typeof InvestigationOverlapRelationEnum[keyof typeof InvestigationOverlapRelationEnum];

/**
 * Set while a delete-without-redrive request awaits MCM approval or execution. The investigation stays READY_TO_REDRIVE but population refresh, redrives, status changes and child splits are rejected with 409 DELETION_PENDING until the request is executed or cancelled.
 * @export
 * @interface InvestigationPendingDeletion
 */
export interface InvestigationPendingDeletion {
    /**
     * 
     * @type {string}
     * @memberof InvestigationPendingDeletion
     */
    'attemptId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPendingDeletion
     */
    'mcmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPendingDeletion
     */
    'mcmUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPendingDeletion
     */
    'requestedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPendingDeletion
     */
    'requestedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationPendingDeletion
     */
    'requestedCount'?: number;
}
/**
 * Set while a population refresh is running (from the POST .../population/refresh 202 until the worker refreezes the population or the preview fails). Poll the preview to follow progress; a second refresh request while this is set is rejected with 409 REFRESH_IN_PROGRESS.
 * @export
 * @interface InvestigationPendingRefresh
 */
export interface InvestigationPendingRefresh {
    /**
     * 
     * @type {string}
     * @memberof InvestigationPendingRefresh
     */
    'previewId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPendingRefresh
     */
    'startedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPendingRefresh
     */
    'startedBy'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationPopulation
 */
export interface InvestigationPopulation {
    /**
     * 
     * @type {string}
     * @memberof InvestigationPopulation
     */
    'manifestUri'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPopulation
     */
    'checksum'?: string;
    /**
     * Items in the frozen manifest: the items this case owns plus any no active case owns. Items other cases own (overlap at creation, or split off to a child) are trimmed out.
     * @type {number}
     * @memberof InvestigationPopulation
     */
    'count'?: number;
    /**
     * What the rule matched when the population was first frozen, before items owned by other cases were trimmed out. Absent until a trim happened.
     * @type {number}
     * @memberof InvestigationPopulation
     */
    'matchedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPopulation
     */
    'trimmedAt'?: string;
    /**
     * Where trimmed items went (top 20 owning cases, running total)
     * @type {Array<InvestigationOtherOwner>}
     * @memberof InvestigationPopulation
     */
    'movedTo'?: Array<InvestigationOtherOwner>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPopulation
     */
    'snapshotTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPopulation
     */
    'frozenAt'?: string;
    /**
     * list when the case was split off by a list of DLQ keys or IDs; such a case never gains items (absent = rule)
     * @type {string}
     * @memberof InvestigationPopulation
     */
    'source'?: InvestigationPopulationSourceEnum;
    /**
     * Athena query execution that produced this frozen population. Lets the UI deep-link to the exact query in the Athena console (history is retained ~45 days).
     * @type {string}
     * @memberof InvestigationPopulation
     */
    'queryExecutionId'?: string;
}

export const InvestigationPopulationSourceEnum = {
    Rule: 'rule',
    List: 'list'
} as const;

export type InvestigationPopulationSourceEnum = typeof InvestigationPopulationSourceEnum[keyof typeof InvestigationPopulationSourceEnum];

/**
 * One field of a population rule. `eq` (the default) pins the field to `value`; `in` pins it to any of `values` (a set: order is irrelevant, duplicates are dropped, a single-value `in` is stored as `eq`). Exactly one of `value` / `values` applies, by operator. Boolean fields only take `eq`. `not_in` (any non-boolean field) admits every value except `values`; an empty/NULL value always passes. Lusca writes it when a rule created with `error_category = uncategorized` is stored (see Investigation.categoryScope), and the builder adds it to leave out the items an overlapping case owns (InvestigationOverlap.exclusion). A rule must pin at least one field with `eq` or `in`.
 * @export
 * @interface InvestigationPredicate
 */
export interface InvestigationPredicate {
    /**
     * Allowlisted DLQ snapshot field
     * @type {string}
     * @memberof InvestigationPredicate
     */
    'field': InvestigationPredicateFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPredicate
     */
    'operator'?: InvestigationPredicateOperatorEnum;
    /**
     * Value to compare for `eq` (booleans as \"true\"/\"false\")
     * @type {string}
     * @memberof InvestigationPredicate
     */
    'value'?: string;
    /**
     * Values to compare for `in` (the item matches when the field equals any of them) or `not_in` (the item matches when the field equals none of them)
     * @type {Array<string>}
     * @memberof InvestigationPredicate
     */
    'values'?: Array<string>;
}

export const InvestigationPredicateFieldEnum = {
    Eventsourcekey: 'eventsourcekey',
    ErrorType: 'error_type',
    ErrorMessage: 'error_message',
    ErrorCategory: 'error_category',
    GlProductGroup: 'gl_product_group',
    MarketplaceId: 'marketplace_id',
    Usecase: 'usecase',
    DigitalOrderSource: 'digital_order_source',
    IsEmpOrder: 'is_emp_order',
    Destination: 'destination',
    AccountingOperation: 'accounting_operation',
    PaymentProcessor: 'payment_processor'
} as const;

export type InvestigationPredicateFieldEnum = typeof InvestigationPredicateFieldEnum[keyof typeof InvestigationPredicateFieldEnum];
export const InvestigationPredicateOperatorEnum = {
    Eq: 'eq',
    In: 'in',
    NotIn: 'not_in'
} as const;

export type InvestigationPredicateOperatorEnum = typeof InvestigationPredicateOperatorEnum[keyof typeof InvestigationPredicateOperatorEnum];

/**
 * 
 * @export
 * @interface InvestigationPreview
 */
export interface InvestigationPreview {
    /**
     * 
     * @type {string}
     * @memberof InvestigationPreview
     */
    'previewId': string;
    /**
     * 
     * @type {Stage}
     * @memberof InvestigationPreview
     */
    'stage': Stage;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPreview
     */
    'status': InvestigationPreviewStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPreview
     */
    'error'?: string;
    /**
     * Conjunction of predicates describing the live population (one rule branch): every field pinned must match (an `in` field matches any of its values).
     * @type {Array<InvestigationPredicate>}
     * @memberof InvestigationPreview
     */
    'rule'?: Array<InvestigationPredicate>;
    /**
     * job_run of the hourly DLQ snapshot the preview was computed from
     * @type {string}
     * @memberof InvestigationPreview
     */
    'snapshotTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPreview
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPreview
     */
    'completedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationPreview
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationPreview
     */
    'unassignedCount'?: number;
    /**
     * Items already owned by an active investigation
     * @type {number}
     * @memberof InvestigationPreview
     */
    'assignedCount'?: number;
    /**
     * Deprecated — always 0 since overlap ownership became narrowest-rule-then-oldest-case (no AMBIGUOUS items); kept for compatibility, will be removed.
     * @type {number}
     * @memberof InvestigationPreview
     * @deprecated
     */
    'ambiguousCount'?: number;
    /**
     * 
     * @type {Array<InvestigationSample>}
     * @memberof InvestigationPreview
     */
    'samples'?: Array<InvestigationSample>;
    /**
     * Value distribution of every rule field not pinned by the rule (\"suggested splits\"). Empty for single-item and transaction lookups.
     * @type {Array<InvestigationFieldBreakdown>}
     * @memberof InvestigationPreview
     */
    'fieldBreakdown'?: Array<InvestigationFieldBreakdown>;
    /**
     * Only for a rule pinning `error_category = uncategorized`: the categories items sharing the rest of the rule already carry (largest first). Creation stores the rule without the pin and excludes these instead, so the case keeps tracking its items once they are categorised. Absent when the lookup did not run or failed (creation then keeps the rule as picked).
     * @type {Array<InvestigationPreviewCategorizedElsewhereInner>}
     * @memberof InvestigationPreview
     */
    'categorizedElsewhere'?: Array<InvestigationPreviewCategorizedElsewhereInner>;
    /**
     * 
     * @type {Array<InvestigationOverlap>}
     * @memberof InvestigationPreview
     */
    'activeOverlaps'?: Array<InvestigationOverlap>;
    /**
     * 
     * @type {Array<InvestigationOverlap>}
     * @memberof InvestigationPreview
     */
    'historicalOverlaps'?: Array<InvestigationOverlap>;
    /**
     * True when item-level overlap was computed on a bounded sample of the population
     * @type {boolean}
     * @memberof InvestigationPreview
     */
    'itemOverlapSampled'?: boolean;
    /**
     * True when the population exceeds maxPopulation; count is exact but no manifest was frozen and the preview cannot be used to create an investigation
     * @type {boolean}
     * @memberof InvestigationPreview
     */
    'truncated'?: boolean;
    /**
     * Largest population that can be frozen into an exact manifest
     * @type {number}
     * @memberof InvestigationPreview
     */
    'maxPopulation'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationPreview
     */
    'manifestUri'?: string;
    /**
     * Set when the preview refreshes an existing investigation\'s population
     * @type {string}
     * @memberof InvestigationPreview
     */
    'appliedToInvestigationId'?: string;
}

export const InvestigationPreviewStatusEnum = {
    Running: 'RUNNING',
    Processing: 'PROCESSING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type InvestigationPreviewStatusEnum = typeof InvestigationPreviewStatusEnum[keyof typeof InvestigationPreviewStatusEnum];

/**
 * 
 * @export
 * @interface InvestigationPreviewCategorizedElsewhereInner
 */
export interface InvestigationPreviewCategorizedElsewhereInner {
    /**
     * 
     * @type {string}
     * @memberof InvestigationPreviewCategorizedElsewhereInner
     */
    'category': string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationPreviewCategorizedElsewhereInner
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface InvestigationPreviewRequest
 */
export interface InvestigationPreviewRequest {
    /**
     * Conjunction of predicates describing the live population (one rule branch): every field pinned must match (an `in` field matches any of its values).
     * @type {Array<InvestigationPredicate>}
     * @memberof InvestigationPreviewRequest
     */
    'rule'?: Array<InvestigationPredicate>;
    /**
     * Look up a single DLQ item by primary key instead of a rule. The completed preview\'s samples carry the item\'s snapshot fields (queue, error type, templated message, ...) so a population rule can be seeded from them. Lookup previews cannot create an investigation.
     * @type {string}
     * @memberof InvestigationPreviewRequest
     */
    'dlqPk'?: string;
    /**
     * Look up DLQ items by transaction or order ID instead of a rule (matches the snapshot\'s transaction_id or order_id columns; may return multiple items). Lookup previews cannot create an investigation.
     * @type {string}
     * @memberof InvestigationPreviewRequest
     */
    'transactionId'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationRedriveAttempt
 */
export interface InvestigationRedriveAttempt {
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'attemptId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'investigationId'?: string;
    /**
     * Present on attempts listed under a survivor that were launched by an investigation since merged into it; the attempt itself still belongs to that source.
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'sourceInvestigationId'?: string;
    /**
     * 
     * @type {InvestigationAttemptKind}
     * @memberof InvestigationRedriveAttempt
     */
    'kind'?: InvestigationAttemptKind;
    /**
     * AWAITING_APPROVAL and CANCELLED apply to DELETE attempts only.
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'status'?: InvestigationRedriveAttemptStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'executionArn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'manifestUri'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'manifestChecksum'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'actor'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationRedriveAttempt
     */
    'dryRun'?: boolean;
    /**
     * DLQ items requeued/deleted, or for DOCUMENT_REDRIVE the distinct transaction IDs sent
     * @type {number}
     * @memberof InvestigationRedriveAttempt
     */
    'requestedCount'?: number;
    /**
     * DOCUMENT_REDRIVE attempts — DLQ items in the frozen manifest the IDs came from
     * @type {number}
     * @memberof InvestigationRedriveAttempt
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationRedriveAttempt
     */
    'processedCount'?: number;
    /**
     * Counts per outcome. DOCUMENT_REDRIVE attempts use DOCUMENT_SUCCESS / DOCUMENT_FAILED (per transaction) and BATCH_FAILED (transactions in a batch that did not run).
     * @type {{ [key: string]: number; }}
     * @memberof InvestigationRedriveAttempt
     */
    'outcomes'?: { [key: string]: number; };
    /**
     * Run in Lusca Search Prod and linked to the investigation by execution ARN
     * @type {boolean}
     * @memberof InvestigationRedriveAttempt
     */
    'linked'?: boolean;
    /**
     * DOCUMENT_REDRIVE attempts — up to 100 transaction IDs whose document redrive failed
     * @type {Array<string>}
     * @memberof InvestigationRedriveAttempt
     */
    'failedIds'?: Array<string>;
    /**
     * DOCUMENT_REDRIVE attempts — the order redrive input file (Redrive Tool execution)
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'redriveFileName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationRedriveAttempt
     */
    'hasReturns'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvestigationRedriveAttempt
     */
    'returnedCount'?: number;
    /**
     * 
     * @type {InvestigationReturnSummary}
     * @memberof InvestigationRedriveAttempt
     */
    'returnSummary'?: InvestigationReturnSummary;
    /**
     * 
     * @type {Array<InvestigationRedriveAttemptReturnedItemsInner>}
     * @memberof InvestigationRedriveAttempt
     */
    'returnedItems'?: Array<InvestigationRedriveAttemptReturnedItemsInner>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'startedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'completedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'error'?: string;
    /**
     * DELETE attempts — the MCM gating the run
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'mcmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'mcmUrl'?: string;
    /**
     * DELETE attempts — live MCM status (Draft, Pending Approval, Scheduled, In Progress, ...) read when listing; only populated for the pending request and null when MCM cannot be reached.
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'mcmStatus'?: string | null;
    /**
     * DELETE attempts — set when the Draft MCM description could not be verified after creation
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'mcmWarning'?: string;
    /**
     * DELETE attempts — the uploaded dlq_pk CSV bound into the MCM literal
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'redriveS3Uri'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'redriveS3Etag'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'justification'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'simLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'requestedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'executedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'cancelledAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'cancelledBy'?: string;
    /**
     * 
     * @type {InvestigationDeletionVerification}
     * @memberof InvestigationRedriveAttempt
     */
    'verification'?: InvestigationDeletionVerification;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'verifiedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttempt
     */
    'verifiedSnapshotTimestamp'?: string;
    /**
     * DELETE attempts — manifest PKs still present in the verification snapshot
     * @type {number}
     * @memberof InvestigationRedriveAttempt
     */
    'remainingCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationRedriveAttempt
     */
    'remainingDlqPks'?: Array<string>;
}

export const InvestigationRedriveAttemptStatusEnum = {
    AwaitingApproval: 'AWAITING_APPROVAL',
    Started: 'STARTED',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type InvestigationRedriveAttemptStatusEnum = typeof InvestigationRedriveAttemptStatusEnum[keyof typeof InvestigationRedriveAttemptStatusEnum];

/**
 * 
 * @export
 * @interface InvestigationRedriveAttemptReturnedItemsInner
 */
export interface InvestigationRedriveAttemptReturnedItemsInner {
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttemptReturnedItemsInner
     */
    'dlqPk'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttemptReturnedItemsInner
     */
    'previousDlqPk'?: string;
    /**
     * Transaction ID of the returned item (display only; opens Lusca Search).
     * @type {string}
     * @memberof InvestigationRedriveAttemptReturnedItemsInner
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttemptReturnedItemsInner
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveAttemptReturnedItemsInner
     */
    'detectedAt'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationRedriveList
 */
export interface InvestigationRedriveList {
    /**
     * 
     * @type {Array<InvestigationRedriveAttempt>}
     * @memberof InvestigationRedriveList
     */
    'attempts'?: Array<InvestigationRedriveAttempt>;
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationRedriveList
     */
    'investigation'?: Investigation;
}
/**
 * 
 * @export
 * @interface InvestigationRedriveRequest
 */
export interface InvestigationRedriveRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationRedriveRequest
     */
    'expectedVersion': number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationRedriveRequest
     */
    'dryRun'?: boolean;
}
/**
 * 
 * @export
 * @interface InvestigationRedriveSummary
 */
export interface InvestigationRedriveSummary {
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveSummary
     */
    'attemptId'?: string;
    /**
     * 
     * @type {InvestigationAttemptKind}
     * @memberof InvestigationRedriveSummary
     */
    'kind'?: InvestigationAttemptKind;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveSummary
     */
    'status'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationRedriveSummary
     */
    'hasReturns'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveSummary
     */
    'startedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRedriveSummary
     */
    'completedAt'?: string | null;
    /**
     * Set by reconciliation while MONITORING_REDRIVE once a DLQ snapshot taken at least the stage\'s quiet period (default 4 hours) after the redrive completed shows no returned items: the case is ready to resolve (resolving stays manual). Cleared by a later return; a new redrive replaces the summary.
     * @type {string}
     * @memberof InvestigationRedriveSummary
     */
    'monitoringClearAt'?: string | null;
    /**
     * Time of the DLQ snapshot that showed no returns.
     * @type {string}
     * @memberof InvestigationRedriveSummary
     */
    'monitoringClearSnapshotAt'?: string | null;
    /**
     * 
     * @type {InvestigationDeletionVerification}
     * @memberof InvestigationRedriveSummary
     */
    'verification'?: InvestigationDeletionVerification;
}
/**
 * 
 * @export
 * @interface InvestigationReleaseRequest
 */
export interface InvestigationReleaseRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationReleaseRequest
     */
    'expectedVersion': number;
}
/**
 * 
 * @export
 * @interface InvestigationReleaseReturnedRequest
 */
export interface InvestigationReleaseReturnedRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationReleaseReturnedRequest
     */
    'expectedVersion': number;
}
/**
 * 
 * @export
 * @interface InvestigationReleaseReturnedResponse
 */
export interface InvestigationReleaseReturnedResponse {
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationReleaseReturnedResponse
     */
    'investigation': Investigation;
    /**
     * 
     * @type {number}
     * @memberof InvestigationReleaseReturnedResponse
     */
    'releasedCount': number;
    /**
     * True when the 10,000-item cap was hit; release again for the rest
     * @type {boolean}
     * @memberof InvestigationReleaseReturnedResponse
     */
    'moreToRelease'?: boolean;
}
/**
 * A \"remind me\" (on a case, or for the CBE check). SCHEDULING until the worker has handed it to the Notifications service, then SCHEDULED (notificationId set) or FAILED (error).
 * @export
 * @interface InvestigationReminder
 */
export interface InvestigationReminder {
    /**
     * 
     * @type {string}
     * @memberof InvestigationReminder
     */
    'remindAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReminder
     */
    'setBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReminder
     */
    'setAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReminder
     */
    'status'?: InvestigationReminderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReminder
     */
    'notificationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReminder
     */
    'error'?: string;
}

export const InvestigationReminderStatusEnum = {
    Scheduling: 'SCHEDULING',
    Scheduled: 'SCHEDULED',
    Failed: 'FAILED'
} as const;

export type InvestigationReminderStatusEnum = typeof InvestigationReminderStatusEnum[keyof typeof InvestigationReminderStatusEnum];

/**
 * 
 * @export
 * @interface InvestigationReminderRequest
 */
export interface InvestigationReminderRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationReminderRequest
     */
    'expectedVersion': number;
    /**
     * When to remind, ISO 8601 with a zone, 5 minutes to 7 days from now
     * @type {string}
     * @memberof InvestigationReminderRequest
     */
    'remindAt': string;
}
/**
 * 
 * @export
 * @interface InvestigationResolution
 */
export interface InvestigationResolution {
    /**
     * 
     * @type {InvestigationResolutionReason}
     * @memberof InvestigationResolution
     */
    'reason'?: InvestigationResolutionReason;
    /**
     * 
     * @type {string}
     * @memberof InvestigationResolution
     */
    'resolvedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationResolution
     */
    'resolvedAt'?: string;
}
/**
 * Why the case was closed, as Lusca reports it (output). Callers set a reason with InvestigationResolutionReasonInput, which excludes the two Lusca-recorded values: WITHDRAWN is the fixed reason on the resolution block of a case whose status is WITHDRAWN (so history rows carry one field to read), and MERGED is recorded by the merge action on a source absorbed into `mergedIntoInvestigationId`, which cannot be reopened. DUPLICATE may be chosen by a person, and is also what Lusca records when a freshly created case\'s claim won no items (`duplicateOfInvestigationId`); such a case cannot be reopened.
 * @export
 * @enum {string}
 */

export const InvestigationResolutionReason = {
    FixedAndRedriven: 'FIXED_AND_REDRIVEN',
    FixedWithoutRedrive: 'FIXED_WITHOUT_REDRIVE',
    DeletedWithoutRedrive: 'DELETED_WITHOUT_REDRIVE',
    NoActionRequired: 'NO_ACTION_REQUIRED',
    Duplicate: 'DUPLICATE',
    Superseded: 'SUPERSEDED',
    Withdrawn: 'WITHDRAWN',
    Merged: 'MERGED'
} as const;

export type InvestigationResolutionReason = typeof InvestigationResolutionReason[keyof typeof InvestigationResolutionReason];

/**
 * Reason a caller may give on a RESOLVED transition (required there, with a conclusion summary). Matches the backend\'s RESOLUTION_REASONS; WITHDRAWN and MERGED are rejected.
 * @export
 * @enum {string}
 */

export const InvestigationResolutionReasonInput = {
    FixedAndRedriven: 'FIXED_AND_REDRIVEN',
    FixedWithoutRedrive: 'FIXED_WITHOUT_REDRIVE',
    DeletedWithoutRedrive: 'DELETED_WITHOUT_REDRIVE',
    NoActionRequired: 'NO_ACTION_REQUIRED',
    Duplicate: 'DUPLICATE',
    Superseded: 'SUPERSEDED'
} as const;

export type InvestigationResolutionReasonInput = typeof InvestigationResolutionReasonInput[keyof typeof InvestigationResolutionReasonInput];

/**
 * How an attempt\'s returns split against the case\'s rule.
 * @export
 * @interface InvestigationReturnSummary
 */
export interface InvestigationReturnSummary {
    /**
     * Returns that still match the case\'s rule (failed the same way again)
     * @type {number}
     * @memberof InvestigationReturnSummary
     */
    'sameError'?: number;
    /**
     * Returns that came back with an error the case\'s rule no longer matches
     * @type {number}
     * @memberof InvestigationReturnSummary
     */
    'newError'?: number;
    /**
     * New-error returns another active case already owned, by investigation id
     * @type {{ [key: string]: number; }}
     * @memberof InvestigationReturnSummary
     */
    'elsewhere'?: { [key: string]: number; };
    /**
     * New-error returns by error_type (top 20, the rest under \"other\")
     * @type {{ [key: string]: number; }}
     * @memberof InvestigationReturnSummary
     */
    'newErrorTypes'?: { [key: string]: number; };
}
/**
 * A redriven message that came back to the DLQ.
 * @export
 * @interface InvestigationReturnedItem
 */
export interface InvestigationReturnedItem {
    /**
     * 
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'dlqPk'?: string;
    /**
     * The PK redriven, when the message returned under a new PK.
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'previousDlqPk'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'attemptId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'detectedAt'?: string;
    /**
     * True when the returned message still matches the case\'s rule (it failed the same way again); false when it came back with a different error. Absent for returns recorded before classification.
     * @type {boolean}
     * @memberof InvestigationReturnedItem
     */
    'matchesRule'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'errorType'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'errorCategory'?: string;
    /**
     * Another active investigation that already owned this new-error return when it was detected.
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'heldBy'?: string;
    /**
     * When the owner released this new-error return (or it was found no longer held here).
     * @type {string}
     * @memberof InvestigationReturnedItem
     */
    'releasedAt'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationReturnedItemsPage
 */
export interface InvestigationReturnedItemsPage {
    /**
     * 
     * @type {Array<InvestigationReturnedItem>}
     * @memberof InvestigationReturnedItemsPage
     */
    'items'?: Array<InvestigationReturnedItem>;
    /**
     * Every return recorded on the investigation (its returnedCount).
     * @type {number}
     * @memberof InvestigationReturnedItemsPage
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationReturnedItemsPage
     */
    'nextToken'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationRowRequest
 */
export interface InvestigationRowRequest {
    /**
     * 
     * @type {string}
     * @memberof InvestigationRowRequest
     */
    'dlqPk': string;
    /**
     * Seed field values from the dashboard row used to build the suggested rule
     * @type {{ [key: string]: string; }}
     * @memberof InvestigationRowRequest
     */
    'seed'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface InvestigationRowResolution
 */
export interface InvestigationRowResolution {
    /**
     * 
     * @type {string}
     * @memberof InvestigationRowResolution
     */
    'dlqPk'?: string;
    /**
     * `ambiguous` is deprecated and no longer returned — contested items resolve to the narrowest rule, then the oldest case. Kept in the enum for compatibility.
     * @type {string}
     * @memberof InvestigationRowResolution
     */
    'state'?: InvestigationRowResolutionStateEnum;
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationRowResolution
     */
    'primary'?: Investigation;
    /**
     * 
     * @type {Array<InvestigationOverlap>}
     * @memberof InvestigationRowResolution
     */
    'history'?: Array<InvestigationOverlap>;
    /**
     * Deprecated — always empty now that `state` is never `ambiguous`; kept for compatibility.
     * @type {Array<InvestigationOverlap>}
     * @memberof InvestigationRowResolution
     * @deprecated
     */
    'ambiguousCandidates'?: Array<InvestigationOverlap>;
    /**
     * Conjunction of predicates describing the live population (one rule branch): every field pinned must match (an `in` field matches any of its values).
     * @type {Array<InvestigationPredicate>}
     * @memberof InvestigationRowResolution
     */
    'suggestedRule'?: Array<InvestigationPredicate>;
    /**
     * True when exactly one active rule matches the row but the hourly reconciliation has not assigned it yet
     * @type {boolean}
     * @memberof InvestigationRowResolution
     */
    'assignmentPending'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestigationRowResolution
     */
    'registryTimestamp'?: string;
}

export const InvestigationRowResolutionStateEnum = {
    Uninvestigated: 'uninvestigated',
    Active: 'active',
    Resolved: 'resolved',
    Ambiguous: 'ambiguous'
} as const;

export type InvestigationRowResolutionStateEnum = typeof InvestigationRowResolutionStateEnum[keyof typeof InvestigationRowResolutionStateEnum];

/**
 * 
 * @export
 * @interface InvestigationSample
 */
export interface InvestigationSample {
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'dlqPk'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'dlqTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'eventsourcekey'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'errorType'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'errorCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'glProductGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'marketplaceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'usecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'digitalOrderSource'?: string;
    /**
     * Boolean as stored in the snapshot (\"true\" / \"false\")
     * @type {string}
     * @memberof InvestigationSample
     */
    'isEmpOrder'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'destination'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'accountingOperation'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'paymentProcessor'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSample
     */
    'orderId'?: string;
    /**
     * Active investigation currently owning this item, if any
     * @type {string}
     * @memberof InvestigationSample
     */
    'primaryInvestigationId'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationSplitListRequest
 */
export interface InvestigationSplitListRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationSplitListRequest
     */
    'expectedVersion': number;
    /**
     * Only count what would move; nothing is written
     * @type {boolean}
     * @memberof InvestigationSplitListRequest
     */
    'dryRun'?: boolean;
    /**
     * DLQ keys (at most 50,000; blanks ignored)
     * @type {Array<string>}
     * @memberof InvestigationSplitListRequest
     */
    'lines': Array<string>;
    /**
     * Title of the child (required unless dryRun)
     * @type {string}
     * @memberof InvestigationSplitListRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSplitListRequest
     */
    'initialComment'?: string;
    /**
     * Owner of the child (default the caller); must be a Lusca Search user
     * @type {string}
     * @memberof InvestigationSplitListRequest
     */
    'owner'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationSplitListResult
 */
export interface InvestigationSplitListResult {
    /**
     * How the lines were read (always DLQ keys)
     * @type {string}
     * @memberof InvestigationSplitListResult
     */
    'kind': InvestigationSplitListResultKindEnum;
    /**
     * Items of this case the list matches
     * @type {number}
     * @memberof InvestigationSplitListResult
     */
    'matchedCount': number;
    /**
     * Distinct listed keys that matched an item
     * @type {number}
     * @memberof InvestigationSplitListResult
     */
    'matchedIdCount'?: number;
    /**
     * Distinct list entries that match nothing this case or another active case holds
     * @type {number}
     * @memberof InvestigationSplitListResult
     */
    'unmatchedCount': number;
    /**
     * The first 200 unmatched entries
     * @type {Array<string>}
     * @memberof InvestigationSplitListResult
     */
    'unmatched'?: Array<string>;
    /**
     * Listed DLQ keys another active investigation holds (e.g. a child already split off), grouped by that investigation. Not counted in unmatchedCount.
     * @type {Array<InvestigationOtherOwner>}
     * @memberof InvestigationSplitListResult
     */
    'heldElsewhere'?: Array<InvestigationOtherOwner>;
    /**
     * 
     * @type {number}
     * @memberof InvestigationSplitListResult
     */
    'heldElsewhereCount'?: number;
    /**
     * Items left in this case after the split
     * @type {number}
     * @memberof InvestigationSplitListResult
     */
    'remainingCount': number;
    /**
     * Up to 5 matched items (transaction ID or order ID, else DLQ key)
     * @type {Array<string>}
     * @memberof InvestigationSplitListResult
     */
    'samples'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSplitListResult
     */
    'childInvestigationId'?: string;
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationSplitListResult
     */
    'investigation'?: Investigation;
    /**
     * 
     * @type {number}
     * @memberof InvestigationSplitListResult
     */
    'assignedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationSplitListResult
     */
    'conflictedCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationSplitListResult
     */
    'assignmentPending'?: boolean;
}

export const InvestigationSplitListResultKindEnum = {
    DlqPk: 'dlq_pk'
} as const;

export type InvestigationSplitListResultKindEnum = typeof InvestigationSplitListResultKindEnum[keyof typeof InvestigationSplitListResultKindEnum];

/**
 * Investigation lifecycle status. EXECUTING_REDRIVE and MONITORING_REDRIVE are set by Lusca only; the one human move into MONITORING_REDRIVE is unblocking a case blocked from it. RESOLVED and WITHDRAWN are the two terminal states and both release the population: RESOLVED claims an outcome (resolutionReason + conclusion summary required); WITHDRAWN cancels a case that should not have been opened (wrong scope, mistake, consolidated into a wider one) — the items are simply back in the pool, no outcome is claimed and the case is never reported as resolved. Withdrawing requires a conclusion summary only. Both reopen to INVESTIGATING.
 * @export
 * @enum {string}
 */

export const InvestigationStatus = {
    Investigating: 'INVESTIGATING',
    Blocked: 'BLOCKED',
    FixInProgress: 'FIX_IN_PROGRESS',
    ReadyToRedrive: 'READY_TO_REDRIVE',
    ExecutingRedrive: 'EXECUTING_REDRIVE',
    MonitoringRedrive: 'MONITORING_REDRIVE',
    Resolved: 'RESOLVED',
    Withdrawn: 'WITHDRAWN'
} as const;

export type InvestigationStatus = typeof InvestigationStatus[keyof typeof InvestigationStatus];

/**
 * 
 * @export
 * @interface InvestigationSuggestion
 */
export interface InvestigationSuggestion {
    /**
     * The TrackStars report the pattern comes from (the latest one unless earlierReport is set)
     * @type {string}
     * @memberof InvestigationSuggestion
     */
    'reportId'?: string;
    /**
     * 
     * @type {InvestigationSuggestionEarlierReport}
     * @memberof InvestigationSuggestion
     */
    'earlierReport'?: InvestigationSuggestionEarlierReport;
    /**
     * Set on an investigation\'s own run patterns (getInvestigationTrackStarsRunPatterns) — items of that investigation the pattern matched
     * @type {number}
     * @memberof InvestigationSuggestion
     */
    'runItems'?: number;
    /**
     * Other patterns of the same report that describe the same finding, folded into this one
     * @type {Array<string>}
     * @memberof InvestigationSuggestion
     */
    'mergedPatternIds'?: Array<string>;
    /**
     * Pattern items no case owns yet, estimated from the reconciled backlog
     * @type {number}
     * @memberof InvestigationSuggestion
     */
    'unownedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestion
     */
    'patternId': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestion
     */
    'description': string;
    /**
     * P1 (critical) … P4 (low)
     * @type {string}
     * @memberof InvestigationSuggestion
     */
    'priority': string;
    /**
     * high, medium or low
     * @type {string}
     * @memberof InvestigationSuggestion
     */
    'confidence': string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationSuggestion
     */
    'confidencePct'?: number;
    /**
     * Items TrackStars validated as matching the pattern in its window
     * @type {number}
     * @memberof InvestigationSuggestion
     */
    'totalMatches': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationSuggestion
     */
    'affectedQueues'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationSuggestion
     */
    'affectedGlGroups'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationSuggestion
     */
    'affectedMarketplaces'?: Array<string>;
    /**
     * 
     * @type {TrackStarsRootCause}
     * @memberof InvestigationSuggestion
     */
    'rootCause'?: TrackStarsRootCause;
    /**
     * error_category name TrackStars proposes for the Glue job
     * @type {string}
     * @memberof InvestigationSuggestion
     */
    'suggestedCategory'?: string | null;
    /**
     * The PySpark .when() clause verbatim
     * @type {string}
     * @memberof InvestigationSuggestion
     */
    'suggestedWhenClause'?: string | null;
    /**
     * 
     * @type {TrackStarsRecommendedAction}
     * @memberof InvestigationSuggestion
     */
    'recommendedAction'?: TrackStarsRecommendedAction;
    /**
     * 
     * @type {Array<TrackStarsSample>}
     * @memberof InvestigationSuggestion
     */
    'samples'?: Array<TrackStarsSample>;
    /**
     * Conjunction of predicates describing the live population (one rule branch): every field pinned must match (an `in` field matches any of its values).
     * @type {Array<InvestigationPredicate>}
     * @memberof InvestigationSuggestion
     */
    'derivedRule': Array<InvestigationPredicate>;
    /**
     * Substrings the error message must contain; the builder pins the templated value(s) the preview shows
     * @type {Array<string>}
     * @memberof InvestigationSuggestion
     */
    'messageConstraints'?: Array<string>;
    /**
     * 
     * @type {Array<InvestigationSuggestionConstraint>}
     * @memberof InvestigationSuggestion
     */
    'constraints'?: Array<InvestigationSuggestionConstraint>;
    /**
     * Plain-language record of how the rule was derived from the pattern
     * @type {Array<string>}
     * @memberof InvestigationSuggestion
     */
    'derivationNotes'?: Array<string>;
    /**
     * A condition of the when-clause on a rule field could not be read (an OR across fields, an unsupported function…), so the derived rule is wider than the pattern
     * @type {boolean}
     * @memberof InvestigationSuggestion
     */
    'approximate'?: boolean;
    /**
     * 
     * @type {InvestigationSuggestionOwnership}
     * @memberof InvestigationSuggestion
     */
    'ownership': InvestigationSuggestionOwnership;
    /**
     * 
     * @type {InvestigationSuggestionStarter}
     * @memberof InvestigationSuggestion
     */
    'starter': InvestigationSuggestionStarter;
}
/**
 * Text conditions from the when-clause on one field that a rule cannot express directly. The field must carry every `contains` substring, none of the `excludes` substrings, and equal none of `notIn`.
 * @export
 * @interface InvestigationSuggestionConstraint
 */
export interface InvestigationSuggestionConstraint {
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionConstraint
     */
    'field': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationSuggestionConstraint
     */
    'contains': Array<string>;
    /**
     * Substrings the field must not contain (a negated .contains in the clause)
     * @type {Array<string>}
     * @memberof InvestigationSuggestionConstraint
     */
    'excludes'?: Array<string>;
    /**
     * Values the field must not equal (!= / ~isin in the clause)
     * @type {Array<string>}
     * @memberof InvestigationSuggestionConstraint
     */
    'notIn'?: Array<string>;
}
/**
 * Set when the pattern is not in the latest report but an open case was started from it; the pattern is read from that archived report so the case keeps its origin
 * @export
 * @interface InvestigationSuggestionEarlierReport
 */
export interface InvestigationSuggestionEarlierReport {
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionEarlierReport
     */
    'reportId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionEarlierReport
     */
    'generatedAt'?: string | null;
    /**
     * 
     * @type {InvestigationSuggestionEarlierReportDateRange}
     * @memberof InvestigationSuggestionEarlierReport
     */
    'dateRange'?: InvestigationSuggestionEarlierReportDateRange;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionEarlierReport
     */
    'reportUrl'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationSuggestionEarlierReportDateRange
 */
export interface InvestigationSuggestionEarlierReportDateRange {
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionEarlierReportDateRange
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionEarlierReportDateRange
     */
    'endDate'?: string | null;
}
/**
 * 
 * @export
 * @interface InvestigationSuggestionOwnership
 */
export interface InvestigationSuggestionOwnership {
    /**
     * owned when an active investigation covers the whole pattern (rule identical or wider, or the case records this pattern as its origin); partial when active cases hold some of it; unowned otherwise
     * @type {string}
     * @memberof InvestigationSuggestionOwnership
     */
    'state': InvestigationSuggestionOwnershipStateEnum;
    /**
     * 
     * @type {Array<InvestigationSuggestionOwnershipInvestigationsInner>}
     * @memberof InvestigationSuggestionOwnership
     */
    'investigations': Array<InvestigationSuggestionOwnershipInvestigationsInner>;
}

export const InvestigationSuggestionOwnershipStateEnum = {
    Unowned: 'unowned',
    Partial: 'partial',
    Owned: 'owned'
} as const;

export type InvestigationSuggestionOwnershipStateEnum = typeof InvestigationSuggestionOwnershipStateEnum[keyof typeof InvestigationSuggestionOwnershipStateEnum];

/**
 * 
 * @export
 * @interface InvestigationSuggestionOwnershipInvestigationsInner
 */
export interface InvestigationSuggestionOwnershipInvestigationsInner {
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionOwnershipInvestigationsInner
     */
    'investigationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionOwnershipInvestigationsInner
     */
    'title'?: string;
    /**
     * 
     * @type {InvestigationStatus}
     * @memberof InvestigationSuggestionOwnershipInvestigationsInner
     */
    'status'?: InvestigationStatus;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionOwnershipInvestigationsInner
     */
    'owner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationSuggestionOwnershipInvestigationsInner
     */
    'relation'?: InvestigationSuggestionOwnershipInvestigationsInnerRelationEnum;
    /**
     * Items this case owns, all of them pattern items; set only when the case\'s rule sits inside the pattern\'s
     * @type {number}
     * @memberof InvestigationSuggestionOwnershipInvestigationsInner
     */
    'ownedCount'?: number;
}

export const InvestigationSuggestionOwnershipInvestigationsInnerRelationEnum = {
    Origin: 'origin',
    Covers: 'covers',
    Partial: 'partial'
} as const;

export type InvestigationSuggestionOwnershipInvestigationsInnerRelationEnum = typeof InvestigationSuggestionOwnershipInvestigationsInnerRelationEnum[keyof typeof InvestigationSuggestionOwnershipInvestigationsInnerRelationEnum];

/**
 * Ready-to-use creation extras — pass as title, description, initialComment and links to createInvestigation
 * @export
 * @interface InvestigationSuggestionStarter
 */
export interface InvestigationSuggestionStarter {
    /**
     * Registry-style title derived from the rule (\"<error type> (<scope>) on <queue>\")
     * @type {string}
     * @memberof InvestigationSuggestionStarter
     */
    'title': string;
    /**
     * TrackStars\' one-sentence diagnosis, for the case description
     * @type {string}
     * @memberof InvestigationSuggestionStarter
     */
    'description'?: string;
    /**
     * A short triage note (why, evidence, fix, provenance)
     * @type {string}
     * @memberof InvestigationSuggestionStarter
     */
    'comment': string;
    /**
     * The recommended action in plain words
     * @type {string}
     * @memberof InvestigationSuggestionStarter
     */
    'fix'?: string;
    /**
     * 
     * @type {Array<InvestigationLinkInput>}
     * @memberof InvestigationSuggestionStarter
     */
    'links': Array<InvestigationLinkInput>;
}
/**
 * 
 * @export
 * @interface InvestigationSuggestionsResult
 */
export interface InvestigationSuggestionsResult {
    /**
     * False when no TrackStars report has been imported for the stage
     * @type {boolean}
     * @memberof InvestigationSuggestionsResult
     */
    'available': boolean;
    /**
     * 
     * @type {Stage}
     * @memberof InvestigationSuggestionsResult
     */
    'stage'?: Stage;
    /**
     * 
     * @type {TrackStarsReportSummary}
     * @memberof InvestigationSuggestionsResult
     */
    'report'?: TrackStarsReportSummary;
    /**
     * 
     * @type {Array<InvestigationSuggestion>}
     * @memberof InvestigationSuggestionsResult
     */
    'suggestions': Array<InvestigationSuggestion>;
    /**
     * Report recommendations not tied to one pattern (taxonomy changes, tooling) — not populations
     * @type {Array<TrackStarsRecommendation>}
     * @memberof InvestigationSuggestionsResult
     */
    'otherRecommendations'?: Array<TrackStarsRecommendation>;
}
/**
 * A revision of a PVAccounting pipeline deployment group.
 * @export
 * @interface InvestigationTargetRevision
 */
export interface InvestigationTargetRevision {
    /**
     * 
     * @type {string}
     * @memberof InvestigationTargetRevision
     */
    'revision'?: string;
    /**
     * The version set revision, e.g. PVAccounting/development@B6524559840.
     * @type {string}
     * @memberof InvestigationTargetRevision
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTargetRevision
     */
    'timestamp'?: string;
}
/**
 * The Taskei task (or SIM issue) tracking this investigation. Only metadata is stored here; the task\'s content lives in Taskei.
 * @export
 * @interface InvestigationTask
 */
export interface InvestigationTask {
    /**
     * Task short id (ROOM-123) or UUID as it appears in the URL
     * @type {string}
     * @memberof InvestigationTask
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTask
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTask
     */
    'linkedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTask
     */
    'linkedAt'?: string;
}
/**
 * Set by the worker when the linked Taskei task disagrees with the investigation — someone changed the task directly in Taskei. Lusca stays the source of truth; the UI offers to apply the task\'s change to the investigation (transfer / resolve / reopen) or to push the investigation\'s state back onto the task. Cleared when they agree again.
 * @export
 * @interface InvestigationTaskDrift
 */
export interface InvestigationTaskDrift {
    /**
     * Alias the task is assigned to in Taskei (null = unassigned)
     * @type {string}
     * @memberof InvestigationTaskDrift
     */
    'taskAssignee'?: string | null;
    /**
     * Task status as Lusca sees it, open or closed
     * @type {string}
     * @memberof InvestigationTaskDrift
     */
    'taskStatus'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationTaskDrift
     */
    'assigneeDiffers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationTaskDrift
     */
    'statusDiffers'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTaskDrift
     */
    'seenAt'?: string;
}
/**
 * Link a Taskei task or SIM issue to the investigation by URL (or bare task id)
 * @export
 * @interface InvestigationTaskLink
 */
export interface InvestigationTaskLink {
    /**
     * 
     * @type {string}
     * @memberof InvestigationTaskLink
     */
    'url': string;
}
/**
 * Why there is no automatically maintained task. Absent while everything is in step. DEFERRED = the service identity is not (yet) authorised, the next ownership or status change retries; FAILED = the last attempt errored; UNLINKED = someone detached the task on purpose, so the worker will not create another until one is linked by hand.
 * @export
 * @interface InvestigationTaskSync
 */
export interface InvestigationTaskSync {
    /**
     * 
     * @type {string}
     * @memberof InvestigationTaskSync
     */
    'status'?: InvestigationTaskSyncStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTaskSync
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTaskSync
     */
    'by'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTaskSync
     */
    'at'?: string;
}

export const InvestigationTaskSyncStatusEnum = {
    Deferred: 'DEFERRED',
    Failed: 'FAILED',
    Unlinked: 'UNLINKED'
} as const;

export type InvestigationTaskSyncStatusEnum = typeof InvestigationTaskSyncStatusEnum[keyof typeof InvestigationTaskSyncStatusEnum];

/**
 * 
 * @export
 * @interface InvestigationTimelinePage
 */
export interface InvestigationTimelinePage {
    /**
     * 
     * @type {Array<InvestigationEvent>}
     * @memberof InvestigationTimelinePage
     */
    'events'?: Array<InvestigationEvent>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTimelinePage
     */
    'nextToken'?: string;
}
/**
 * The latest TrackStars run requested on this investigation.
 * @export
 * @interface InvestigationTrackStarsRun
 */
export interface InvestigationTrackStarsRun {
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'mode': InvestigationTrackStarsRunModeEnum;
    /**
     * REQUESTED until TrackStars writes back; SCORING while its patterns are counted in the population; COMPLETED with `result`, or FAILED with `error`.
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'status': InvestigationTrackStarsRunStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'requestedAt': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'requestedBy': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'receivedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'completedAt'?: string;
    /**
     * Who TrackStars wrote back as.
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'completedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'reportKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRun
     */
    'error'?: string;
    /**
     * 
     * @type {InvestigationTrackStarsRunResult}
     * @memberof InvestigationTrackStarsRun
     */
    'result'?: InvestigationTrackStarsRunResult;
}

export const InvestigationTrackStarsRunModeEnum = {
    Categorise: 'categorise',
    Analyse: 'analyse'
} as const;

export type InvestigationTrackStarsRunModeEnum = typeof InvestigationTrackStarsRunModeEnum[keyof typeof InvestigationTrackStarsRunModeEnum];
export const InvestigationTrackStarsRunStatusEnum = {
    Requested: 'REQUESTED',
    Scoring: 'SCORING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type InvestigationTrackStarsRunStatusEnum = typeof InvestigationTrackStarsRunStatusEnum[keyof typeof InvestigationTrackStarsRunStatusEnum];

/**
 * 
 * @export
 * @interface InvestigationTrackStarsRunPattern
 */
export interface InvestigationTrackStarsRunPattern {
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'patternId': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'confidence'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'confidencePct'?: number;
    /**
     * Items of this investigation the pattern matches.
     * @type {number}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'items': number;
    /**
     * Conjunction of predicates describing the live population (one rule branch): every field pinned must match (an `in` field matches any of its values).
     * @type {Array<InvestigationPredicate>}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'rule': Array<InvestigationPredicate>;
    /**
     * 
     * @type {Array<InvestigationSuggestionConstraint>}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'constraints': Array<InvestigationSuggestionConstraint>;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'approximate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'whenClause'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'rootCause'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'actionType'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationTrackStarsRunPattern
     */
    'notes': Array<string>;
}
/**
 * 
 * @export
 * @interface InvestigationTrackStarsRunPatterns
 */
export interface InvestigationTrackStarsRunPatterns {
    /**
     * False when the investigation has no completed TrackStars run (or its report is unreadable)
     * @type {boolean}
     * @memberof InvestigationTrackStarsRunPatterns
     */
    'available': boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunPatterns
     */
    'runId'?: string;
    /**
     * 
     * @type {TrackStarsReportSummary}
     * @memberof InvestigationTrackStarsRunPatterns
     */
    'report'?: TrackStarsReportSummary;
    /**
     * Most items of this investigation first, at most 30; each carries runItems.
     * @type {Array<InvestigationSuggestion>}
     * @memberof InvestigationTrackStarsRunPatterns
     */
    'suggestions': Array<InvestigationSuggestion>;
}
/**
 * 
 * @export
 * @interface InvestigationTrackStarsRunResult
 */
export interface InvestigationTrackStarsRunResult {
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunResult
     */
    'reportId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrackStarsRunResult
     */
    'generatedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvestigationTrackStarsRunResult
     */
    'totalItems': number;
    /**
     * Items matched by at least one pattern.
     * @type {number}
     * @memberof InvestigationTrackStarsRunResult
     */
    'explainedItems': number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationTrackStarsRunResult
     */
    'explainedPct': number;
    /**
     * 
     * @type {number}
     * @memberof InvestigationTrackStarsRunResult
     */
    'patternCount': number;
    /**
     * Set when one pattern with a category explains at least 90% of the items.
     * @type {string}
     * @memberof InvestigationTrackStarsRunResult
     */
    'suggestedTitle'?: string;
    /**
     * True when the run renamed the investigation to suggestedTitle (its title was not chosen by a person).
     * @type {boolean}
     * @memberof InvestigationTrackStarsRunResult
     */
    'renamed'?: boolean;
    /**
     * Largest first, at most 30.
     * @type {Array<InvestigationTrackStarsRunPattern>}
     * @memberof InvestigationTrackStarsRunResult
     */
    'patterns': Array<InvestigationTrackStarsRunPattern>;
}
/**
 * 
 * @export
 * @interface InvestigationTransferRequest
 */
export interface InvestigationTransferRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationTransferRequest
     */
    'expectedVersion': number;
    /**
     * Alias of the new owner; must appear in GET /investigations/assignees
     * @type {string}
     * @memberof InvestigationTransferRequest
     */
    'newOwner': string;
}
/**
 * 
 * @export
 * @interface InvestigationTrendMarker
 */
export interface InvestigationTrendMarker {
    /**
     * When the event happened (ISO 8601 UTC)
     * @type {string}
     * @memberof InvestigationTrendMarker
     */
    't': string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationTrendMarker
     */
    'kind': InvestigationTrendMarkerKindEnum;
    /**
     * Human-readable label, e.g. \"Split: 1,084 items to inv-…\"
     * @type {string}
     * @memberof InvestigationTrendMarker
     */
    'label': string;
}

export const InvestigationTrendMarkerKindEnum = {
    Split: 'split',
    Merge: 'merge',
    Redrive: 'redrive',
    Fix: 'fix',
    Resolved: 'resolved'
} as const;

export type InvestigationTrendMarkerKindEnum = typeof InvestigationTrendMarkerKindEnum[keyof typeof InvestigationTrendMarkerKindEnum];

/**
 * 
 * @export
 * @interface InvestigationTrendPoint
 */
export interface InvestigationTrendPoint {
    /**
     * Snapshot time (ISO 8601 UTC)
     * @type {string}
     * @memberof InvestigationTrendPoint
     */
    't': string;
    /**
     * Items at that snapshot: for an investigation the owned items still in the DLQ (the Items column), for a backlog group its unassigned count
     * @type {number}
     * @memberof InvestigationTrendPoint
     */
    'n': number;
    /**
     * Investigations only - rows the live rule matched (including items owned elsewhere)
     * @type {number}
     * @memberof InvestigationTrendPoint
     */
    'live'?: number;
    /**
     * Investigations only - summed estimated USD impact
     * @type {number}
     * @memberof InvestigationTrendPoint
     */
    'impact'?: number;
    /**
     * True when n is a group-level estimate (oversized investigation)
     * @type {boolean}
     * @memberof InvestigationTrendPoint
     */
    'est'?: boolean;
}
/**
 * 
 * @export
 * @interface InvestigationUpdateRequest
 */
export interface InvestigationUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationUpdateRequest
     */
    'expectedVersion': number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationUpdateRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationUpdateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {InvestigationStatus}
     * @memberof InvestigationUpdateRequest
     */
    'status'?: InvestigationStatus;
    /**
     * 
     * @type {InvestigationBlocker}
     * @memberof InvestigationUpdateRequest
     */
    'blocker'?: InvestigationBlocker;
    /**
     * 
     * @type {InvestigationLink}
     * @memberof InvestigationUpdateRequest
     */
    'addLink'?: InvestigationLink;
    /**
     * Several evidence links at once (e.g. the comment links picked when resolving). URLs the case already has are skipped. A link without a label is labelled with the id in its URL (CR-123, TRACK-123, MCM-123), else the URL.
     * @type {Array<InvestigationLink>}
     * @memberof InvestigationUpdateRequest
     */
    'addLinks'?: Array<InvestigationLink>;
    /**
     * 
     * @type {InvestigationLinkEdit}
     * @memberof InvestigationUpdateRequest
     */
    'editLink'?: InvestigationLinkEdit;
    /**
     * URL of an evidence link to delete (adder or owner only)
     * @type {string}
     * @memberof InvestigationUpdateRequest
     */
    'removeLink'?: string;
    /**
     * 
     * @type {InvestigationTaskLink}
     * @memberof InvestigationUpdateRequest
     */
    'linkTask'?: InvestigationTaskLink;
    /**
     * Detach the linked Taskei task (linker or owner only). The task itself is untouched.
     * @type {boolean}
     * @memberof InvestigationUpdateRequest
     */
    'unlinkTask'?: boolean;
    /**
     * Re-assert the investigation\'s owner and status onto the linked Taskei task (owner only). Used to resolve reported taskDrift in Lusca\'s favour.
     * @type {boolean}
     * @memberof InvestigationUpdateRequest
     */
    'pushTaskState'?: boolean;
    /**
     * Alias to take off the contributors (the owner may remove anyone; a contributor may remove themselves). Their unread notifications on this investigation are cleared. 404 when the alias is not a contributor, 403 NOT_OWNER otherwise.
     * @type {string}
     * @memberof InvestigationUpdateRequest
     */
    'removeContributor'?: string;
    /**
     * 
     * @type {InvestigationConclusion}
     * @memberof InvestigationUpdateRequest
     */
    'conclusion'?: InvestigationConclusion;
    /**
     * 
     * @type {InvestigationResolutionReasonInput}
     * @memberof InvestigationUpdateRequest
     */
    'resolutionReason'?: InvestigationResolutionReasonInput;
    /**
     * Clear the caller\'s own notifications on this investigation. A passive read — no timeline event, no activity timestamp change.
     * @type {boolean}
     * @memberof InvestigationUpdateRequest
     */
    'acknowledgeNotifications'?: boolean;
}
/**
 * 
 * @export
 * @interface InvestigationVersionedRequest
 */
export interface InvestigationVersionedRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationVersionedRequest
     */
    'expectedVersion': number;
}
/**
 * 
 * @export
 * @interface InvestigationWidenRuleRequest
 */
export interface InvestigationWidenRuleRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestigationWidenRuleRequest
     */
    'expectedVersion': number;
    /**
     * Conjunction of predicates describing the live population (one rule branch): every field pinned must match (an `in` field matches any of its values).
     * @type {Array<InvestigationPredicate>}
     * @memberof InvestigationWidenRuleRequest
     */
    'rule': Array<InvestigationPredicate>;
    /**
     * The TrackStars pattern the rule comes from, recorded on the event
     * @type {string}
     * @memberof InvestigationWidenRuleRequest
     */
    'patternId'?: string;
    /**
     * Title for the widened rule; applied only when no person chose the current title (titleSource is not user)
     * @type {string}
     * @memberof InvestigationWidenRuleRequest
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationWidenRuleResponse
 */
export interface InvestigationWidenRuleResponse {
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationWidenRuleResponse
     */
    'investigation': Investigation;
    /**
     * False when the investigation\'s rule already covered the given rule
     * @type {boolean}
     * @memberof InvestigationWidenRuleResponse
     */
    'ruleWidened': boolean;
}
/**
 * 
 * @export
 * @interface ListProjects200Response
 */
export interface ListProjects200Response {
    /**
     * 
     * @type {Array<Project>}
     * @memberof ListProjects200Response
     */
    'projects'?: Array<Project>;
}
/**
 * 
 * @export
 * @interface MatchSetEntry
 */
export interface MatchSetEntry {
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'matchKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'matchSetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'state'?: MatchSetEntryStateEnum;
    /**
     * 
     * @type {MatchSetEntryAmount}
     * @memberof MatchSetEntry
     */
    'amount'?: MatchSetEntryAmount;
    /**
     * 
     * @type {number}
     * @memberof MatchSetEntry
     */
    'numCredits'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchSetEntry
     */
    'numDebits'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'accountingDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'matchKeyType'?: string;
}

export const MatchSetEntryStateEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED',
    Partial: 'PARTIAL',
    Pending: 'PENDING',
    Unknown: 'UNKNOWN'
} as const;

export type MatchSetEntryStateEnum = typeof MatchSetEntryStateEnum[keyof typeof MatchSetEntryStateEnum];

/**
 * 
 * @export
 * @interface MatchSetEntryAmount
 */
export interface MatchSetEntryAmount {
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntryAmount
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntryAmount
     */
    'currencyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntryAmount
     */
    'creditValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntryAmount
     */
    'debitValue'?: string;
}
/**
 * 
 * @export
 * @interface MatchSetResponse
 */
export interface MatchSetResponse {
    /**
     * 
     * @type {Array<MatchSetEntry>}
     * @memberof MatchSetResponse
     */
    'matchSets'?: Array<MatchSetEntry>;
}
/**
 * 
 * @export
 * @interface MatchSetsQueryError
 */
export interface MatchSetsQueryError {
    /**
     * 
     * @type {string}
     * @memberof MatchSetsQueryError
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetsQueryError
     */
    'details'?: string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface OrderContentsResponse
 */
export interface OrderContentsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OrderContentsResponse
     */
    'found'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderContentsResponse
     */
    'eventVersion'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderContentsResponse
     */
    'totalProducts'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderContentsResponse
     */
    'realProductCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderContentsResponse
     */
    'placeholderCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderContentsResponse
     */
    'placeholderProductIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderContentsResponse
     */
    'realProductIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrderContentsResponse
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface OrderRedriveInfoResult
 */
export interface OrderRedriveInfoResult {
    /**
     * The ID of the redrive execution
     * @type {string}
     * @memberof OrderRedriveInfoResult
     */
    'executionId'?: string;
    /**
     * The number of orders redriven
     * @type {number}
     * @memberof OrderRedriveInfoResult
     */
    'orders'?: number;
    /**
     * The name of the executor
     * @type {string}
     * @memberof OrderRedriveInfoResult
     */
    'executor'?: string;
    /**
     * The stage that the redrive was executed on
     * @type {string}
     * @memberof OrderRedriveInfoResult
     */
    'stage'?: string;
    /**
     * The status of the Redrive (was it successful, is it still executing, etc.)
     * @type {string}
     * @memberof OrderRedriveInfoResult
     */
    'status'?: string;
    /**
     * When was the redrive executed
     * @type {number}
     * @memberof OrderRedriveInfoResult
     */
    'timestamp'?: number;
}
/**
 * The current status of a payment
 * @export
 * @enum {string}
 */

export const PaymentStatus = {
    PaymentInitiated: 'PaymentInitiated',
    PaymentRejected: 'PaymentRejected',
    PaymentFxReceived: 'PaymentFXReceived'
} as const;

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];

/**
 * 
 * @export
 * @interface PostDLQRedriveInfoRequest
 */
export interface PostDLQRedriveInfoRequest {
    /**
     * Array of DLQ primary keys (pk field from DLQItem, NOT message_id)
     * @type {Array<string>}
     * @memberof PostDLQRedriveInfoRequest
     */
    'messageIds'?: Array<string>;
    /**
     * S3 URI of uploaded CSV file containing message IDs
     * @type {string}
     * @memberof PostDLQRedriveInfoRequest
     */
    'messageIdsS3Uri'?: string;
    /**
     * ETag of the uploaded S3 file for validation
     * @type {string}
     * @memberof PostDLQRedriveInfoRequest
     */
    'messageIdsS3Etag'?: string;
    /**
     * MCM ID (required when deleteWithoutRedriving is true)
     * @type {string}
     * @memberof PostDLQRedriveInfoRequest
     */
    'mcmId'?: string;
    /**
     * If true, validate without executing
     * @type {boolean}
     * @memberof PostDLQRedriveInfoRequest
     */
    'dryRun'?: boolean;
    /**
     * If true, delete messages without redriving (requires mcmId)
     * @type {boolean}
     * @memberof PostDLQRedriveInfoRequest
     */
    'deleteWithoutRedriving'?: boolean;
}
/**
 * 
 * @export
 * @interface PostDLQRedriveMcm201Response
 */
export interface PostDLQRedriveMcm201Response {
    /**
     * 
     * @type {string}
     * @memberof PostDLQRedriveMcm201Response
     */
    'mcmId': string;
    /**
     * 
     * @type {string}
     * @memberof PostDLQRedriveMcm201Response
     */
    'mcmUrl': string;
    /**
     * Warning when the Draft MCM was created but its description could not be verified
     * @type {string}
     * @memberof PostDLQRedriveMcm201Response
     */
    'warning'?: string;
}
/**
 * 
 * @export
 * @interface PostDLQRedriveMcmRequest
 */
export interface PostDLQRedriveMcmRequest {
    /**
     * DLQ primary keys for the manual-pk path
     * @type {Array<string>}
     * @memberof PostDLQRedriveMcmRequest
     */
    'messageIds'?: Array<string>;
    /**
     * S3 URI of the already-uploaded DLQ primary-key CSV
     * @type {string}
     * @memberof PostDLQRedriveMcmRequest
     */
    'messageIdsS3Uri'?: string;
    /**
     * ETag of the already-uploaded CSV
     * @type {string}
     * @memberof PostDLQRedriveMcmRequest
     */
    'messageIdsS3Etag'?: string;
    /**
     * Optional SIM issue URL included in the MCM description
     * @type {string}
     * @memberof PostDLQRedriveMcmRequest
     */
    'simLink'?: string;
    /**
     * Optional Athena query included in the MCM description for audit context
     * @type {string}
     * @memberof PostDLQRedriveMcmRequest
     */
    'athenaQuery'?: string;
}
/**
 * 
 * @export
 * @interface PostPaymentRedriveBulkRequest
 */
export interface PostPaymentRedriveBulkRequest {
    /**
     * S3 URI of the uploaded CSV file. Use the s3Uri value returned by GET /payment-redrive-upload-url to ensure the fileName is resolved correctly by the step function. 
     * @type {string}
     * @memberof PostPaymentRedriveBulkRequest
     */
    's3_uri': string;
}
/**
 * 
 * @export
 * @interface PostPaymentRedriveRequest
 */
export interface PostPaymentRedriveRequest {
    /**
     * Primary key of the cost document to redrive
     * @type {string}
     * @memberof PostPaymentRedriveRequest
     */
    'pk': string;
}
/**
 * 
 * @export
 * @interface PostRedriveInfo202Response
 */
export interface PostRedriveInfo202Response {
    /**
     * 
     * @type {string}
     * @memberof PostRedriveInfo202Response
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveInfo202Response
     */
    'executionArn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveInfo202Response
     */
    'executionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveInfo202Response
     */
    'fileName'?: string;
}
/**
 * 
 * @export
 * @interface PostRedriveInfoRequest
 */
export interface PostRedriveInfoRequest {
    /**
     * S3 URI of the uploaded CSV file. Use the s3Uri value returned by GET /redrive-upload-url to ensure the fileName is resolved correctly by the step function. 
     * @type {string}
     * @memberof PostRedriveInfoRequest
     */
    's3_uri': string;
}
/**
 * 
 * @export
 * @interface PostRedriveOrder202Response
 */
export interface PostRedriveOrder202Response {
    /**
     * 
     * @type {string}
     * @memberof PostRedriveOrder202Response
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveOrder202Response
     */
    'executionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveOrder202Response
     */
    'fileName'?: string;
}
/**
 * 
 * @export
 * @interface PostRedriveOrderRequest
 */
export interface PostRedriveOrderRequest {
    /**
     * The single transaction or order ID to redrive
     * @type {string}
     * @memberof PostRedriveOrderRequest
     */
    'orderId': string;
}
/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'lastModifiedBy': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'lastModified': string;
    /**
     * 
     * @type {Array<ProjectTransaction>}
     * @memberof Project
     */
    'transactions': Array<ProjectTransaction>;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    'version': number;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    'isArchived': boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Project
     */
    'metadata'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ProjectCreate
 */
export interface ProjectCreate {
    /**
     * 
     * @type {string}
     * @memberof ProjectCreate
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCreate
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProjectCreate
     */
    'metadata'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ProjectTransaction
 */
export interface ProjectTransaction {
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'txnStatus': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'uatStatus': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'assignedTo': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'addedBy': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'addedAt': string;
}
/**
 * 
 * @export
 * @interface ProjectUpdate
 */
export interface ProjectUpdate {
    /**
     * 
     * @type {string}
     * @memberof ProjectUpdate
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectUpdate
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProjectUpdate
     */
    'metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof ProjectUpdate
     */
    'isArchived'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProjectUpdate
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface ProjectValidationCase
 */
export interface ProjectValidationCase {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'taskGid': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'taskName': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'taskUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'orderId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'verdict': ProjectValidationCaseVerdictEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'assessment': ProjectValidationCaseAssessmentEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectValidationCase
     */
    'retestRecommended': boolean;
    /**
     * 
     * @type {{ [key: string]: ProjectValidationFieldResult; }}
     * @memberof ProjectValidationCase
     */
    'fields': { [key: string]: ProjectValidationFieldResult; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectValidationCase
     */
    'scopeErrors': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectValidationCase
     */
    'sourceRefs': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'validatorVersion': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'actionCatalogVersion': string;
}

export const ProjectValidationCaseVerdictEnum = {
    MatchesScope: 'matches_scope',
    Mismatch: 'mismatch',
    NeedsReview: 'needs_review'
} as const;

export type ProjectValidationCaseVerdictEnum = typeof ProjectValidationCaseVerdictEnum[keyof typeof ProjectValidationCaseVerdictEnum];
export const ProjectValidationCaseAssessmentEnum = {
    MatchesScope: 'matches_scope',
    WrongOrder: 'wrong_order',
    AccountingMismatch: 'accounting_mismatch',
    CannotVerify: 'cannot_verify',
    IncompleteScope: 'incomplete_scope'
} as const;

export type ProjectValidationCaseAssessmentEnum = typeof ProjectValidationCaseAssessmentEnum[keyof typeof ProjectValidationCaseAssessmentEnum];

/**
 * 
 * @export
 * @interface ProjectValidationCounts
 */
export interface ProjectValidationCounts {
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'matchesScope': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'mismatch': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'needsReview': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'incomplete': number;
}
/**
 * 
 * @export
 * @interface ProjectValidationFieldResult
 */
export interface ProjectValidationFieldResult {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationFieldResult
     */
    'verdict': ProjectValidationFieldResultVerdictEnum;
    /**
     * Bounded scalar or string-list expected value
     * @type {any}
     * @memberof ProjectValidationFieldResult
     */
    'expected'?: any | null;
    /**
     * Bounded scalar or string-list observed value
     * @type {any}
     * @memberof ProjectValidationFieldResult
     */
    'observed'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationFieldResult
     */
    'reasonCode': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationFieldResult
     */
    'reason': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectValidationFieldResult
     */
    'evidenceRefs': Array<string>;
}

export const ProjectValidationFieldResultVerdictEnum = {
    Match: 'match',
    Mismatch: 'mismatch',
    NotVerifiable: 'not_verifiable',
    NotApplicable: 'not_applicable'
} as const;

export type ProjectValidationFieldResultVerdictEnum = typeof ProjectValidationFieldResultVerdictEnum[keyof typeof ProjectValidationFieldResultVerdictEnum];

/**
 * 
 * @export
 * @interface ProjectValidationProgress
 */
export interface ProjectValidationProgress {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationProgress
     */
    'phase': ProjectValidationProgressPhaseEnum;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationProgress
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationProgress
     */
    'completed': number;
}

export const ProjectValidationProgressPhaseEnum = {
    Queued: 'queued',
    Loading: 'loading',
    Validating: 'validating'
} as const;

export type ProjectValidationProgressPhaseEnum = typeof ProjectValidationProgressPhaseEnum[keyof typeof ProjectValidationProgressPhaseEnum];

/**
 * 
 * @export
 * @interface ProjectValidationResult
 */
export interface ProjectValidationResult {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationResult
     */
    'schemaVersion': ProjectValidationResultSchemaVersionEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationResult
     */
    'projectGid': string;
    /**
     * 
     * @type {ProjectValidationStage}
     * @memberof ProjectValidationResult
     */
    'stage': ProjectValidationStage;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationResult
     */
    'sourceReadAt': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationResult
     */
    'sourceTaskCount': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationResult
     */
    'durationMs': number;
    /**
     * 
     * @type {ProjectValidationCounts}
     * @memberof ProjectValidationResult
     */
    'counts': ProjectValidationCounts;
    /**
     * 
     * @type {Array<ProjectValidationCase>}
     * @memberof ProjectValidationResult
     */
    'cases': Array<ProjectValidationCase>;
}

export const ProjectValidationResultSchemaVersionEnum = {
    _1: '1'
} as const;

export type ProjectValidationResultSchemaVersionEnum = typeof ProjectValidationResultSchemaVersionEnum[keyof typeof ProjectValidationResultSchemaVersionEnum];

/**
 * 
 * @export
 * @interface ProjectValidationRunSummary
 */
export interface ProjectValidationRunSummary {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'status': ProjectValidationRunSummaryStatusEnum;
    /**
     * 
     * @type {ProjectValidationStage}
     * @memberof ProjectValidationRunSummary
     */
    'stage': ProjectValidationStage;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'completedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'sourceReadAt': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationRunSummary
     */
    'sourceTaskCount': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationRunSummary
     */
    'durationMs': number;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'asanaProjectGid': string;
    /**
     * 
     * @type {ProjectValidationCounts}
     * @memberof ProjectValidationRunSummary
     */
    'counts': ProjectValidationCounts;
}

export const ProjectValidationRunSummaryStatusEnum = {
    Completed: 'completed'
} as const;

export type ProjectValidationRunSummaryStatusEnum = typeof ProjectValidationRunSummaryStatusEnum[keyof typeof ProjectValidationRunSummaryStatusEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ProjectValidationStage = {
    Beta: 'beta',
    Gamma: 'gamma',
    Prod: 'prod'
} as const;

export type ProjectValidationStage = typeof ProjectValidationStage[keyof typeof ProjectValidationStage];

/**
 * 
 * @export
 * @interface PsnsRedriveInfoResult
 */
export interface PsnsRedriveInfoResult {
    /**
     * The status of the redrive execution (e.g., \"PENDING\", \"COMPLETED\", \"ERROR\")
     * @type {string}
     * @memberof PsnsRedriveInfoResult
     */
    'status': string;
    /**
     * The ARN of the redrive execution (present when status is \"PENDING\")
     * @type {string}
     * @memberof PsnsRedriveInfoResult
     */
    'executionArn'?: string;
    /**
     * 
     * @type {PsnsRedriveInfoResultResult}
     * @memberof PsnsRedriveInfoResult
     */
    'result'?: PsnsRedriveInfoResultResult;
    /**
     * 
     * @type {PsnsRedriveInfoResultMetadata}
     * @memberof PsnsRedriveInfoResult
     */
    'metadata'?: PsnsRedriveInfoResultMetadata;
    /**
     * 
     * @type {string}
     * @memberof PsnsRedriveInfoResult
     */
    'error'?: string;
}
/**
 * Execution metadata for the detail view (who/when/what was redriven)
 * @export
 * @interface PsnsRedriveInfoResultMetadata
 */
export interface PsnsRedriveInfoResultMetadata {
    /**
     * Alias of the user who started the redrive
     * @type {string}
     * @memberof PsnsRedriveInfoResultMetadata
     */
    'executor'?: string;
    /**
     * Epoch seconds when the redrive was started
     * @type {number}
     * @memberof PsnsRedriveInfoResultMetadata
     */
    'timestamp'?: number;
    /**
     * Whether the redrive was a dry run
     * @type {boolean}
     * @memberof PsnsRedriveInfoResultMetadata
     */
    'dryRun'?: boolean;
    /**
     * Human-readable request type (\"Redrive\", \"Dry run\")
     * @type {string}
     * @memberof PsnsRedriveInfoResultMetadata
     */
    'requestType'?: string;
    /**
     * Number of events in the uploaded file, when resolvable
     * @type {number}
     * @memberof PsnsRedriveInfoResultMetadata
     */
    'eventCount'?: number;
    /**
     * S3 URI of the uploaded NDJSON file
     * @type {string}
     * @memberof PsnsRedriveInfoResultMetadata
     */
    'eventsS3Uri'?: string;
}
/**
 * 
 * @export
 * @interface PsnsRedriveInfoResultResult
 */
export interface PsnsRedriveInfoResultResult {
    /**
     * Mapping of event_id to status (PUBLISHED, DRY_RUN, INVALID, FAILED, SKIPPED)
     * @type {{ [key: string]: any; }}
     * @memberof PsnsRedriveInfoResultResult
     */
    'publishedEvents'?: { [key: string]: any; };
    /**
     * True when a large file redrive\'s per-event results were capped
     * @type {boolean}
     * @memberof PsnsRedriveInfoResultResult
     */
    'truncated'?: boolean;
    /**
     * S3 prefix holding the full sanitized per-event results (present when truncated)
     * @type {string}
     * @memberof PsnsRedriveInfoResultResult
     */
    'resultsS3Uri'?: string;
    /**
     * 
     * @type {PsnsRedriveInfoResultResultCounts}
     * @memberof PsnsRedriveInfoResultResult
     */
    'counts'?: PsnsRedriveInfoResultResultCounts;
    /**
     * Error code from failed execution
     * @type {string}
     * @memberof PsnsRedriveInfoResultResult
     */
    'error'?: string;
    /**
     * Detailed error message from failed execution
     * @type {string}
     * @memberof PsnsRedriveInfoResultResult
     */
    'cause'?: string;
}
/**
 * Event-level totals (from the DistributedMap item counts), present when resolvable
 * @export
 * @interface PsnsRedriveInfoResultResultCounts
 */
export interface PsnsRedriveInfoResultResultCounts {
    /**
     * Total events the redrive attempted
     * @type {number}
     * @memberof PsnsRedriveInfoResultResultCounts
     */
    'total'?: number;
    /**
     * Events published to EventBridge (0 for a dry run)
     * @type {number}
     * @memberof PsnsRedriveInfoResultResultCounts
     */
    'published'?: number;
    /**
     * Events that failed validation or PutEvents
     * @type {number}
     * @memberof PsnsRedriveInfoResultResultCounts
     */
    'failed'?: number;
    /**
     * Events rejected by structural validation
     * @type {number}
     * @memberof PsnsRedriveInfoResultResultCounts
     */
    'invalid'?: number;
    /**
     * Events that never ran (skipped after the redrive failed)
     * @type {number}
     * @memberof PsnsRedriveInfoResultResultCounts
     */
    'pending'?: number;
}
/**
 * 
 * @export
 * @interface PublishMockAcadiaInvoice202Response
 */
export interface PublishMockAcadiaInvoice202Response {
    /**
     * 
     * @type {string}
     * @memberof PublishMockAcadiaInvoice202Response
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishMockAcadiaInvoice202Response
     */
    'executionArn'?: string;
}
/**
 * 
 * @export
 * @interface PublishMockAcadiaInvoiceRequest
 */
export interface PublishMockAcadiaInvoiceRequest {
    /**
     * paymentId for the invoice
     * @type {string}
     * @memberof PublishMockAcadiaInvoiceRequest
     */
    'paymentId': string;
    /**
     * paymentDate for the invoice
     * @type {string}
     * @memberof PublishMockAcadiaInvoiceRequest
     */
    'paymentDate': string;
}
/**
 * 
 * @export
 * @interface QueryMatchSetsRequest
 */
export interface QueryMatchSetsRequest {
    /**
     * 
     * @type {Stage}
     * @memberof QueryMatchSetsRequest
     */
    'stage': Stage;
    /**
     * Match Set Accounting realm
     * @type {string}
     * @memberof QueryMatchSetsRequest
     */
    'realm': QueryMatchSetsRequestRealmEnum;
    /**
     * Match keys to look up
     * @type {Array<string>}
     * @memberof QueryMatchSetsRequest
     */
    'matchKeys': Array<string>;
}

export const QueryMatchSetsRequestRealmEnum = {
    Na: 'na',
    Eu: 'eu',
    Fe: 'fe'
} as const;

export type QueryMatchSetsRequestRealmEnum = typeof QueryMatchSetsRequestRealmEnum[keyof typeof QueryMatchSetsRequestRealmEnum];

/**
 * 
 * @export
 * @interface RavenChatUatAnalysisDispatchRequest
 */
export interface RavenChatUatAnalysisDispatchRequest {
    /**
     * 
     * @type {string}
     * @memberof RavenChatUatAnalysisDispatchRequest
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof RavenChatUatAnalysisDispatchRequest
     */
    'testVersion': number;
}
/**
 * 
 * @export
 * @interface RavenChatUatAnalysisDispatchResponse
 */
export interface RavenChatUatAnalysisDispatchResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RavenChatUatAnalysisDispatchResponse
     */
    'accepted': RavenChatUatAnalysisDispatchResponseAcceptedEnum;
}

export const RavenChatUatAnalysisDispatchResponseAcceptedEnum = {
    True: true
} as const;

export type RavenChatUatAnalysisDispatchResponseAcceptedEnum = typeof RavenChatUatAnalysisDispatchResponseAcceptedEnum[keyof typeof RavenChatUatAnalysisDispatchResponseAcceptedEnum];

/**
 * 
 * @export
 * @interface RavenChatUatAnalysisRequest
 */
export interface RavenChatUatAnalysisRequest {
    /**
     * 
     * @type {string}
     * @memberof RavenChatUatAnalysisRequest
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof RavenChatUatAnalysisRequest
     */
    'testTimestamp': number;
    /**
     * 
     * @type {boolean}
     * @memberof RavenChatUatAnalysisRequest
     */
    'expectedPassed': boolean;
}
/**
 * 
 * @export
 * @interface RavenChatUatAnalysisResponse
 */
export interface RavenChatUatAnalysisResponse {
    /**
     * 
     * @type {string}
     * @memberof RavenChatUatAnalysisResponse
     */
    'analysisStatus': RavenChatUatAnalysisResponseAnalysisStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RavenChatUatAnalysisResponse
     */
    'analysis'?: string;
}

export const RavenChatUatAnalysisResponseAnalysisStatusEnum = {
    Pending: 'PENDING',
    Complete: 'COMPLETE',
    Unavailable: 'UNAVAILABLE'
} as const;

export type RavenChatUatAnalysisResponseAnalysisStatusEnum = typeof RavenChatUatAnalysisResponseAnalysisStatusEnum[keyof typeof RavenChatUatAnalysisResponseAnalysisStatusEnum];

/**
 * 
 * @export
 * @interface RecentTransactionsResponse
 */
export interface RecentTransactionsResponse {
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof RecentTransactionsResponse
     */
    'transactions': Array<Transaction>;
    /**
     * Timestamp to use for fetching the next page of results
     * @type {number}
     * @memberof RecentTransactionsResponse
     */
    'nextPageTimestamp'?: number;
    /**
     * The CloudWatch Logs Insights query that was executed
     * @type {string}
     * @memberof RecentTransactionsResponse
     */
    'executedQuery'?: string;
}
/**
 * 
 * @export
 * @interface RelatedInvestigation
 */
export interface RelatedInvestigation {
    /**
     * 
     * @type {string}
     * @memberof RelatedInvestigation
     */
    'investigationId': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedInvestigation
     */
    'relation': RelatedInvestigationRelationEnum;
    /**
     * Absent when the related record could not be read
     * @type {string}
     * @memberof RelatedInvestigation
     */
    'title'?: string;
    /**
     * 
     * @type {InvestigationStatus}
     * @memberof RelatedInvestigation
     */
    'status'?: InvestigationStatus;
    /**
     * 
     * @type {string}
     * @memberof RelatedInvestigation
     */
    'owner'?: string | null;
    /**
     * Conjunction of predicates describing the live population (one rule branch): every field pinned must match (an `in` field matches any of its values).
     * @type {Array<InvestigationPredicate>}
     * @memberof RelatedInvestigation
     */
    'rule'?: Array<InvestigationPredicate>;
    /**
     * Disjunction of rule branches: an item belongs to the population when ANY branch matches. Unmerged investigations have exactly one branch (identical to `rule`); merging appends the source rules as further branches.
     * @type {Array<Array<InvestigationPredicate>>}
     * @memberof RelatedInvestigation
     */
    'rules'?: Array<Array<InvestigationPredicate>>;
    /**
     * Frozen population size of the related investigation
     * @type {number}
     * @memberof RelatedInvestigation
     */
    'populationCount'?: number;
    /**
     * Predicates that distinguish the narrower rule from the wider one along a parent/child edge: for a child, the predicates it added to this investigation\'s rule (the split criteria); for the parent, the predicates this investigation added to the parent\'s rule. Empty for other relations.
     * @type {Array<InvestigationPredicate>}
     * @memberof RelatedInvestigation
     */
    'ruleDelta'?: Array<InvestigationPredicate>;
}

export const RelatedInvestigationRelationEnum = {
    Parent: 'parent',
    Child: 'child',
    RecurrenceOf: 'recurrence_of',
    Linked: 'linked',
    MergedFrom: 'merged_from',
    MergedInto: 'merged_into',
    DuplicateOf: 'duplicate_of'
} as const;

export type RelatedInvestigationRelationEnum = typeof RelatedInvestigationRelationEnum[keyof typeof RelatedInvestigationRelationEnum];

/**
 * 
 * @export
 * @interface RetryDLQRedriveRequest
 */
export interface RetryDLQRedriveRequest {
    /**
     * ARN of the execution to retry (its input is reused verbatim)
     * @type {string}
     * @memberof RetryDLQRedriveRequest
     */
    'executionArn': string;
}
/**
 * 
 * @export
 * @interface ShadowTestClassificationsResponse
 */
export interface ShadowTestClassificationsResponse {
    /**
     * 
     * @type {Array<ClassificationEntry>}
     * @memberof ShadowTestClassificationsResponse
     */
    'classifications': Array<ClassificationEntry>;
}
/**
 * 
 * @export
 * @interface ShadowTestDiscrepancy
 */
export interface ShadowTestDiscrepancy {
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'field'?: string;
    /**
     * Component GTI for bundle orders
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'gti'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'usecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'prodValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'gammaValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'intent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'classification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestDiscrepancy
     */
    'passed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'jemValue'?: string;
}
/**
 * 
 * @export
 * @interface ShadowTestLine
 */
export interface ShadowTestLine {
    /**
     * MATCHED, GAMMA_UNIQUE, PROD_UNIQUE, or JEM_UNIQUE
     * @type {string}
     * @memberof ShadowTestLine
     */
    'type'?: string;
    /**
     * e.g. gamma, prod, gamma+prod, gamma+jem
     * @type {string}
     * @memberof ShadowTestLine
     */
    'environment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'classification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestLine
     */
    'passed'?: boolean;
    /**
     * Component GTI for bundle orders
     * @type {string}
     * @memberof ShadowTestLine
     */
    'gti'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'usecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'journalSide'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'costCenter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'project'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'channel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'productLine'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'glLineDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'functionalAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'localAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'functionalCurrency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'localCurrency'?: string;
    /**
     * Deprecated: equal to functionalCurrency. Read functionalCurrency/localCurrency instead.
     * @type {string}
     * @memberof ShadowTestLine
     * @deprecated
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'setOfBooks'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'matchKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'intent'?: string;
}
/**
 * 
 * @export
 * @interface ShadowTestMatchSet
 */
export interface ShadowTestMatchSet {
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'environment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'matchKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'classification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestMatchSet
     */
    'passed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestMatchSet
     */
    'closed'?: boolean;
}
/**
 * 
 * @export
 * @interface ShadowTestResponse
 */
export interface ShadowTestResponse {
    /**
     * Status message of the shadow test initiation
     * @type {string}
     * @memberof ShadowTestResponse
     */
    'message': string;
    /**
     * Number of orders included in the shadow test
     * @type {number}
     * @memberof ShadowTestResponse
     */
    'transactionsCount': number;
}
/**
 * 
 * @export
 * @interface ShadowTestResultResponse
 */
export interface ShadowTestResultResponse {
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'transactionId': string;
    /**
     * Legacy pass/fail result retained for backwards compatibility
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'passed'?: boolean;
    /**
     * Explicit tri-state shadow test result; absent on legacy responses
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'resultStatus'?: ShadowTestResultResponseResultStatusEnum;
    /**
     * Additional detail about the shadow test result status
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'resultStatusMessage'?: string;
    /**
     * Epoch millis when the test ran
     * @type {number}
     * @memberof ShadowTestResultResponse
     */
    'testTimestamp': number;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'glProductGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'paymentProvider'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'orderDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'isPromo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'isBundle'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'prodRevenueUsecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'gammaRevenueUsecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'prodRoyaltyUsecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'gammaRoyaltyUsecase'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowTestResultResponse
     */
    'prodUsecases'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowTestResultResponse
     */
    'gammaUsecases'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowTestResultResponse
     */
    'jemUsecases'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ShadowTestResultResponse
     */
    'totalProdLines'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShadowTestResultResponse
     */
    'totalGammaLines'?: number;
    /**
     * Map of reference key names to values (order_id, auid, subscription_id, etc.)
     * @type {{ [key: string]: string; }}
     * @memberof ShadowTestResultResponse
     */
    'referenceKeys'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<ShadowTestLine>}
     * @memberof ShadowTestResultResponse
     */
    'matchedLines'?: Array<ShadowTestLine>;
    /**
     * 
     * @type {Array<ShadowTestLine>}
     * @memberof ShadowTestResultResponse
     */
    'gammaUniqueLines'?: Array<ShadowTestLine>;
    /**
     * 
     * @type {Array<ShadowTestLine>}
     * @memberof ShadowTestResultResponse
     */
    'prodUniqueLines'?: Array<ShadowTestLine>;
    /**
     * 
     * @type {Array<ShadowTestLine>}
     * @memberof ShadowTestResultResponse
     */
    'jemUniqueLines'?: Array<ShadowTestLine>;
    /**
     * 
     * @type {Array<ShadowTestDiscrepancy>}
     * @memberof ShadowTestResultResponse
     */
    'discrepancies'?: Array<ShadowTestDiscrepancy>;
    /**
     * 
     * @type {Array<ShadowTestMatchSet>}
     * @memberof ShadowTestResultResponse
     */
    'matchSets'?: Array<ShadowTestMatchSet>;
    /**
     * Account balance pivot for gamma: glLineDescription -> accountNumber-companyCode -> signed amount
     * @type {{ [key: string]: { [key: string]: number; }; }}
     * @memberof ShadowTestResultResponse
     */
    'gammaPivot'?: { [key: string]: { [key: string]: number; }; };
    /**
     * Account balance pivot for prod: glLineDescription -> accountNumber-companyCode -> signed amount
     * @type {{ [key: string]: { [key: string]: number; }; }}
     * @memberof ShadowTestResultResponse
     */
    'prodPivot'?: { [key: string]: { [key: string]: number; }; };
    /**
     * Bundle orders only. Per-component gamma pivot: glLineDescription -> GTI -> accountNumber-companyCode -> signed amount
     * @type {{ [key: string]: { [key: string]: { [key: string]: number; }; }; }}
     * @memberof ShadowTestResultResponse
     */
    'gammaPivotByProduct'?: { [key: string]: { [key: string]: { [key: string]: number; }; }; };
    /**
     * Bundle orders only. Per-component prod pivot: glLineDescription -> GTI -> accountNumber-companyCode -> signed amount
     * @type {{ [key: string]: { [key: string]: { [key: string]: number; }; }; }}
     * @memberof ShadowTestResultResponse
     */
    'prodPivotByProduct'?: { [key: string]: { [key: string]: { [key: string]: number; }; }; };
    /**
     * Bundle orders only. Split validation rows: component GTI (plus a Total Bundle Level entry) -> cell name -> value
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof ShadowTestResultResponse
     */
    'bundleAllocation'?: { [key: string]: { [key: string]: string; }; };
    /**
     * Whether every populated bundle allocation cell matched
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'bundleAllocationPassed'?: boolean;
    /**
     * Whether the order payment total equals the summed component SSPs
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'bundleAllocationPaymentIntegrityPassed'?: boolean;
    /**
     * Financial amounts validation rows: key -> FinancialAmountRow
     * @type {{ [key: string]: FinancialAmountRow; }}
     * @memberof ShadowTestResultResponse
     */
    'financialAmounts'?: { [key: string]: FinancialAmountRow; };
    /**
     * Whether all source amounts match the USL amounts
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'sourceAmountCheckPassed'?: boolean;
}

export const ShadowTestResultResponseResultStatusEnum = {
    Passed: 'PASSED',
    Failed: 'FAILED',
    Blocked: 'BLOCKED'
} as const;

export type ShadowTestResultResponseResultStatusEnum = typeof ShadowTestResultResponseResultStatusEnum[keyof typeof ShadowTestResultResponseResultStatusEnum];

/**
 * environment name
 * @export
 * @enum {string}
 */

export const Stage = {
    Dev: 'Dev',
    Beta: 'Beta',
    Gamma: 'Gamma',
    Prod: 'Prod'
} as const;

export type Stage = typeof Stage[keyof typeof Stage];

/**
 * 
 * @export
 * @interface StartPsnsRedriveRequest
 */
export interface StartPsnsRedriveRequest {
    /**
     * S3 URI of the uploaded EventBridge-envelope NDJSON file
     * @type {string}
     * @memberof StartPsnsRedriveRequest
     */
    'eventsS3Uri': string;
    /**
     * ETag of the uploaded S3 file for validation
     * @type {string}
     * @memberof StartPsnsRedriveRequest
     */
    'eventsS3Etag': string;
    /**
     * If true, validate only and do not publish to EventBridge
     * @type {boolean}
     * @memberof StartPsnsRedriveRequest
     */
    'dryRun'?: boolean;
}
/**
 * 
 * @export
 * @interface SubmitInvestigationTrackStarsReport202Response
 */
export interface SubmitInvestigationTrackStarsReport202Response {
    /**
     * 
     * @type {Investigation}
     * @memberof SubmitInvestigationTrackStarsReport202Response
     */
    'investigation': Investigation;
    /**
     * 
     * @type {InvestigationTrackStarsRun}
     * @memberof SubmitInvestigationTrackStarsReport202Response
     */
    'trackstarsRun': InvestigationTrackStarsRun;
}
/**
 * 
 * @export
 * @interface SubmitInvestigationTrackStarsReportRequest
 */
export interface SubmitInvestigationTrackStarsReportRequest {
    /**
     * TrackStars DashboardReport (metadata, executive_summary, pattern_analysis[], recommendations[]); at most 1 MB.
     * @type {{ [key: string]: any; }}
     * @memberof SubmitInvestigationTrackStarsReportRequest
     */
    'report': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface TrackStarsRecommendation
 */
export interface TrackStarsRecommendation {
    /**
     * 
     * @type {string}
     * @memberof TrackStarsRecommendation
     */
    'priority'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsRecommendation
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsRecommendation
     */
    'confidence'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsRecommendation
     */
    'impact'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsRecommendation
     */
    'effort'?: string;
}
/**
 * 
 * @export
 * @interface TrackStarsRecommendedAction
 */
export interface TrackStarsRecommendedAction {
    /**
     * code_fix, foil_redrive, lusca_redrive, monitor, delete or investigate
     * @type {string}
     * @memberof TrackStarsRecommendedAction
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsRecommendedAction
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsRecommendedAction
     */
    'suggestedCodeFix'?: string | null;
    /**
     * foil_redrive (upstream re-emit run by TRACK, not a Lusca DLQ redrive) or lusca_redrive
     * @type {string}
     * @memberof TrackStarsRecommendedAction
     */
    'redriveMechanism'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsRecommendedAction
     */
    'relatedCommit'?: string | null;
}
/**
 * 
 * @export
 * @interface TrackStarsReportImportResult
 */
export interface TrackStarsReportImportResult {
    /**
     * 
     * @type {TrackStarsReportSummary}
     * @memberof TrackStarsReportImportResult
     */
    'report': TrackStarsReportSummary;
    /**
     * 
     * @type {number}
     * @memberof TrackStarsReportImportResult
     */
    'patternCount': number;
    /**
     * Pattern ids prefixed with the report id to keep them unique across reports
     * @type {number}
     * @memberof TrackStarsReportImportResult
     */
    'renumberedPatterns': number;
    /**
     * The stage\'s previous latest report, when a different one was replaced
     * @type {string}
     * @memberof TrackStarsReportImportResult
     */
    'replacedReportId'?: string | null;
}
/**
 * 
 * @export
 * @interface TrackStarsReportSummary
 */
export interface TrackStarsReportSummary {
    /**
     * 
     * @type {string}
     * @memberof TrackStarsReportSummary
     */
    'reportId': string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsReportSummary
     */
    'generatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsReportSummary
     */
    'generatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsReportSummary
     */
    'modelUsed'?: string;
    /**
     * 
     * @type {TrackStarsReportSummaryDateRange}
     * @memberof TrackStarsReportSummary
     */
    'dateRange'?: TrackStarsReportSummaryDateRange;
    /**
     * The report on the TrackStars dashboard
     * @type {string}
     * @memberof TrackStarsReportSummary
     */
    'reportUrl'?: string;
    /**
     * The narrative report document (SharePoint DOCX) when published
     * @type {string}
     * @memberof TrackStarsReportSummary
     */
    'documentUrl'?: string | null;
    /**
     * Uncategorized DLQ items in the report\'s window
     * @type {number}
     * @memberof TrackStarsReportSummary
     */
    'totalUncategorized'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackStarsReportSummary
     */
    'patternsFound'?: number;
    /**
     * Items the report\'s patterns explain
     * @type {number}
     * @memberof TrackStarsReportSummary
     */
    'transactionsCategorizable'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackStarsReportSummary
     */
    'categorizationImprovementPct'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackStarsReportSummary
     */
    'criticalFindings'?: Array<string>;
    /**
     * True when the report is older than staleAfterDays
     * @type {boolean}
     * @memberof TrackStarsReportSummary
     */
    'stale'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrackStarsReportSummary
     */
    'staleAfterDays'?: number;
}
/**
 * 
 * @export
 * @interface TrackStarsReportSummaryDateRange
 */
export interface TrackStarsReportSummaryDateRange {
    /**
     * 
     * @type {string}
     * @memberof TrackStarsReportSummaryDateRange
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsReportSummaryDateRange
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface TrackStarsRootCause
 */
export interface TrackStarsRootCause {
    /**
     * 
     * @type {string}
     * @memberof TrackStarsRootCause
     */
    'summary'?: string;
    /**
     * ingestion, accounting, publishing or unknown
     * @type {string}
     * @memberof TrackStarsRootCause
     */
    'layer'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackStarsRootCause
     */
    'evidence'?: Array<string>;
}
/**
 * A sample transaction from the report. Display only — the report\'s dlq_pk values are truncated, so none is carried.
 * @export
 * @interface TrackStarsSample
 */
export interface TrackStarsSample {
    /**
     * 
     * @type {string}
     * @memberof TrackStarsSample
     */
    'orderId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsSample
     */
    'transactionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsSample
     */
    'marketplaceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsSample
     */
    'glProductGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsSample
     */
    'eventsourcekey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackStarsSample
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * Either AUID or OrderId depending on GL code
     * @type {string}
     * @memberof Transaction
     */
    'id': string;
    /**
     * 
     * @type {Stage}
     * @memberof Transaction
     */
    'stage': Stage;
    /**
     * Country code (e.g., US, GB, DE)
     * @type {string}
     * @memberof Transaction
     */
    'country': string;
    /**
     * GL code (e.g., 318, 613)
     * @type {string}
     * @memberof Transaction
     */
    'gl': string;
    /**
     * Time when the transaction was processed
     * @type {string}
     * @memberof Transaction
     */
    'processedTime': string;
    /**
     * Simplified transaction type
     * @type {string}
     * @memberof Transaction
     */
    'usecase': string;
    /**
     * Payment method used for the transaction
     * @type {string}
     * @memberof Transaction
     */
    'paymentMethod': string;
    /**
     * Consumption Type for the transaction
     * @type {string}
     * @memberof Transaction
     */
    'consumptionType': string;
}
/**
 * 
 * @export
 * @interface TransactionCreate
 */
export interface TransactionCreate {
    /**
     * 
     * @type {string}
     * @memberof TransactionCreate
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreate
     */
    'assignedTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionCreate
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface TransactionUpdate
 */
export interface TransactionUpdate {
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdate
     */
    'txnStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdate
     */
    'uatStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdate
     */
    'assignedTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionUpdate
     */
    'version': number;
}
/**
 * Distinct values across every reconciled group (not just the current page or filter), sorted, for filter suggestions. Error messages are not enumerated (too many, free text).
 * @export
 * @interface UninvestigatedFilterOptions
 */
export interface UninvestigatedFilterOptions {
    /**
     * 
     * @type {Array<string>}
     * @memberof UninvestigatedFilterOptions
     */
    'queues'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UninvestigatedFilterOptions
     */
    'errorTypes'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UninvestigatedFilterOptions
     */
    'categories'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UninvestigatedGroup
 */
export interface UninvestigatedGroup {
    /**
     * 
     * @type {string}
     * @memberof UninvestigatedGroup
     */
    'eventsourcekey'?: string;
    /**
     * 
     * @type {string}
     * @memberof UninvestigatedGroup
     */
    'errorType'?: string;
    /**
     * 
     * @type {string}
     * @memberof UninvestigatedGroup
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof UninvestigatedGroup
     */
    'errorCategory'?: string;
    /**
     * 
     * @type {number}
     * @memberof UninvestigatedGroup
     */
    'count'?: number;
    /**
     * Summed estimated financial impact (USD) of the unassigned items in this group
     * @type {number}
     * @memberof UninvestigatedGroup
     */
    'impactUsd'?: number;
    /**
     * Deprecated — always 0 since overlap ownership became narrowest-rule-then-oldest-case (no AMBIGUOUS items); kept for compatibility, will be removed.
     * @type {number}
     * @memberof UninvestigatedGroup
     * @deprecated
     */
    'ambiguousCount'?: number;
    /**
     * Newest dlq_timestamp among the group\'s unassigned items, as snapshot text (\"YYYY-MM-DD HH:MM:SS.fff\", UTC); absent for reconciliations that predate this field
     * @type {string}
     * @memberof UninvestigatedGroup
     */
    'latestDlqTimestamp'?: string;
    /**
     * Group size per reconciled snapshot, oldest first (last snapshot of each day, 14 days). Category rows sum their members.
     * @type {Array<InvestigationTrendPoint>}
     * @memberof UninvestigatedGroup
     */
    'trend'?: Array<InvestigationTrendPoint>;
    /**
     * Latest count minus the earliest count within the last 7 days of snapshots; null while the group has been seen in only one snapshot.
     * @type {number}
     * @memberof UninvestigatedGroup
     */
    'growth7d'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UninvestigatedGroup
     */
    'sampleDlqPks'?: Array<string>;
    /**
     * Conjunction of predicates describing the live population (one rule branch): every field pinned must match (an `in` field matches any of its values).
     * @type {Array<InvestigationPredicate>}
     * @memberof UninvestigatedGroup
     */
    'suggestedRule'?: Array<InvestigationPredicate>;
    /**
     * Ids of patterns in the latest TrackStars report whose derived rule matches this group, so an identified-but-not-yet-categorised population is visible in the backlog.
     * @type {Array<string>}
     * @memberof UninvestigatedGroup
     */
    'trackstarsPatterns'?: Array<string>;
    /**
     * Category view only: how many reconciled groups this row stands for (a category row or one of its members). Absent on a plain group.
     * @type {number}
     * @memberof UninvestigatedGroup
     */
    'groupCount'?: number;
    /**
     * Category view only: distinct templated error messages among the row\'s groups. errorMessage is set when there is exactly one, null otherwise.
     * @type {number}
     * @memberof UninvestigatedGroup
     */
    'messageVariants'?: number;
    /**
     * Category view only, on a category row: its split by (queue, error type), highest impact first. Each member is itself a row (eventsourcekey, errorType, errorCategory set; sizes summed; suggestedRule pins queue, error type and category, plus the message when the member has a single variant).
     * @type {Array<UninvestigatedGroup>}
     * @memberof UninvestigatedGroup
     */
    'members'?: Array<UninvestigatedGroup>;
}
/**
 * 
 * @export
 * @interface UninvestigatedGroupsResult
 */
export interface UninvestigatedGroupsResult {
    /**
     * The requested page of groups
     * @type {Array<UninvestigatedGroup>}
     * @memberof UninvestigatedGroupsResult
     */
    'groups'?: Array<UninvestigatedGroup>;
    /**
     * Number of rows matching the filter (filter, q, uncategorizedOnly), before paging
     * @type {number}
     * @memberof UninvestigatedGroupsResult
     */
    'totalCount'?: number;
    /**
     * Number of groups in the latest reconciliation, unfiltered
     * @type {number}
     * @memberof UninvestigatedGroupsResult
     */
    'totalGroups'?: number;
    /**
     * Number of rows the unfiltered request would hold: totalGroups, or with groupByCategory the number of categories plus uncategorized groups
     * @type {number}
     * @memberof UninvestigatedGroupsResult
     */
    'totalRows'?: number;
    /**
     * 
     * @type {number}
     * @memberof UninvestigatedGroupsResult
     */
    'offset'?: number;
    /**
     * 
     * @type {UninvestigatedFilterOptions}
     * @memberof UninvestigatedGroupsResult
     */
    'filterOptions'?: UninvestigatedFilterOptions;
    /**
     * Summed item count across all groups matching the filter
     * @type {number}
     * @memberof UninvestigatedGroupsResult
     */
    'matchedItems'?: number;
    /**
     * Summed estimated impact (USD) across all groups matching the filter
     * @type {number}
     * @memberof UninvestigatedGroupsResult
     */
    'matchedImpactUsd'?: number;
    /**
     * Number of reconciled groups matching each countFilters entry, in request order (unfiltered by filter, q or uncategorizedOnly). Absent when countFilters was not given.
     * @type {Array<number>}
     * @memberof UninvestigatedGroupsResult
     */
    'filterCounts'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof UninvestigatedGroupsResult
     */
    'snapshotTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof UninvestigatedGroupsResult
     */
    'reconciledAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof UninvestigatedGroupsResult
     */
    'totalUnassigned'?: number;
    /**
     * Summed estimated financial impact (USD) across all unassigned items
     * @type {number}
     * @memberof UninvestigatedGroupsResult
     */
    'totalUnassignedImpactUsd'?: number;
    /**
     * Deprecated — always 0 since overlap ownership became narrowest-rule-then-oldest-case (no AMBIGUOUS items); kept for compatibility, will be removed.
     * @type {number}
     * @memberof UninvestigatedGroupsResult
     * @deprecated
     */
    'totalAmbiguous'?: number;
    /**
     * False when no reconciliation has run yet for the stage
     * @type {boolean}
     * @memberof UninvestigatedGroupsResult
     */
    'available'?: boolean;
}

/**
 * CbesApi - axios parameter creator
 * @export
 */
export const CbesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Rollup of CBE counts by usecase, operation, and publish status
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCbeSummary: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getCbeSummary', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getCbeSummary', 'orderId', orderId)
            const localVarPath = `/cbe-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of cbe\'s
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCbes: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getCbes', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getCbes', 'orderId', orderId)
            const localVarPath = `/cbes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDetails', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getDetails', 'orderId', orderId)
            const localVarPath = `/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Full Herd/USL failure detail (stack trace) for a single errored FLARE CBE
         * @param {Stage} stage environment name
         * @param {string} objectId The CBE\&#39;s Herd execution objectId
         * @param {string} realm The CBE\&#39;s accounting realm (selects the regional ORCA gateway)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHerdErrorDetail: async (stage: Stage, objectId: string, realm: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getHerdErrorDetail', 'stage', stage)
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getHerdErrorDetail', 'objectId', objectId)
            // verify required parameter 'realm' is not null or undefined
            assertParamExists('getHerdErrorDetail', 'realm', realm)
            const localVarPath = `/herd-error-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['objectId'] = objectId;
            }

            if (realm !== undefined) {
                localVarQueryParameter['realm'] = realm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CbesApi - functional programming interface
 * @export
 */
export const CbesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CbesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Rollup of CBE counts by usecase, operation, and publish status
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCbeSummary(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbeSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCbeSummary(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List of cbe\'s
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCbes(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Cbe>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCbes(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetails(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Full Herd/USL failure detail (stack trace) for a single errored FLARE CBE
         * @param {Stage} stage environment name
         * @param {string} objectId The CBE\&#39;s Herd execution objectId
         * @param {string} realm The CBE\&#39;s accounting realm (selects the regional ORCA gateway)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHerdErrorDetail(stage: Stage, objectId: string, realm: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HerdErrorDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHerdErrorDetail(stage, objectId, realm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CbesApi - factory interface
 * @export
 */
export const CbesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CbesApiFp(configuration)
    return {
        /**
         * 
         * @summary Rollup of CBE counts by usecase, operation, and publish status
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCbeSummary(stage: Stage, orderId: string, options?: any): AxiosPromise<CbeSummaryResponse> {
            return localVarFp.getCbeSummary(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of cbe\'s
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCbes(stage: Stage, orderId: string, options?: any): AxiosPromise<Array<Cbe>> {
            return localVarFp.getCbes(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails(stage: Stage, orderId: string, options?: any): AxiosPromise<DetailsResponse> {
            return localVarFp.getDetails(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Full Herd/USL failure detail (stack trace) for a single errored FLARE CBE
         * @param {Stage} stage environment name
         * @param {string} objectId The CBE\&#39;s Herd execution objectId
         * @param {string} realm The CBE\&#39;s accounting realm (selects the regional ORCA gateway)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHerdErrorDetail(stage: Stage, objectId: string, realm: string, options?: any): AxiosPromise<HerdErrorDetail> {
            return localVarFp.getHerdErrorDetail(stage, objectId, realm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CbesApi - object-oriented interface
 * @export
 * @class CbesApi
 * @extends {BaseAPI}
 */
export class CbesApi extends BaseAPI {
    /**
     * 
     * @summary Rollup of CBE counts by usecase, operation, and publish status
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CbesApi
     */
    public getCbeSummary(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return CbesApiFp(this.configuration).getCbeSummary(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of cbe\'s
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CbesApi
     */
    public getCbes(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return CbesApiFp(this.configuration).getCbes(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of CBEs and events
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CbesApi
     */
    public getDetails(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return CbesApiFp(this.configuration).getDetails(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Full Herd/USL failure detail (stack trace) for a single errored FLARE CBE
     * @param {Stage} stage environment name
     * @param {string} objectId The CBE\&#39;s Herd execution objectId
     * @param {string} realm The CBE\&#39;s accounting realm (selects the regional ORCA gateway)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CbesApi
     */
    public getHerdErrorDetail(stage: Stage, objectId: string, realm: string, options?: AxiosRequestConfig) {
        return CbesApiFp(this.configuration).getHerdErrorDetail(stage, objectId, realm, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ask questions about a transaction using an AI assistant grounded in Lusca data
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat: async (stage: Stage, chatRequest: ChatRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('chat', 'stage', stage)
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('chat', 'chatRequest', chatRequest)
            const localVarPath = `/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a chat turn in the background and return a job id to poll
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatAsync: async (stage: Stage, chatRequest: ChatRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('chatAsync', 'stage', stage)
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('chatAsync', 'chatRequest', chatRequest)
            const localVarPath = `/chat-async`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suggest short follow-up questions for the last chat Q&A
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatFollowups: async (stage: Stage, chatRequest: ChatRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('chatFollowups', 'stage', stage)
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('chatFollowups', 'chatRequest', chatRequest)
            const localVarPath = `/chat-followups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll an async chat job for its progress and, once done, its answer
         * @param {Stage} stage environment name
         * @param {string} jobId Job id returned by chat-async
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatStatus: async (stage: Stage, jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('chatStatus', 'stage', stage)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('chatStatus', 'jobId', jobId)
            const localVarPath = `/chat-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ask questions about a transaction using an AI assistant grounded in Lusca data
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chat(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chat(stage, chatRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start a chat turn in the background and return a job id to poll
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatAsync(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatAsyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatAsync(stage, chatRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Suggest short follow-up questions for the last chat Q&A
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatFollowups(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatFollowupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatFollowups(stage, chatRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Poll an async chat job for its progress and, once done, its answer
         * @param {Stage} stage environment name
         * @param {string} jobId Job id returned by chat-async
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatStatus(stage: Stage, jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatStatus(stage, jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * 
         * @summary Ask questions about a transaction using an AI assistant grounded in Lusca data
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat(stage: Stage, chatRequest: ChatRequest, options?: any): AxiosPromise<ChatResponse> {
            return localVarFp.chat(stage, chatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a chat turn in the background and return a job id to poll
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatAsync(stage: Stage, chatRequest: ChatRequest, options?: any): AxiosPromise<ChatAsyncResponse> {
            return localVarFp.chatAsync(stage, chatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suggest short follow-up questions for the last chat Q&A
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatFollowups(stage: Stage, chatRequest: ChatRequest, options?: any): AxiosPromise<ChatFollowupsResponse> {
            return localVarFp.chatFollowups(stage, chatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll an async chat job for its progress and, once done, its answer
         * @param {Stage} stage environment name
         * @param {string} jobId Job id returned by chat-async
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatStatus(stage: Stage, jobId: string, options?: any): AxiosPromise<ChatStatusResponse> {
            return localVarFp.chatStatus(stage, jobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * 
     * @summary Ask questions about a transaction using an AI assistant grounded in Lusca data
     * @param {Stage} stage environment name
     * @param {ChatRequest} chatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chat(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chat(stage, chatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a chat turn in the background and return a job id to poll
     * @param {Stage} stage environment name
     * @param {ChatRequest} chatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatAsync(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatAsync(stage, chatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suggest short follow-up questions for the last chat Q&A
     * @param {Stage} stage environment name
     * @param {ChatRequest} chatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatFollowups(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatFollowups(stage, chatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll an async chat job for its progress and, once done, its answer
     * @param {Stage} stage environment name
     * @param {string} jobId Job id returned by chat-async
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatStatus(stage: Stage, jobId: string, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatStatus(stage, jobId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ChatUatApi - axios parameter creator
 * @export
 */
export const ChatUatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Begin per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationRequest} asanaAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beginChatUatAsanaAuthorization: async (asanaAuthorizationRequest: AsanaAuthorizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asanaAuthorizationRequest' is not null or undefined
            assertParamExists('beginChatUatAsanaAuthorization', 'asanaAuthorizationRequest', asanaAuthorizationRequest)
            const localVarPath = `/chat-uat/asana/authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asanaAuthorizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationCompleteRequest} asanaAuthorizationCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeChatUatAsanaAuthorization: async (asanaAuthorizationCompleteRequest: AsanaAuthorizationCompleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asanaAuthorizationCompleteRequest' is not null or undefined
            assertParamExists('completeChatUatAsanaAuthorization', 'asanaAuthorizationCompleteRequest', asanaAuthorizationCompleteRequest)
            const localVarPath = `/chat-uat/asana/authorization/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asanaAuthorizationCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove the linked Asana scope while retaining validation history
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatUatAsanaScope: async (version: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('deleteChatUatAsanaScope', 'version', version)
            const localVarPath = `/chat-uat/validation/asana`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Queue persona analysis for one completed Raven result
         * @param {'dev' | 'prod'} ravenEnvironment 
         * @param {RavenChatUatAnalysisDispatchRequest} ravenChatUatAnalysisDispatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchRavenChatUatAnalysis: async (ravenEnvironment: 'dev' | 'prod', ravenChatUatAnalysisDispatchRequest: RavenChatUatAnalysisDispatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ravenEnvironment' is not null or undefined
            assertParamExists('dispatchRavenChatUatAnalysis', 'ravenEnvironment', ravenEnvironment)
            // verify required parameter 'ravenChatUatAnalysisDispatchRequest' is not null or undefined
            assertParamExists('dispatchRavenChatUatAnalysis', 'ravenChatUatAnalysisDispatchRequest', ravenChatUatAnalysisDispatchRequest)
            const localVarPath = `/iam/chat-uat/raven-analysis/dispatch/{ravenEnvironment}`
                .replace(`{${"ravenEnvironment"}}`, encodeURIComponent(String(ravenEnvironment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ravenChatUatAnalysisDispatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return bounded order content facts for ChatUAT validation
         * @param {string} orderId 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatContentFacts: async (orderId: string, stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getChatUatContentFacts', 'orderId', orderId)
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getChatUatContentFacts', 'stage', stage)
            const localVarPath = `/iam/chat-uat/content-facts/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a long-running ChatUAT turn
         * @param {string} conversationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatJob: async (conversationId: string, jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getChatUatJob', 'conversationId', conversationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getChatUatJob', 'jobId', jobId)
            const localVarPath = `/chat-uat/jobs/{conversationId}/{jobId}`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)))
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll a deterministic Asana-scope validation job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatScopeValidationJob: async (jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getChatUatScopeValidationJob', 'jobId', jobId)
            const localVarPath = `/chat-uat/validation/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one validation run and all bounded case results
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatScopeValidationRun: async (runId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getChatUatScopeValidationRun', 'runId', runId)
            const localVarPath = `/chat-uat/validation/runs/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the authenticated user\'s Asana validation state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatValidationState: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat-uat/validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search active Asana projects readable by the authenticated user
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChatUatAsanaProjects: async (query: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('listChatUatAsanaProjects', 'query', query)
            const localVarPath = `/chat-uat/validation/asana/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve a readable Asana project
         * @param {AsanaLinkPreviewRequest} asanaLinkPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewChatUatAsanaScope: async (asanaLinkPreviewRequest: AsanaLinkPreviewRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asanaLinkPreviewRequest' is not null or undefined
            assertParamExists('previewChatUatAsanaScope', 'asanaLinkPreviewRequest', asanaLinkPreviewRequest)
            const localVarPath = `/chat-uat/validation/asana/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asanaLinkPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a long-running ChatUAT turn
         * @param {ChatUatJobRequest} chatUatJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatUatJob: async (chatUatJobRequest: ChatUatJobRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatUatJobRequest' is not null or undefined
            assertParamExists('startChatUatJob', 'chatUatJobRequest', chatUatJobRequest)
            const localVarPath = `/chat-uat/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatUatJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start deterministic validation of the linked Asana test cases
         * @param {ChatUatValidationStartRequest} chatUatValidationStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatUatScopeValidation: async (chatUatValidationStartRequest: ChatUatValidationStartRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatUatValidationStartRequest' is not null or undefined
            assertParamExists('startChatUatScopeValidation', 'chatUatValidationStartRequest', chatUatValidationStartRequest)
            const localVarPath = `/chat-uat/validation/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatUatValidationStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start or read automated ChatUAT analysis for a completed Raven result
         * @param {RavenChatUatAnalysisRequest} ravenChatUatAnalysisRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRavenChatUatAnalysis: async (ravenChatUatAnalysisRequest: RavenChatUatAnalysisRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ravenChatUatAnalysisRequest' is not null or undefined
            assertParamExists('startRavenChatUatAnalysis', 'ravenChatUatAnalysisRequest', ravenChatUatAnalysisRequest)
            const localVarPath = `/iam/chat-uat/raven-analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ravenChatUatAnalysisRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit feedback for a terminal ChatUAT response
         * @param {ChatUatFeedbackRequest} chatUatFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitChatUatFeedback: async (chatUatFeedbackRequest: ChatUatFeedbackRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatUatFeedbackRequest' is not null or undefined
            assertParamExists('submitChatUatFeedback', 'chatUatFeedbackRequest', chatUatFeedbackRequest)
            const localVarPath = `/chat-uat/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatUatFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save the Asana project used by ChatUAT
         * @param {AsanaLinkUpdate} asanaLinkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatUatAsanaScope: async (asanaLinkUpdate: AsanaLinkUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asanaLinkUpdate' is not null or undefined
            assertParamExists('updateChatUatAsanaScope', 'asanaLinkUpdate', asanaLinkUpdate)
            const localVarPath = `/chat-uat/validation/asana`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asanaLinkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatUatApi - functional programming interface
 * @export
 */
export const ChatUatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatUatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Begin per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationRequest} asanaAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async beginChatUatAsanaAuthorization(asanaAuthorizationRequest: AsanaAuthorizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsanaAuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.beginChatUatAsanaAuthorization(asanaAuthorizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Complete per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationCompleteRequest} asanaAuthorizationCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest: AsanaAuthorizationCompleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsanaAuthorizationCompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove the linked Asana scope while retaining validation history
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChatUatAsanaScope(version: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChatUatAsanaScope(version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Queue persona analysis for one completed Raven result
         * @param {'dev' | 'prod'} ravenEnvironment 
         * @param {RavenChatUatAnalysisDispatchRequest} ravenChatUatAnalysisDispatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dispatchRavenChatUatAnalysis(ravenEnvironment: 'dev' | 'prod', ravenChatUatAnalysisDispatchRequest: RavenChatUatAnalysisDispatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RavenChatUatAnalysisDispatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dispatchRavenChatUatAnalysis(ravenEnvironment, ravenChatUatAnalysisDispatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return bounded order content facts for ChatUAT validation
         * @param {string} orderId 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatContentFacts(orderId: string, stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatContentFacts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatContentFacts(orderId, stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a long-running ChatUAT turn
         * @param {string} conversationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatJob(conversationId: string, jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatJobStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatJob(conversationId, jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Poll a deterministic Asana-scope validation job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatScopeValidationJob(jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatScopeValidationJob(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get one validation run and all bounded case results
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatScopeValidationRun(runId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationRun>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatScopeValidationRun(runId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the authenticated user\'s Asana validation state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatValidationState(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatValidationState(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search active Asana projects readable by the authenticated user
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listChatUatAsanaProjects(query: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsanaProjectList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listChatUatAsanaProjects(query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resolve a readable Asana project
         * @param {AsanaLinkPreviewRequest} asanaLinkPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewChatUatAsanaScope(asanaLinkPreviewRequest: AsanaLinkPreviewRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsanaProjectPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewChatUatAsanaScope(asanaLinkPreviewRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start a long-running ChatUAT turn
         * @param {ChatUatJobRequest} chatUatJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatUatJob(chatUatJobRequest: ChatUatJobRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatJobStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatUatJob(chatUatJobRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start deterministic validation of the linked Asana test cases
         * @param {ChatUatValidationStartRequest} chatUatValidationStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatUatScopeValidation(chatUatValidationStartRequest: ChatUatValidationStartRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatUatScopeValidation(chatUatValidationStartRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start or read automated ChatUAT analysis for a completed Raven result
         * @param {RavenChatUatAnalysisRequest} ravenChatUatAnalysisRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startRavenChatUatAnalysis(ravenChatUatAnalysisRequest: RavenChatUatAnalysisRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RavenChatUatAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startRavenChatUatAnalysis(ravenChatUatAnalysisRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit feedback for a terminal ChatUAT response
         * @param {ChatUatFeedbackRequest} chatUatFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitChatUatFeedback(chatUatFeedbackRequest: ChatUatFeedbackRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatFeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitChatUatFeedback(chatUatFeedbackRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save the Asana project used by ChatUAT
         * @param {AsanaLinkUpdate} asanaLinkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChatUatAsanaScope(asanaLinkUpdate: AsanaLinkUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChatUatAsanaScope(asanaLinkUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChatUatApi - factory interface
 * @export
 */
export const ChatUatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatUatApiFp(configuration)
    return {
        /**
         * 
         * @summary Begin per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationRequest} asanaAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beginChatUatAsanaAuthorization(asanaAuthorizationRequest: AsanaAuthorizationRequest, options?: any): AxiosPromise<AsanaAuthorizationResponse> {
            return localVarFp.beginChatUatAsanaAuthorization(asanaAuthorizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationCompleteRequest} asanaAuthorizationCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest: AsanaAuthorizationCompleteRequest, options?: any): AxiosPromise<AsanaAuthorizationCompleteResponse> {
            return localVarFp.completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove the linked Asana scope while retaining validation history
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatUatAsanaScope(version: number, options?: any): AxiosPromise<ChatUatValidationState> {
            return localVarFp.deleteChatUatAsanaScope(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Queue persona analysis for one completed Raven result
         * @param {'dev' | 'prod'} ravenEnvironment 
         * @param {RavenChatUatAnalysisDispatchRequest} ravenChatUatAnalysisDispatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchRavenChatUatAnalysis(ravenEnvironment: 'dev' | 'prod', ravenChatUatAnalysisDispatchRequest: RavenChatUatAnalysisDispatchRequest, options?: any): AxiosPromise<RavenChatUatAnalysisDispatchResponse> {
            return localVarFp.dispatchRavenChatUatAnalysis(ravenEnvironment, ravenChatUatAnalysisDispatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return bounded order content facts for ChatUAT validation
         * @param {string} orderId 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatContentFacts(orderId: string, stage: Stage, options?: any): AxiosPromise<ChatUatContentFacts> {
            return localVarFp.getChatUatContentFacts(orderId, stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a long-running ChatUAT turn
         * @param {string} conversationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatJob(conversationId: string, jobId: string, options?: any): AxiosPromise<ChatUatJobStatusResponse> {
            return localVarFp.getChatUatJob(conversationId, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll a deterministic Asana-scope validation job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatScopeValidationJob(jobId: string, options?: any): AxiosPromise<ChatUatValidationJobResponse> {
            return localVarFp.getChatUatScopeValidationJob(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one validation run and all bounded case results
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatScopeValidationRun(runId: string, options?: any): AxiosPromise<ChatUatValidationRun> {
            return localVarFp.getChatUatScopeValidationRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the authenticated user\'s Asana validation state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatValidationState(options?: any): AxiosPromise<ChatUatValidationState> {
            return localVarFp.getChatUatValidationState(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search active Asana projects readable by the authenticated user
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChatUatAsanaProjects(query: string, options?: any): AxiosPromise<AsanaProjectList> {
            return localVarFp.listChatUatAsanaProjects(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve a readable Asana project
         * @param {AsanaLinkPreviewRequest} asanaLinkPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewChatUatAsanaScope(asanaLinkPreviewRequest: AsanaLinkPreviewRequest, options?: any): AxiosPromise<AsanaProjectPreview> {
            return localVarFp.previewChatUatAsanaScope(asanaLinkPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a long-running ChatUAT turn
         * @param {ChatUatJobRequest} chatUatJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatUatJob(chatUatJobRequest: ChatUatJobRequest, options?: any): AxiosPromise<ChatUatJobStartResponse> {
            return localVarFp.startChatUatJob(chatUatJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start deterministic validation of the linked Asana test cases
         * @param {ChatUatValidationStartRequest} chatUatValidationStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatUatScopeValidation(chatUatValidationStartRequest: ChatUatValidationStartRequest, options?: any): AxiosPromise<ChatUatValidationJobResponse> {
            return localVarFp.startChatUatScopeValidation(chatUatValidationStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start or read automated ChatUAT analysis for a completed Raven result
         * @param {RavenChatUatAnalysisRequest} ravenChatUatAnalysisRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRavenChatUatAnalysis(ravenChatUatAnalysisRequest: RavenChatUatAnalysisRequest, options?: any): AxiosPromise<RavenChatUatAnalysisResponse> {
            return localVarFp.startRavenChatUatAnalysis(ravenChatUatAnalysisRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit feedback for a terminal ChatUAT response
         * @param {ChatUatFeedbackRequest} chatUatFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitChatUatFeedback(chatUatFeedbackRequest: ChatUatFeedbackRequest, options?: any): AxiosPromise<ChatUatFeedbackResponse> {
            return localVarFp.submitChatUatFeedback(chatUatFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save the Asana project used by ChatUAT
         * @param {AsanaLinkUpdate} asanaLinkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatUatAsanaScope(asanaLinkUpdate: AsanaLinkUpdate, options?: any): AxiosPromise<ChatUatValidationState> {
            return localVarFp.updateChatUatAsanaScope(asanaLinkUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatUatApi - object-oriented interface
 * @export
 * @class ChatUatApi
 * @extends {BaseAPI}
 */
export class ChatUatApi extends BaseAPI {
    /**
     * 
     * @summary Begin per-user Asana authorization for ChatUAT
     * @param {AsanaAuthorizationRequest} asanaAuthorizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public beginChatUatAsanaAuthorization(asanaAuthorizationRequest: AsanaAuthorizationRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).beginChatUatAsanaAuthorization(asanaAuthorizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete per-user Asana authorization for ChatUAT
     * @param {AsanaAuthorizationCompleteRequest} asanaAuthorizationCompleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest: AsanaAuthorizationCompleteRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove the linked Asana scope while retaining validation history
     * @param {number} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public deleteChatUatAsanaScope(version: number, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).deleteChatUatAsanaScope(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Queue persona analysis for one completed Raven result
     * @param {'dev' | 'prod'} ravenEnvironment 
     * @param {RavenChatUatAnalysisDispatchRequest} ravenChatUatAnalysisDispatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public dispatchRavenChatUatAnalysis(ravenEnvironment: 'dev' | 'prod', ravenChatUatAnalysisDispatchRequest: RavenChatUatAnalysisDispatchRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).dispatchRavenChatUatAnalysis(ravenEnvironment, ravenChatUatAnalysisDispatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return bounded order content facts for ChatUAT validation
     * @param {string} orderId 
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatContentFacts(orderId: string, stage: Stage, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatContentFacts(orderId, stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a long-running ChatUAT turn
     * @param {string} conversationId 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatJob(conversationId: string, jobId: string, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatJob(conversationId, jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll a deterministic Asana-scope validation job
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatScopeValidationJob(jobId: string, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatScopeValidationJob(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one validation run and all bounded case results
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatScopeValidationRun(runId: string, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatScopeValidationRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the authenticated user\'s Asana validation state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatValidationState(options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatValidationState(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search active Asana projects readable by the authenticated user
     * @param {string} query 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public listChatUatAsanaProjects(query: string, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).listChatUatAsanaProjects(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve a readable Asana project
     * @param {AsanaLinkPreviewRequest} asanaLinkPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public previewChatUatAsanaScope(asanaLinkPreviewRequest: AsanaLinkPreviewRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).previewChatUatAsanaScope(asanaLinkPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a long-running ChatUAT turn
     * @param {ChatUatJobRequest} chatUatJobRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public startChatUatJob(chatUatJobRequest: ChatUatJobRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).startChatUatJob(chatUatJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start deterministic validation of the linked Asana test cases
     * @param {ChatUatValidationStartRequest} chatUatValidationStartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public startChatUatScopeValidation(chatUatValidationStartRequest: ChatUatValidationStartRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).startChatUatScopeValidation(chatUatValidationStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start or read automated ChatUAT analysis for a completed Raven result
     * @param {RavenChatUatAnalysisRequest} ravenChatUatAnalysisRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public startRavenChatUatAnalysis(ravenChatUatAnalysisRequest: RavenChatUatAnalysisRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).startRavenChatUatAnalysis(ravenChatUatAnalysisRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit feedback for a terminal ChatUAT response
     * @param {ChatUatFeedbackRequest} chatUatFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public submitChatUatFeedback(chatUatFeedbackRequest: ChatUatFeedbackRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).submitChatUatFeedback(chatUatFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save the Asana project used by ChatUAT
     * @param {AsanaLinkUpdate} asanaLinkUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public updateChatUatAsanaScope(asanaLinkUpdate: AsanaLinkUpdate, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).updateChatUatAsanaScope(asanaLinkUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get QuickSight dashboard embed URL
         * @param {'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels'} type 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardEmbedUrl: async (type: 'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels', stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getDashboardEmbedUrl', 'type', type)
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDashboardEmbedUrl', 'stage', stage)
            const localVarPath = `/dashboard/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get QuickSight dashboard embed URL
         * @param {'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels'} type 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardEmbedUrl(type: 'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels', stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardEmbedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardEmbedUrl(type, stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Get QuickSight dashboard embed URL
         * @param {'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels'} type 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardEmbedUrl(type: 'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels', stage: Stage, options?: any): AxiosPromise<DashboardEmbedResponse> {
            return localVarFp.getDashboardEmbedUrl(type, stage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @summary Get QuickSight dashboard embed URL
     * @param {'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels'} type 
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getDashboardEmbedUrl(type: 'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels', stage: Stage, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getDashboardEmbedUrl(type, stage, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * DlqApi - axios parameter creator
 * @export
 */
export const DlqApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check DLQ status and get details for a transaction
         * @param {Stage} stage environment name
         * @param {string} [orderId] ID of the transaction to check
         * @param {string} [dlqPk] DLQ primary key to look up a single DLQ event (full input body and error). Mutually exclusive with orderId. The snapshot item is returned even if it has since been redriven; inDLQ reports whether it is still present in the live DLQ table.
         * @param {string} [queryExecutionId] ID of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQInfo: async (stage: Stage, orderId?: string, dlqPk?: string, queryExecutionId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDLQInfo', 'stage', stage)
            const localVarPath = `/dlq-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (dlqPk !== undefined) {
                localVarQueryParameter['dlqPk'] = dlqPk;
            }

            if (queryExecutionId !== undefined) {
                localVarQueryParameter['queryExecutionId'] = queryExecutionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The stage\'s whole DLQ over time. `points` is the DLQ table\'s size from CloudWatch\'s AWS/DynamoDB ItemCount metric (DynamoDB refreshes it roughly every six hours; CloudWatch records it hourly): one point per period, the period chosen from the window, hourly up to 14 days, daily beyond; every item in the table, investigated or not. `snapshots` is the per-snapshot total recorded by the hourly reconcile from the latest DLQ snapshot: items, summed financial impact and the share no investigation owns. Snapshot points lag the live table by the Glue run and only exist from the first reconcile after this was added.
         * @summary Total DLQ items and impact over time
         * @param {Stage} stage environment name
         * @param {number} [days] How many days back to return (1-455)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDlqSizeHistory: async (stage: Stage, days?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDlqSizeHistory', 'stage', stage)
            const localVarPath = `/dlq-size-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DlqApi - functional programming interface
 * @export
 */
export const DlqApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DlqApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check DLQ status and get details for a transaction
         * @param {Stage} stage environment name
         * @param {string} [orderId] ID of the transaction to check
         * @param {string} [dlqPk] DLQ primary key to look up a single DLQ event (full input body and error). Mutually exclusive with orderId. The snapshot item is returned even if it has since been redriven; inDLQ reports whether it is still present in the live DLQ table.
         * @param {string} [queryExecutionId] ID of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDLQInfo(stage: Stage, orderId?: string, dlqPk?: string, queryExecutionId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLQInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDLQInfo(stage, orderId, dlqPk, queryExecutionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The stage\'s whole DLQ over time. `points` is the DLQ table\'s size from CloudWatch\'s AWS/DynamoDB ItemCount metric (DynamoDB refreshes it roughly every six hours; CloudWatch records it hourly): one point per period, the period chosen from the window, hourly up to 14 days, daily beyond; every item in the table, investigated or not. `snapshots` is the per-snapshot total recorded by the hourly reconcile from the latest DLQ snapshot: items, summed financial impact and the share no investigation owns. Snapshot points lag the live table by the Glue run and only exist from the first reconcile after this was added.
         * @summary Total DLQ items and impact over time
         * @param {Stage} stage environment name
         * @param {number} [days] How many days back to return (1-455)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDlqSizeHistory(stage: Stage, days?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DlqSizeHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDlqSizeHistory(stage, days, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DlqApi - factory interface
 * @export
 */
export const DlqApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DlqApiFp(configuration)
    return {
        /**
         * 
         * @summary Check DLQ status and get details for a transaction
         * @param {Stage} stage environment name
         * @param {string} [orderId] ID of the transaction to check
         * @param {string} [dlqPk] DLQ primary key to look up a single DLQ event (full input body and error). Mutually exclusive with orderId. The snapshot item is returned even if it has since been redriven; inDLQ reports whether it is still present in the live DLQ table.
         * @param {string} [queryExecutionId] ID of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQInfo(stage: Stage, orderId?: string, dlqPk?: string, queryExecutionId?: string, options?: any): AxiosPromise<DLQInfoResult> {
            return localVarFp.getDLQInfo(stage, orderId, dlqPk, queryExecutionId, options).then((request) => request(axios, basePath));
        },
        /**
         * The stage\'s whole DLQ over time. `points` is the DLQ table\'s size from CloudWatch\'s AWS/DynamoDB ItemCount metric (DynamoDB refreshes it roughly every six hours; CloudWatch records it hourly): one point per period, the period chosen from the window, hourly up to 14 days, daily beyond; every item in the table, investigated or not. `snapshots` is the per-snapshot total recorded by the hourly reconcile from the latest DLQ snapshot: items, summed financial impact and the share no investigation owns. Snapshot points lag the live table by the Glue run and only exist from the first reconcile after this was added.
         * @summary Total DLQ items and impact over time
         * @param {Stage} stage environment name
         * @param {number} [days] How many days back to return (1-455)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDlqSizeHistory(stage: Stage, days?: number, options?: any): AxiosPromise<DlqSizeHistory> {
            return localVarFp.getDlqSizeHistory(stage, days, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DlqApi - object-oriented interface
 * @export
 * @class DlqApi
 * @extends {BaseAPI}
 */
export class DlqApi extends BaseAPI {
    /**
     * 
     * @summary Check DLQ status and get details for a transaction
     * @param {Stage} stage environment name
     * @param {string} [orderId] ID of the transaction to check
     * @param {string} [dlqPk] DLQ primary key to look up a single DLQ event (full input body and error). Mutually exclusive with orderId. The snapshot item is returned even if it has since been redriven; inDLQ reports whether it is still present in the live DLQ table.
     * @param {string} [queryExecutionId] ID of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqApi
     */
    public getDLQInfo(stage: Stage, orderId?: string, dlqPk?: string, queryExecutionId?: string, options?: AxiosRequestConfig) {
        return DlqApiFp(this.configuration).getDLQInfo(stage, orderId, dlqPk, queryExecutionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The stage\'s whole DLQ over time. `points` is the DLQ table\'s size from CloudWatch\'s AWS/DynamoDB ItemCount metric (DynamoDB refreshes it roughly every six hours; CloudWatch records it hourly): one point per period, the period chosen from the window, hourly up to 14 days, daily beyond; every item in the table, investigated or not. `snapshots` is the per-snapshot total recorded by the hourly reconcile from the latest DLQ snapshot: items, summed financial impact and the share no investigation owns. Snapshot points lag the live table by the Glue run and only exist from the first reconcile after this was added.
     * @summary Total DLQ items and impact over time
     * @param {Stage} stage environment name
     * @param {number} [days] How many days back to return (1-455)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqApi
     */
    public getDlqSizeHistory(stage: Stage, days?: number, options?: AxiosRequestConfig) {
        return DlqApiFp(this.configuration).getDlqSizeHistory(stage, days, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * DlqRedriveApi - axios parameter creator
 * @export
 */
export const DlqRedriveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check DLQ redrive status
         * @param {Stage} stage environment name
         * @param {string} executionArn Arn of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedriveInfo: async (stage: Stage, executionArn: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDLQRedriveInfo', 'stage', stage)
            // verify required parameter 'executionArn' is not null or undefined
            assertParamExists('getDLQRedriveInfo', 'executionArn', executionArn)
            const localVarPath = `/dlq-redrive-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (executionArn !== undefined) {
                localVarQueryParameter['executionArn'] = executionArn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get presigned URL for DLQ redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName name of the file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedriveUploadUrl: async (stage: Stage, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDLQRedriveUploadUrl', 'stage', stage)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getDLQRedriveUploadUrl', 'fileName', fileName)
            const localVarPath = `/dlq-redrive-upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all DLQ redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedrivesInfo: async (stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDLQRedrivesInfo', 'stage', stage)
            const localVarPath = `/dlq-redrives-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start DLQ redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveInfoRequest} postDLQRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDLQRedriveInfo: async (stage: Stage, postDLQRedriveInfoRequest: PostDLQRedriveInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postDLQRedriveInfo', 'stage', stage)
            // verify required parameter 'postDLQRedriveInfoRequest' is not null or undefined
            assertParamExists('postDLQRedriveInfo', 'postDLQRedriveInfoRequest', postDLQRedriveInfoRequest)
            const localVarPath = `/dlq-redrive-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postDLQRedriveInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Draft MCM for deleting DLQ items without redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveMcmRequest} postDLQRedriveMcmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDLQRedriveMcm: async (stage: Stage, postDLQRedriveMcmRequest: PostDLQRedriveMcmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postDLQRedriveMcm', 'stage', stage)
            // verify required parameter 'postDLQRedriveMcmRequest' is not null or undefined
            assertParamExists('postDLQRedriveMcm', 'postDLQRedriveMcmRequest', postDLQRedriveMcmRequest)
            const localVarPath = `/dlq-redrive-mcm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postDLQRedriveMcmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retry a DLQ redrive by re-running a prior execution with the same input
         * @param {Stage} stage environment name
         * @param {RetryDLQRedriveRequest} retryDLQRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryDLQRedrive: async (stage: Stage, retryDLQRedriveRequest: RetryDLQRedriveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('retryDLQRedrive', 'stage', stage)
            // verify required parameter 'retryDLQRedriveRequest' is not null or undefined
            assertParamExists('retryDLQRedrive', 'retryDLQRedriveRequest', retryDLQRedriveRequest)
            const localVarPath = `/dlq-redrive-retry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retryDLQRedriveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DlqRedriveApi - functional programming interface
 * @export
 */
export const DlqRedriveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DlqRedriveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check DLQ redrive status
         * @param {Stage} stage environment name
         * @param {string} executionArn Arn of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDLQRedriveInfo(stage: Stage, executionArn: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLQRedriveInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDLQRedriveInfo(stage, executionArn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get presigned URL for DLQ redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName name of the file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDLQRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDLQRedriveUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDLQRedriveUploadUrl(stage, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all DLQ redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDLQRedrivesInfo(stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDLQRedrivesInfo200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDLQRedrivesInfo(stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start DLQ redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveInfoRequest} postDLQRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDLQRedriveInfo(stage: Stage, postDLQRedriveInfoRequest: PostDLQRedriveInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLQRedriveInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDLQRedriveInfo(stage, postDLQRedriveInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a Draft MCM for deleting DLQ items without redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveMcmRequest} postDLQRedriveMcmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDLQRedriveMcm(stage: Stage, postDLQRedriveMcmRequest: PostDLQRedriveMcmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostDLQRedriveMcm201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDLQRedriveMcm(stage, postDLQRedriveMcmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retry a DLQ redrive by re-running a prior execution with the same input
         * @param {Stage} stage environment name
         * @param {RetryDLQRedriveRequest} retryDLQRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryDLQRedrive(stage: Stage, retryDLQRedriveRequest: RetryDLQRedriveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLQRedriveInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryDLQRedrive(stage, retryDLQRedriveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DlqRedriveApi - factory interface
 * @export
 */
export const DlqRedriveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DlqRedriveApiFp(configuration)
    return {
        /**
         * 
         * @summary Check DLQ redrive status
         * @param {Stage} stage environment name
         * @param {string} executionArn Arn of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedriveInfo(stage: Stage, executionArn: string, options?: any): AxiosPromise<DLQRedriveInfoResult> {
            return localVarFp.getDLQRedriveInfo(stage, executionArn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get presigned URL for DLQ redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName name of the file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedriveUploadUrl(stage: Stage, fileName: string, options?: any): AxiosPromise<GetDLQRedriveUploadUrl200Response> {
            return localVarFp.getDLQRedriveUploadUrl(stage, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all DLQ redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedrivesInfo(stage: Stage, options?: any): AxiosPromise<Array<GetDLQRedrivesInfo200ResponseInner>> {
            return localVarFp.getDLQRedrivesInfo(stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start DLQ redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveInfoRequest} postDLQRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDLQRedriveInfo(stage: Stage, postDLQRedriveInfoRequest: PostDLQRedriveInfoRequest, options?: any): AxiosPromise<DLQRedriveInfoResult> {
            return localVarFp.postDLQRedriveInfo(stage, postDLQRedriveInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Draft MCM for deleting DLQ items without redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveMcmRequest} postDLQRedriveMcmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDLQRedriveMcm(stage: Stage, postDLQRedriveMcmRequest: PostDLQRedriveMcmRequest, options?: any): AxiosPromise<PostDLQRedriveMcm201Response> {
            return localVarFp.postDLQRedriveMcm(stage, postDLQRedriveMcmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retry a DLQ redrive by re-running a prior execution with the same input
         * @param {Stage} stage environment name
         * @param {RetryDLQRedriveRequest} retryDLQRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryDLQRedrive(stage: Stage, retryDLQRedriveRequest: RetryDLQRedriveRequest, options?: any): AxiosPromise<DLQRedriveInfoResult> {
            return localVarFp.retryDLQRedrive(stage, retryDLQRedriveRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DlqRedriveApi - object-oriented interface
 * @export
 * @class DlqRedriveApi
 * @extends {BaseAPI}
 */
export class DlqRedriveApi extends BaseAPI {
    /**
     * 
     * @summary Check DLQ redrive status
     * @param {Stage} stage environment name
     * @param {string} executionArn Arn of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public getDLQRedriveInfo(stage: Stage, executionArn: string, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).getDLQRedriveInfo(stage, executionArn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get presigned URL for DLQ redrive file upload
     * @param {Stage} stage environment name
     * @param {string} fileName name of the file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public getDLQRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).getDLQRedriveUploadUrl(stage, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all DLQ redrive executions
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public getDLQRedrivesInfo(stage: Stage, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).getDLQRedrivesInfo(stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start DLQ redrive
     * @param {Stage} stage environment name
     * @param {PostDLQRedriveInfoRequest} postDLQRedriveInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public postDLQRedriveInfo(stage: Stage, postDLQRedriveInfoRequest: PostDLQRedriveInfoRequest, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).postDLQRedriveInfo(stage, postDLQRedriveInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Draft MCM for deleting DLQ items without redrive
     * @param {Stage} stage environment name
     * @param {PostDLQRedriveMcmRequest} postDLQRedriveMcmRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public postDLQRedriveMcm(stage: Stage, postDLQRedriveMcmRequest: PostDLQRedriveMcmRequest, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).postDLQRedriveMcm(stage, postDLQRedriveMcmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retry a DLQ redrive by re-running a prior execution with the same input
     * @param {Stage} stage environment name
     * @param {RetryDLQRedriveRequest} retryDLQRedriveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public retryDLQRedrive(stage: Stage, retryDLQRedriveRequest: RetryDLQRedriveRequest, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).retryDLQRedrive(stage, retryDLQRedriveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * DownloadS3FileApi - axios parameter creator
 * @export
 */
export const DownloadS3FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download S3 File
         * @param {string} key file name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('download', 'key', key)
            const localVarPath = `/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadS3FileApi - functional programming interface
 * @export
 */
export const DownloadS3FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadS3FileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download S3 File
         * @param {string} key file name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async download(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadS3FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.download(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DownloadS3FileApi - factory interface
 * @export
 */
export const DownloadS3FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadS3FileApiFp(configuration)
    return {
        /**
         * 
         * @summary Download S3 File
         * @param {string} key file name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download(key: string, options?: any): AxiosPromise<DownloadS3FileResponse> {
            return localVarFp.download(key, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadS3FileApi - object-oriented interface
 * @export
 * @class DownloadS3FileApi
 * @extends {BaseAPI}
 */
export class DownloadS3FileApi extends BaseAPI {
    /**
     * 
     * @summary Download S3 File
     * @param {string} key file name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadS3FileApi
     */
    public download(key: string, options?: AxiosRequestConfig) {
        return DownloadS3FileApiFp(this.configuration).download(key, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDetails', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getDetails', 'orderId', orderId)
            const localVarPath = `/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of events with different versions
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getEvents', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getEvents', 'orderId', orderId)
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Product/episode summary from the decompressed event body
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderContents: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getOrderContents', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderContents', 'orderId', orderId)
            const localVarPath = `/order-contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetails(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List of events with different versions
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Product/episode summary from the decompressed event body
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderContents(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderContentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderContents(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails(stage: Stage, orderId: string, options?: any): AxiosPromise<DetailsResponse> {
            return localVarFp.getDetails(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of events with different versions
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(stage: Stage, orderId: string, options?: any): AxiosPromise<Array<Event>> {
            return localVarFp.getEvents(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Product/episode summary from the decompressed event body
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderContents(stage: Stage, orderId: string, options?: any): AxiosPromise<OrderContentsResponse> {
            return localVarFp.getOrderContents(stage, orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * 
     * @summary List of CBEs and events
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getDetails(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getDetails(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of events with different versions
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEvents(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEvents(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Product/episode summary from the decompressed event body
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getOrderContents(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getOrderContents(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * InvestigationsApi - axios parameter creator
 * @export
 */
export const InvestigationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a comment to an investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationCommentRequest} investigationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addInvestigationComment: async (stage: Stage, investigationId: string, investigationCommentRequest: InvestigationCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('addInvestigationComment', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('addInvestigationComment', 'investigationId', investigationId)
            // verify required parameter 'investigationCommentRequest' is not null or undefined
            assertParamExists('addInvestigationComment', 'investigationCommentRequest', investigationCommentRequest)
            const localVarPath = `/investigations/{investigationId}/comments`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks the request CANCELLED and clears `pendingDeletion`, unlocking the investigation. Lusca does not cancel the MCM; discard it in MCM.
         * @summary Cancel a pending delete-without-redrive request (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId Redrive / deletion attempt id (att-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvestigationDeletion: async (stage: Stage, investigationId: string, attemptId: string, investigationVersionedRequest: InvestigationVersionedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('cancelInvestigationDeletion', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('cancelInvestigationDeletion', 'investigationId', investigationId)
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('cancelInvestigationDeletion', 'attemptId', attemptId)
            // verify required parameter 'investigationVersionedRequest' is not null or undefined
            assertParamExists('cancelInvestigationDeletion', 'investigationVersionedRequest', investigationVersionedRequest)
            const localVarPath = `/investigations/{investigationId}/deletions/{attemptId}/cancel`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)))
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationVersionedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancels the caller\'s pending reminder on the case (CancelScheduledNotification). Idempotent.
         * @summary Cancel my reminder on an investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvestigationReminder: async (stage: Stage, investigationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('cancelInvestigationReminder', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('cancelInvestigationReminder', 'investigationId', investigationId)
            const localVarPath = `/investigations/{investigationId}/reminder`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Makes the caller the owner of any active investigation, owned or not. A takeover is recorded in the timeline (called out as stale after the configured inactivity period, default 72 hours), the previous owner is notified and stays a contributor. Resolved/cancelled cases must be reopened first.
         * @summary Take ownership of an active investigation (anyone may; the previous owner is notified)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimInvestigation: async (stage: Stage, investigationId: string, investigationVersionedRequest: InvestigationVersionedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('claimInvestigation', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('claimInvestigation', 'investigationId', investigationId)
            // verify required parameter 'investigationVersionedRequest' is not null or undefined
            assertParamExists('claimInvestigation', 'investigationVersionedRequest', investigationVersionedRequest)
            const localVarPath = `/investigations/{investigationId}/claim`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationVersionedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Step 2 gate of the document-redrive path. After a document redrive completes the case is back in READY_TO_REDRIVE with documentRedrive.stage AWAITING_CONFIRMATION and a DLQ redrive is refused (409 DOCUMENT_REDRIVE_UNCONFIRMED) until the owner has spot-checked the sample transactions and confirms here. Moves documentRedrive.stage to CONFIRMED; the DLQ redrive that clears the items may then be launched.
         * @summary Confirm a completed document redrive\'s CBEs were republished (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId 
         * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmInvestigationDocumentRedrive: async (stage: Stage, investigationId: string, attemptId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('confirmInvestigationDocumentRedrive', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('confirmInvestigationDocumentRedrive', 'investigationId', investigationId)
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('confirmInvestigationDocumentRedrive', 'attemptId', attemptId)
            // verify required parameter 'investigationDocumentRedriveRequest' is not null or undefined
            assertParamExists('confirmInvestigationDocumentRedrive', 'investigationDocumentRedriveRequest', investigationDocumentRedriveRequest)
            const localVarPath = `/investigations/{investigationId}/document-redrives/{attemptId}/confirm`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)))
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationDocumentRedriveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Freezes the preview\'s exact DLQ-PK manifest, creates the investigation and conditionally claims primary ownership of each DLQ item. Items already owned by another active investigation are reported as conflicts and never stolen. mode=remainder creates the case for unassigned items only; mode=child creates a narrower child of parentInvestigationId that takes over its matching subset. A mode=full request whose rule is identical to an active investigation\'s is refused with 409 DUPLICATE_RULE (`current` is that investigation) before anything is written; the check reads only the active registry, so it costs the same for any population size. Should the claim nonetheless win no items (a different rule that covers the same items, or a race), the new case is closed at once as RESOLVED / DUPLICATE with duplicateOfInvestigationId set, the creator is notified, and the response carries duplicateOfInvestigationId.
         * @summary Create a DLQ investigation from a completed preview
         * @param {Stage} stage environment name
         * @param {InvestigationCreateRequest} investigationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvestigation: async (stage: Stage, investigationCreateRequest: InvestigationCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('createInvestigation', 'stage', stage)
            // verify required parameter 'investigationCreateRequest' is not null or undefined
            assertParamExists('createInvestigation', 'investigationCreateRequest', investigationCreateRequest)
            const localVarPath = `/investigations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a comment (author or owner only). The event stays in the timeline marked deleted.
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvestigationComment: async (stage: Stage, investigationId: string, eventId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('deleteInvestigationComment', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('deleteInvestigationComment', 'investigationId', investigationId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteInvestigationComment', 'eventId', eventId)
            const localVarPath = `/investigations/{investigationId}/comments/{eventId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit a comment (author or owner only). The original text is kept in the event\'s edit history.
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} eventId 
         * @param {InvestigationCommentRequest} investigationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editInvestigationComment: async (stage: Stage, investigationId: string, eventId: string, investigationCommentRequest: InvestigationCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('editInvestigationComment', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('editInvestigationComment', 'investigationId', investigationId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('editInvestigationComment', 'eventId', eventId)
            // verify required parameter 'investigationCommentRequest' is not null or undefined
            assertParamExists('editInvestigationComment', 'investigationCommentRequest', investigationCommentRequest)
            const localVarPath = `/investigations/{investigationId}/comments/{eventId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-checks that every manifest PK is still owned by the investigation (409 MANIFEST_DRIFTED otherwise) and starts the DLQ redrive state machine with deleteWithoutRedriving=true and the MCM ID. The redriver enforces the MCM gate (In Progress, approver, title, exact literal). Moves the investigation to EXECUTING_REDRIVE. A FAILED run can be executed again after fixing the MCM.
         * @summary Execute an approved delete-without-redrive request (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId Redrive / deletion attempt id (att-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeInvestigationDeletion: async (stage: Stage, investigationId: string, attemptId: string, investigationVersionedRequest: InvestigationVersionedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('executeInvestigationDeletion', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('executeInvestigationDeletion', 'investigationId', investigationId)
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('executeInvestigationDeletion', 'attemptId', attemptId)
            // verify required parameter 'investigationVersionedRequest' is not null or undefined
            assertParamExists('executeInvestigationDeletion', 'investigationVersionedRequest', investigationVersionedRequest)
            const localVarPath = `/investigations/{investigationId}/deletions/{attemptId}/execute`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)))
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationVersionedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For stages this deployment cannot redrive itself (Investigation.redriveMode = external): uploads the file the Lusca Search Prod tool takes for the chosen kind — the DLQ redrive bulk CSV (header dlq_pk) for REDRIVE / DELETE, the Redrive Tool CSV (distinct transaction ids, no header) for DOCUMENT_REDRIVE — built from the items the investigation owns now, and returns a one-hour download link plus the Prod page to run it on.
         * @summary File to upload in Lusca Search Prod for a redrive of this investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationExternalRedriveExportRequest} investigationExternalRedriveExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvestigationExternalRedrive: async (stage: Stage, investigationId: string, investigationExternalRedriveExportRequest: InvestigationExternalRedriveExportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('exportInvestigationExternalRedrive', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('exportInvestigationExternalRedrive', 'investigationId', investigationId)
            // verify required parameter 'investigationExternalRedriveExportRequest' is not null or undefined
            assertParamExists('exportInvestigationExternalRedrive', 'investigationExternalRedriveExportRequest', investigationExternalRedriveExportRequest)
            const localVarPath = `/investigations/{investigationId}/redrives/export`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationExternalRedriveExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds the preview\'s items that no other active case owns or wins (narrowest rule, then oldest case) to this investigation and refreezes its manifest as the union. The rule is unchanged. The preview must be COMPLETED, not truncated, at most 60 minutes old, and add at most 2,000 new items.
         * @summary Add a completed preview\'s unowned items to an existing investigation (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationExtendRequest} investigationExtendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendInvestigationPopulation: async (stage: Stage, investigationId: string, investigationExtendRequest: InvestigationExtendRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('extendInvestigationPopulation', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('extendInvestigationPopulation', 'investigationId', investigationId)
            // verify required parameter 'investigationExtendRequest' is not null or undefined
            assertParamExists('extendInvestigationPopulation', 'investigationExtendRequest', investigationExtendRequest)
            const localVarPath = `/investigations/{investigationId}/population/extend`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationExtendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Followers get a bell notification (and email/Slack) when someone else comments, changes the status or owner, merges the case, or when a redrive or deletion finishes or needs attention. Following is recorded as a FOLLOWED / UNFOLLOWED timeline event (audit log and activity feed) but does not count as activity, does not make the caller a contributor and notifies nobody. It needs no expectedVersion. The owner is always told about their own case and is not notified twice. Idempotent.
         * @summary Follow or unfollow an investigation (anyone signed in)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationFollowRequest} investigationFollowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followInvestigation: async (stage: Stage, investigationId: string, investigationFollowRequest: InvestigationFollowRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('followInvestigation', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('followInvestigation', 'investigationId', investigationId)
            // verify required parameter 'investigationFollowRequest' is not null or undefined
            assertParamExists('followInvestigation', 'investigationFollowRequest', investigationFollowRequest)
            const localVarPath = `/investigations/{investigationId}/follow`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationFollowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the investigation metadata, redrive attempts and the most recent timeline events.
         * @summary Get a DLQ investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigation: async (stage: Stage, investigationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getInvestigation', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('getInvestigation', 'investigationId', investigationId)
            const localVarPath = `/investigations/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Build a prompt for a local agent to continue the investigation through Lusca MCP
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationAgentPrompt: async (stage: Stage, investigationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getInvestigationAgentPrompt', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('getInvestigationAgentPrompt', 'investigationId', investigationId)
            const localVarPath = `/investigations/{investigationId}/agent-prompt`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload with the presigned POST (`post.url` + `post.fields` as multipart form fields, file last) — S3 enforces the size limit and content type — or with a plain PUT to `uploadUrl`. Nothing is recorded yet: send the returned `key` in `attachments` of a comment or of the conclusion to attach it. Limits: 10 MB per file, 10 files per comment/conclusion; images (PNG, JPEG, GIF, WebP), PDF, text, CSV, JSON, ZIP, XLSX. Files are never deleted.
         * @summary Get a presigned upload for a comment or conclusion attachment (screenshot, log, export)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationAttachmentUploadRequest} investigationAttachmentUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationArtifactUploadUrl: async (stage: Stage, investigationId: string, investigationAttachmentUploadRequest: InvestigationAttachmentUploadRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getInvestigationArtifactUploadUrl', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('getInvestigationArtifactUploadUrl', 'investigationId', investigationId)
            // verify required parameter 'investigationAttachmentUploadRequest' is not null or undefined
            assertParamExists('getInvestigationArtifactUploadUrl', 'investigationAttachmentUploadRequest', investigationAttachmentUploadRequest)
            const localVarPath = `/investigations/{investigationId}/artifacts/upload-url`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationAttachmentUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a fresh presigned download URL for an attachment of this investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationArtifactUrl: async (stage: Stage, investigationId: string, key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getInvestigationArtifactUrl', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('getInvestigationArtifactUrl', 'investigationId', investigationId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getInvestigationArtifactUrl', 'key', key)
            const localVarPath = `/investigations/{investigationId}/artifacts/url`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Groups the frozen manifest\'s items that this investigation does not own by their current owning active investigation. Populations larger than the check limit are sampled evenly and the counts are scaled (sampled=true).
         * @summary Which other investigations own items of this investigation\'s frozen population
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationOtherOwners: async (stage: Stage, investigationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getInvestigationOtherOwners', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('getInvestigationOtherOwners', 'investigationId', investigationId)
            const localVarPath = `/investigations/{investigationId}/other-owners`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the preview job status. When COMPLETED it includes the matching count, representative samples, the effective rule, the snapshot timestamp and overlap analysis against active and resolved investigations.
         * @summary Poll a DLQ investigation population preview
         * @param {Stage} stage environment name
         * @param {string} previewId Preview job id returned by startInvestigationPreview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationPreview: async (stage: Stage, previewId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getInvestigationPreview', 'stage', stage)
            // verify required parameter 'previewId' is not null or undefined
            assertParamExists('getInvestigationPreview', 'previewId', previewId)
            const localVarPath = `/investigations/previews/{previewId}`
                .replace(`{${"previewId"}}`, encodeURIComponent(String(previewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the immutable activity timeline of an investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationTimeline: async (stage: Stage, investigationId: string, limit?: number, nextToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getInvestigationTimeline', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('getInvestigationTimeline', 'investigationId', investigationId)
            const localVarPath = `/investigations/{investigationId}/timeline`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextToken !== undefined) {
                localVarQueryParameter['nextToken'] = nextToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A report TrackStars writes back to an investigation is stored per case and never becomes the stage\'s latest, so its patterns are not in listInvestigationSuggestions. This reads the latest completed run\'s report and shapes every pattern like a suggestion (root cause, recommended action, samples, when-clause, derived rule), ordered by how many of this investigation\'s items it matched (runItems). Ownership is empty: the cards are shown on the case itself. available=false when the case has no completed run.
         * @summary The patterns of the investigation\'s own TrackStars run, as full suggestion cards
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationTrackStarsRunPatterns: async (stage: Stage, investigationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getInvestigationTrackStarsRunPatterns', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('getInvestigationTrackStarsRunPatterns', 'investigationId', investigationId)
            const localVarPath = `/investigations/{investigationId}/trackstars-run`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Imports a TrackStars DLQ analysis report (the JSON TrackStars produces) for the stage. Pattern ids are made unique across reports (<reportId>-PAT-NNN, references rewritten); the report is archived under trackstars/<stage>/reports/<reportId>.json and then becomes trackstars/<stage>/latest.json, which drives listInvestigationSuggestions. Earlier reports stay archived so cases opened from them keep their origin pattern. Re-uploading the same report is idempotent. At most 5 MB.
         * @summary Upload a TrackStars report as the stage\'s latest
         * @param {Stage} stage environment name
         * @param {ImportTrackStarsReportRequest} importTrackStarsReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTrackStarsReport: async (stage: Stage, importTrackStarsReportRequest: ImportTrackStarsReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('importTrackStarsReport', 'stage', stage)
            // verify required parameter 'importTrackStarsReportRequest' is not null or undefined
            assertParamExists('importTrackStarsReport', 'importTrackStarsReportRequest', importTrackStarsReportRequest)
            const localVarPath = `/investigations/trackstars-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importTrackStarsReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Records the execution (ARN or execution ID on the stage\'s DLQ redrive or order redrive state machine) as an attempt with linked=true, frozen from the items the investigation owns now, and moves the case to EXECUTING_REDRIVE; from then on it is polled, completed, verified and return-checked like a launched attempt. Requires READY_TO_REDRIVE. REDRIVE is refused while a document redrive awaits confirmation; DELETE requires a deleteWithoutRedriving execution.
         * @summary Link a redrive run in Lusca Search Prod to this investigation (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationExternalRedriveLinkRequest} investigationExternalRedriveLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkInvestigationExternalRedrive: async (stage: Stage, investigationId: string, investigationExternalRedriveLinkRequest: InvestigationExternalRedriveLinkRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('linkInvestigationExternalRedrive', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('linkInvestigationExternalRedrive', 'investigationId', investigationId)
            // verify required parameter 'investigationExternalRedriveLinkRequest' is not null or undefined
            assertParamExists('linkInvestigationExternalRedrive', 'investigationExternalRedriveLinkRequest', investigationExternalRedriveLinkRequest)
            const localVarPath = `/investigations/{investigationId}/redrives/link`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationExternalRedriveLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DLQ error categories are `.when(...)` rules in PVAccountingCDK\'s DLQ Glue job (assets/glue/dlq_dynamo_job.py). A scheduled worker task walks that file\'s history over GitFarm and records, per category, the first commit that added its rule and the CR in that commit\'s `cr:` trailer. Categories written before the rules moved into code carry migrated=true: their commit is the migration, not the original investigation. available=false until the task has run once.
         * @summary The code change (CR) that introduced each DLQ error category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listErrorCategorySources: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/investigations/category-sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Timeline events caused by a person (UI or MCP) on every investigation in the stage, newest first: comments, status changes, claims and transfers, redrives, merges, splits, links. System and worker events are left out. scope=mine keeps the caller\'s cases (owned in any status, or contributed to while active) plus anything the caller did. `investigations` summarises every case the page mentions. Events recorded before the activity index existed appear only once backfilled.
         * @summary Stage-wide feed of what people did on investigations
         * @param {Stage} stage environment name
         * @param {'all' | 'mine'} [scope] 
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationActivity: async (stage: Stage, scope?: 'all' | 'mine', limit?: number, nextToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('listInvestigationActivity', 'stage', stage)
            const localVarPath = `/investigations/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextToken !== undefined) {
                localVarQueryParameter['nextToken'] = nextToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Everyone permitted to unlock the Lusca Search Bindle lock (the same lock the Midway authorizer enforces), resolved through BRASS and cached for a few minutes. Reassignment to an alias outside this list is rejected with 400.
         * @summary List aliases that may own or be assigned an investigation
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationAssignees: async (stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('listInvestigationAssignees', 'stage', stage)
            const localVarPath = `/investigations/assignees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every owner notification addressed to the signed-in user (assignment, takeover, comments, contributions, merges, redrive outcomes), newest first, regardless of stage. This is the feed behind the notification bell; the same events are also delivered by email and Slack through the Amazon Notifications service. Entries expire after 30 days.
         * @summary The caller\'s notification inbox across all stages
         * @param {boolean} [unreadOnly] 
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationInbox: async (unreadOnly?: boolean, limit?: number, nextToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/investigations/inbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (unreadOnly !== undefined) {
                localVarQueryParameter['unreadOnly'] = unreadOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextToken !== undefined) {
                localVarQueryParameter['nextToken'] = nextToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * By default (scope=live) lists the items this investigation owns that were still in the DLQ at the last hourly reconcile (the count shown on the case). scope=all lists the frozen DLQ-PK manifest, every item the case was created with or later claimed, each row marked inDlq. Cases not yet reconciled have no live list and are served from the frozen manifest (scope=all in the response). Rows carry their snapshot fields and whether this investigation still holds primary ownership of each item.
         * @summary List the investigation\'s items (still in the DLQ by default, or all it was frozen with)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {number} [limit] 
         * @param {number} [offset] Row offset into the manifest for paging
         * @param {string} [q] Case-insensitive substring match over PK, queue, error type/message, use case and transaction/order ID
         * @param {string} [filter] Structured filter, JSON-encoded (same shape as the backlog\&#39;s filter): {\&quot;operation\&quot;: \&quot;and\&quot;|\&quot;or\&quot;, \&quot;tokens\&quot;: [{\&quot;propertyKey\&quot;, \&quot;operator\&quot;, \&quot;value\&quot;}]}. propertyKey is a manifest column: a rule field, dlq_pk, transaction_id or order_id (operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;:\&quot; contains, \&quot;!:\&quot; does not contain; case-insensitive; a missing value reads as \&quot;\&quot;) or dlq_timestamp / transaction_date (operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;&gt;\&quot;, \&quot;&gt;&#x3D;\&quot;, \&quot;&lt;\&quot;, \&quot;&lt;&#x3D;\&quot; on a date or timestamp prefix). A token without propertyKey is a free-text substring match over the same columns as q. Combined with q.
         * @param {'dlq_pk' | 'dlq_timestamp' | 'transaction_date' | 'eventsourcekey' | 'error_type' | 'error_message' | 'usecase' | 'transaction_id'} [sort] Manifest column to sort by (default dlq_timestamp)
         * @param {boolean} [desc] Sort descending (default true)
         * @param {'live' | 'all'} [scope] live (default) &#x3D; owned items still in the DLQ; all &#x3D; the whole frozen manifest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationItems: async (stage: Stage, investigationId: string, limit?: number, offset?: number, q?: string, filter?: string, sort?: 'dlq_pk' | 'dlq_timestamp' | 'transaction_date' | 'eventsourcekey' | 'error_type' | 'error_message' | 'usecase' | 'transaction_id', desc?: boolean, scope?: 'live' | 'all', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('listInvestigationItems', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('listInvestigationItems', 'investigationId', investigationId)
            const localVarPath = `/investigations/{investigationId}/items`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List redrive attempts of an investigation and refresh their status
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationRedrives: async (stage: Stage, investigationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('listInvestigationRedrives', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('listInvestigationRedrives', 'investigationId', investigationId)
            const localVarPath = `/investigations/{investigationId}/redrives`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redriven messages that returned to the DLQ, newest first
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationReturnedItems: async (stage: Stage, investigationId: string, limit?: number, nextToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('listInvestigationReturnedItems', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('listInvestigationReturnedItems', 'investigationId', investigationId)
            const localVarPath = `/investigations/{investigationId}/returned-items`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextToken !== undefined) {
                localVarQueryParameter['nextToken'] = nextToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * TrackStars (TRACK\'s multi-agent DLQ analysis) publishes each run as a report of root-caused failure patterns. This returns every pattern of the latest report imported for the stage as a population suggestion: the eq rule derived from the pattern\'s PySpark when-clause (fields it pins exactly plus single-valued scope), any error-message substrings the rule cannot express until a preview reveals the matching templated value(s), the root cause, evidence, recommended action, sample order IDs (display only), how the pattern relates to active investigations (unowned, partially covered, or owned — by rule containment or because a case records the pattern as its origin) and a ready-to-use starter (title, first comment, evidence links) for createInvestigation. available=false when no report has been imported for the stage.
         * @summary Investigation suggestions derived from the latest TrackStars DLQ analysis report
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationSuggestions: async (stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('listInvestigationSuggestions', 'stage', stage)
            const localVarPath = `/investigations/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists investigations for a stage using indexed queries. view selects a standard work-queue view (mine, active, blocked, ready_to_redrive, monitoring, resolved, withdrawn); status/owner/unclaimed/ redriven/returned narrow the results. Paginated with nextToken.
         * @summary List DLQ investigations (work queue)
         * @param {Stage} stage environment name
         * @param {'mine' | 'active' | 'blocked' | 'ready_to_redrive' | 'monitoring' | 'resolved' | 'withdrawn' | 'all'} [view] 
         * @param {InvestigationStatus} [status] 
         * @param {string} [owner] Owner alias filter
         * @param {boolean} [unclaimed] 
         * @param {boolean} [redriven] Only investigations with at least one redrive attempt
         * @param {boolean} [returned] Only investigations where redriven messages returned to the DLQ
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigations: async (stage: Stage, view?: 'mine' | 'active' | 'blocked' | 'ready_to_redrive' | 'monitoring' | 'resolved' | 'withdrawn' | 'all', status?: InvestigationStatus, owner?: string, unclaimed?: boolean, redriven?: boolean, returned?: boolean, limit?: number, nextToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('listInvestigations', 'stage', stage)
            const localVarPath = `/investigations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (owner !== undefined) {
                localVarQueryParameter['owner'] = owner;
            }

            if (unclaimed !== undefined) {
                localVarQueryParameter['unclaimed'] = unclaimed;
            }

            if (redriven !== undefined) {
                localVarQueryParameter['redriven'] = redriven;
            }

            if (returned !== undefined) {
                localVarQueryParameter['returned'] = returned;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextToken !== undefined) {
                localVarQueryParameter['nextToken'] = nextToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns one page of the groups of DLQ items (by queue, error type, templated error message and category) that are not assigned to any investigation, computed by the hourly reconciliation. Filtering (filter, q, uncategorizedOnly), sorting and paging happen server-side over the full set of reconciled groups; totalCount is the number of rows matching the filter and totalGroups the number of groups reconciled. Default order is highest impact first. Every response also carries the distinct queue, error type and category values (filterOptions) so a client can offer them as filter suggestions without loading every group. With groupByCategory=true the rows are the category view: every group with an error category collapses into one row per category (sizes summed, members listing the (queue, error type) split), while uncategorized groups stay one row each. Identity filter tokens (queue, errorType, errorMessage, category, free text, q) narrow the constituent groups before collapsing, so a category row shows only its matching share; size tokens (items, impactUsd, ambiguous, growth, lastSeen) apply to the collapsed row. totalRows is what the unfiltered view holds in either mode.
         * @summary List uninvestigated DLQ populations from the latest reconciliation
         * @param {Stage} stage environment name
         * @param {boolean} [uncategorizedOnly] 
         * @param {boolean} [groupByCategory] Collapse categorized groups into one row per error category (see description)
         * @param {number} [limit] 
         * @param {number} [offset] Group offset into the filtered, sorted list for paging
         * @param {string} [q] Case-insensitive substring match over queue, error type, error message and category
         * @param {string} [filter] Structured filter, JSON-encoded: {\&quot;operation\&quot;: \&quot;and\&quot;|\&quot;or\&quot;, \&quot;tokens\&quot;: [{\&quot;propertyKey\&quot;, \&quot;operator\&quot;, \&quot;value\&quot;}]}. propertyKey is one of queue, errorType, errorMessage, category (string operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;:\&quot; contains, \&quot;!:\&quot; does not contain), items, impactUsd, ambiguous, growth (the group\&#39;s growth7d; a group seen in a single snapshot never matches) (numeric operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;&gt;\&quot;, \&quot;&gt;&#x3D;\&quot;, \&quot;&lt;\&quot;, \&quot;&lt;&#x3D;\&quot;) or lastSeen (the group\&#39;s latestDlqTimestamp compared with a \&quot;YYYY-MM-DD\&quot; date or \&quot;YYYY-MM-DD HH:MM:SS\&quot; timestamp prefix, same operators as numeric; a group without a timestamp never matches). A token without propertyKey is a free-text substring match over the same fields as q. Combined with q and uncategorizedOnly (all must match).
         * @param {string} [countFilters] Optional JSON array of up to 10 structured filters (same shape as filter). For each, the response\&#39;s filterCounts carries the number of reconciled groups it matches, evaluated over the whole reconciliation independently of filter, q and uncategorizedOnly — one round trip for a navigation\&#39;s slice badges.
         * @param {'impactUsd' | 'count' | 'ambiguousCount' | 'eventsourcekey' | 'errorType' | 'errorMessage' | 'errorCategory' | 'latestDlqTimestamp' | 'growth7d'} [sort] Group field to sort by (default impactUsd; groups without an impact value rank last). &#x60;ambiguousCount&#x60; is deprecated (always 0) and kept for compatibility.
         * @param {boolean} [desc] Sort descending (default true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUninvestigatedGroups: async (stage: Stage, uncategorizedOnly?: boolean, groupByCategory?: boolean, limit?: number, offset?: number, q?: string, filter?: string, countFilters?: string, sort?: 'impactUsd' | 'count' | 'ambiguousCount' | 'eventsourcekey' | 'errorType' | 'errorMessage' | 'errorCategory' | 'latestDlqTimestamp' | 'growth7d', desc?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('listUninvestigatedGroups', 'stage', stage)
            const localVarPath = `/investigations/uninvestigated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (uncategorizedOnly !== undefined) {
                localVarQueryParameter['uncategorizedOnly'] = uncategorizedOnly;
            }

            if (groupByCategory !== undefined) {
                localVarQueryParameter['groupByCategory'] = groupByCategory;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (countFilters !== undefined) {
                localVarQueryParameter['countFilters'] = countFilters;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Passive: no timeline event, no activity timestamp change. Provide notificationIds for specific entries, investigationId for every entry of one case, or all=true for everything unread.
         * @summary Mark the caller\'s inbox notifications as read
         * @param {InvestigationInboxReadRequest} investigationInboxReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvestigationInboxRead: async (investigationInboxReadRequest: InvestigationInboxReadRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationInboxReadRequest' is not null or undefined
            assertParamExists('markInvestigationInboxRead', 'investigationInboxReadRequest', investigationInboxReadRequest)
            const localVarPath = `/investigations/inbox/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationInboxReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Anyone signed in may merge. The survivor keeps its id, owner, status and comments; its rule gains every source rule as an additional OR branch and its population becomes the union of all frozen manifests. Each source is closed as RESOLVED with reason MERGED (it cannot be reopened), its owner and contributors become contributors of the survivor, its children are re-parented to the survivor. Item ownership is re-pointed inline for small populations and by the worker otherwise (`mergePending` set until done). Refused (409) when any participant is resolved, executing or monitoring a redrive, awaiting a deletion MCM, already merging, or in another stage. There is no unmerge — split the survivor instead.
         * @summary Merge other active investigations into this one (the survivor)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationMergeRequest} investigationMergeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeInvestigations: async (stage: Stage, investigationId: string, investigationMergeRequest: InvestigationMergeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('mergeInvestigations', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('mergeInvestigations', 'investigationId', investigationId)
            // verify required parameter 'investigationMergeRequest' is not null or undefined
            assertParamExists('mergeInvestigations', 'investigationMergeRequest', investigationMergeRequest)
            const localVarPath = `/investigations/{investigationId}/merge`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationMergeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a preview for the investigation\'s rule; when it completes the worker assigns unassigned matching items to the investigation and refreshes the frozen population snapshot. Owner only. While the refresh runs the investigation carries `pendingRefresh`; a second request in that window is rejected with 409 `REFRESH_IN_PROGRESS` (the running preview is returned as `preview`) so the expensive Athena scan is never started twice.
         * @summary Re-evaluate the investigation\'s live population rule against the latest DLQ snapshot (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshInvestigationPopulation: async (stage: Stage, investigationId: string, investigationVersionedRequest: InvestigationVersionedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('refreshInvestigationPopulation', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('refreshInvestigationPopulation', 'investigationId', investigationId)
            // verify required parameter 'investigationVersionedRequest' is not null or undefined
            assertParamExists('refreshInvestigationPopulation', 'investigationVersionedRequest', investigationVersionedRequest)
            const localVarPath = `/investigations/{investigationId}/population/refresh`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationVersionedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The caller must be the current owner. The investigation is left without an owner (it appears in the \"Needs an owner\" list) and the caller stays on it as a contributor. Resolved investigations cannot be released; reopen first.
         * @summary Give up ownership of an investigation without naming a successor (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationReleaseRequest} investigationReleaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseInvestigation: async (stage: Stage, investigationId: string, investigationReleaseRequest: InvestigationReleaseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('releaseInvestigation', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('releaseInvestigation', 'investigationId', investigationId)
            // verify required parameter 'investigationReleaseRequest' is not null or undefined
            assertParamExists('releaseInvestigation', 'investigationReleaseRequest', investigationReleaseRequest)
            const localVarPath = `/investigations/{investigationId}/release`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationReleaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A redriven message that returns with an error the case\'s rule no longer matches failed for a different reason. The case keeps it until the owner releases it: this drops the case\'s ownership of every such return it still holds and asks for an early reconcile, which hands each one to the active case whose rule matches it or leaves it in the backlog. Returns still failing the same way are untouched. At most 10,000 per call (moreToRelease).
         * @summary Release returned messages that came back with a new error (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationReleaseReturnedRequest} investigationReleaseReturnedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseInvestigationReturnedItems: async (stage: Stage, investigationId: string, investigationReleaseReturnedRequest: InvestigationReleaseReturnedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('releaseInvestigationReturnedItems', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('releaseInvestigationReturnedItems', 'investigationId', investigationId)
            // verify required parameter 'investigationReleaseReturnedRequest' is not null or undefined
            assertParamExists('releaseInvestigationReturnedItems', 'investigationReleaseReturnedRequest', investigationReleaseReturnedRequest)
            const localVarPath = `/investigations/{investigationId}/returned-items/release`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationReleaseReturnedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Freezes the current primary assignments into an exact manifest, uploads it as the bulk-redrive CSV to the stage\'s DLQ redrive bucket and creates a Draft MCM whose description carries the S3 URI + ETag literal the redriver validates, plus the justification and the investigation context. The investigation stays READY_TO_REDRIVE with `pendingDeletion` set, which locks population refresh, redrives, status changes and child splits until the request is executed or cancelled (409 DELETION_PENDING). Requires status READY_TO_REDRIVE and the DLQ redrive Bindle lock.
         * @summary Request an MCM-gated delete-without-redrive of the investigation\'s frozen manifest (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationDeletionRequest} investigationDeletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestInvestigationDeletion: async (stage: Stage, investigationId: string, investigationDeletionRequest: InvestigationDeletionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('requestInvestigationDeletion', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('requestInvestigationDeletion', 'investigationId', investigationId)
            // verify required parameter 'investigationDeletionRequest' is not null or undefined
            assertParamExists('requestInvestigationDeletion', 'investigationDeletionRequest', investigationDeletionRequest)
            const localVarPath = `/investigations/{investigationId}/deletions`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationDeletionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Given a stage and DLQ primary key returns whether the item is owned by an active investigation, matches a resolved (historical) investigation, is ambiguous, or is uninvestigated, plus a suggested population rule built from the seed fields.
         * @summary Resolve a DLQ dashboard row against the live investigation registry
         * @param {Stage} stage environment name
         * @param {InvestigationRowRequest} investigationRowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveInvestigationRow: async (stage: Stage, investigationRowRequest: InvestigationRowRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('resolveInvestigationRow', 'stage', stage)
            // verify required parameter 'investigationRowRequest' is not null or undefined
            assertParamExists('resolveInvestigationRow', 'investigationRowRequest', investigationRowRequest)
            const localVarPath = `/investigations/resolve-row`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationRowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * While a document redrive awaits the owner\'s CBE check (documentRedrive.stage AWAITING_CONFIRMATION), schedules an email + Slack reminder to the owner at remindAt (5 minutes to 7 days ahead) through the Notifications service and records it as documentRedrive.reminder. A new reminder replaces the previous one; confirming the check cancels it (CancelScheduledNotification).
         * @summary Remind the owner to do the CBE check later (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId 
         * @param {InvestigationReminderRequest} investigationReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInvestigationDocumentRedriveReminder: async (stage: Stage, investigationId: string, attemptId: string, investigationReminderRequest: InvestigationReminderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('setInvestigationDocumentRedriveReminder', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('setInvestigationDocumentRedriveReminder', 'investigationId', investigationId)
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('setInvestigationDocumentRedriveReminder', 'attemptId', attemptId)
            // verify required parameter 'investigationReminderRequest' is not null or undefined
            assertParamExists('setInvestigationDocumentRedriveReminder', 'investigationReminderRequest', investigationReminderRequest)
            const localVarPath = `/investigations/{investigationId}/document-redrives/{attemptId}/reminder`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)))
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationReminderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Schedules an email + Slack reminder to the caller at remindAt (5 minutes to 7 days ahead) through the Notifications service. Private: each person has at most one reminder per case, only they see it (myReminder), it writes no timeline event, does not count as activity and needs no expectedVersion. A new reminder replaces (cancels) the caller\'s previous one.
         * @summary Remind me to check back on an investigation (anyone signed in)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationCaseReminderRequest} investigationCaseReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInvestigationReminder: async (stage: Stage, investigationId: string, investigationCaseReminderRequest: InvestigationCaseReminderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('setInvestigationReminder', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('setInvestigationReminder', 'investigationId', investigationId)
            // verify required parameter 'investigationCaseReminderRequest' is not null or undefined
            assertParamExists('setInvestigationReminder', 'investigationCaseReminderRequest', investigationCaseReminderRequest)
            const localVarPath = `/investigations/{investigationId}/reminder`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationCaseReminderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For populations no rule can separate (e.g. safe vs unsafe orders decided from their FLARE history). `lines` holds DLQ keys, one per entry (an optional first entry `dlq_pk` is ignored). Order IDs are refused (400): they would also move items that arrived for those orders after the list was made. Keys are matched against this case\'s frozen manifest (no Athena query). With dryRun=true only the counts are returned; otherwise a child investigation is created that takes over the matched items this case still owns (more than 2,000 are moved on the worker). A list child never gains items later: reconcile, population refresh, add-items, rule widening and rule splits skip or refuse it. Refused while a deletion is pending, a merge is running or a redrive is executing/monitoring, and when every item would move.
         * @summary Split items off into a child investigation by a list of DLQ keys (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationSplitListRequest} investigationSplitListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitInvestigationByList: async (stage: Stage, investigationId: string, investigationSplitListRequest: InvestigationSplitListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('splitInvestigationByList', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('splitInvestigationByList', 'investigationId', investigationId)
            // verify required parameter 'investigationSplitListRequest' is not null or undefined
            assertParamExists('splitInvestigationByList', 'investigationSplitListRequest', investigationSplitListRequest)
            const localVarPath = `/investigations/{investigationId}/split-list`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationSplitListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Step 1 of the document-redrive path. Re-processes the distinct transaction IDs (accounting unique id, else order id) of the items the investigation owns through the order redrive state machine: Lusca rebuilds each document from its own store with a bumped version tagged MANUAL_REDRIVE and republishes its CBEs. Requires READY_TO_REDRIVE and the DLQ redrive Bindle lock; the case is EXECUTING_REDRIVE while it runs and returns to READY_TO_REDRIVE with documentRedrive.stage AWAITING_CONFIRMATION. The DLQ items are not touched: after the owner confirms (document-redrives/{attemptId}/confirm) a DLQ redrive clears them. Use it when the stored document is correct but its accounting (CBEs) is wrong or missing.
         * @summary Launch a document redrive of the investigation\'s transactions (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startInvestigationDocumentRedrive: async (stage: Stage, investigationId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('startInvestigationDocumentRedrive', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('startInvestigationDocumentRedrive', 'investigationId', investigationId)
            // verify required parameter 'investigationDocumentRedriveRequest' is not null or undefined
            assertParamExists('startInvestigationDocumentRedrive', 'investigationDocumentRedriveRequest', investigationDocumentRedriveRequest)
            const localVarPath = `/investigations/{investigationId}/document-redrives`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationDocumentRedriveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts an Athena query over the latest hourly DLQ snapshot for the given population rule and returns a previewId to poll with GET investigations/previews/{previewId}. The rule is a list of equality predicates over allowlisted DLQ fields (eventsourcekey, error_type, error_message, error_category, gl_product_group, marketplace_id, usecase, digital_order_source, is_emp_order, destination, accounting_operation, payment_processor).
         * @summary Start an asynchronous DLQ investigation population preview
         * @param {Stage} stage environment name
         * @param {InvestigationPreviewRequest} investigationPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startInvestigationPreview: async (stage: Stage, investigationPreviewRequest: InvestigationPreviewRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('startInvestigationPreview', 'stage', stage)
            // verify required parameter 'investigationPreviewRequest' is not null or undefined
            assertParamExists('startInvestigationPreview', 'investigationPreviewRequest', investigationPreviewRequest)
            const localVarPath = `/investigations/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Freezes the current primary assignments into an exact manifest, invokes the existing DLQ redrive state machine (Bindle lock check applies) and moves the investigation to EXECUTING_REDRIVE. Requires status READY_TO_REDRIVE.
         * @summary Launch a redrive of the investigation\'s frozen DLQ-PK manifest (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationRedriveRequest} investigationRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startInvestigationRedrive: async (stage: Stage, investigationId: string, investigationRedriveRequest: InvestigationRedriveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('startInvestigationRedrive', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('startInvestigationRedrive', 'investigationId', investigationId)
            // verify required parameter 'investigationRedriveRequest' is not null or undefined
            assertParamExists('startInvestigationRedrive', 'investigationRedriveRequest', investigationRedriveRequest)
            const localVarPath = `/investigations/{investigationId}/redrives`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationRedriveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by TrackStars (through the Lusca MCP server, as the person who ran it) once, with its DashboardReport JSON. Completes the investigation\'s current run while it is REQUESTED; otherwise records a new run for the report first, so the latest report wins. Lusca stores the report, counts each pattern\'s items in the frozen population (on the worker) and moves the run SCORING → COMPLETED (or FAILED), logging TRACKSTARS_RUN_COMPLETED.
         * @summary TrackStars writes its finished report back, knowing only the investigation id
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {SubmitInvestigationTrackStarsReportRequest} submitInvestigationTrackStarsReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitInvestigationTrackStarsReport: async (stage: Stage, investigationId: string, submitInvestigationTrackStarsReportRequest: SubmitInvestigationTrackStarsReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('submitInvestigationTrackStarsReport', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('submitInvestigationTrackStarsReport', 'investigationId', investigationId)
            // verify required parameter 'submitInvestigationTrackStarsReportRequest' is not null or undefined
            assertParamExists('submitInvestigationTrackStarsReport', 'submitInvestigationTrackStarsReportRequest', submitInvestigationTrackStarsReportRequest)
            const localVarPath = `/investigations/{investigationId}/trackstars-report`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitInvestigationTrackStarsReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Transfer ownership of an investigation to another Lusca Search user (anyone may; only the new owner is notified)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationTransferRequest} investigationTransferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferInvestigation: async (stage: Stage, investigationId: string, investigationTransferRequest: InvestigationTransferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('transferInvestigation', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('transferInvestigation', 'investigationId', investigationId)
            // verify required parameter 'investigationTransferRequest' is not null or undefined
            assertParamExists('transferInvestigation', 'investigationTransferRequest', investigationTransferRequest)
            const localVarPath = `/investigations/{investigationId}/transfer`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationTransferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a case confirmed by mistake back to the CBE check: documentRedrive.stage CONFIRMED → AWAITING_CONFIRMATION (confirmedAt/confirmedBy cleared), so the DLQ redrive is locked again until the owner confirms. Only while the case is still READY_TO_REDRIVE (no DLQ redrive launched since).
         * @summary Undo the CBE confirmation of a document redrive (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId 
         * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unconfirmInvestigationDocumentRedrive: async (stage: Stage, investigationId: string, attemptId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('unconfirmInvestigationDocumentRedrive', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('unconfirmInvestigationDocumentRedrive', 'investigationId', investigationId)
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('unconfirmInvestigationDocumentRedrive', 'attemptId', attemptId)
            // verify required parameter 'investigationDocumentRedriveRequest' is not null or undefined
            assertParamExists('unconfirmInvestigationDocumentRedrive', 'investigationDocumentRedriveRequest', investigationDocumentRedriveRequest)
            const localVarPath = `/investigations/{investigationId}/document-redrives/{attemptId}/unconfirm`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)))
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationDocumentRedriveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Owner-only for status transitions, blocker and resolution; anyone may rename (title) or add or edit the conclusion and its evidence links. Requires expectedVersion; returns 409 on version mismatch. Humans cannot set EXECUTING_REDRIVE or MONITORING_REDRIVE, except to unblock a case that was blocked while MONITORING_REDRIVE (blocker.blockedFrom), which resumes monitoring. Resolving requires a conclusion summary; evidence links are recommended but not enforced. Free-form progress notes go to the comments endpoint.
         * @summary Update an investigation (title and links by anyone; description, conclusion, blocker, status, resolution by the owner; Taskei task link)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationUpdateRequest} investigationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvestigation: async (stage: Stage, investigationId: string, investigationUpdateRequest: InvestigationUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('updateInvestigation', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('updateInvestigation', 'investigationId', investigationId)
            // verify required parameter 'investigationUpdateRequest' is not null or undefined
            assertParamExists('updateInvestigation', 'investigationUpdateRequest', investigationUpdateRequest)
            const localVarPath = `/investigations/{investigationId}/update`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds `rule` to the investigation\'s rules as an OR branch (a branch it already contains is dropped; nothing changes when the case already covers it) and asks for an early reconcile, so unowned items matching the wider rule move in within minutes, and future ones keep arriving at every hourly reconcile. Recorded as RULE_WIDENED with the previous and new rules.
         * @summary Widen an investigation\'s rule with another rule branch (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationWidenRuleRequest} investigationWidenRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widenInvestigationRule: async (stage: Stage, investigationId: string, investigationWidenRuleRequest: InvestigationWidenRuleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('widenInvestigationRule', 'stage', stage)
            // verify required parameter 'investigationId' is not null or undefined
            assertParamExists('widenInvestigationRule', 'investigationId', investigationId)
            // verify required parameter 'investigationWidenRuleRequest' is not null or undefined
            assertParamExists('widenInvestigationRule', 'investigationWidenRuleRequest', investigationWidenRuleRequest)
            const localVarPath = `/investigations/{investigationId}/rule/widen`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationWidenRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvestigationsApi - functional programming interface
 * @export
 */
export const InvestigationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvestigationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a comment to an investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationCommentRequest} investigationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addInvestigationComment(stage: Stage, investigationId: string, investigationCommentRequest: InvestigationCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addInvestigationComment(stage, investigationId, investigationCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Marks the request CANCELLED and clears `pendingDeletion`, unlocking the investigation. Lusca does not cancel the MCM; discard it in MCM.
         * @summary Cancel a pending delete-without-redrive request (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId Redrive / deletion attempt id (att-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelInvestigationDeletion(stage: Stage, investigationId: string, attemptId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationDeletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelInvestigationDeletion(stage, investigationId, attemptId, investigationVersionedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancels the caller\'s pending reminder on the case (CancelScheduledNotification). Idempotent.
         * @summary Cancel my reminder on an investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelInvestigationReminder(stage: Stage, investigationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelInvestigationReminder(stage, investigationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Makes the caller the owner of any active investigation, owned or not. A takeover is recorded in the timeline (called out as stale after the configured inactivity period, default 72 hours), the previous owner is notified and stays a contributor. Resolved/cancelled cases must be reopened first.
         * @summary Take ownership of an active investigation (anyone may; the previous owner is notified)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimInvestigation(stage: Stage, investigationId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimInvestigation(stage, investigationId, investigationVersionedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Step 2 gate of the document-redrive path. After a document redrive completes the case is back in READY_TO_REDRIVE with documentRedrive.stage AWAITING_CONFIRMATION and a DLQ redrive is refused (409 DOCUMENT_REDRIVE_UNCONFIRMED) until the owner has spot-checked the sample transactions and confirms here. Moves documentRedrive.stage to CONFIRMED; the DLQ redrive that clears the items may then be launched.
         * @summary Confirm a completed document redrive\'s CBEs were republished (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId 
         * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmInvestigationDocumentRedrive(stage: Stage, investigationId: string, attemptId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmInvestigationDocumentRedrive(stage, investigationId, attemptId, investigationDocumentRedriveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Freezes the preview\'s exact DLQ-PK manifest, creates the investigation and conditionally claims primary ownership of each DLQ item. Items already owned by another active investigation are reported as conflicts and never stolen. mode=remainder creates the case for unassigned items only; mode=child creates a narrower child of parentInvestigationId that takes over its matching subset. A mode=full request whose rule is identical to an active investigation\'s is refused with 409 DUPLICATE_RULE (`current` is that investigation) before anything is written; the check reads only the active registry, so it costs the same for any population size. Should the claim nonetheless win no items (a different rule that covers the same items, or a race), the new case is closed at once as RESOLVED / DUPLICATE with duplicateOfInvestigationId set, the creator is notified, and the response carries duplicateOfInvestigationId.
         * @summary Create a DLQ investigation from a completed preview
         * @param {Stage} stage environment name
         * @param {InvestigationCreateRequest} investigationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvestigation(stage: Stage, investigationCreateRequest: InvestigationCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvestigation(stage, investigationCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a comment (author or owner only). The event stays in the timeline marked deleted.
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInvestigationComment(stage: Stage, investigationId: string, eventId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvestigationComment(stage, investigationId, eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Edit a comment (author or owner only). The original text is kept in the event\'s edit history.
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} eventId 
         * @param {InvestigationCommentRequest} investigationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editInvestigationComment(stage: Stage, investigationId: string, eventId: string, investigationCommentRequest: InvestigationCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editInvestigationComment(stage, investigationId, eventId, investigationCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Re-checks that every manifest PK is still owned by the investigation (409 MANIFEST_DRIFTED otherwise) and starts the DLQ redrive state machine with deleteWithoutRedriving=true and the MCM ID. The redriver enforces the MCM gate (In Progress, approver, title, exact literal). Moves the investigation to EXECUTING_REDRIVE. A FAILED run can be executed again after fixing the MCM.
         * @summary Execute an approved delete-without-redrive request (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId Redrive / deletion attempt id (att-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeInvestigationDeletion(stage: Stage, investigationId: string, attemptId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationDeletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeInvestigationDeletion(stage, investigationId, attemptId, investigationVersionedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For stages this deployment cannot redrive itself (Investigation.redriveMode = external): uploads the file the Lusca Search Prod tool takes for the chosen kind — the DLQ redrive bulk CSV (header dlq_pk) for REDRIVE / DELETE, the Redrive Tool CSV (distinct transaction ids, no header) for DOCUMENT_REDRIVE — built from the items the investigation owns now, and returns a one-hour download link plus the Prod page to run it on.
         * @summary File to upload in Lusca Search Prod for a redrive of this investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationExternalRedriveExportRequest} investigationExternalRedriveExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportInvestigationExternalRedrive(stage: Stage, investigationId: string, investigationExternalRedriveExportRequest: InvestigationExternalRedriveExportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationExternalRedriveExport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportInvestigationExternalRedrive(stage, investigationId, investigationExternalRedriveExportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Adds the preview\'s items that no other active case owns or wins (narrowest rule, then oldest case) to this investigation and refreezes its manifest as the union. The rule is unchanged. The preview must be COMPLETED, not truncated, at most 60 minutes old, and add at most 2,000 new items.
         * @summary Add a completed preview\'s unowned items to an existing investigation (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationExtendRequest} investigationExtendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendInvestigationPopulation(stage: Stage, investigationId: string, investigationExtendRequest: InvestigationExtendRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationExtendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendInvestigationPopulation(stage, investigationId, investigationExtendRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Followers get a bell notification (and email/Slack) when someone else comments, changes the status or owner, merges the case, or when a redrive or deletion finishes or needs attention. Following is recorded as a FOLLOWED / UNFOLLOWED timeline event (audit log and activity feed) but does not count as activity, does not make the caller a contributor and notifies nobody. It needs no expectedVersion. The owner is always told about their own case and is not notified twice. Idempotent.
         * @summary Follow or unfollow an investigation (anyone signed in)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationFollowRequest} investigationFollowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followInvestigation(stage: Stage, investigationId: string, investigationFollowRequest: InvestigationFollowRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followInvestigation(stage, investigationId, investigationFollowRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the investigation metadata, redrive attempts and the most recent timeline events.
         * @summary Get a DLQ investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestigation(stage: Stage, investigationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestigation(stage, investigationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Build a prompt for a local agent to continue the investigation through Lusca MCP
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestigationAgentPrompt(stage: Stage, investigationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationAgentPrompt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestigationAgentPrompt(stage, investigationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload with the presigned POST (`post.url` + `post.fields` as multipart form fields, file last) — S3 enforces the size limit and content type — or with a plain PUT to `uploadUrl`. Nothing is recorded yet: send the returned `key` in `attachments` of a comment or of the conclusion to attach it. Limits: 10 MB per file, 10 files per comment/conclusion; images (PNG, JPEG, GIF, WebP), PDF, text, CSV, JSON, ZIP, XLSX. Files are never deleted.
         * @summary Get a presigned upload for a comment or conclusion attachment (screenshot, log, export)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationAttachmentUploadRequest} investigationAttachmentUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestigationArtifactUploadUrl(stage: Stage, investigationId: string, investigationAttachmentUploadRequest: InvestigationAttachmentUploadRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationAttachmentUpload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestigationArtifactUploadUrl(stage, investigationId, investigationAttachmentUploadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a fresh presigned download URL for an attachment of this investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestigationArtifactUrl(stage: Stage, investigationId: string, key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationAttachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestigationArtifactUrl(stage, investigationId, key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Groups the frozen manifest\'s items that this investigation does not own by their current owning active investigation. Populations larger than the check limit are sampled evenly and the counts are scaled (sampled=true).
         * @summary Which other investigations own items of this investigation\'s frozen population
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestigationOtherOwners(stage: Stage, investigationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationOtherOwnersResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestigationOtherOwners(stage, investigationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the preview job status. When COMPLETED it includes the matching count, representative samples, the effective rule, the snapshot timestamp and overlap analysis against active and resolved investigations.
         * @summary Poll a DLQ investigation population preview
         * @param {Stage} stage environment name
         * @param {string} previewId Preview job id returned by startInvestigationPreview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestigationPreview(stage: Stage, previewId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestigationPreview(stage, previewId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the immutable activity timeline of an investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestigationTimeline(stage: Stage, investigationId: string, limit?: number, nextToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationTimelinePage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestigationTimeline(stage, investigationId, limit, nextToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A report TrackStars writes back to an investigation is stored per case and never becomes the stage\'s latest, so its patterns are not in listInvestigationSuggestions. This reads the latest completed run\'s report and shapes every pattern like a suggestion (root cause, recommended action, samples, when-clause, derived rule), ordered by how many of this investigation\'s items it matched (runItems). Ownership is empty: the cards are shown on the case itself. available=false when the case has no completed run.
         * @summary The patterns of the investigation\'s own TrackStars run, as full suggestion cards
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestigationTrackStarsRunPatterns(stage: Stage, investigationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationTrackStarsRunPatterns>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestigationTrackStarsRunPatterns(stage, investigationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Imports a TrackStars DLQ analysis report (the JSON TrackStars produces) for the stage. Pattern ids are made unique across reports (<reportId>-PAT-NNN, references rewritten); the report is archived under trackstars/<stage>/reports/<reportId>.json and then becomes trackstars/<stage>/latest.json, which drives listInvestigationSuggestions. Earlier reports stay archived so cases opened from them keep their origin pattern. Re-uploading the same report is idempotent. At most 5 MB.
         * @summary Upload a TrackStars report as the stage\'s latest
         * @param {Stage} stage environment name
         * @param {ImportTrackStarsReportRequest} importTrackStarsReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importTrackStarsReport(stage: Stage, importTrackStarsReportRequest: ImportTrackStarsReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackStarsReportImportResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importTrackStarsReport(stage, importTrackStarsReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Records the execution (ARN or execution ID on the stage\'s DLQ redrive or order redrive state machine) as an attempt with linked=true, frozen from the items the investigation owns now, and moves the case to EXECUTING_REDRIVE; from then on it is polled, completed, verified and return-checked like a launched attempt. Requires READY_TO_REDRIVE. REDRIVE is refused while a document redrive awaits confirmation; DELETE requires a deleteWithoutRedriving execution.
         * @summary Link a redrive run in Lusca Search Prod to this investigation (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationExternalRedriveLinkRequest} investigationExternalRedriveLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkInvestigationExternalRedrive(stage: Stage, investigationId: string, investigationExternalRedriveLinkRequest: InvestigationExternalRedriveLinkRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationRedriveAttempt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkInvestigationExternalRedrive(stage, investigationId, investigationExternalRedriveLinkRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DLQ error categories are `.when(...)` rules in PVAccountingCDK\'s DLQ Glue job (assets/glue/dlq_dynamo_job.py). A scheduled worker task walks that file\'s history over GitFarm and records, per category, the first commit that added its rule and the CR in that commit\'s `cr:` trailer. Categories written before the rules moved into code carry migrated=true: their commit is the migration, not the original investigation. available=false until the task has run once.
         * @summary The code change (CR) that introduced each DLQ error category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listErrorCategorySources(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorCategorySourcesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listErrorCategorySources(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Timeline events caused by a person (UI or MCP) on every investigation in the stage, newest first: comments, status changes, claims and transfers, redrives, merges, splits, links. System and worker events are left out. scope=mine keeps the caller\'s cases (owned in any status, or contributed to while active) plus anything the caller did. `investigations` summarises every case the page mentions. Events recorded before the activity index existed appear only once backfilled.
         * @summary Stage-wide feed of what people did on investigations
         * @param {Stage} stage environment name
         * @param {'all' | 'mine'} [scope] 
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvestigationActivity(stage: Stage, scope?: 'all' | 'mine', limit?: number, nextToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationActivityPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvestigationActivity(stage, scope, limit, nextToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Everyone permitted to unlock the Lusca Search Bindle lock (the same lock the Midway authorizer enforces), resolved through BRASS and cached for a few minutes. Reassignment to an alias outside this list is rejected with 400.
         * @summary List aliases that may own or be assigned an investigation
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvestigationAssignees(stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationAssigneesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvestigationAssignees(stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Every owner notification addressed to the signed-in user (assignment, takeover, comments, contributions, merges, redrive outcomes), newest first, regardless of stage. This is the feed behind the notification bell; the same events are also delivered by email and Slack through the Amazon Notifications service. Entries expire after 30 days.
         * @summary The caller\'s notification inbox across all stages
         * @param {boolean} [unreadOnly] 
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvestigationInbox(unreadOnly?: boolean, limit?: number, nextToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationInbox>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvestigationInbox(unreadOnly, limit, nextToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * By default (scope=live) lists the items this investigation owns that were still in the DLQ at the last hourly reconcile (the count shown on the case). scope=all lists the frozen DLQ-PK manifest, every item the case was created with or later claimed, each row marked inDlq. Cases not yet reconciled have no live list and are served from the frozen manifest (scope=all in the response). Rows carry their snapshot fields and whether this investigation still holds primary ownership of each item.
         * @summary List the investigation\'s items (still in the DLQ by default, or all it was frozen with)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {number} [limit] 
         * @param {number} [offset] Row offset into the manifest for paging
         * @param {string} [q] Case-insensitive substring match over PK, queue, error type/message, use case and transaction/order ID
         * @param {string} [filter] Structured filter, JSON-encoded (same shape as the backlog\&#39;s filter): {\&quot;operation\&quot;: \&quot;and\&quot;|\&quot;or\&quot;, \&quot;tokens\&quot;: [{\&quot;propertyKey\&quot;, \&quot;operator\&quot;, \&quot;value\&quot;}]}. propertyKey is a manifest column: a rule field, dlq_pk, transaction_id or order_id (operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;:\&quot; contains, \&quot;!:\&quot; does not contain; case-insensitive; a missing value reads as \&quot;\&quot;) or dlq_timestamp / transaction_date (operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;&gt;\&quot;, \&quot;&gt;&#x3D;\&quot;, \&quot;&lt;\&quot;, \&quot;&lt;&#x3D;\&quot; on a date or timestamp prefix). A token without propertyKey is a free-text substring match over the same columns as q. Combined with q.
         * @param {'dlq_pk' | 'dlq_timestamp' | 'transaction_date' | 'eventsourcekey' | 'error_type' | 'error_message' | 'usecase' | 'transaction_id'} [sort] Manifest column to sort by (default dlq_timestamp)
         * @param {boolean} [desc] Sort descending (default true)
         * @param {'live' | 'all'} [scope] live (default) &#x3D; owned items still in the DLQ; all &#x3D; the whole frozen manifest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvestigationItems(stage: Stage, investigationId: string, limit?: number, offset?: number, q?: string, filter?: string, sort?: 'dlq_pk' | 'dlq_timestamp' | 'transaction_date' | 'eventsourcekey' | 'error_type' | 'error_message' | 'usecase' | 'transaction_id', desc?: boolean, scope?: 'live' | 'all', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationItemsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvestigationItems(stage, investigationId, limit, offset, q, filter, sort, desc, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List redrive attempts of an investigation and refresh their status
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvestigationRedrives(stage: Stage, investigationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationRedriveList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvestigationRedrives(stage, investigationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Redriven messages that returned to the DLQ, newest first
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvestigationReturnedItems(stage: Stage, investigationId: string, limit?: number, nextToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationReturnedItemsPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvestigationReturnedItems(stage, investigationId, limit, nextToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * TrackStars (TRACK\'s multi-agent DLQ analysis) publishes each run as a report of root-caused failure patterns. This returns every pattern of the latest report imported for the stage as a population suggestion: the eq rule derived from the pattern\'s PySpark when-clause (fields it pins exactly plus single-valued scope), any error-message substrings the rule cannot express until a preview reveals the matching templated value(s), the root cause, evidence, recommended action, sample order IDs (display only), how the pattern relates to active investigations (unowned, partially covered, or owned — by rule containment or because a case records the pattern as its origin) and a ready-to-use starter (title, first comment, evidence links) for createInvestigation. available=false when no report has been imported for the stage.
         * @summary Investigation suggestions derived from the latest TrackStars DLQ analysis report
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvestigationSuggestions(stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationSuggestionsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvestigationSuggestions(stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists investigations for a stage using indexed queries. view selects a standard work-queue view (mine, active, blocked, ready_to_redrive, monitoring, resolved, withdrawn); status/owner/unclaimed/ redriven/returned narrow the results. Paginated with nextToken.
         * @summary List DLQ investigations (work queue)
         * @param {Stage} stage environment name
         * @param {'mine' | 'active' | 'blocked' | 'ready_to_redrive' | 'monitoring' | 'resolved' | 'withdrawn' | 'all'} [view] 
         * @param {InvestigationStatus} [status] 
         * @param {string} [owner] Owner alias filter
         * @param {boolean} [unclaimed] 
         * @param {boolean} [redriven] Only investigations with at least one redrive attempt
         * @param {boolean} [returned] Only investigations where redriven messages returned to the DLQ
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvestigations(stage: Stage, view?: 'mine' | 'active' | 'blocked' | 'ready_to_redrive' | 'monitoring' | 'resolved' | 'withdrawn' | 'all', status?: InvestigationStatus, owner?: string, unclaimed?: boolean, redriven?: boolean, returned?: boolean, limit?: number, nextToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvestigations(stage, view, status, owner, unclaimed, redriven, returned, limit, nextToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns one page of the groups of DLQ items (by queue, error type, templated error message and category) that are not assigned to any investigation, computed by the hourly reconciliation. Filtering (filter, q, uncategorizedOnly), sorting and paging happen server-side over the full set of reconciled groups; totalCount is the number of rows matching the filter and totalGroups the number of groups reconciled. Default order is highest impact first. Every response also carries the distinct queue, error type and category values (filterOptions) so a client can offer them as filter suggestions without loading every group. With groupByCategory=true the rows are the category view: every group with an error category collapses into one row per category (sizes summed, members listing the (queue, error type) split), while uncategorized groups stay one row each. Identity filter tokens (queue, errorType, errorMessage, category, free text, q) narrow the constituent groups before collapsing, so a category row shows only its matching share; size tokens (items, impactUsd, ambiguous, growth, lastSeen) apply to the collapsed row. totalRows is what the unfiltered view holds in either mode.
         * @summary List uninvestigated DLQ populations from the latest reconciliation
         * @param {Stage} stage environment name
         * @param {boolean} [uncategorizedOnly] 
         * @param {boolean} [groupByCategory] Collapse categorized groups into one row per error category (see description)
         * @param {number} [limit] 
         * @param {number} [offset] Group offset into the filtered, sorted list for paging
         * @param {string} [q] Case-insensitive substring match over queue, error type, error message and category
         * @param {string} [filter] Structured filter, JSON-encoded: {\&quot;operation\&quot;: \&quot;and\&quot;|\&quot;or\&quot;, \&quot;tokens\&quot;: [{\&quot;propertyKey\&quot;, \&quot;operator\&quot;, \&quot;value\&quot;}]}. propertyKey is one of queue, errorType, errorMessage, category (string operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;:\&quot; contains, \&quot;!:\&quot; does not contain), items, impactUsd, ambiguous, growth (the group\&#39;s growth7d; a group seen in a single snapshot never matches) (numeric operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;&gt;\&quot;, \&quot;&gt;&#x3D;\&quot;, \&quot;&lt;\&quot;, \&quot;&lt;&#x3D;\&quot;) or lastSeen (the group\&#39;s latestDlqTimestamp compared with a \&quot;YYYY-MM-DD\&quot; date or \&quot;YYYY-MM-DD HH:MM:SS\&quot; timestamp prefix, same operators as numeric; a group without a timestamp never matches). A token without propertyKey is a free-text substring match over the same fields as q. Combined with q and uncategorizedOnly (all must match).
         * @param {string} [countFilters] Optional JSON array of up to 10 structured filters (same shape as filter). For each, the response\&#39;s filterCounts carries the number of reconciled groups it matches, evaluated over the whole reconciliation independently of filter, q and uncategorizedOnly — one round trip for a navigation\&#39;s slice badges.
         * @param {'impactUsd' | 'count' | 'ambiguousCount' | 'eventsourcekey' | 'errorType' | 'errorMessage' | 'errorCategory' | 'latestDlqTimestamp' | 'growth7d'} [sort] Group field to sort by (default impactUsd; groups without an impact value rank last). &#x60;ambiguousCount&#x60; is deprecated (always 0) and kept for compatibility.
         * @param {boolean} [desc] Sort descending (default true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUninvestigatedGroups(stage: Stage, uncategorizedOnly?: boolean, groupByCategory?: boolean, limit?: number, offset?: number, q?: string, filter?: string, countFilters?: string, sort?: 'impactUsd' | 'count' | 'ambiguousCount' | 'eventsourcekey' | 'errorType' | 'errorMessage' | 'errorCategory' | 'latestDlqTimestamp' | 'growth7d', desc?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UninvestigatedGroupsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUninvestigatedGroups(stage, uncategorizedOnly, groupByCategory, limit, offset, q, filter, countFilters, sort, desc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Passive: no timeline event, no activity timestamp change. Provide notificationIds for specific entries, investigationId for every entry of one case, or all=true for everything unread.
         * @summary Mark the caller\'s inbox notifications as read
         * @param {InvestigationInboxReadRequest} investigationInboxReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markInvestigationInboxRead(investigationInboxReadRequest: InvestigationInboxReadRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationInboxReadResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markInvestigationInboxRead(investigationInboxReadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Anyone signed in may merge. The survivor keeps its id, owner, status and comments; its rule gains every source rule as an additional OR branch and its population becomes the union of all frozen manifests. Each source is closed as RESOLVED with reason MERGED (it cannot be reopened), its owner and contributors become contributors of the survivor, its children are re-parented to the survivor. Item ownership is re-pointed inline for small populations and by the worker otherwise (`mergePending` set until done). Refused (409) when any participant is resolved, executing or monitoring a redrive, awaiting a deletion MCM, already merging, or in another stage. There is no unmerge — split the survivor instead.
         * @summary Merge other active investigations into this one (the survivor)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationMergeRequest} investigationMergeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeInvestigations(stage: Stage, investigationId: string, investigationMergeRequest: InvestigationMergeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationMergeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeInvestigations(stage, investigationId, investigationMergeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Starts a preview for the investigation\'s rule; when it completes the worker assigns unassigned matching items to the investigation and refreshes the frozen population snapshot. Owner only. While the refresh runs the investigation carries `pendingRefresh`; a second request in that window is rejected with 409 `REFRESH_IN_PROGRESS` (the running preview is returned as `preview`) so the expensive Athena scan is never started twice.
         * @summary Re-evaluate the investigation\'s live population rule against the latest DLQ snapshot (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshInvestigationPopulation(stage: Stage, investigationId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshInvestigationPopulation(stage, investigationId, investigationVersionedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The caller must be the current owner. The investigation is left without an owner (it appears in the \"Needs an owner\" list) and the caller stays on it as a contributor. Resolved investigations cannot be released; reopen first.
         * @summary Give up ownership of an investigation without naming a successor (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationReleaseRequest} investigationReleaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseInvestigation(stage: Stage, investigationId: string, investigationReleaseRequest: InvestigationReleaseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseInvestigation(stage, investigationId, investigationReleaseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A redriven message that returns with an error the case\'s rule no longer matches failed for a different reason. The case keeps it until the owner releases it: this drops the case\'s ownership of every such return it still holds and asks for an early reconcile, which hands each one to the active case whose rule matches it or leaves it in the backlog. Returns still failing the same way are untouched. At most 10,000 per call (moreToRelease).
         * @summary Release returned messages that came back with a new error (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationReleaseReturnedRequest} investigationReleaseReturnedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseInvestigationReturnedItems(stage: Stage, investigationId: string, investigationReleaseReturnedRequest: InvestigationReleaseReturnedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationReleaseReturnedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseInvestigationReturnedItems(stage, investigationId, investigationReleaseReturnedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Freezes the current primary assignments into an exact manifest, uploads it as the bulk-redrive CSV to the stage\'s DLQ redrive bucket and creates a Draft MCM whose description carries the S3 URI + ETag literal the redriver validates, plus the justification and the investigation context. The investigation stays READY_TO_REDRIVE with `pendingDeletion` set, which locks population refresh, redrives, status changes and child splits until the request is executed or cancelled (409 DELETION_PENDING). Requires status READY_TO_REDRIVE and the DLQ redrive Bindle lock.
         * @summary Request an MCM-gated delete-without-redrive of the investigation\'s frozen manifest (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationDeletionRequest} investigationDeletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestInvestigationDeletion(stage: Stage, investigationId: string, investigationDeletionRequest: InvestigationDeletionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationDeletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestInvestigationDeletion(stage, investigationId, investigationDeletionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Given a stage and DLQ primary key returns whether the item is owned by an active investigation, matches a resolved (historical) investigation, is ambiguous, or is uninvestigated, plus a suggested population rule built from the seed fields.
         * @summary Resolve a DLQ dashboard row against the live investigation registry
         * @param {Stage} stage environment name
         * @param {InvestigationRowRequest} investigationRowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveInvestigationRow(stage: Stage, investigationRowRequest: InvestigationRowRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationRowResolution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveInvestigationRow(stage, investigationRowRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * While a document redrive awaits the owner\'s CBE check (documentRedrive.stage AWAITING_CONFIRMATION), schedules an email + Slack reminder to the owner at remindAt (5 minutes to 7 days ahead) through the Notifications service and records it as documentRedrive.reminder. A new reminder replaces the previous one; confirming the check cancels it (CancelScheduledNotification).
         * @summary Remind the owner to do the CBE check later (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId 
         * @param {InvestigationReminderRequest} investigationReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setInvestigationDocumentRedriveReminder(stage: Stage, investigationId: string, attemptId: string, investigationReminderRequest: InvestigationReminderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setInvestigationDocumentRedriveReminder(stage, investigationId, attemptId, investigationReminderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Schedules an email + Slack reminder to the caller at remindAt (5 minutes to 7 days ahead) through the Notifications service. Private: each person has at most one reminder per case, only they see it (myReminder), it writes no timeline event, does not count as activity and needs no expectedVersion. A new reminder replaces (cancels) the caller\'s previous one.
         * @summary Remind me to check back on an investigation (anyone signed in)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationCaseReminderRequest} investigationCaseReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setInvestigationReminder(stage: Stage, investigationId: string, investigationCaseReminderRequest: InvestigationCaseReminderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setInvestigationReminder(stage, investigationId, investigationCaseReminderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For populations no rule can separate (e.g. safe vs unsafe orders decided from their FLARE history). `lines` holds DLQ keys, one per entry (an optional first entry `dlq_pk` is ignored). Order IDs are refused (400): they would also move items that arrived for those orders after the list was made. Keys are matched against this case\'s frozen manifest (no Athena query). With dryRun=true only the counts are returned; otherwise a child investigation is created that takes over the matched items this case still owns (more than 2,000 are moved on the worker). A list child never gains items later: reconcile, population refresh, add-items, rule widening and rule splits skip or refuse it. Refused while a deletion is pending, a merge is running or a redrive is executing/monitoring, and when every item would move.
         * @summary Split items off into a child investigation by a list of DLQ keys (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationSplitListRequest} investigationSplitListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async splitInvestigationByList(stage: Stage, investigationId: string, investigationSplitListRequest: InvestigationSplitListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationSplitListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.splitInvestigationByList(stage, investigationId, investigationSplitListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Step 1 of the document-redrive path. Re-processes the distinct transaction IDs (accounting unique id, else order id) of the items the investigation owns through the order redrive state machine: Lusca rebuilds each document from its own store with a bumped version tagged MANUAL_REDRIVE and republishes its CBEs. Requires READY_TO_REDRIVE and the DLQ redrive Bindle lock; the case is EXECUTING_REDRIVE while it runs and returns to READY_TO_REDRIVE with documentRedrive.stage AWAITING_CONFIRMATION. The DLQ items are not touched: after the owner confirms (document-redrives/{attemptId}/confirm) a DLQ redrive clears them. Use it when the stored document is correct but its accounting (CBEs) is wrong or missing.
         * @summary Launch a document redrive of the investigation\'s transactions (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startInvestigationDocumentRedrive(stage: Stage, investigationId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationRedriveAttempt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startInvestigationDocumentRedrive(stage, investigationId, investigationDocumentRedriveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Starts an Athena query over the latest hourly DLQ snapshot for the given population rule and returns a previewId to poll with GET investigations/previews/{previewId}. The rule is a list of equality predicates over allowlisted DLQ fields (eventsourcekey, error_type, error_message, error_category, gl_product_group, marketplace_id, usecase, digital_order_source, is_emp_order, destination, accounting_operation, payment_processor).
         * @summary Start an asynchronous DLQ investigation population preview
         * @param {Stage} stage environment name
         * @param {InvestigationPreviewRequest} investigationPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startInvestigationPreview(stage: Stage, investigationPreviewRequest: InvestigationPreviewRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startInvestigationPreview(stage, investigationPreviewRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Freezes the current primary assignments into an exact manifest, invokes the existing DLQ redrive state machine (Bindle lock check applies) and moves the investigation to EXECUTING_REDRIVE. Requires status READY_TO_REDRIVE.
         * @summary Launch a redrive of the investigation\'s frozen DLQ-PK manifest (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationRedriveRequest} investigationRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startInvestigationRedrive(stage: Stage, investigationId: string, investigationRedriveRequest: InvestigationRedriveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationRedriveAttempt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startInvestigationRedrive(stage, investigationId, investigationRedriveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by TrackStars (through the Lusca MCP server, as the person who ran it) once, with its DashboardReport JSON. Completes the investigation\'s current run while it is REQUESTED; otherwise records a new run for the report first, so the latest report wins. Lusca stores the report, counts each pattern\'s items in the frozen population (on the worker) and moves the run SCORING → COMPLETED (or FAILED), logging TRACKSTARS_RUN_COMPLETED.
         * @summary TrackStars writes its finished report back, knowing only the investigation id
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {SubmitInvestigationTrackStarsReportRequest} submitInvestigationTrackStarsReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitInvestigationTrackStarsReport(stage: Stage, investigationId: string, submitInvestigationTrackStarsReportRequest: SubmitInvestigationTrackStarsReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitInvestigationTrackStarsReport202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitInvestigationTrackStarsReport(stage, investigationId, submitInvestigationTrackStarsReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Transfer ownership of an investigation to another Lusca Search user (anyone may; only the new owner is notified)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationTransferRequest} investigationTransferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferInvestigation(stage: Stage, investigationId: string, investigationTransferRequest: InvestigationTransferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferInvestigation(stage, investigationId, investigationTransferRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Takes a case confirmed by mistake back to the CBE check: documentRedrive.stage CONFIRMED → AWAITING_CONFIRMATION (confirmedAt/confirmedBy cleared), so the DLQ redrive is locked again until the owner confirms. Only while the case is still READY_TO_REDRIVE (no DLQ redrive launched since).
         * @summary Undo the CBE confirmation of a document redrive (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId 
         * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unconfirmInvestigationDocumentRedrive(stage: Stage, investigationId: string, attemptId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unconfirmInvestigationDocumentRedrive(stage, investigationId, attemptId, investigationDocumentRedriveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Owner-only for status transitions, blocker and resolution; anyone may rename (title) or add or edit the conclusion and its evidence links. Requires expectedVersion; returns 409 on version mismatch. Humans cannot set EXECUTING_REDRIVE or MONITORING_REDRIVE, except to unblock a case that was blocked while MONITORING_REDRIVE (blocker.blockedFrom), which resumes monitoring. Resolving requires a conclusion summary; evidence links are recommended but not enforced. Free-form progress notes go to the comments endpoint.
         * @summary Update an investigation (title and links by anyone; description, conclusion, blocker, status, resolution by the owner; Taskei task link)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationUpdateRequest} investigationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInvestigation(stage: Stage, investigationId: string, investigationUpdateRequest: InvestigationUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Investigation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInvestigation(stage, investigationId, investigationUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Adds `rule` to the investigation\'s rules as an OR branch (a branch it already contains is dropped; nothing changes when the case already covers it) and asks for an early reconcile, so unowned items matching the wider rule move in within minutes, and future ones keep arriving at every hourly reconcile. Recorded as RULE_WIDENED with the previous and new rules.
         * @summary Widen an investigation\'s rule with another rule branch (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationWidenRuleRequest} investigationWidenRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widenInvestigationRule(stage: Stage, investigationId: string, investigationWidenRuleRequest: InvestigationWidenRuleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationWidenRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widenInvestigationRule(stage, investigationId, investigationWidenRuleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvestigationsApi - factory interface
 * @export
 */
export const InvestigationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvestigationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a comment to an investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationCommentRequest} investigationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addInvestigationComment(stage: Stage, investigationId: string, investigationCommentRequest: InvestigationCommentRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.addInvestigationComment(stage, investigationId, investigationCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks the request CANCELLED and clears `pendingDeletion`, unlocking the investigation. Lusca does not cancel the MCM; discard it in MCM.
         * @summary Cancel a pending delete-without-redrive request (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId Redrive / deletion attempt id (att-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvestigationDeletion(stage: Stage, investigationId: string, attemptId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: any): AxiosPromise<InvestigationDeletionResponse> {
            return localVarFp.cancelInvestigationDeletion(stage, investigationId, attemptId, investigationVersionedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancels the caller\'s pending reminder on the case (CancelScheduledNotification). Idempotent.
         * @summary Cancel my reminder on an investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvestigationReminder(stage: Stage, investigationId: string, options?: any): AxiosPromise<Investigation> {
            return localVarFp.cancelInvestigationReminder(stage, investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Makes the caller the owner of any active investigation, owned or not. A takeover is recorded in the timeline (called out as stale after the configured inactivity period, default 72 hours), the previous owner is notified and stays a contributor. Resolved/cancelled cases must be reopened first.
         * @summary Take ownership of an active investigation (anyone may; the previous owner is notified)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimInvestigation(stage: Stage, investigationId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.claimInvestigation(stage, investigationId, investigationVersionedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Step 2 gate of the document-redrive path. After a document redrive completes the case is back in READY_TO_REDRIVE with documentRedrive.stage AWAITING_CONFIRMATION and a DLQ redrive is refused (409 DOCUMENT_REDRIVE_UNCONFIRMED) until the owner has spot-checked the sample transactions and confirms here. Moves documentRedrive.stage to CONFIRMED; the DLQ redrive that clears the items may then be launched.
         * @summary Confirm a completed document redrive\'s CBEs were republished (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId 
         * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmInvestigationDocumentRedrive(stage: Stage, investigationId: string, attemptId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.confirmInvestigationDocumentRedrive(stage, investigationId, attemptId, investigationDocumentRedriveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Freezes the preview\'s exact DLQ-PK manifest, creates the investigation and conditionally claims primary ownership of each DLQ item. Items already owned by another active investigation are reported as conflicts and never stolen. mode=remainder creates the case for unassigned items only; mode=child creates a narrower child of parentInvestigationId that takes over its matching subset. A mode=full request whose rule is identical to an active investigation\'s is refused with 409 DUPLICATE_RULE (`current` is that investigation) before anything is written; the check reads only the active registry, so it costs the same for any population size. Should the claim nonetheless win no items (a different rule that covers the same items, or a race), the new case is closed at once as RESOLVED / DUPLICATE with duplicateOfInvestigationId set, the creator is notified, and the response carries duplicateOfInvestigationId.
         * @summary Create a DLQ investigation from a completed preview
         * @param {Stage} stage environment name
         * @param {InvestigationCreateRequest} investigationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvestigation(stage: Stage, investigationCreateRequest: InvestigationCreateRequest, options?: any): AxiosPromise<InvestigationCreateResult> {
            return localVarFp.createInvestigation(stage, investigationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a comment (author or owner only). The event stays in the timeline marked deleted.
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvestigationComment(stage: Stage, investigationId: string, eventId: string, options?: any): AxiosPromise<InvestigationEvent> {
            return localVarFp.deleteInvestigationComment(stage, investigationId, eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit a comment (author or owner only). The original text is kept in the event\'s edit history.
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} eventId 
         * @param {InvestigationCommentRequest} investigationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editInvestigationComment(stage: Stage, investigationId: string, eventId: string, investigationCommentRequest: InvestigationCommentRequest, options?: any): AxiosPromise<InvestigationEvent> {
            return localVarFp.editInvestigationComment(stage, investigationId, eventId, investigationCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Re-checks that every manifest PK is still owned by the investigation (409 MANIFEST_DRIFTED otherwise) and starts the DLQ redrive state machine with deleteWithoutRedriving=true and the MCM ID. The redriver enforces the MCM gate (In Progress, approver, title, exact literal). Moves the investigation to EXECUTING_REDRIVE. A FAILED run can be executed again after fixing the MCM.
         * @summary Execute an approved delete-without-redrive request (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId Redrive / deletion attempt id (att-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeInvestigationDeletion(stage: Stage, investigationId: string, attemptId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: any): AxiosPromise<InvestigationDeletionResponse> {
            return localVarFp.executeInvestigationDeletion(stage, investigationId, attemptId, investigationVersionedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * For stages this deployment cannot redrive itself (Investigation.redriveMode = external): uploads the file the Lusca Search Prod tool takes for the chosen kind — the DLQ redrive bulk CSV (header dlq_pk) for REDRIVE / DELETE, the Redrive Tool CSV (distinct transaction ids, no header) for DOCUMENT_REDRIVE — built from the items the investigation owns now, and returns a one-hour download link plus the Prod page to run it on.
         * @summary File to upload in Lusca Search Prod for a redrive of this investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationExternalRedriveExportRequest} investigationExternalRedriveExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvestigationExternalRedrive(stage: Stage, investigationId: string, investigationExternalRedriveExportRequest: InvestigationExternalRedriveExportRequest, options?: any): AxiosPromise<InvestigationExternalRedriveExport> {
            return localVarFp.exportInvestigationExternalRedrive(stage, investigationId, investigationExternalRedriveExportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds the preview\'s items that no other active case owns or wins (narrowest rule, then oldest case) to this investigation and refreezes its manifest as the union. The rule is unchanged. The preview must be COMPLETED, not truncated, at most 60 minutes old, and add at most 2,000 new items.
         * @summary Add a completed preview\'s unowned items to an existing investigation (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationExtendRequest} investigationExtendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendInvestigationPopulation(stage: Stage, investigationId: string, investigationExtendRequest: InvestigationExtendRequest, options?: any): AxiosPromise<InvestigationExtendResponse> {
            return localVarFp.extendInvestigationPopulation(stage, investigationId, investigationExtendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Followers get a bell notification (and email/Slack) when someone else comments, changes the status or owner, merges the case, or when a redrive or deletion finishes or needs attention. Following is recorded as a FOLLOWED / UNFOLLOWED timeline event (audit log and activity feed) but does not count as activity, does not make the caller a contributor and notifies nobody. It needs no expectedVersion. The owner is always told about their own case and is not notified twice. Idempotent.
         * @summary Follow or unfollow an investigation (anyone signed in)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationFollowRequest} investigationFollowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followInvestigation(stage: Stage, investigationId: string, investigationFollowRequest: InvestigationFollowRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.followInvestigation(stage, investigationId, investigationFollowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the investigation metadata, redrive attempts and the most recent timeline events.
         * @summary Get a DLQ investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigation(stage: Stage, investigationId: string, options?: any): AxiosPromise<InvestigationDetail> {
            return localVarFp.getInvestigation(stage, investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Build a prompt for a local agent to continue the investigation through Lusca MCP
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationAgentPrompt(stage: Stage, investigationId: string, options?: any): AxiosPromise<InvestigationAgentPrompt> {
            return localVarFp.getInvestigationAgentPrompt(stage, investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload with the presigned POST (`post.url` + `post.fields` as multipart form fields, file last) — S3 enforces the size limit and content type — or with a plain PUT to `uploadUrl`. Nothing is recorded yet: send the returned `key` in `attachments` of a comment or of the conclusion to attach it. Limits: 10 MB per file, 10 files per comment/conclusion; images (PNG, JPEG, GIF, WebP), PDF, text, CSV, JSON, ZIP, XLSX. Files are never deleted.
         * @summary Get a presigned upload for a comment or conclusion attachment (screenshot, log, export)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationAttachmentUploadRequest} investigationAttachmentUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationArtifactUploadUrl(stage: Stage, investigationId: string, investigationAttachmentUploadRequest: InvestigationAttachmentUploadRequest, options?: any): AxiosPromise<InvestigationAttachmentUpload> {
            return localVarFp.getInvestigationArtifactUploadUrl(stage, investigationId, investigationAttachmentUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a fresh presigned download URL for an attachment of this investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationArtifactUrl(stage: Stage, investigationId: string, key: string, options?: any): AxiosPromise<InvestigationAttachment> {
            return localVarFp.getInvestigationArtifactUrl(stage, investigationId, key, options).then((request) => request(axios, basePath));
        },
        /**
         * Groups the frozen manifest\'s items that this investigation does not own by their current owning active investigation. Populations larger than the check limit are sampled evenly and the counts are scaled (sampled=true).
         * @summary Which other investigations own items of this investigation\'s frozen population
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationOtherOwners(stage: Stage, investigationId: string, options?: any): AxiosPromise<InvestigationOtherOwnersResult> {
            return localVarFp.getInvestigationOtherOwners(stage, investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the preview job status. When COMPLETED it includes the matching count, representative samples, the effective rule, the snapshot timestamp and overlap analysis against active and resolved investigations.
         * @summary Poll a DLQ investigation population preview
         * @param {Stage} stage environment name
         * @param {string} previewId Preview job id returned by startInvestigationPreview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationPreview(stage: Stage, previewId: string, options?: any): AxiosPromise<InvestigationPreview> {
            return localVarFp.getInvestigationPreview(stage, previewId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the immutable activity timeline of an investigation
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationTimeline(stage: Stage, investigationId: string, limit?: number, nextToken?: string, options?: any): AxiosPromise<InvestigationTimelinePage> {
            return localVarFp.getInvestigationTimeline(stage, investigationId, limit, nextToken, options).then((request) => request(axios, basePath));
        },
        /**
         * A report TrackStars writes back to an investigation is stored per case and never becomes the stage\'s latest, so its patterns are not in listInvestigationSuggestions. This reads the latest completed run\'s report and shapes every pattern like a suggestion (root cause, recommended action, samples, when-clause, derived rule), ordered by how many of this investigation\'s items it matched (runItems). Ownership is empty: the cards are shown on the case itself. available=false when the case has no completed run.
         * @summary The patterns of the investigation\'s own TrackStars run, as full suggestion cards
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestigationTrackStarsRunPatterns(stage: Stage, investigationId: string, options?: any): AxiosPromise<InvestigationTrackStarsRunPatterns> {
            return localVarFp.getInvestigationTrackStarsRunPatterns(stage, investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Imports a TrackStars DLQ analysis report (the JSON TrackStars produces) for the stage. Pattern ids are made unique across reports (<reportId>-PAT-NNN, references rewritten); the report is archived under trackstars/<stage>/reports/<reportId>.json and then becomes trackstars/<stage>/latest.json, which drives listInvestigationSuggestions. Earlier reports stay archived so cases opened from them keep their origin pattern. Re-uploading the same report is idempotent. At most 5 MB.
         * @summary Upload a TrackStars report as the stage\'s latest
         * @param {Stage} stage environment name
         * @param {ImportTrackStarsReportRequest} importTrackStarsReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTrackStarsReport(stage: Stage, importTrackStarsReportRequest: ImportTrackStarsReportRequest, options?: any): AxiosPromise<TrackStarsReportImportResult> {
            return localVarFp.importTrackStarsReport(stage, importTrackStarsReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Records the execution (ARN or execution ID on the stage\'s DLQ redrive or order redrive state machine) as an attempt with linked=true, frozen from the items the investigation owns now, and moves the case to EXECUTING_REDRIVE; from then on it is polled, completed, verified and return-checked like a launched attempt. Requires READY_TO_REDRIVE. REDRIVE is refused while a document redrive awaits confirmation; DELETE requires a deleteWithoutRedriving execution.
         * @summary Link a redrive run in Lusca Search Prod to this investigation (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationExternalRedriveLinkRequest} investigationExternalRedriveLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkInvestigationExternalRedrive(stage: Stage, investigationId: string, investigationExternalRedriveLinkRequest: InvestigationExternalRedriveLinkRequest, options?: any): AxiosPromise<InvestigationRedriveAttempt> {
            return localVarFp.linkInvestigationExternalRedrive(stage, investigationId, investigationExternalRedriveLinkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * DLQ error categories are `.when(...)` rules in PVAccountingCDK\'s DLQ Glue job (assets/glue/dlq_dynamo_job.py). A scheduled worker task walks that file\'s history over GitFarm and records, per category, the first commit that added its rule and the CR in that commit\'s `cr:` trailer. Categories written before the rules moved into code carry migrated=true: their commit is the migration, not the original investigation. available=false until the task has run once.
         * @summary The code change (CR) that introduced each DLQ error category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listErrorCategorySources(options?: any): AxiosPromise<ErrorCategorySourcesResult> {
            return localVarFp.listErrorCategorySources(options).then((request) => request(axios, basePath));
        },
        /**
         * Timeline events caused by a person (UI or MCP) on every investigation in the stage, newest first: comments, status changes, claims and transfers, redrives, merges, splits, links. System and worker events are left out. scope=mine keeps the caller\'s cases (owned in any status, or contributed to while active) plus anything the caller did. `investigations` summarises every case the page mentions. Events recorded before the activity index existed appear only once backfilled.
         * @summary Stage-wide feed of what people did on investigations
         * @param {Stage} stage environment name
         * @param {'all' | 'mine'} [scope] 
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationActivity(stage: Stage, scope?: 'all' | 'mine', limit?: number, nextToken?: string, options?: any): AxiosPromise<InvestigationActivityPage> {
            return localVarFp.listInvestigationActivity(stage, scope, limit, nextToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Everyone permitted to unlock the Lusca Search Bindle lock (the same lock the Midway authorizer enforces), resolved through BRASS and cached for a few minutes. Reassignment to an alias outside this list is rejected with 400.
         * @summary List aliases that may own or be assigned an investigation
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationAssignees(stage: Stage, options?: any): AxiosPromise<InvestigationAssigneesResult> {
            return localVarFp.listInvestigationAssignees(stage, options).then((request) => request(axios, basePath));
        },
        /**
         * Every owner notification addressed to the signed-in user (assignment, takeover, comments, contributions, merges, redrive outcomes), newest first, regardless of stage. This is the feed behind the notification bell; the same events are also delivered by email and Slack through the Amazon Notifications service. Entries expire after 30 days.
         * @summary The caller\'s notification inbox across all stages
         * @param {boolean} [unreadOnly] 
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationInbox(unreadOnly?: boolean, limit?: number, nextToken?: string, options?: any): AxiosPromise<InvestigationInbox> {
            return localVarFp.listInvestigationInbox(unreadOnly, limit, nextToken, options).then((request) => request(axios, basePath));
        },
        /**
         * By default (scope=live) lists the items this investigation owns that were still in the DLQ at the last hourly reconcile (the count shown on the case). scope=all lists the frozen DLQ-PK manifest, every item the case was created with or later claimed, each row marked inDlq. Cases not yet reconciled have no live list and are served from the frozen manifest (scope=all in the response). Rows carry their snapshot fields and whether this investigation still holds primary ownership of each item.
         * @summary List the investigation\'s items (still in the DLQ by default, or all it was frozen with)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {number} [limit] 
         * @param {number} [offset] Row offset into the manifest for paging
         * @param {string} [q] Case-insensitive substring match over PK, queue, error type/message, use case and transaction/order ID
         * @param {string} [filter] Structured filter, JSON-encoded (same shape as the backlog\&#39;s filter): {\&quot;operation\&quot;: \&quot;and\&quot;|\&quot;or\&quot;, \&quot;tokens\&quot;: [{\&quot;propertyKey\&quot;, \&quot;operator\&quot;, \&quot;value\&quot;}]}. propertyKey is a manifest column: a rule field, dlq_pk, transaction_id or order_id (operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;:\&quot; contains, \&quot;!:\&quot; does not contain; case-insensitive; a missing value reads as \&quot;\&quot;) or dlq_timestamp / transaction_date (operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;&gt;\&quot;, \&quot;&gt;&#x3D;\&quot;, \&quot;&lt;\&quot;, \&quot;&lt;&#x3D;\&quot; on a date or timestamp prefix). A token without propertyKey is a free-text substring match over the same columns as q. Combined with q.
         * @param {'dlq_pk' | 'dlq_timestamp' | 'transaction_date' | 'eventsourcekey' | 'error_type' | 'error_message' | 'usecase' | 'transaction_id'} [sort] Manifest column to sort by (default dlq_timestamp)
         * @param {boolean} [desc] Sort descending (default true)
         * @param {'live' | 'all'} [scope] live (default) &#x3D; owned items still in the DLQ; all &#x3D; the whole frozen manifest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationItems(stage: Stage, investigationId: string, limit?: number, offset?: number, q?: string, filter?: string, sort?: 'dlq_pk' | 'dlq_timestamp' | 'transaction_date' | 'eventsourcekey' | 'error_type' | 'error_message' | 'usecase' | 'transaction_id', desc?: boolean, scope?: 'live' | 'all', options?: any): AxiosPromise<InvestigationItemsResult> {
            return localVarFp.listInvestigationItems(stage, investigationId, limit, offset, q, filter, sort, desc, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List redrive attempts of an investigation and refresh their status
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationRedrives(stage: Stage, investigationId: string, options?: any): AxiosPromise<InvestigationRedriveList> {
            return localVarFp.listInvestigationRedrives(stage, investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redriven messages that returned to the DLQ, newest first
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationReturnedItems(stage: Stage, investigationId: string, limit?: number, nextToken?: string, options?: any): AxiosPromise<InvestigationReturnedItemsPage> {
            return localVarFp.listInvestigationReturnedItems(stage, investigationId, limit, nextToken, options).then((request) => request(axios, basePath));
        },
        /**
         * TrackStars (TRACK\'s multi-agent DLQ analysis) publishes each run as a report of root-caused failure patterns. This returns every pattern of the latest report imported for the stage as a population suggestion: the eq rule derived from the pattern\'s PySpark when-clause (fields it pins exactly plus single-valued scope), any error-message substrings the rule cannot express until a preview reveals the matching templated value(s), the root cause, evidence, recommended action, sample order IDs (display only), how the pattern relates to active investigations (unowned, partially covered, or owned — by rule containment or because a case records the pattern as its origin) and a ready-to-use starter (title, first comment, evidence links) for createInvestigation. available=false when no report has been imported for the stage.
         * @summary Investigation suggestions derived from the latest TrackStars DLQ analysis report
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigationSuggestions(stage: Stage, options?: any): AxiosPromise<InvestigationSuggestionsResult> {
            return localVarFp.listInvestigationSuggestions(stage, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists investigations for a stage using indexed queries. view selects a standard work-queue view (mine, active, blocked, ready_to_redrive, monitoring, resolved, withdrawn); status/owner/unclaimed/ redriven/returned narrow the results. Paginated with nextToken.
         * @summary List DLQ investigations (work queue)
         * @param {Stage} stage environment name
         * @param {'mine' | 'active' | 'blocked' | 'ready_to_redrive' | 'monitoring' | 'resolved' | 'withdrawn' | 'all'} [view] 
         * @param {InvestigationStatus} [status] 
         * @param {string} [owner] Owner alias filter
         * @param {boolean} [unclaimed] 
         * @param {boolean} [redriven] Only investigations with at least one redrive attempt
         * @param {boolean} [returned] Only investigations where redriven messages returned to the DLQ
         * @param {number} [limit] 
         * @param {string} [nextToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvestigations(stage: Stage, view?: 'mine' | 'active' | 'blocked' | 'ready_to_redrive' | 'monitoring' | 'resolved' | 'withdrawn' | 'all', status?: InvestigationStatus, owner?: string, unclaimed?: boolean, redriven?: boolean, returned?: boolean, limit?: number, nextToken?: string, options?: any): AxiosPromise<InvestigationListResult> {
            return localVarFp.listInvestigations(stage, view, status, owner, unclaimed, redriven, returned, limit, nextToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns one page of the groups of DLQ items (by queue, error type, templated error message and category) that are not assigned to any investigation, computed by the hourly reconciliation. Filtering (filter, q, uncategorizedOnly), sorting and paging happen server-side over the full set of reconciled groups; totalCount is the number of rows matching the filter and totalGroups the number of groups reconciled. Default order is highest impact first. Every response also carries the distinct queue, error type and category values (filterOptions) so a client can offer them as filter suggestions without loading every group. With groupByCategory=true the rows are the category view: every group with an error category collapses into one row per category (sizes summed, members listing the (queue, error type) split), while uncategorized groups stay one row each. Identity filter tokens (queue, errorType, errorMessage, category, free text, q) narrow the constituent groups before collapsing, so a category row shows only its matching share; size tokens (items, impactUsd, ambiguous, growth, lastSeen) apply to the collapsed row. totalRows is what the unfiltered view holds in either mode.
         * @summary List uninvestigated DLQ populations from the latest reconciliation
         * @param {Stage} stage environment name
         * @param {boolean} [uncategorizedOnly] 
         * @param {boolean} [groupByCategory] Collapse categorized groups into one row per error category (see description)
         * @param {number} [limit] 
         * @param {number} [offset] Group offset into the filtered, sorted list for paging
         * @param {string} [q] Case-insensitive substring match over queue, error type, error message and category
         * @param {string} [filter] Structured filter, JSON-encoded: {\&quot;operation\&quot;: \&quot;and\&quot;|\&quot;or\&quot;, \&quot;tokens\&quot;: [{\&quot;propertyKey\&quot;, \&quot;operator\&quot;, \&quot;value\&quot;}]}. propertyKey is one of queue, errorType, errorMessage, category (string operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;:\&quot; contains, \&quot;!:\&quot; does not contain), items, impactUsd, ambiguous, growth (the group\&#39;s growth7d; a group seen in a single snapshot never matches) (numeric operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;&gt;\&quot;, \&quot;&gt;&#x3D;\&quot;, \&quot;&lt;\&quot;, \&quot;&lt;&#x3D;\&quot;) or lastSeen (the group\&#39;s latestDlqTimestamp compared with a \&quot;YYYY-MM-DD\&quot; date or \&quot;YYYY-MM-DD HH:MM:SS\&quot; timestamp prefix, same operators as numeric; a group without a timestamp never matches). A token without propertyKey is a free-text substring match over the same fields as q. Combined with q and uncategorizedOnly (all must match).
         * @param {string} [countFilters] Optional JSON array of up to 10 structured filters (same shape as filter). For each, the response\&#39;s filterCounts carries the number of reconciled groups it matches, evaluated over the whole reconciliation independently of filter, q and uncategorizedOnly — one round trip for a navigation\&#39;s slice badges.
         * @param {'impactUsd' | 'count' | 'ambiguousCount' | 'eventsourcekey' | 'errorType' | 'errorMessage' | 'errorCategory' | 'latestDlqTimestamp' | 'growth7d'} [sort] Group field to sort by (default impactUsd; groups without an impact value rank last). &#x60;ambiguousCount&#x60; is deprecated (always 0) and kept for compatibility.
         * @param {boolean} [desc] Sort descending (default true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUninvestigatedGroups(stage: Stage, uncategorizedOnly?: boolean, groupByCategory?: boolean, limit?: number, offset?: number, q?: string, filter?: string, countFilters?: string, sort?: 'impactUsd' | 'count' | 'ambiguousCount' | 'eventsourcekey' | 'errorType' | 'errorMessage' | 'errorCategory' | 'latestDlqTimestamp' | 'growth7d', desc?: boolean, options?: any): AxiosPromise<UninvestigatedGroupsResult> {
            return localVarFp.listUninvestigatedGroups(stage, uncategorizedOnly, groupByCategory, limit, offset, q, filter, countFilters, sort, desc, options).then((request) => request(axios, basePath));
        },
        /**
         * Passive: no timeline event, no activity timestamp change. Provide notificationIds for specific entries, investigationId for every entry of one case, or all=true for everything unread.
         * @summary Mark the caller\'s inbox notifications as read
         * @param {InvestigationInboxReadRequest} investigationInboxReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvestigationInboxRead(investigationInboxReadRequest: InvestigationInboxReadRequest, options?: any): AxiosPromise<InvestigationInboxReadResult> {
            return localVarFp.markInvestigationInboxRead(investigationInboxReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Anyone signed in may merge. The survivor keeps its id, owner, status and comments; its rule gains every source rule as an additional OR branch and its population becomes the union of all frozen manifests. Each source is closed as RESOLVED with reason MERGED (it cannot be reopened), its owner and contributors become contributors of the survivor, its children are re-parented to the survivor. Item ownership is re-pointed inline for small populations and by the worker otherwise (`mergePending` set until done). Refused (409) when any participant is resolved, executing or monitoring a redrive, awaiting a deletion MCM, already merging, or in another stage. There is no unmerge — split the survivor instead.
         * @summary Merge other active investigations into this one (the survivor)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationMergeRequest} investigationMergeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeInvestigations(stage: Stage, investigationId: string, investigationMergeRequest: InvestigationMergeRequest, options?: any): AxiosPromise<InvestigationMergeResult> {
            return localVarFp.mergeInvestigations(stage, investigationId, investigationMergeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a preview for the investigation\'s rule; when it completes the worker assigns unassigned matching items to the investigation and refreshes the frozen population snapshot. Owner only. While the refresh runs the investigation carries `pendingRefresh`; a second request in that window is rejected with 409 `REFRESH_IN_PROGRESS` (the running preview is returned as `preview`) so the expensive Athena scan is never started twice.
         * @summary Re-evaluate the investigation\'s live population rule against the latest DLQ snapshot (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationVersionedRequest} investigationVersionedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshInvestigationPopulation(stage: Stage, investigationId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: any): AxiosPromise<InvestigationPreview> {
            return localVarFp.refreshInvestigationPopulation(stage, investigationId, investigationVersionedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The caller must be the current owner. The investigation is left without an owner (it appears in the \"Needs an owner\" list) and the caller stays on it as a contributor. Resolved investigations cannot be released; reopen first.
         * @summary Give up ownership of an investigation without naming a successor (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationReleaseRequest} investigationReleaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseInvestigation(stage: Stage, investigationId: string, investigationReleaseRequest: InvestigationReleaseRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.releaseInvestigation(stage, investigationId, investigationReleaseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * A redriven message that returns with an error the case\'s rule no longer matches failed for a different reason. The case keeps it until the owner releases it: this drops the case\'s ownership of every such return it still holds and asks for an early reconcile, which hands each one to the active case whose rule matches it or leaves it in the backlog. Returns still failing the same way are untouched. At most 10,000 per call (moreToRelease).
         * @summary Release returned messages that came back with a new error (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationReleaseReturnedRequest} investigationReleaseReturnedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseInvestigationReturnedItems(stage: Stage, investigationId: string, investigationReleaseReturnedRequest: InvestigationReleaseReturnedRequest, options?: any): AxiosPromise<InvestigationReleaseReturnedResponse> {
            return localVarFp.releaseInvestigationReturnedItems(stage, investigationId, investigationReleaseReturnedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Freezes the current primary assignments into an exact manifest, uploads it as the bulk-redrive CSV to the stage\'s DLQ redrive bucket and creates a Draft MCM whose description carries the S3 URI + ETag literal the redriver validates, plus the justification and the investigation context. The investigation stays READY_TO_REDRIVE with `pendingDeletion` set, which locks population refresh, redrives, status changes and child splits until the request is executed or cancelled (409 DELETION_PENDING). Requires status READY_TO_REDRIVE and the DLQ redrive Bindle lock.
         * @summary Request an MCM-gated delete-without-redrive of the investigation\'s frozen manifest (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationDeletionRequest} investigationDeletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestInvestigationDeletion(stage: Stage, investigationId: string, investigationDeletionRequest: InvestigationDeletionRequest, options?: any): AxiosPromise<InvestigationDeletionResponse> {
            return localVarFp.requestInvestigationDeletion(stage, investigationId, investigationDeletionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Given a stage and DLQ primary key returns whether the item is owned by an active investigation, matches a resolved (historical) investigation, is ambiguous, or is uninvestigated, plus a suggested population rule built from the seed fields.
         * @summary Resolve a DLQ dashboard row against the live investigation registry
         * @param {Stage} stage environment name
         * @param {InvestigationRowRequest} investigationRowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveInvestigationRow(stage: Stage, investigationRowRequest: InvestigationRowRequest, options?: any): AxiosPromise<InvestigationRowResolution> {
            return localVarFp.resolveInvestigationRow(stage, investigationRowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * While a document redrive awaits the owner\'s CBE check (documentRedrive.stage AWAITING_CONFIRMATION), schedules an email + Slack reminder to the owner at remindAt (5 minutes to 7 days ahead) through the Notifications service and records it as documentRedrive.reminder. A new reminder replaces the previous one; confirming the check cancels it (CancelScheduledNotification).
         * @summary Remind the owner to do the CBE check later (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId 
         * @param {InvestigationReminderRequest} investigationReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInvestigationDocumentRedriveReminder(stage: Stage, investigationId: string, attemptId: string, investigationReminderRequest: InvestigationReminderRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.setInvestigationDocumentRedriveReminder(stage, investigationId, attemptId, investigationReminderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Schedules an email + Slack reminder to the caller at remindAt (5 minutes to 7 days ahead) through the Notifications service. Private: each person has at most one reminder per case, only they see it (myReminder), it writes no timeline event, does not count as activity and needs no expectedVersion. A new reminder replaces (cancels) the caller\'s previous one.
         * @summary Remind me to check back on an investigation (anyone signed in)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationCaseReminderRequest} investigationCaseReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInvestigationReminder(stage: Stage, investigationId: string, investigationCaseReminderRequest: InvestigationCaseReminderRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.setInvestigationReminder(stage, investigationId, investigationCaseReminderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * For populations no rule can separate (e.g. safe vs unsafe orders decided from their FLARE history). `lines` holds DLQ keys, one per entry (an optional first entry `dlq_pk` is ignored). Order IDs are refused (400): they would also move items that arrived for those orders after the list was made. Keys are matched against this case\'s frozen manifest (no Athena query). With dryRun=true only the counts are returned; otherwise a child investigation is created that takes over the matched items this case still owns (more than 2,000 are moved on the worker). A list child never gains items later: reconcile, population refresh, add-items, rule widening and rule splits skip or refuse it. Refused while a deletion is pending, a merge is running or a redrive is executing/monitoring, and when every item would move.
         * @summary Split items off into a child investigation by a list of DLQ keys (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationSplitListRequest} investigationSplitListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitInvestigationByList(stage: Stage, investigationId: string, investigationSplitListRequest: InvestigationSplitListRequest, options?: any): AxiosPromise<InvestigationSplitListResult> {
            return localVarFp.splitInvestigationByList(stage, investigationId, investigationSplitListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Step 1 of the document-redrive path. Re-processes the distinct transaction IDs (accounting unique id, else order id) of the items the investigation owns through the order redrive state machine: Lusca rebuilds each document from its own store with a bumped version tagged MANUAL_REDRIVE and republishes its CBEs. Requires READY_TO_REDRIVE and the DLQ redrive Bindle lock; the case is EXECUTING_REDRIVE while it runs and returns to READY_TO_REDRIVE with documentRedrive.stage AWAITING_CONFIRMATION. The DLQ items are not touched: after the owner confirms (document-redrives/{attemptId}/confirm) a DLQ redrive clears them. Use it when the stored document is correct but its accounting (CBEs) is wrong or missing.
         * @summary Launch a document redrive of the investigation\'s transactions (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startInvestigationDocumentRedrive(stage: Stage, investigationId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options?: any): AxiosPromise<InvestigationRedriveAttempt> {
            return localVarFp.startInvestigationDocumentRedrive(stage, investigationId, investigationDocumentRedriveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts an Athena query over the latest hourly DLQ snapshot for the given population rule and returns a previewId to poll with GET investigations/previews/{previewId}. The rule is a list of equality predicates over allowlisted DLQ fields (eventsourcekey, error_type, error_message, error_category, gl_product_group, marketplace_id, usecase, digital_order_source, is_emp_order, destination, accounting_operation, payment_processor).
         * @summary Start an asynchronous DLQ investigation population preview
         * @param {Stage} stage environment name
         * @param {InvestigationPreviewRequest} investigationPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startInvestigationPreview(stage: Stage, investigationPreviewRequest: InvestigationPreviewRequest, options?: any): AxiosPromise<InvestigationPreview> {
            return localVarFp.startInvestigationPreview(stage, investigationPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Freezes the current primary assignments into an exact manifest, invokes the existing DLQ redrive state machine (Bindle lock check applies) and moves the investigation to EXECUTING_REDRIVE. Requires status READY_TO_REDRIVE.
         * @summary Launch a redrive of the investigation\'s frozen DLQ-PK manifest (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationRedriveRequest} investigationRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startInvestigationRedrive(stage: Stage, investigationId: string, investigationRedriveRequest: InvestigationRedriveRequest, options?: any): AxiosPromise<InvestigationRedriveAttempt> {
            return localVarFp.startInvestigationRedrive(stage, investigationId, investigationRedriveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by TrackStars (through the Lusca MCP server, as the person who ran it) once, with its DashboardReport JSON. Completes the investigation\'s current run while it is REQUESTED; otherwise records a new run for the report first, so the latest report wins. Lusca stores the report, counts each pattern\'s items in the frozen population (on the worker) and moves the run SCORING → COMPLETED (or FAILED), logging TRACKSTARS_RUN_COMPLETED.
         * @summary TrackStars writes its finished report back, knowing only the investigation id
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {SubmitInvestigationTrackStarsReportRequest} submitInvestigationTrackStarsReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitInvestigationTrackStarsReport(stage: Stage, investigationId: string, submitInvestigationTrackStarsReportRequest: SubmitInvestigationTrackStarsReportRequest, options?: any): AxiosPromise<SubmitInvestigationTrackStarsReport202Response> {
            return localVarFp.submitInvestigationTrackStarsReport(stage, investigationId, submitInvestigationTrackStarsReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Transfer ownership of an investigation to another Lusca Search user (anyone may; only the new owner is notified)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationTransferRequest} investigationTransferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferInvestigation(stage: Stage, investigationId: string, investigationTransferRequest: InvestigationTransferRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.transferInvestigation(stage, investigationId, investigationTransferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes a case confirmed by mistake back to the CBE check: documentRedrive.stage CONFIRMED → AWAITING_CONFIRMATION (confirmedAt/confirmedBy cleared), so the DLQ redrive is locked again until the owner confirms. Only while the case is still READY_TO_REDRIVE (no DLQ redrive launched since).
         * @summary Undo the CBE confirmation of a document redrive (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {string} attemptId 
         * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unconfirmInvestigationDocumentRedrive(stage: Stage, investigationId: string, attemptId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.unconfirmInvestigationDocumentRedrive(stage, investigationId, attemptId, investigationDocumentRedriveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Owner-only for status transitions, blocker and resolution; anyone may rename (title) or add or edit the conclusion and its evidence links. Requires expectedVersion; returns 409 on version mismatch. Humans cannot set EXECUTING_REDRIVE or MONITORING_REDRIVE, except to unblock a case that was blocked while MONITORING_REDRIVE (blocker.blockedFrom), which resumes monitoring. Resolving requires a conclusion summary; evidence links are recommended but not enforced. Free-form progress notes go to the comments endpoint.
         * @summary Update an investigation (title and links by anyone; description, conclusion, blocker, status, resolution by the owner; Taskei task link)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationUpdateRequest} investigationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvestigation(stage: Stage, investigationId: string, investigationUpdateRequest: InvestigationUpdateRequest, options?: any): AxiosPromise<Investigation> {
            return localVarFp.updateInvestigation(stage, investigationId, investigationUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds `rule` to the investigation\'s rules as an OR branch (a branch it already contains is dropped; nothing changes when the case already covers it) and asks for an early reconcile, so unowned items matching the wider rule move in within minutes, and future ones keep arriving at every hourly reconcile. Recorded as RULE_WIDENED with the previous and new rules.
         * @summary Widen an investigation\'s rule with another rule branch (owner only)
         * @param {Stage} stage environment name
         * @param {string} investigationId Investigation id (inv-...)
         * @param {InvestigationWidenRuleRequest} investigationWidenRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widenInvestigationRule(stage: Stage, investigationId: string, investigationWidenRuleRequest: InvestigationWidenRuleRequest, options?: any): AxiosPromise<InvestigationWidenRuleResponse> {
            return localVarFp.widenInvestigationRule(stage, investigationId, investigationWidenRuleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvestigationsApi - object-oriented interface
 * @export
 * @class InvestigationsApi
 * @extends {BaseAPI}
 */
export class InvestigationsApi extends BaseAPI {
    /**
     * 
     * @summary Add a comment to an investigation
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationCommentRequest} investigationCommentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public addInvestigationComment(stage: Stage, investigationId: string, investigationCommentRequest: InvestigationCommentRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).addInvestigationComment(stage, investigationId, investigationCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks the request CANCELLED and clears `pendingDeletion`, unlocking the investigation. Lusca does not cancel the MCM; discard it in MCM.
     * @summary Cancel a pending delete-without-redrive request (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {string} attemptId Redrive / deletion attempt id (att-...)
     * @param {InvestigationVersionedRequest} investigationVersionedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public cancelInvestigationDeletion(stage: Stage, investigationId: string, attemptId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).cancelInvestigationDeletion(stage, investigationId, attemptId, investigationVersionedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancels the caller\'s pending reminder on the case (CancelScheduledNotification). Idempotent.
     * @summary Cancel my reminder on an investigation
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public cancelInvestigationReminder(stage: Stage, investigationId: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).cancelInvestigationReminder(stage, investigationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Makes the caller the owner of any active investigation, owned or not. A takeover is recorded in the timeline (called out as stale after the configured inactivity period, default 72 hours), the previous owner is notified and stays a contributor. Resolved/cancelled cases must be reopened first.
     * @summary Take ownership of an active investigation (anyone may; the previous owner is notified)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationVersionedRequest} investigationVersionedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public claimInvestigation(stage: Stage, investigationId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).claimInvestigation(stage, investigationId, investigationVersionedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Step 2 gate of the document-redrive path. After a document redrive completes the case is back in READY_TO_REDRIVE with documentRedrive.stage AWAITING_CONFIRMATION and a DLQ redrive is refused (409 DOCUMENT_REDRIVE_UNCONFIRMED) until the owner has spot-checked the sample transactions and confirms here. Moves documentRedrive.stage to CONFIRMED; the DLQ redrive that clears the items may then be launched.
     * @summary Confirm a completed document redrive\'s CBEs were republished (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {string} attemptId 
     * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public confirmInvestigationDocumentRedrive(stage: Stage, investigationId: string, attemptId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).confirmInvestigationDocumentRedrive(stage, investigationId, attemptId, investigationDocumentRedriveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Freezes the preview\'s exact DLQ-PK manifest, creates the investigation and conditionally claims primary ownership of each DLQ item. Items already owned by another active investigation are reported as conflicts and never stolen. mode=remainder creates the case for unassigned items only; mode=child creates a narrower child of parentInvestigationId that takes over its matching subset. A mode=full request whose rule is identical to an active investigation\'s is refused with 409 DUPLICATE_RULE (`current` is that investigation) before anything is written; the check reads only the active registry, so it costs the same for any population size. Should the claim nonetheless win no items (a different rule that covers the same items, or a race), the new case is closed at once as RESOLVED / DUPLICATE with duplicateOfInvestigationId set, the creator is notified, and the response carries duplicateOfInvestigationId.
     * @summary Create a DLQ investigation from a completed preview
     * @param {Stage} stage environment name
     * @param {InvestigationCreateRequest} investigationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public createInvestigation(stage: Stage, investigationCreateRequest: InvestigationCreateRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).createInvestigation(stage, investigationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a comment (author or owner only). The event stays in the timeline marked deleted.
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public deleteInvestigationComment(stage: Stage, investigationId: string, eventId: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).deleteInvestigationComment(stage, investigationId, eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit a comment (author or owner only). The original text is kept in the event\'s edit history.
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {string} eventId 
     * @param {InvestigationCommentRequest} investigationCommentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public editInvestigationComment(stage: Stage, investigationId: string, eventId: string, investigationCommentRequest: InvestigationCommentRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).editInvestigationComment(stage, investigationId, eventId, investigationCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Re-checks that every manifest PK is still owned by the investigation (409 MANIFEST_DRIFTED otherwise) and starts the DLQ redrive state machine with deleteWithoutRedriving=true and the MCM ID. The redriver enforces the MCM gate (In Progress, approver, title, exact literal). Moves the investigation to EXECUTING_REDRIVE. A FAILED run can be executed again after fixing the MCM.
     * @summary Execute an approved delete-without-redrive request (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {string} attemptId Redrive / deletion attempt id (att-...)
     * @param {InvestigationVersionedRequest} investigationVersionedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public executeInvestigationDeletion(stage: Stage, investigationId: string, attemptId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).executeInvestigationDeletion(stage, investigationId, attemptId, investigationVersionedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For stages this deployment cannot redrive itself (Investigation.redriveMode = external): uploads the file the Lusca Search Prod tool takes for the chosen kind — the DLQ redrive bulk CSV (header dlq_pk) for REDRIVE / DELETE, the Redrive Tool CSV (distinct transaction ids, no header) for DOCUMENT_REDRIVE — built from the items the investigation owns now, and returns a one-hour download link plus the Prod page to run it on.
     * @summary File to upload in Lusca Search Prod for a redrive of this investigation
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationExternalRedriveExportRequest} investigationExternalRedriveExportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public exportInvestigationExternalRedrive(stage: Stage, investigationId: string, investigationExternalRedriveExportRequest: InvestigationExternalRedriveExportRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).exportInvestigationExternalRedrive(stage, investigationId, investigationExternalRedriveExportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds the preview\'s items that no other active case owns or wins (narrowest rule, then oldest case) to this investigation and refreezes its manifest as the union. The rule is unchanged. The preview must be COMPLETED, not truncated, at most 60 minutes old, and add at most 2,000 new items.
     * @summary Add a completed preview\'s unowned items to an existing investigation (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationExtendRequest} investigationExtendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public extendInvestigationPopulation(stage: Stage, investigationId: string, investigationExtendRequest: InvestigationExtendRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).extendInvestigationPopulation(stage, investigationId, investigationExtendRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Followers get a bell notification (and email/Slack) when someone else comments, changes the status or owner, merges the case, or when a redrive or deletion finishes or needs attention. Following is recorded as a FOLLOWED / UNFOLLOWED timeline event (audit log and activity feed) but does not count as activity, does not make the caller a contributor and notifies nobody. It needs no expectedVersion. The owner is always told about their own case and is not notified twice. Idempotent.
     * @summary Follow or unfollow an investigation (anyone signed in)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationFollowRequest} investigationFollowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public followInvestigation(stage: Stage, investigationId: string, investigationFollowRequest: InvestigationFollowRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).followInvestigation(stage, investigationId, investigationFollowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the investigation metadata, redrive attempts and the most recent timeline events.
     * @summary Get a DLQ investigation
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public getInvestigation(stage: Stage, investigationId: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).getInvestigation(stage, investigationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Build a prompt for a local agent to continue the investigation through Lusca MCP
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public getInvestigationAgentPrompt(stage: Stage, investigationId: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).getInvestigationAgentPrompt(stage, investigationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload with the presigned POST (`post.url` + `post.fields` as multipart form fields, file last) — S3 enforces the size limit and content type — or with a plain PUT to `uploadUrl`. Nothing is recorded yet: send the returned `key` in `attachments` of a comment or of the conclusion to attach it. Limits: 10 MB per file, 10 files per comment/conclusion; images (PNG, JPEG, GIF, WebP), PDF, text, CSV, JSON, ZIP, XLSX. Files are never deleted.
     * @summary Get a presigned upload for a comment or conclusion attachment (screenshot, log, export)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationAttachmentUploadRequest} investigationAttachmentUploadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public getInvestigationArtifactUploadUrl(stage: Stage, investigationId: string, investigationAttachmentUploadRequest: InvestigationAttachmentUploadRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).getInvestigationArtifactUploadUrl(stage, investigationId, investigationAttachmentUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a fresh presigned download URL for an attachment of this investigation
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public getInvestigationArtifactUrl(stage: Stage, investigationId: string, key: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).getInvestigationArtifactUrl(stage, investigationId, key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Groups the frozen manifest\'s items that this investigation does not own by their current owning active investigation. Populations larger than the check limit are sampled evenly and the counts are scaled (sampled=true).
     * @summary Which other investigations own items of this investigation\'s frozen population
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public getInvestigationOtherOwners(stage: Stage, investigationId: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).getInvestigationOtherOwners(stage, investigationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the preview job status. When COMPLETED it includes the matching count, representative samples, the effective rule, the snapshot timestamp and overlap analysis against active and resolved investigations.
     * @summary Poll a DLQ investigation population preview
     * @param {Stage} stage environment name
     * @param {string} previewId Preview job id returned by startInvestigationPreview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public getInvestigationPreview(stage: Stage, previewId: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).getInvestigationPreview(stage, previewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the immutable activity timeline of an investigation
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {number} [limit] 
     * @param {string} [nextToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public getInvestigationTimeline(stage: Stage, investigationId: string, limit?: number, nextToken?: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).getInvestigationTimeline(stage, investigationId, limit, nextToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A report TrackStars writes back to an investigation is stored per case and never becomes the stage\'s latest, so its patterns are not in listInvestigationSuggestions. This reads the latest completed run\'s report and shapes every pattern like a suggestion (root cause, recommended action, samples, when-clause, derived rule), ordered by how many of this investigation\'s items it matched (runItems). Ownership is empty: the cards are shown on the case itself. available=false when the case has no completed run.
     * @summary The patterns of the investigation\'s own TrackStars run, as full suggestion cards
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public getInvestigationTrackStarsRunPatterns(stage: Stage, investigationId: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).getInvestigationTrackStarsRunPatterns(stage, investigationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Imports a TrackStars DLQ analysis report (the JSON TrackStars produces) for the stage. Pattern ids are made unique across reports (<reportId>-PAT-NNN, references rewritten); the report is archived under trackstars/<stage>/reports/<reportId>.json and then becomes trackstars/<stage>/latest.json, which drives listInvestigationSuggestions. Earlier reports stay archived so cases opened from them keep their origin pattern. Re-uploading the same report is idempotent. At most 5 MB.
     * @summary Upload a TrackStars report as the stage\'s latest
     * @param {Stage} stage environment name
     * @param {ImportTrackStarsReportRequest} importTrackStarsReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public importTrackStarsReport(stage: Stage, importTrackStarsReportRequest: ImportTrackStarsReportRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).importTrackStarsReport(stage, importTrackStarsReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Records the execution (ARN or execution ID on the stage\'s DLQ redrive or order redrive state machine) as an attempt with linked=true, frozen from the items the investigation owns now, and moves the case to EXECUTING_REDRIVE; from then on it is polled, completed, verified and return-checked like a launched attempt. Requires READY_TO_REDRIVE. REDRIVE is refused while a document redrive awaits confirmation; DELETE requires a deleteWithoutRedriving execution.
     * @summary Link a redrive run in Lusca Search Prod to this investigation (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationExternalRedriveLinkRequest} investigationExternalRedriveLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public linkInvestigationExternalRedrive(stage: Stage, investigationId: string, investigationExternalRedriveLinkRequest: InvestigationExternalRedriveLinkRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).linkInvestigationExternalRedrive(stage, investigationId, investigationExternalRedriveLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DLQ error categories are `.when(...)` rules in PVAccountingCDK\'s DLQ Glue job (assets/glue/dlq_dynamo_job.py). A scheduled worker task walks that file\'s history over GitFarm and records, per category, the first commit that added its rule and the CR in that commit\'s `cr:` trailer. Categories written before the rules moved into code carry migrated=true: their commit is the migration, not the original investigation. available=false until the task has run once.
     * @summary The code change (CR) that introduced each DLQ error category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listErrorCategorySources(options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listErrorCategorySources(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Timeline events caused by a person (UI or MCP) on every investigation in the stage, newest first: comments, status changes, claims and transfers, redrives, merges, splits, links. System and worker events are left out. scope=mine keeps the caller\'s cases (owned in any status, or contributed to while active) plus anything the caller did. `investigations` summarises every case the page mentions. Events recorded before the activity index existed appear only once backfilled.
     * @summary Stage-wide feed of what people did on investigations
     * @param {Stage} stage environment name
     * @param {'all' | 'mine'} [scope] 
     * @param {number} [limit] 
     * @param {string} [nextToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listInvestigationActivity(stage: Stage, scope?: 'all' | 'mine', limit?: number, nextToken?: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listInvestigationActivity(stage, scope, limit, nextToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Everyone permitted to unlock the Lusca Search Bindle lock (the same lock the Midway authorizer enforces), resolved through BRASS and cached for a few minutes. Reassignment to an alias outside this list is rejected with 400.
     * @summary List aliases that may own or be assigned an investigation
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listInvestigationAssignees(stage: Stage, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listInvestigationAssignees(stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every owner notification addressed to the signed-in user (assignment, takeover, comments, contributions, merges, redrive outcomes), newest first, regardless of stage. This is the feed behind the notification bell; the same events are also delivered by email and Slack through the Amazon Notifications service. Entries expire after 30 days.
     * @summary The caller\'s notification inbox across all stages
     * @param {boolean} [unreadOnly] 
     * @param {number} [limit] 
     * @param {string} [nextToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listInvestigationInbox(unreadOnly?: boolean, limit?: number, nextToken?: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listInvestigationInbox(unreadOnly, limit, nextToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * By default (scope=live) lists the items this investigation owns that were still in the DLQ at the last hourly reconcile (the count shown on the case). scope=all lists the frozen DLQ-PK manifest, every item the case was created with or later claimed, each row marked inDlq. Cases not yet reconciled have no live list and are served from the frozen manifest (scope=all in the response). Rows carry their snapshot fields and whether this investigation still holds primary ownership of each item.
     * @summary List the investigation\'s items (still in the DLQ by default, or all it was frozen with)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {number} [limit] 
     * @param {number} [offset] Row offset into the manifest for paging
     * @param {string} [q] Case-insensitive substring match over PK, queue, error type/message, use case and transaction/order ID
     * @param {string} [filter] Structured filter, JSON-encoded (same shape as the backlog\&#39;s filter): {\&quot;operation\&quot;: \&quot;and\&quot;|\&quot;or\&quot;, \&quot;tokens\&quot;: [{\&quot;propertyKey\&quot;, \&quot;operator\&quot;, \&quot;value\&quot;}]}. propertyKey is a manifest column: a rule field, dlq_pk, transaction_id or order_id (operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;:\&quot; contains, \&quot;!:\&quot; does not contain; case-insensitive; a missing value reads as \&quot;\&quot;) or dlq_timestamp / transaction_date (operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;&gt;\&quot;, \&quot;&gt;&#x3D;\&quot;, \&quot;&lt;\&quot;, \&quot;&lt;&#x3D;\&quot; on a date or timestamp prefix). A token without propertyKey is a free-text substring match over the same columns as q. Combined with q.
     * @param {'dlq_pk' | 'dlq_timestamp' | 'transaction_date' | 'eventsourcekey' | 'error_type' | 'error_message' | 'usecase' | 'transaction_id'} [sort] Manifest column to sort by (default dlq_timestamp)
     * @param {boolean} [desc] Sort descending (default true)
     * @param {'live' | 'all'} [scope] live (default) &#x3D; owned items still in the DLQ; all &#x3D; the whole frozen manifest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listInvestigationItems(stage: Stage, investigationId: string, limit?: number, offset?: number, q?: string, filter?: string, sort?: 'dlq_pk' | 'dlq_timestamp' | 'transaction_date' | 'eventsourcekey' | 'error_type' | 'error_message' | 'usecase' | 'transaction_id', desc?: boolean, scope?: 'live' | 'all', options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listInvestigationItems(stage, investigationId, limit, offset, q, filter, sort, desc, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List redrive attempts of an investigation and refresh their status
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listInvestigationRedrives(stage: Stage, investigationId: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listInvestigationRedrives(stage, investigationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redriven messages that returned to the DLQ, newest first
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {number} [limit] 
     * @param {string} [nextToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listInvestigationReturnedItems(stage: Stage, investigationId: string, limit?: number, nextToken?: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listInvestigationReturnedItems(stage, investigationId, limit, nextToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * TrackStars (TRACK\'s multi-agent DLQ analysis) publishes each run as a report of root-caused failure patterns. This returns every pattern of the latest report imported for the stage as a population suggestion: the eq rule derived from the pattern\'s PySpark when-clause (fields it pins exactly plus single-valued scope), any error-message substrings the rule cannot express until a preview reveals the matching templated value(s), the root cause, evidence, recommended action, sample order IDs (display only), how the pattern relates to active investigations (unowned, partially covered, or owned — by rule containment or because a case records the pattern as its origin) and a ready-to-use starter (title, first comment, evidence links) for createInvestigation. available=false when no report has been imported for the stage.
     * @summary Investigation suggestions derived from the latest TrackStars DLQ analysis report
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listInvestigationSuggestions(stage: Stage, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listInvestigationSuggestions(stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists investigations for a stage using indexed queries. view selects a standard work-queue view (mine, active, blocked, ready_to_redrive, monitoring, resolved, withdrawn); status/owner/unclaimed/ redriven/returned narrow the results. Paginated with nextToken.
     * @summary List DLQ investigations (work queue)
     * @param {Stage} stage environment name
     * @param {'mine' | 'active' | 'blocked' | 'ready_to_redrive' | 'monitoring' | 'resolved' | 'withdrawn' | 'all'} [view] 
     * @param {InvestigationStatus} [status] 
     * @param {string} [owner] Owner alias filter
     * @param {boolean} [unclaimed] 
     * @param {boolean} [redriven] Only investigations with at least one redrive attempt
     * @param {boolean} [returned] Only investigations where redriven messages returned to the DLQ
     * @param {number} [limit] 
     * @param {string} [nextToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listInvestigations(stage: Stage, view?: 'mine' | 'active' | 'blocked' | 'ready_to_redrive' | 'monitoring' | 'resolved' | 'withdrawn' | 'all', status?: InvestigationStatus, owner?: string, unclaimed?: boolean, redriven?: boolean, returned?: boolean, limit?: number, nextToken?: string, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listInvestigations(stage, view, status, owner, unclaimed, redriven, returned, limit, nextToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns one page of the groups of DLQ items (by queue, error type, templated error message and category) that are not assigned to any investigation, computed by the hourly reconciliation. Filtering (filter, q, uncategorizedOnly), sorting and paging happen server-side over the full set of reconciled groups; totalCount is the number of rows matching the filter and totalGroups the number of groups reconciled. Default order is highest impact first. Every response also carries the distinct queue, error type and category values (filterOptions) so a client can offer them as filter suggestions without loading every group. With groupByCategory=true the rows are the category view: every group with an error category collapses into one row per category (sizes summed, members listing the (queue, error type) split), while uncategorized groups stay one row each. Identity filter tokens (queue, errorType, errorMessage, category, free text, q) narrow the constituent groups before collapsing, so a category row shows only its matching share; size tokens (items, impactUsd, ambiguous, growth, lastSeen) apply to the collapsed row. totalRows is what the unfiltered view holds in either mode.
     * @summary List uninvestigated DLQ populations from the latest reconciliation
     * @param {Stage} stage environment name
     * @param {boolean} [uncategorizedOnly] 
     * @param {boolean} [groupByCategory] Collapse categorized groups into one row per error category (see description)
     * @param {number} [limit] 
     * @param {number} [offset] Group offset into the filtered, sorted list for paging
     * @param {string} [q] Case-insensitive substring match over queue, error type, error message and category
     * @param {string} [filter] Structured filter, JSON-encoded: {\&quot;operation\&quot;: \&quot;and\&quot;|\&quot;or\&quot;, \&quot;tokens\&quot;: [{\&quot;propertyKey\&quot;, \&quot;operator\&quot;, \&quot;value\&quot;}]}. propertyKey is one of queue, errorType, errorMessage, category (string operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;:\&quot; contains, \&quot;!:\&quot; does not contain), items, impactUsd, ambiguous, growth (the group\&#39;s growth7d; a group seen in a single snapshot never matches) (numeric operators \&quot;&#x3D;\&quot;, \&quot;!&#x3D;\&quot;, \&quot;&gt;\&quot;, \&quot;&gt;&#x3D;\&quot;, \&quot;&lt;\&quot;, \&quot;&lt;&#x3D;\&quot;) or lastSeen (the group\&#39;s latestDlqTimestamp compared with a \&quot;YYYY-MM-DD\&quot; date or \&quot;YYYY-MM-DD HH:MM:SS\&quot; timestamp prefix, same operators as numeric; a group without a timestamp never matches). A token without propertyKey is a free-text substring match over the same fields as q. Combined with q and uncategorizedOnly (all must match).
     * @param {string} [countFilters] Optional JSON array of up to 10 structured filters (same shape as filter). For each, the response\&#39;s filterCounts carries the number of reconciled groups it matches, evaluated over the whole reconciliation independently of filter, q and uncategorizedOnly — one round trip for a navigation\&#39;s slice badges.
     * @param {'impactUsd' | 'count' | 'ambiguousCount' | 'eventsourcekey' | 'errorType' | 'errorMessage' | 'errorCategory' | 'latestDlqTimestamp' | 'growth7d'} [sort] Group field to sort by (default impactUsd; groups without an impact value rank last). &#x60;ambiguousCount&#x60; is deprecated (always 0) and kept for compatibility.
     * @param {boolean} [desc] Sort descending (default true)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public listUninvestigatedGroups(stage: Stage, uncategorizedOnly?: boolean, groupByCategory?: boolean, limit?: number, offset?: number, q?: string, filter?: string, countFilters?: string, sort?: 'impactUsd' | 'count' | 'ambiguousCount' | 'eventsourcekey' | 'errorType' | 'errorMessage' | 'errorCategory' | 'latestDlqTimestamp' | 'growth7d', desc?: boolean, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).listUninvestigatedGroups(stage, uncategorizedOnly, groupByCategory, limit, offset, q, filter, countFilters, sort, desc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Passive: no timeline event, no activity timestamp change. Provide notificationIds for specific entries, investigationId for every entry of one case, or all=true for everything unread.
     * @summary Mark the caller\'s inbox notifications as read
     * @param {InvestigationInboxReadRequest} investigationInboxReadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public markInvestigationInboxRead(investigationInboxReadRequest: InvestigationInboxReadRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).markInvestigationInboxRead(investigationInboxReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Anyone signed in may merge. The survivor keeps its id, owner, status and comments; its rule gains every source rule as an additional OR branch and its population becomes the union of all frozen manifests. Each source is closed as RESOLVED with reason MERGED (it cannot be reopened), its owner and contributors become contributors of the survivor, its children are re-parented to the survivor. Item ownership is re-pointed inline for small populations and by the worker otherwise (`mergePending` set until done). Refused (409) when any participant is resolved, executing or monitoring a redrive, awaiting a deletion MCM, already merging, or in another stage. There is no unmerge — split the survivor instead.
     * @summary Merge other active investigations into this one (the survivor)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationMergeRequest} investigationMergeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public mergeInvestigations(stage: Stage, investigationId: string, investigationMergeRequest: InvestigationMergeRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).mergeInvestigations(stage, investigationId, investigationMergeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a preview for the investigation\'s rule; when it completes the worker assigns unassigned matching items to the investigation and refreshes the frozen population snapshot. Owner only. While the refresh runs the investigation carries `pendingRefresh`; a second request in that window is rejected with 409 `REFRESH_IN_PROGRESS` (the running preview is returned as `preview`) so the expensive Athena scan is never started twice.
     * @summary Re-evaluate the investigation\'s live population rule against the latest DLQ snapshot (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationVersionedRequest} investigationVersionedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public refreshInvestigationPopulation(stage: Stage, investigationId: string, investigationVersionedRequest: InvestigationVersionedRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).refreshInvestigationPopulation(stage, investigationId, investigationVersionedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The caller must be the current owner. The investigation is left without an owner (it appears in the \"Needs an owner\" list) and the caller stays on it as a contributor. Resolved investigations cannot be released; reopen first.
     * @summary Give up ownership of an investigation without naming a successor (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationReleaseRequest} investigationReleaseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public releaseInvestigation(stage: Stage, investigationId: string, investigationReleaseRequest: InvestigationReleaseRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).releaseInvestigation(stage, investigationId, investigationReleaseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A redriven message that returns with an error the case\'s rule no longer matches failed for a different reason. The case keeps it until the owner releases it: this drops the case\'s ownership of every such return it still holds and asks for an early reconcile, which hands each one to the active case whose rule matches it or leaves it in the backlog. Returns still failing the same way are untouched. At most 10,000 per call (moreToRelease).
     * @summary Release returned messages that came back with a new error (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationReleaseReturnedRequest} investigationReleaseReturnedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public releaseInvestigationReturnedItems(stage: Stage, investigationId: string, investigationReleaseReturnedRequest: InvestigationReleaseReturnedRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).releaseInvestigationReturnedItems(stage, investigationId, investigationReleaseReturnedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Freezes the current primary assignments into an exact manifest, uploads it as the bulk-redrive CSV to the stage\'s DLQ redrive bucket and creates a Draft MCM whose description carries the S3 URI + ETag literal the redriver validates, plus the justification and the investigation context. The investigation stays READY_TO_REDRIVE with `pendingDeletion` set, which locks population refresh, redrives, status changes and child splits until the request is executed or cancelled (409 DELETION_PENDING). Requires status READY_TO_REDRIVE and the DLQ redrive Bindle lock.
     * @summary Request an MCM-gated delete-without-redrive of the investigation\'s frozen manifest (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationDeletionRequest} investigationDeletionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public requestInvestigationDeletion(stage: Stage, investigationId: string, investigationDeletionRequest: InvestigationDeletionRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).requestInvestigationDeletion(stage, investigationId, investigationDeletionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Given a stage and DLQ primary key returns whether the item is owned by an active investigation, matches a resolved (historical) investigation, is ambiguous, or is uninvestigated, plus a suggested population rule built from the seed fields.
     * @summary Resolve a DLQ dashboard row against the live investigation registry
     * @param {Stage} stage environment name
     * @param {InvestigationRowRequest} investigationRowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public resolveInvestigationRow(stage: Stage, investigationRowRequest: InvestigationRowRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).resolveInvestigationRow(stage, investigationRowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * While a document redrive awaits the owner\'s CBE check (documentRedrive.stage AWAITING_CONFIRMATION), schedules an email + Slack reminder to the owner at remindAt (5 minutes to 7 days ahead) through the Notifications service and records it as documentRedrive.reminder. A new reminder replaces the previous one; confirming the check cancels it (CancelScheduledNotification).
     * @summary Remind the owner to do the CBE check later (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {string} attemptId 
     * @param {InvestigationReminderRequest} investigationReminderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public setInvestigationDocumentRedriveReminder(stage: Stage, investigationId: string, attemptId: string, investigationReminderRequest: InvestigationReminderRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).setInvestigationDocumentRedriveReminder(stage, investigationId, attemptId, investigationReminderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Schedules an email + Slack reminder to the caller at remindAt (5 minutes to 7 days ahead) through the Notifications service. Private: each person has at most one reminder per case, only they see it (myReminder), it writes no timeline event, does not count as activity and needs no expectedVersion. A new reminder replaces (cancels) the caller\'s previous one.
     * @summary Remind me to check back on an investigation (anyone signed in)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationCaseReminderRequest} investigationCaseReminderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public setInvestigationReminder(stage: Stage, investigationId: string, investigationCaseReminderRequest: InvestigationCaseReminderRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).setInvestigationReminder(stage, investigationId, investigationCaseReminderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For populations no rule can separate (e.g. safe vs unsafe orders decided from their FLARE history). `lines` holds DLQ keys, one per entry (an optional first entry `dlq_pk` is ignored). Order IDs are refused (400): they would also move items that arrived for those orders after the list was made. Keys are matched against this case\'s frozen manifest (no Athena query). With dryRun=true only the counts are returned; otherwise a child investigation is created that takes over the matched items this case still owns (more than 2,000 are moved on the worker). A list child never gains items later: reconcile, population refresh, add-items, rule widening and rule splits skip or refuse it. Refused while a deletion is pending, a merge is running or a redrive is executing/monitoring, and when every item would move.
     * @summary Split items off into a child investigation by a list of DLQ keys (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationSplitListRequest} investigationSplitListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public splitInvestigationByList(stage: Stage, investigationId: string, investigationSplitListRequest: InvestigationSplitListRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).splitInvestigationByList(stage, investigationId, investigationSplitListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Step 1 of the document-redrive path. Re-processes the distinct transaction IDs (accounting unique id, else order id) of the items the investigation owns through the order redrive state machine: Lusca rebuilds each document from its own store with a bumped version tagged MANUAL_REDRIVE and republishes its CBEs. Requires READY_TO_REDRIVE and the DLQ redrive Bindle lock; the case is EXECUTING_REDRIVE while it runs and returns to READY_TO_REDRIVE with documentRedrive.stage AWAITING_CONFIRMATION. The DLQ items are not touched: after the owner confirms (document-redrives/{attemptId}/confirm) a DLQ redrive clears them. Use it when the stored document is correct but its accounting (CBEs) is wrong or missing.
     * @summary Launch a document redrive of the investigation\'s transactions (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public startInvestigationDocumentRedrive(stage: Stage, investigationId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).startInvestigationDocumentRedrive(stage, investigationId, investigationDocumentRedriveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts an Athena query over the latest hourly DLQ snapshot for the given population rule and returns a previewId to poll with GET investigations/previews/{previewId}. The rule is a list of equality predicates over allowlisted DLQ fields (eventsourcekey, error_type, error_message, error_category, gl_product_group, marketplace_id, usecase, digital_order_source, is_emp_order, destination, accounting_operation, payment_processor).
     * @summary Start an asynchronous DLQ investigation population preview
     * @param {Stage} stage environment name
     * @param {InvestigationPreviewRequest} investigationPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public startInvestigationPreview(stage: Stage, investigationPreviewRequest: InvestigationPreviewRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).startInvestigationPreview(stage, investigationPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Freezes the current primary assignments into an exact manifest, invokes the existing DLQ redrive state machine (Bindle lock check applies) and moves the investigation to EXECUTING_REDRIVE. Requires status READY_TO_REDRIVE.
     * @summary Launch a redrive of the investigation\'s frozen DLQ-PK manifest (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationRedriveRequest} investigationRedriveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public startInvestigationRedrive(stage: Stage, investigationId: string, investigationRedriveRequest: InvestigationRedriveRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).startInvestigationRedrive(stage, investigationId, investigationRedriveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by TrackStars (through the Lusca MCP server, as the person who ran it) once, with its DashboardReport JSON. Completes the investigation\'s current run while it is REQUESTED; otherwise records a new run for the report first, so the latest report wins. Lusca stores the report, counts each pattern\'s items in the frozen population (on the worker) and moves the run SCORING → COMPLETED (or FAILED), logging TRACKSTARS_RUN_COMPLETED.
     * @summary TrackStars writes its finished report back, knowing only the investigation id
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {SubmitInvestigationTrackStarsReportRequest} submitInvestigationTrackStarsReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public submitInvestigationTrackStarsReport(stage: Stage, investigationId: string, submitInvestigationTrackStarsReportRequest: SubmitInvestigationTrackStarsReportRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).submitInvestigationTrackStarsReport(stage, investigationId, submitInvestigationTrackStarsReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Transfer ownership of an investigation to another Lusca Search user (anyone may; only the new owner is notified)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationTransferRequest} investigationTransferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public transferInvestigation(stage: Stage, investigationId: string, investigationTransferRequest: InvestigationTransferRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).transferInvestigation(stage, investigationId, investigationTransferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes a case confirmed by mistake back to the CBE check: documentRedrive.stage CONFIRMED → AWAITING_CONFIRMATION (confirmedAt/confirmedBy cleared), so the DLQ redrive is locked again until the owner confirms. Only while the case is still READY_TO_REDRIVE (no DLQ redrive launched since).
     * @summary Undo the CBE confirmation of a document redrive (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {string} attemptId 
     * @param {InvestigationDocumentRedriveRequest} investigationDocumentRedriveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public unconfirmInvestigationDocumentRedrive(stage: Stage, investigationId: string, attemptId: string, investigationDocumentRedriveRequest: InvestigationDocumentRedriveRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).unconfirmInvestigationDocumentRedrive(stage, investigationId, attemptId, investigationDocumentRedriveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Owner-only for status transitions, blocker and resolution; anyone may rename (title) or add or edit the conclusion and its evidence links. Requires expectedVersion; returns 409 on version mismatch. Humans cannot set EXECUTING_REDRIVE or MONITORING_REDRIVE, except to unblock a case that was blocked while MONITORING_REDRIVE (blocker.blockedFrom), which resumes monitoring. Resolving requires a conclusion summary; evidence links are recommended but not enforced. Free-form progress notes go to the comments endpoint.
     * @summary Update an investigation (title and links by anyone; description, conclusion, blocker, status, resolution by the owner; Taskei task link)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationUpdateRequest} investigationUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public updateInvestigation(stage: Stage, investigationId: string, investigationUpdateRequest: InvestigationUpdateRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).updateInvestigation(stage, investigationId, investigationUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds `rule` to the investigation\'s rules as an OR branch (a branch it already contains is dropped; nothing changes when the case already covers it) and asks for an early reconcile, so unowned items matching the wider rule move in within minutes, and future ones keep arriving at every hourly reconcile. Recorded as RULE_WIDENED with the previous and new rules.
     * @summary Widen an investigation\'s rule with another rule branch (owner only)
     * @param {Stage} stage environment name
     * @param {string} investigationId Investigation id (inv-...)
     * @param {InvestigationWidenRuleRequest} investigationWidenRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationsApi
     */
    public widenInvestigationRule(stage: Stage, investigationId: string, investigationWidenRuleRequest: InvestigationWidenRuleRequest, options?: AxiosRequestConfig) {
        return InvestigationsApiFp(this.configuration).widenInvestigationRule(stage, investigationId, investigationWidenRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * MatchSetsApi - axios parameter creator
 * @export
 */
export const MatchSetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get match set statuses for an order
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchSets: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getMatchSets', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getMatchSets', 'orderId', orderId)
            const localVarPath = `/match-sets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Looks up Match Set Accounting statuses for the given match keys in one realm. Unlike GET /match-sets it does not read the order\'s CBEs: the caller supplies the keys and realm (the transaction page derives them client-side). Keys are trimmed and blanks dropped; an empty key list returns an empty result. The stage is read from the request body, not the query string.
         * @summary Query match set statuses for explicit match keys
         * @param {QueryMatchSetsRequest} queryMatchSetsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryMatchSets: async (queryMatchSetsRequest: QueryMatchSetsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queryMatchSetsRequest' is not null or undefined
            assertParamExists('queryMatchSets', 'queryMatchSetsRequest', queryMatchSetsRequest)
            const localVarPath = `/match-sets-query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryMatchSetsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatchSetsApi - functional programming interface
 * @export
 */
export const MatchSetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatchSetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get match set statuses for an order
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMatchSets(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchSetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMatchSets(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Looks up Match Set Accounting statuses for the given match keys in one realm. Unlike GET /match-sets it does not read the order\'s CBEs: the caller supplies the keys and realm (the transaction page derives them client-side). Keys are trimmed and blanks dropped; an empty key list returns an empty result. The stage is read from the request body, not the query string.
         * @summary Query match set statuses for explicit match keys
         * @param {QueryMatchSetsRequest} queryMatchSetsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryMatchSets(queryMatchSetsRequest: QueryMatchSetsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchSetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryMatchSets(queryMatchSetsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MatchSetsApi - factory interface
 * @export
 */
export const MatchSetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatchSetsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get match set statuses for an order
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchSets(stage: Stage, orderId: string, options?: any): AxiosPromise<MatchSetResponse> {
            return localVarFp.getMatchSets(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Looks up Match Set Accounting statuses for the given match keys in one realm. Unlike GET /match-sets it does not read the order\'s CBEs: the caller supplies the keys and realm (the transaction page derives them client-side). Keys are trimmed and blanks dropped; an empty key list returns an empty result. The stage is read from the request body, not the query string.
         * @summary Query match set statuses for explicit match keys
         * @param {QueryMatchSetsRequest} queryMatchSetsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryMatchSets(queryMatchSetsRequest: QueryMatchSetsRequest, options?: any): AxiosPromise<MatchSetResponse> {
            return localVarFp.queryMatchSets(queryMatchSetsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatchSetsApi - object-oriented interface
 * @export
 * @class MatchSetsApi
 * @extends {BaseAPI}
 */
export class MatchSetsApi extends BaseAPI {
    /**
     * 
     * @summary Get match set statuses for an order
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchSetsApi
     */
    public getMatchSets(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return MatchSetsApiFp(this.configuration).getMatchSets(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Looks up Match Set Accounting statuses for the given match keys in one realm. Unlike GET /match-sets it does not read the order\'s CBEs: the caller supplies the keys and realm (the transaction page derives them client-side). Keys are trimmed and blanks dropped; an empty key list returns an empty result. The stage is read from the request body, not the query string.
     * @summary Query match set statuses for explicit match keys
     * @param {QueryMatchSetsRequest} queryMatchSetsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchSetsApi
     */
    public queryMatchSets(queryMatchSetsRequest: QueryMatchSetsRequest, options?: AxiosRequestConfig) {
        return MatchSetsApiFp(this.configuration).queryMatchSets(queryMatchSetsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * PaymentRedriveApi - axios parameter creator
 * @export
 */
export const PaymentRedriveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get presigned URL for payment redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRedriveUploadUrl: async (stage: Stage, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getPaymentRedriveUploadUrl', 'stage', stage)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getPaymentRedriveUploadUrl', 'fileName', fileName)
            const localVarPath = `/payment-redrive-upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redrive a ManualRoyaltyAdjustment cost document
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveRequest} postPaymentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRedrive: async (stage: Stage, postPaymentRedriveRequest: PostPaymentRedriveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postPaymentRedrive', 'stage', stage)
            // verify required parameter 'postPaymentRedriveRequest' is not null or undefined
            assertParamExists('postPaymentRedrive', 'postPaymentRedriveRequest', postPaymentRedriveRequest)
            const localVarPath = `/payment-redrive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPaymentRedriveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a bulk payment redrive from a CSV file in S3
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveBulkRequest} postPaymentRedriveBulkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRedriveBulk: async (stage: Stage, postPaymentRedriveBulkRequest: PostPaymentRedriveBulkRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postPaymentRedriveBulk', 'stage', stage)
            // verify required parameter 'postPaymentRedriveBulkRequest' is not null or undefined
            assertParamExists('postPaymentRedriveBulk', 'postPaymentRedriveBulkRequest', postPaymentRedriveBulkRequest)
            const localVarPath = `/payment-redrive-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPaymentRedriveBulkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentRedriveApi - functional programming interface
 * @export
 */
export const PaymentRedriveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentRedriveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get presigned URL for payment redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDLQRedriveUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRedriveUploadUrl(stage, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Redrive a ManualRoyaltyAdjustment cost document
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveRequest} postPaymentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPaymentRedrive(stage: Stage, postPaymentRedriveRequest: PostPaymentRedriveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishMockAcadiaInvoice202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPaymentRedrive(stage, postPaymentRedriveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start a bulk payment redrive from a CSV file in S3
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveBulkRequest} postPaymentRedriveBulkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPaymentRedriveBulk(stage: Stage, postPaymentRedriveBulkRequest: PostPaymentRedriveBulkRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRedriveOrder202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPaymentRedriveBulk(stage, postPaymentRedriveBulkRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentRedriveApi - factory interface
 * @export
 */
export const PaymentRedriveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentRedriveApiFp(configuration)
    return {
        /**
         * 
         * @summary Get presigned URL for payment redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRedriveUploadUrl(stage: Stage, fileName: string, options?: any): AxiosPromise<GetDLQRedriveUploadUrl200Response> {
            return localVarFp.getPaymentRedriveUploadUrl(stage, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redrive a ManualRoyaltyAdjustment cost document
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveRequest} postPaymentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRedrive(stage: Stage, postPaymentRedriveRequest: PostPaymentRedriveRequest, options?: any): AxiosPromise<PublishMockAcadiaInvoice202Response> {
            return localVarFp.postPaymentRedrive(stage, postPaymentRedriveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a bulk payment redrive from a CSV file in S3
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveBulkRequest} postPaymentRedriveBulkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRedriveBulk(stage: Stage, postPaymentRedriveBulkRequest: PostPaymentRedriveBulkRequest, options?: any): AxiosPromise<PostRedriveOrder202Response> {
            return localVarFp.postPaymentRedriveBulk(stage, postPaymentRedriveBulkRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentRedriveApi - object-oriented interface
 * @export
 * @class PaymentRedriveApi
 * @extends {BaseAPI}
 */
export class PaymentRedriveApi extends BaseAPI {
    /**
     * 
     * @summary Get presigned URL for payment redrive file upload
     * @param {Stage} stage environment name
     * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRedriveApi
     */
    public getPaymentRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig) {
        return PaymentRedriveApiFp(this.configuration).getPaymentRedriveUploadUrl(stage, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redrive a ManualRoyaltyAdjustment cost document
     * @param {Stage} stage environment name
     * @param {PostPaymentRedriveRequest} postPaymentRedriveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRedriveApi
     */
    public postPaymentRedrive(stage: Stage, postPaymentRedriveRequest: PostPaymentRedriveRequest, options?: AxiosRequestConfig) {
        return PaymentRedriveApiFp(this.configuration).postPaymentRedrive(stage, postPaymentRedriveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a bulk payment redrive from a CSV file in S3
     * @param {Stage} stage environment name
     * @param {PostPaymentRedriveBulkRequest} postPaymentRedriveBulkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRedriveApi
     */
    public postPaymentRedriveBulk(stage: Stage, postPaymentRedriveBulkRequest: PostPaymentRedriveBulkRequest, options?: AxiosRequestConfig) {
        return PaymentRedriveApiFp(this.configuration).postPaymentRedriveBulk(stage, postPaymentRedriveBulkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransaction: async (projectId: string, transactionCreate: TransactionCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addTransaction', 'projectId', projectId)
            // verify required parameter 'transactionCreate' is not null or undefined
            assertParamExists('addTransaction', 'transactionCreate', transactionCreate)
            const localVarPath = `/projects/{projectId}/transactions`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new UAT project
         * @param {ProjectCreate} projectCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (projectCreate: ProjectCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectCreate' is not null or undefined
            assertParamExists('createProject', 'projectCreate', projectCreate)
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: async (projectId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProject', 'projectId', projectId)
            const localVarPath = `/projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all UAT projects
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects: async (includeArchived?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a project
         * @param {string} projectId 
         * @param {ProjectUpdate} projectUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: async (projectId: string, projectUpdate: ProjectUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateProject', 'projectId', projectId)
            // verify required parameter 'projectUpdate' is not null or undefined
            assertParamExists('updateProject', 'projectUpdate', projectUpdate)
            const localVarPath = `/projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction: async (projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateTransaction', 'projectId', projectId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('updateTransaction', 'transactionId', transactionId)
            // verify required parameter 'transactionUpdate' is not null or undefined
            assertParamExists('updateTransaction', 'transactionUpdate', transactionUpdate)
            const localVarPath = `/projects/{projectId}/transactions/{transactionId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTransaction(projectId, transactionCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new UAT project
         * @param {ProjectCreate} projectCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(projectCreate: ProjectCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(projectCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a specific project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProject(projectId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProject(projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all UAT projects
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProjects(includeArchived?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListProjects200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProjects(includeArchived, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a project
         * @param {string} projectId 
         * @param {ProjectUpdate} projectUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProject(projectId: string, projectUpdate: ProjectUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(projectId, projectUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransaction(projectId, transactionId, transactionUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: any): AxiosPromise<Project> {
            return localVarFp.addTransaction(projectId, transactionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new UAT project
         * @param {ProjectCreate} projectCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(projectCreate: ProjectCreate, options?: any): AxiosPromise<Project> {
            return localVarFp.createProject(projectCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(projectId: string, options?: any): AxiosPromise<Project> {
            return localVarFp.getProject(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all UAT projects
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects(includeArchived?: boolean, options?: any): AxiosPromise<ListProjects200Response> {
            return localVarFp.listProjects(includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a project
         * @param {string} projectId 
         * @param {ProjectUpdate} projectUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(projectId: string, projectUpdate: ProjectUpdate, options?: any): AxiosPromise<Project> {
            return localVarFp.updateProject(projectId, projectUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: any): AxiosPromise<Project> {
            return localVarFp.updateTransaction(projectId, transactionId, transactionUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     * 
     * @summary Add a transaction to a project
     * @param {string} projectId 
     * @param {TransactionCreate} transactionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).addTransaction(projectId, transactionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new UAT project
     * @param {ProjectCreate} projectCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public createProject(projectCreate: ProjectCreate, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).createProject(projectCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific project
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProject(projectId: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProject(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all UAT projects
     * @param {boolean} [includeArchived] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public listProjects(includeArchived?: boolean, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).listProjects(includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a project
     * @param {string} projectId 
     * @param {ProjectUpdate} projectUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public updateProject(projectId: string, projectUpdate: ProjectUpdate, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).updateProject(projectId, projectUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a transaction in a project
     * @param {string} projectId 
     * @param {string} transactionId 
     * @param {TransactionUpdate} transactionUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).updateTransaction(projectId, transactionId, transactionUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * PsnsRedriveApi - axios parameter creator
 * @export
 */
export const PsnsRedriveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check PSNS settlement redrive status
         * @param {Stage} stage environment name
         * @param {string} executionArn Arn of the redrive execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPsnsRedriveInfo: async (stage: Stage, executionArn: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getPsnsRedriveInfo', 'stage', stage)
            // verify required parameter 'executionArn' is not null or undefined
            assertParamExists('getPsnsRedriveInfo', 'executionArn', executionArn)
            const localVarPath = `/psns-redrive-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (executionArn !== undefined) {
                localVarQueryParameter['executionArn'] = executionArn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get presigned URL for PSNS settlement redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName name of the NDJSON file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPsnsRedriveUploadUrl: async (stage: Stage, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getPsnsRedriveUploadUrl', 'stage', stage)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getPsnsRedriveUploadUrl', 'fileName', fileName)
            const localVarPath = `/psns-redrive-upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a PSNS settlement redrive (dry-run or publish)
         * @param {Stage} stage environment name
         * @param {StartPsnsRedriveRequest} startPsnsRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPsnsRedrive: async (stage: Stage, startPsnsRedriveRequest: StartPsnsRedriveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('startPsnsRedrive', 'stage', stage)
            // verify required parameter 'startPsnsRedriveRequest' is not null or undefined
            assertParamExists('startPsnsRedrive', 'startPsnsRedriveRequest', startPsnsRedriveRequest)
            const localVarPath = `/psns-redrive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startPsnsRedriveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PsnsRedriveApi - functional programming interface
 * @export
 */
export const PsnsRedriveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PsnsRedriveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check PSNS settlement redrive status
         * @param {Stage} stage environment name
         * @param {string} executionArn Arn of the redrive execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPsnsRedriveInfo(stage: Stage, executionArn: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PsnsRedriveInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPsnsRedriveInfo(stage, executionArn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get presigned URL for PSNS settlement redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName name of the NDJSON file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPsnsRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPsnsRedriveUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPsnsRedriveUploadUrl(stage, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start a PSNS settlement redrive (dry-run or publish)
         * @param {Stage} stage environment name
         * @param {StartPsnsRedriveRequest} startPsnsRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startPsnsRedrive(stage: Stage, startPsnsRedriveRequest: StartPsnsRedriveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PsnsRedriveInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startPsnsRedrive(stage, startPsnsRedriveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PsnsRedriveApi - factory interface
 * @export
 */
export const PsnsRedriveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PsnsRedriveApiFp(configuration)
    return {
        /**
         * 
         * @summary Check PSNS settlement redrive status
         * @param {Stage} stage environment name
         * @param {string} executionArn Arn of the redrive execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPsnsRedriveInfo(stage: Stage, executionArn: string, options?: any): AxiosPromise<PsnsRedriveInfoResult> {
            return localVarFp.getPsnsRedriveInfo(stage, executionArn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get presigned URL for PSNS settlement redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName name of the NDJSON file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPsnsRedriveUploadUrl(stage: Stage, fileName: string, options?: any): AxiosPromise<GetPsnsRedriveUploadUrl200Response> {
            return localVarFp.getPsnsRedriveUploadUrl(stage, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a PSNS settlement redrive (dry-run or publish)
         * @param {Stage} stage environment name
         * @param {StartPsnsRedriveRequest} startPsnsRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPsnsRedrive(stage: Stage, startPsnsRedriveRequest: StartPsnsRedriveRequest, options?: any): AxiosPromise<PsnsRedriveInfoResult> {
            return localVarFp.startPsnsRedrive(stage, startPsnsRedriveRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PsnsRedriveApi - object-oriented interface
 * @export
 * @class PsnsRedriveApi
 * @extends {BaseAPI}
 */
export class PsnsRedriveApi extends BaseAPI {
    /**
     * 
     * @summary Check PSNS settlement redrive status
     * @param {Stage} stage environment name
     * @param {string} executionArn Arn of the redrive execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PsnsRedriveApi
     */
    public getPsnsRedriveInfo(stage: Stage, executionArn: string, options?: AxiosRequestConfig) {
        return PsnsRedriveApiFp(this.configuration).getPsnsRedriveInfo(stage, executionArn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get presigned URL for PSNS settlement redrive file upload
     * @param {Stage} stage environment name
     * @param {string} fileName name of the NDJSON file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PsnsRedriveApi
     */
    public getPsnsRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig) {
        return PsnsRedriveApiFp(this.configuration).getPsnsRedriveUploadUrl(stage, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a PSNS settlement redrive (dry-run or publish)
     * @param {Stage} stage environment name
     * @param {StartPsnsRedriveRequest} startPsnsRedriveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PsnsRedriveApi
     */
    public startPsnsRedrive(stage: Stage, startPsnsRedriveRequest: StartPsnsRedriveRequest, options?: AxiosRequestConfig) {
        return PsnsRedriveApiFp(this.configuration).startPsnsRedrive(stage, startPsnsRedriveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * PublishMockAcadiaInvoiceApi - axios parameter creator
 * @export
 */
export const PublishMockAcadiaInvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Publish mock Acadia invoice
         * @param {Stage} stage environment name
         * @param {PublishMockAcadiaInvoiceRequest} publishMockAcadiaInvoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishMockAcadiaInvoice: async (stage: Stage, publishMockAcadiaInvoiceRequest: PublishMockAcadiaInvoiceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('publishMockAcadiaInvoice', 'stage', stage)
            // verify required parameter 'publishMockAcadiaInvoiceRequest' is not null or undefined
            assertParamExists('publishMockAcadiaInvoice', 'publishMockAcadiaInvoiceRequest', publishMockAcadiaInvoiceRequest)
            const localVarPath = `/publish-mock-acadia-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishMockAcadiaInvoiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublishMockAcadiaInvoiceApi - functional programming interface
 * @export
 */
export const PublishMockAcadiaInvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublishMockAcadiaInvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Publish mock Acadia invoice
         * @param {Stage} stage environment name
         * @param {PublishMockAcadiaInvoiceRequest} publishMockAcadiaInvoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishMockAcadiaInvoice(stage: Stage, publishMockAcadiaInvoiceRequest: PublishMockAcadiaInvoiceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishMockAcadiaInvoice202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishMockAcadiaInvoice(stage, publishMockAcadiaInvoiceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublishMockAcadiaInvoiceApi - factory interface
 * @export
 */
export const PublishMockAcadiaInvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublishMockAcadiaInvoiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Publish mock Acadia invoice
         * @param {Stage} stage environment name
         * @param {PublishMockAcadiaInvoiceRequest} publishMockAcadiaInvoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishMockAcadiaInvoice(stage: Stage, publishMockAcadiaInvoiceRequest: PublishMockAcadiaInvoiceRequest, options?: any): AxiosPromise<PublishMockAcadiaInvoice202Response> {
            return localVarFp.publishMockAcadiaInvoice(stage, publishMockAcadiaInvoiceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublishMockAcadiaInvoiceApi - object-oriented interface
 * @export
 * @class PublishMockAcadiaInvoiceApi
 * @extends {BaseAPI}
 */
export class PublishMockAcadiaInvoiceApi extends BaseAPI {
    /**
     * 
     * @summary Publish mock Acadia invoice
     * @param {Stage} stage environment name
     * @param {PublishMockAcadiaInvoiceRequest} publishMockAcadiaInvoiceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishMockAcadiaInvoiceApi
     */
    public publishMockAcadiaInvoice(stage: Stage, publishMockAcadiaInvoiceRequest: PublishMockAcadiaInvoiceRequest, options?: AxiosRequestConfig) {
        return PublishMockAcadiaInvoiceApiFp(this.configuration).publishMockAcadiaInvoice(stage, publishMockAcadiaInvoiceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * RedriveApi - axios parameter creator
 * @export
 */
export const RedriveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveInfo: async (stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getRedriveInfo', 'stage', stage)
            const localVarPath = `/redrive-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get orders processed in a specific redrive execution
         * @param {string} executionId ID of the redrive execution
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveOrders: async (executionId: string, stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executionId' is not null or undefined
            assertParamExists('getRedriveOrders', 'executionId', executionId)
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getRedriveOrders', 'stage', stage)
            const localVarPath = `/redrive-info/{executionId}/orders`
                .replace(`{${"executionId"}}`, encodeURIComponent(String(executionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get presigned URL for file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveUploadUrl: async (stage: Stage, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getRedriveUploadUrl', 'stage', stage)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getRedriveUploadUrl', 'fileName', fileName)
            const localVarPath = `/redrive-upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new redrive request
         * @param {Stage} stage environment name
         * @param {PostRedriveInfoRequest} postRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedriveInfo: async (stage: Stage, postRedriveInfoRequest: PostRedriveInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postRedriveInfo', 'stage', stage)
            // verify required parameter 'postRedriveInfoRequest' is not null or undefined
            assertParamExists('postRedriveInfo', 'postRedriveInfoRequest', postRedriveInfoRequest)
            const localVarPath = `/redrive-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRedriveInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a one-order CSV server-side and starts the existing order redrive workflow. The caller does not need to provide an S3 URI. 
         * @summary Redrive a single order
         * @param {Stage} stage environment name
         * @param {PostRedriveOrderRequest} postRedriveOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedriveOrder: async (stage: Stage, postRedriveOrderRequest: PostRedriveOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postRedriveOrder', 'stage', stage)
            // verify required parameter 'postRedriveOrderRequest' is not null or undefined
            assertParamExists('postRedriveOrder', 'postRedriveOrderRequest', postRedriveOrderRequest)
            const localVarPath = `/redrive-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRedriveOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedriveApi - functional programming interface
 * @export
 */
export const RedriveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RedriveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedriveInfo(stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRedriveInfo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedriveInfo(stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get orders processed in a specific redrive execution
         * @param {string} executionId ID of the redrive execution
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedriveOrders(executionId: string, stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRedriveOrders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedriveOrders(executionId, stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get presigned URL for file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDLQRedriveUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedriveUploadUrl(stage, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start a new redrive request
         * @param {Stage} stage environment name
         * @param {PostRedriveInfoRequest} postRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRedriveInfo(stage: Stage, postRedriveInfoRequest: PostRedriveInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRedriveInfo202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRedriveInfo(stage, postRedriveInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads a one-order CSV server-side and starts the existing order redrive workflow. The caller does not need to provide an S3 URI. 
         * @summary Redrive a single order
         * @param {Stage} stage environment name
         * @param {PostRedriveOrderRequest} postRedriveOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRedriveOrder(stage: Stage, postRedriveOrderRequest: PostRedriveOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRedriveOrder202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRedriveOrder(stage, postRedriveOrderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RedriveApi - factory interface
 * @export
 */
export const RedriveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RedriveApiFp(configuration)
    return {
        /**
         * 
         * @summary List all redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveInfo(stage: Stage, options?: any): AxiosPromise<GetRedriveInfo200Response> {
            return localVarFp.getRedriveInfo(stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get orders processed in a specific redrive execution
         * @param {string} executionId ID of the redrive execution
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveOrders(executionId: string, stage: Stage, options?: any): AxiosPromise<GetRedriveOrders200Response> {
            return localVarFp.getRedriveOrders(executionId, stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get presigned URL for file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveUploadUrl(stage: Stage, fileName: string, options?: any): AxiosPromise<GetDLQRedriveUploadUrl200Response> {
            return localVarFp.getRedriveUploadUrl(stage, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new redrive request
         * @param {Stage} stage environment name
         * @param {PostRedriveInfoRequest} postRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedriveInfo(stage: Stage, postRedriveInfoRequest: PostRedriveInfoRequest, options?: any): AxiosPromise<PostRedriveInfo202Response> {
            return localVarFp.postRedriveInfo(stage, postRedriveInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a one-order CSV server-side and starts the existing order redrive workflow. The caller does not need to provide an S3 URI. 
         * @summary Redrive a single order
         * @param {Stage} stage environment name
         * @param {PostRedriveOrderRequest} postRedriveOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedriveOrder(stage: Stage, postRedriveOrderRequest: PostRedriveOrderRequest, options?: any): AxiosPromise<PostRedriveOrder202Response> {
            return localVarFp.postRedriveOrder(stage, postRedriveOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RedriveApi - object-oriented interface
 * @export
 * @class RedriveApi
 * @extends {BaseAPI}
 */
export class RedriveApi extends BaseAPI {
    /**
     * 
     * @summary List all redrive executions
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public getRedriveInfo(stage: Stage, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).getRedriveInfo(stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get orders processed in a specific redrive execution
     * @param {string} executionId ID of the redrive execution
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public getRedriveOrders(executionId: string, stage: Stage, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).getRedriveOrders(executionId, stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get presigned URL for file upload
     * @param {Stage} stage environment name
     * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public getRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).getRedriveUploadUrl(stage, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new redrive request
     * @param {Stage} stage environment name
     * @param {PostRedriveInfoRequest} postRedriveInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public postRedriveInfo(stage: Stage, postRedriveInfoRequest: PostRedriveInfoRequest, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).postRedriveInfo(stage, postRedriveInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a one-order CSV server-side and starts the existing order redrive workflow. The caller does not need to provide an S3 URI. 
     * @summary Redrive a single order
     * @param {Stage} stage environment name
     * @param {PostRedriveOrderRequest} postRedriveOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public postRedriveOrder(stage: Stage, postRedriveOrderRequest: PostRedriveOrderRequest, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).postRedriveOrder(stage, postRedriveOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ShadowTestApi - axios parameter creator
 * @export
 */
export const ShadowTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Trigger a shadow test for a list of transactions
         * @param {Stage} stage environment name (prod, beta, etc)
         * @param {CreateShadowTestRequest} createShadowTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShadowTest: async (stage: Stage, createShadowTestRequest: CreateShadowTestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('createShadowTest', 'stage', stage)
            // verify required parameter 'createShadowTestRequest' is not null or undefined
            assertParamExists('createShadowTest', 'createShadowTestRequest', createShadowTestRequest)
            const localVarPath = `/shadow-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShadowTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get shadow test classification descriptions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShadowTestClassifications: async (stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getShadowTestClassifications', 'stage', stage)
            const localVarPath = `/shadow-test-classifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get shadow test result for a transaction
         * @param {Stage} stage environment name
         * @param {string} transactionId Transaction ID to fetch results for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShadowTestResult: async (stage: Stage, transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getShadowTestResult', 'stage', stage)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getShadowTestResult', 'transactionId', transactionId)
            const localVarPath = `/shadow-test-result/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShadowTestApi - functional programming interface
 * @export
 */
export const ShadowTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShadowTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Trigger a shadow test for a list of transactions
         * @param {Stage} stage environment name (prod, beta, etc)
         * @param {CreateShadowTestRequest} createShadowTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShadowTest(stage: Stage, createShadowTestRequest: CreateShadowTestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShadowTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShadowTest(stage, createShadowTestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get shadow test classification descriptions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShadowTestClassifications(stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShadowTestClassificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShadowTestClassifications(stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get shadow test result for a transaction
         * @param {Stage} stage environment name
         * @param {string} transactionId Transaction ID to fetch results for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShadowTestResult(stage: Stage, transactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShadowTestResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShadowTestResult(stage, transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShadowTestApi - factory interface
 * @export
 */
export const ShadowTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShadowTestApiFp(configuration)
    return {
        /**
         * 
         * @summary Trigger a shadow test for a list of transactions
         * @param {Stage} stage environment name (prod, beta, etc)
         * @param {CreateShadowTestRequest} createShadowTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShadowTest(stage: Stage, createShadowTestRequest: CreateShadowTestRequest, options?: any): AxiosPromise<ShadowTestResponse> {
            return localVarFp.createShadowTest(stage, createShadowTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get shadow test classification descriptions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShadowTestClassifications(stage: Stage, options?: any): AxiosPromise<ShadowTestClassificationsResponse> {
            return localVarFp.getShadowTestClassifications(stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get shadow test result for a transaction
         * @param {Stage} stage environment name
         * @param {string} transactionId Transaction ID to fetch results for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShadowTestResult(stage: Stage, transactionId: string, options?: any): AxiosPromise<ShadowTestResultResponse> {
            return localVarFp.getShadowTestResult(stage, transactionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShadowTestApi - object-oriented interface
 * @export
 * @class ShadowTestApi
 * @extends {BaseAPI}
 */
export class ShadowTestApi extends BaseAPI {
    /**
     * 
     * @summary Trigger a shadow test for a list of transactions
     * @param {Stage} stage environment name (prod, beta, etc)
     * @param {CreateShadowTestRequest} createShadowTestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShadowTestApi
     */
    public createShadowTest(stage: Stage, createShadowTestRequest: CreateShadowTestRequest, options?: AxiosRequestConfig) {
        return ShadowTestApiFp(this.configuration).createShadowTest(stage, createShadowTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get shadow test classification descriptions
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShadowTestApi
     */
    public getShadowTestClassifications(stage: Stage, options?: AxiosRequestConfig) {
        return ShadowTestApiFp(this.configuration).getShadowTestClassifications(stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get shadow test result for a transaction
     * @param {Stage} stage environment name
     * @param {string} transactionId Transaction ID to fetch results for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShadowTestApi
     */
    public getShadowTestResult(stage: Stage, transactionId: string, options?: AxiosRequestConfig) {
        return ShadowTestApiFp(this.configuration).getShadowTestResult(stage, transactionId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransaction: async (projectId: string, transactionCreate: TransactionCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addTransaction', 'projectId', projectId)
            // verify required parameter 'transactionCreate' is not null or undefined
            assertParamExists('addTransaction', 'transactionCreate', transactionCreate)
            const localVarPath = `/projects/{projectId}/transactions`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get recent transactions across regions
         * @param {Stage} stage environment name
         * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
         * @param {string} [gl] GL code to filter by (e.g., 318, 613)
         * @param {Array<string>} [usecases] usecase types to filter by
         * @param {string} [paymentMethod] payment provider to filter by (AMP or EMP; EMP means Apple or Google). Legacy values Apple and Google are accepted and treated as EMP with that paymentType.
         * @param {'GiftCard' | 'DirectDebit' | 'CreditCard' | 'UnmappedPaymentInstrument' | 'Apple' | 'Google'} [paymentType] payment type to filter by. AMP types are GiftCard, DirectDebit, CreditCard and UnmappedPaymentInstrument; EMP types are Apple and Google. Must belong to paymentMethod when both are given.
         * @param {string} [paymentMethodClass] filter for payment method class
         * @param {string} [asin] exact 10-character alphanumeric ASIN to filter by
         * @param {number} [endTime] timestamp for pagination
         * @param {boolean} [deep] whether to perform a deep searrch
         * @param {Array<string>} [features] additional features to apply to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentTransactions: async (stage: Stage, countries?: Array<string>, gl?: string, usecases?: Array<string>, paymentMethod?: string, paymentType?: 'GiftCard' | 'DirectDebit' | 'CreditCard' | 'UnmappedPaymentInstrument' | 'Apple' | 'Google', paymentMethodClass?: string, asin?: string, endTime?: number, deep?: boolean, features?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getRecentTransactions', 'stage', stage)
            const localVarPath = `/recent-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (gl !== undefined) {
                localVarQueryParameter['gl'] = gl;
            }

            if (usecases) {
                localVarQueryParameter['usecases'] = usecases;
            }

            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }

            if (paymentType !== undefined) {
                localVarQueryParameter['paymentType'] = paymentType;
            }

            if (paymentMethodClass !== undefined) {
                localVarQueryParameter['paymentMethodClass'] = paymentMethodClass;
            }

            if (asin !== undefined) {
                localVarQueryParameter['asin'] = asin;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (deep !== undefined) {
                localVarQueryParameter['deep'] = deep;
            }

            if (features) {
                localVarQueryParameter['features'] = features;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction: async (projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateTransaction', 'projectId', projectId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('updateTransaction', 'transactionId', transactionId)
            // verify required parameter 'transactionUpdate' is not null or undefined
            assertParamExists('updateTransaction', 'transactionUpdate', transactionUpdate)
            const localVarPath = `/projects/{projectId}/transactions/{transactionId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTransaction(projectId, transactionCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get recent transactions across regions
         * @param {Stage} stage environment name
         * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
         * @param {string} [gl] GL code to filter by (e.g., 318, 613)
         * @param {Array<string>} [usecases] usecase types to filter by
         * @param {string} [paymentMethod] payment provider to filter by (AMP or EMP; EMP means Apple or Google). Legacy values Apple and Google are accepted and treated as EMP with that paymentType.
         * @param {'GiftCard' | 'DirectDebit' | 'CreditCard' | 'UnmappedPaymentInstrument' | 'Apple' | 'Google'} [paymentType] payment type to filter by. AMP types are GiftCard, DirectDebit, CreditCard and UnmappedPaymentInstrument; EMP types are Apple and Google. Must belong to paymentMethod when both are given.
         * @param {string} [paymentMethodClass] filter for payment method class
         * @param {string} [asin] exact 10-character alphanumeric ASIN to filter by
         * @param {number} [endTime] timestamp for pagination
         * @param {boolean} [deep] whether to perform a deep searrch
         * @param {Array<string>} [features] additional features to apply to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentTransactions(stage: Stage, countries?: Array<string>, gl?: string, usecases?: Array<string>, paymentMethod?: string, paymentType?: 'GiftCard' | 'DirectDebit' | 'CreditCard' | 'UnmappedPaymentInstrument' | 'Apple' | 'Google', paymentMethodClass?: string, asin?: string, endTime?: number, deep?: boolean, features?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentTransactions(stage, countries, gl, usecases, paymentMethod, paymentType, paymentMethodClass, asin, endTime, deep, features, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransaction(projectId, transactionId, transactionUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: any): AxiosPromise<Project> {
            return localVarFp.addTransaction(projectId, transactionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get recent transactions across regions
         * @param {Stage} stage environment name
         * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
         * @param {string} [gl] GL code to filter by (e.g., 318, 613)
         * @param {Array<string>} [usecases] usecase types to filter by
         * @param {string} [paymentMethod] payment provider to filter by (AMP or EMP; EMP means Apple or Google). Legacy values Apple and Google are accepted and treated as EMP with that paymentType.
         * @param {'GiftCard' | 'DirectDebit' | 'CreditCard' | 'UnmappedPaymentInstrument' | 'Apple' | 'Google'} [paymentType] payment type to filter by. AMP types are GiftCard, DirectDebit, CreditCard and UnmappedPaymentInstrument; EMP types are Apple and Google. Must belong to paymentMethod when both are given.
         * @param {string} [paymentMethodClass] filter for payment method class
         * @param {string} [asin] exact 10-character alphanumeric ASIN to filter by
         * @param {number} [endTime] timestamp for pagination
         * @param {boolean} [deep] whether to perform a deep searrch
         * @param {Array<string>} [features] additional features to apply to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentTransactions(stage: Stage, countries?: Array<string>, gl?: string, usecases?: Array<string>, paymentMethod?: string, paymentType?: 'GiftCard' | 'DirectDebit' | 'CreditCard' | 'UnmappedPaymentInstrument' | 'Apple' | 'Google', paymentMethodClass?: string, asin?: string, endTime?: number, deep?: boolean, features?: Array<string>, options?: any): AxiosPromise<RecentTransactionsResponse> {
            return localVarFp.getRecentTransactions(stage, countries, gl, usecases, paymentMethod, paymentType, paymentMethodClass, asin, endTime, deep, features, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: any): AxiosPromise<Project> {
            return localVarFp.updateTransaction(projectId, transactionId, transactionUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
    /**
     * 
     * @summary Add a transaction to a project
     * @param {string} projectId 
     * @param {TransactionCreate} transactionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).addTransaction(projectId, transactionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get recent transactions across regions
     * @param {Stage} stage environment name
     * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
     * @param {string} [gl] GL code to filter by (e.g., 318, 613)
     * @param {Array<string>} [usecases] usecase types to filter by
     * @param {string} [paymentMethod] payment provider to filter by (AMP or EMP; EMP means Apple or Google). Legacy values Apple and Google are accepted and treated as EMP with that paymentType.
     * @param {'GiftCard' | 'DirectDebit' | 'CreditCard' | 'UnmappedPaymentInstrument' | 'Apple' | 'Google'} [paymentType] payment type to filter by. AMP types are GiftCard, DirectDebit, CreditCard and UnmappedPaymentInstrument; EMP types are Apple and Google. Must belong to paymentMethod when both are given.
     * @param {string} [paymentMethodClass] filter for payment method class
     * @param {string} [asin] exact 10-character alphanumeric ASIN to filter by
     * @param {number} [endTime] timestamp for pagination
     * @param {boolean} [deep] whether to perform a deep searrch
     * @param {Array<string>} [features] additional features to apply to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getRecentTransactions(stage: Stage, countries?: Array<string>, gl?: string, usecases?: Array<string>, paymentMethod?: string, paymentType?: 'GiftCard' | 'DirectDebit' | 'CreditCard' | 'UnmappedPaymentInstrument' | 'Apple' | 'Google', paymentMethodClass?: string, asin?: string, endTime?: number, deep?: boolean, features?: Array<string>, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getRecentTransactions(stage, countries, gl, usecases, paymentMethod, paymentType, paymentMethodClass, asin, endTime, deep, features, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a transaction in a project
     * @param {string} projectId 
     * @param {string} transactionId 
     * @param {TransactionUpdate} transactionUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateTransaction(projectId, transactionId, transactionUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

